/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43f6b20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d43f6b20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"8e626e3c-cb08-4d3a-a72b-bc62ba558e02","title":"Fræðast um prentarann","link":"finding-information-about-printer-topic.html","desc":"Finna upplýsingar um prentarann Tilföng","descFull":"Finna upplýsingar um prentarann Tilföng og hvar hægt er að finna þau Að hverju ertu að leita? Finndu það hér Leiðbeiningar varðandi fyrstu uppsetningu Skoðaðu uppsetningarskjölin sem fylgdu með prentaranum. Hugbúnaður prentara Rekill fyrir prentun eða fax Fastbúnaður prentara Hjálparforrit Farðu á  www.lexmark.com/downloads , leitaðu að þinni gerð prentara, og síðan í valmynd fyrir gerð, vedlu rekil, fastbúnað eða hjálparforrit sem þú þarfnast. Velja og geyma pappír og sérstaka miðla Hlaða pappír Breyta stillingum prentarans Skoða og prenta skjöl og myndir Setja prentarann upp á netkerfi Umhirða og viðhald á prentaranum Villuleit og lausn vandamála Upplýsingamiðstöð—Farðu á  https://infoserve.lexmark.com . Leiðbeiningarvídeó—Farðu á  https://infoserve.lexmark.com/idv/ . Leiðbeiningar á snertiskjá —Farðu á  http://support.lexmark.com . Uppsetning og stilling á aðgangseiginleikum á þínum prentara Leiðbeiningar um aðgengi Lexmark —Farðu á  http://support.lexmark.com . Upplýsingar um aðstoð við að nota hugbúnað prentarans. Hjálp fyrir stýrikerfi Microsoft Windows® eða Macintosh—Opnaðu hugbúnað prentara eða forrit og smelltu síðan á  Hjálp . Smelltu á   til að sjá samhengisnæmar upplýsingar. Hjálp er uppsett sjálfvirkt með hugbúnaði prentarans. Prentarahugbúnaðurinn er annað hvort í kerfismöppu prentara eða á skjáborðinu, en það fer eftir stýrikerfinu. Skjöl Stuðningur í beinu spjalli Stuðningur í tölvupósti Stuðningur í síma Farðu á  http://support.lexmark.com . Veldu landið þitt eða svæði, og veldu síðan vöruna til að skoða viðeigandi vefsvæði stuðnings. Upplýsingar varðandi stuðningstengiliði fyrir land þitt eða svæði er hægt að finna á vefsíðunni eða í prentaðri ábyrgð sem fylgdi með prentaranum þínum. Hafðu eftirfarandi upplýsingar tilbúnar þegar þú hefur samband við þjónustudeild: Staður og dagsetning kaupa Gerð vélar og raðnúmer Varðandi frekari upplýsingar, sjá  . Öryggisupplýsingar Upplýsingar um reglugerðir Upplýsingar um ábyrgð Umhverfisupplýsingar Ábyrgðarupplýsingar mismunandi eftir löndum eða svæðum: Í Bandaríkjunum —Sjá yfirlýsingu varðandi takmörkun ábyrgðar sem fylgdi með prentaranum, eða farðu á  http://support.lexmark.com . Í öðrum löndum eða svæðum —Sjá prentaða ábyrgð sem fylgdi með prentaranum. Upplýsingahandbók vöru —Skoðaðu skjölin sem fylgdu með prentaranum eða farðu á  http://support.lexmark.com . Upplýsingar um stafrænt vegabréf Lexmark Farðu á  https://csr.lexmark.com/digital-passport.php . upplýsingar um prentara finna finna upplýsingar um prentara"},{"UUID":"37d57c60-924f-442a-bfcf-2eb68be9421a","title":"Fræðast um prentarann","link":"finding-printer-serial-number-topic.html","desc":"Finna raðnúmerið á prentaranum Opnaðu","descFull":"Finna raðnúmerið á prentaranum Opnaðu hurð að framan. Finndu raðnúmerið á vinstri hlið prentarans. finna raðnúmerið á prentaranum raðnúmer, prentari finna"},{"UUID":"995b612e-e525-429e-af87-2c67bb390dae","title":"Fræðast um prentarann","link":"printer-configurations-topic.html","desc":"Uppsetningar prentara Vertu viss um","descFull":"Uppsetningar prentara Vertu viss um að setja upp prentarann á flötu, traustu og stöðugu yfirborði. Grunngerð Hlutir grunngerðar prentarans 1 Sjálfvirkur matari skjala (ADF) 2 Skúffa sjálfvirks matara 3 Bakki sjálfvirks matara 4 Staðalbakki 5 520-blaða staðalskúffa 6 Fjölnotamatari 7 Stjórnborð Uppsett gerð Uppsetning á einum eða fleiri valkostum á þínum prentara eða fjölnotatæki (MFP) getur krafist undirstöðu á hjólum, húsgagni eða öðrum eiginleika til að koma í veg óstöðugleika sem getur valdið hugsanlegum meiðslum. Fyrir frekari upplýsingar um studdar uppsetningar, sjá  www.lexmark.com/multifunctionprinters . Uppsetning á einum eða fleiri valkostum á þínum prentara eða fjölnotatæki (MFP) getur krafist undirstöðu á hjólum, húsgagni eða öðrum eiginleika til að koma í veg óstöðugleika sem getur valdið hugsanlegum meiðslum. Hafðu samband við þann stað sem seldi þér prentarann varðandi frekari upplýsingar um studdar uppsetningar. Hlaðið í hverja skúffu fyrir sig inn til að koma í veg fyrir óstöðugleika tækisins. Haldið öllum öðrum skúffum lokuðum þar til þörf er á. Hlutir uppsetts prentara 1 Heftarabúnaður Ekki stutt ef önnur frágangseining er sett upp. 2 520-blaða staðalskúffa 3 3 x 520-blaða skúffa sem er aukabúnaður 4 Frágangseining með heftara og gatara Eingöngu stutt ef aukaskúffur eru settar upp. 5 2520‑blaða samstæðuskúffa sem er aukabúnaður 6 Skúffa fyrir 2000 blöð sem er aukabúnaður Sumir valkostir kunna að vera ekki tiltækir. Hafðu samband við þann stað sem þú keyptir prentarann varðandi frekari upplýsingar. stillingar prentara grunnuppsetning prentara fulluppsettur prentari"},{"UUID":"6f3b2ccb-8444-4170-a11d-a77a23b9e0c5","title":"Fræðast um prentarann","link":"using-control-panel-topic.html","desc":"Nota stjórnborð prentara Hlutir á","descFull":"Nota stjórnborð prentara Hlutir á stjórnborði og aðgerðir þeirra Hlutur á stjórnborði Virkni 1 Straumhnappur Kveikja á eða slökkva á prentaranum Til að slökkva á prentaranum, ýtið á og haldið straumhnappi í fimm sekúndur. Stilla prentarann til að fara í svefnstillingu eða stillingu í dvala. Vekja prentarann úr svefnstillingu eða stillingu í dvala. 2 Skjár Skoða skilaboð prentara og stöðu á rekstrarvörum. Setja upp og nota prentarann. 3 Gaumljós Athuga stöðu prentarans. stjórnborð notar notar stjórnborð prentara"},{"UUID":"c6a33cfb-33e9-4bd6-9de4-be05293a9076","title":"Fræðast um prentarann","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Skilja stöðuna á gaumljósinu Litur","descFull":"Skilja stöðuna á gaumljósinu Litur á gaumljósi og samsvarandi staða prentarans Gaumljós Staða prentara Slökkt Slökkt er á prentaranum. Stöðugt blátt Prentarinn er tilbúinn Blikkandi blátt Prentarinn er að prenta eða er að vinna úr gögnum. Blikkandi rautt Prentarinn þarfnast íhlutunar notandans. Stöðugt gult ljós Prentarinn er í svefnstillingu. Blikkandi gult Prentarinn er í djúpri svefnstillingu eða stillingu í dvala. gaumljós skilja stöðuna staða prentara"},{"UUID":"f7dc85d0-0197-4b6b-9ff5-e40336726722","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Viðmiðunarreglur varðandi pappír Notið viðeigandi","descFull":"Viðmiðunarreglur varðandi pappír Notið viðeigandi pappír til að koma í veg fyrir flækjur og tryggja prentun án vandræða. Ávallt skal nota nýjan og óskemmdan pappír. Vertu viss um meðmælta hlið fyrir prentun áður en pappír er hlaðið. Þessar upplýsingar er yfirleitt að finna á umbúðum pappírs. Ekki nota pappír sem hefur verið skorinn eða klipptur með hendi. Ekki blanda saman pappírsstærðum, gerðum eða þyngdum í sömu skúffu; blöndun orsakar flækjur. Ekki nota húðaðan pappír nema hann sé sérstaklega hannaður fyrir rafræna prentun Varðandi frekari upplýsingar, sjá  Leiðbeiningar varðandi pappír og sérstaka miðla . pappír velur viðmiðunarreglur varðandi pappír"},{"UUID":"046f21b3-6ee3-4187-9311-8836095c8823","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Eiginleikar pappírs Eftirfarandi eiginleikar hafa","descFull":"Eiginleikar pappírs Eftirfarandi eiginleikar hafa áhrif á prentgæði og áreiðanleika. Hafðu þessar breytur í huga áður en prentað er á hann. Þyngd Skúffur geta matað pappír af mismunandi þyngd. Pappír léttari en 60 g/m 2  (16 lb) kann að vera ekki nægilega stífur til að mötun hans sé ekki rétt og hann valdi stíflum. Varðandi frekari upplýsingar, sjá efnið „Studdar pappírsþyngdir“. Krullun Krullun er tilhneiging pappírs til að krullast á jöðrum. Mikil krullun getur valdið vandamálum í mötun á pappír. Krullun getur komið fram eftir að pappír fer í gegnum prentarann, þar sem hann er verður fyrir miklum hita. Geymsla á ópökkuðum pappír við heitar, rakar, kaldar eða þurrar aðstæður, jafnvel í skúffum, getur stuðlað að því að pappír krullast fyrir prentun og getur valdið vandamálum við mötun. Sléttleiki Sléttleiki pappírs hefur bein áhrif á prentgæði. Ef pappír er of grófur þá nær prentliturinn ekki að samlagast honum á réttan hátt. Ef pappír er of sléttur, þá getur það valdið vandamálum við mötun hans eða prentgæði. Við mælum með notkun á pappír með 50 Sheffield-punktum. Rakainnihald Magn af raka í pappírnum hefur áhrif á bæði á prentgæði og getu prentarans til að mata pappírinn á réttan hátt. Láttu pappír vera í upphaflegum umbúðum þar til að það á að nota hann. Þetta takmarkar útsetningu af pappír gagnvart rakabreytingum sem geta rýrt frammistöðu hans. Fyrir prentun skal geyma pappír í upprunalegum umbúðum í 24 til 48 klukkustundir. Umhverfið sem pappírinn er geymdur í verður að vera það sama og prentarinn. Lengdu tímann í nokkra daga ef umhverfi geymslu eða flutnings er mjög frábrugðið umhverfi prentarans. Þykkur pappír getur einnig þurft lengri aðlögunartíma. Stefna á trefjum Trefjar eiga við um hvernig pappírstrefjar liggja í pappírsörk. Trefjar eru annað hvort  langar trefjar  sem liggja eftir lengd á pappírnum, eða  stuttar trefjar  sem liggja þvert á breidd pappírs. Varðandi meðmælta stefnu trefja, sjá efnið „Studdar pappírsþyngdir“. Trefjainnihald Mest af hágæða ljósritunarpappír er búinn til úr 100% efnameðhöndlaðri trjákvoðu. Þetta innihald gefur pappírnum mikinn stöðugleika sem leiðir til færri vandamála við mötun pappírs og betri prentgæði. Pappír sem inniheldur trefjar eins og bómull getur haft neikvæð áhrif á meðhöndlun pappírs. Eiginleikar pappírs"},{"UUID":"f8ad35d6-0fdf-49a3-a425-6d72111797f8","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Óásættanlegur pappír Ekki er mælt","descFull":"Óásættanlegur pappír Ekki er mælt með eftirfarandi pappírsgerðum til nota í prentaranum: Efnafræðilega meðhöndlaðir pappírar sem eru notaðir til að gera afrit án kalkipappírs. Þeir eru einnig þekktir sem kolefnislausir pappírar, kolefnislaus afritunarpappír (CCP) eða pappír sem ekki þarfnast kolefnis (NCR). Forprentaður pappír með kemískum efnum sem geta mengað prentarann Forprentaður pappír sem getur orðið fyrir áhrifum að hitastigi í prentaranum Forprentaður pappír sem þarfnast stillingar (nákvæmni prentunar á pappírinn) meiri eða minni en ±2.3 mm (±0.09 to.). Til dæmis eyðublöð með ljóskennsl stafa (OCR). Í sumum tilfellum, er hægt að stilla samfærslu með hugbúnaði til að prenta með árangri á þessi eyðublöð. Húðaður pappír (útþurrkanlegur), pappír úr gerviefnum eða hitanæmur pappír Með grófum brúnum. grófan eða mjög munstraður pappír eða krumpaður pappír Pappírar sem ekki uppfylla EN12281:2002 (evrópa). Pappír sem er þynnri en 60g/m 2  (16lb) Margskipt eyðublöð eða skjöl. óásættanlegur pappír"},{"UUID":"3c72431c-e5e1-40df-bff6-1c9e28ca09a4","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Geymsla á pappír Notaðu þessar","descFull":"Geymsla á pappír Notaðu þessar viðmiðunarreglur varðandi pappírsgeymslu til að hjálpa til við að forðast flækjur og misjöfn prentgæði: Geymið pappír í upprunalegum umbúðum í sama umhverfi og prentarinn í 24 til 48 klukkustundir fyrir prentun. Lengdu tímann í nokkra daga ef umhverfi geymslu eða flutnings er mjög frábrugðið umhverfi prentarans. Þykkur pappír getur einnig þurft lengri aðlögunartíma. Fyrir bestu útkomu, geymið pappír þar sem hitastigið er 21°C (70°F) og rakastig er 40 prósent. Flestir miðaframleiðendur mæla með prentun við hitastig á bilinu 18-24°C (65-75°F) og með hlutfallslegum raka á bilinu 40 og 60 prósent. Geymið pappír í öskjum, á bretti eða hillu, frekar en á gólfinu. Geymið einstaka pakka á flötu yfirborði. Ekki geyma neitt ofan á stökum pappírspökkum. Taktu pappír út úr öskjunni eða umbúðum aðeins þegar þú ert tilbúinn til að hlaða honum í prentarann. Askjan og umbúðirnar að halda pappírnum hreinum, þurrum og flötum. geymsla á pappír"},{"UUID":"7636e312-8d05-40e2-8008-9d6e17533e1f","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Val á forprentuðum eyðublöðum og","descFull":"Val á forprentuðum eyðublöðum og bréfhausum Notaðu pappír með löngum trefjum. Notaðu aðeins eyðublöð sem eru offsetprentuð eða prentuð með aðferð djúpprentunar. Varastu pappír með grófri eða mjög mynstraðri áferð. Notaðu blek sem prentliturinn í prentaranum hefur ekki áhrif á. Prentlitir sem þorna við oxun eða eru á olíugrunni uppfylla venjulegast þessar kröfur; latex-prentlitir kunna ekki að gera það. Prentaðu prufueintök á forprentuð eyðublöð og bréfsefni sem ætlun er að nota áður en mikið magn er keypt. Þessi aðgerð ákvarðar hvort blek í forprentuðu eyðublaði eða bréfsefni mun hafa áhrif á prentgæðin. Hafðu samráð við söluaðila pappírs ef í vafa. Hlaðið pappír í rétta stefnu fyrir prentarann þegar verið er að prenta á bréfhaus. Varðandi frekari upplýsingar, sjá  Leiðbeiningar varðandi pappír og sérstaka miðla . pappír forprentuð eyðublöð forprentuð eyðublöð velur pappír bréfhaus bréfhaus velur"},{"UUID":"95b0a25f-bb03-495d-837b-d7f6ddc1621e","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Studdar pappírsstærðir Pappírsstærðir studdar af","descFull":"Studdar pappírsstærðir Pappírsstærðir studdar af staðalbakka, fjölnotamatara, skúffu fyrir umslög og prentun á tvær hliðar Pappírsstærð Staðalskúffa fyrir 520 blöð Fjölnotamatari Skúffa fyrir umslög Prentun á tvær hliðar 1  Hleðst eingöngu í stuttri brún. 2  Hleðst eingöngu í langri brún. 3  Styður við pappírsstærðir frá 139,7 x 181,86 mm (5,5 x 7,16 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). 4  Styður við pappírsstærðir frá 88,9 x 98,38 mm (3,5 x 3,87 to.) til 296,93 x 482,6 mm (11,69 x 19 to.). 5  Styður við pappírsstærðir frá 128 x 139,7 mm (5 x 5,5 to.) til 296,93 x 482,6 mm (11,69 x 19 to.). A3 1 297 x 420 mm (11,69 x 16,54 to.) X A4 210 x 297 mm (8,27 x 11,7 to.) 2 X A5 148 x 210 mm (5,83 x 8,27 to.) 1 2 X A6 105 x 148 mm (4,13 x 5,83 to.) X 1 X X Stjórnunarleg (Executive) 184,2 x 266,7 mm (7,25 x 10,5 to.) 2 X Fólíó 1 215,9 x 330,2 mm (8,5 x 13 to.) X Hagaki 100 x 148 mm (3,94 x 5,83 to.) X 1 X X JIS B4 1 257 x 364 mm (10,12 x 14,33 to.) X JIS B5 182 x 257 mm (7,17 x 10,1 to.) 2 X Kladdi 1 279,4 x 4431,8 mm (11 x 17 to.) X Lögfræði (Legal) 1 215,9 x 355,6 mm (8,5 x 14 to.) X Bréf (Letter) 215,9 x 279,4 mm (8,5 x 11 to.) 2 X Oficio (Mexico) 1 215,9 x 340,4 mm (8,5 x 13,4 to.) X Yfirlýsing 139,7 x 215,9 mm (5,5 x 8,5 to.) 1 2 X Alhliða 3 4 X 5 7 3/4 umslag 98,4 x 190,5 mm (3,875 x 7,5 to.) X 2 X 9 umslag 98,4 x 225,4 mm (3,875 x 8,9 to.) X 2 X 10 umslag 104,8 x 241,3 mm (4,12 x 9,5 to.) X 2 X B5 umslag 176 x 250 mm (6,93 x 9,84 to.) X 1 X C5 umslag 162 x 229 mm (6,38 x 9,01 to.) X 2 X DL umslag 110 x 220 mm (4,33 x 8,66 to.) X 2 X Sjálfvirkur matari styður við pappírsstærðir frá 125 x 85 mm (4,92 x 3,35 to.) til 297 x 431,8 mm (11,69 x 17 to.). Flatskanni styður við hámarks pappírsstærðina 297 x 431,8 mm (11,69 x 17 to.). Pappírsstærðir studdar af aukaskúffum Pappírsstærð 520-blaða aukaskúffa, 520-blaða aukaskúffa með skáp og 3 x 520-blaða aukaskúffa 2520‑blaða samstæðuskúffa sem er aukabúnaður Skúffa fyrir 2000 blöð sem er aukabúnaður 1  Hleðst eingöngu í stuttri brún. 2  Hleðst eingöngu í langri brún. 3  Styður við pappírsstærðir frá 139,7 x 181,86 mm (5,5 x 7,16 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). A3 1 297 x 420 mm (11,69 x 16,54 to.) X A4 210 x 297 mm (8,27 x 11,7 to.) 2 A5 1 148 x 210 mm (5,83 x 8,27 to.) X A6 105 x 148 mm (4,13 x 5,83 to.) X X X Stjórnunarleg (Executive) 184,2 x 266,7 mm (7,25 x 10,5 to.) 2 Fólíó 1 215,9 x 330,2 mm (8,5 x 13 to.) X Hagaki 100 x 148 mm (3,94 x 5,83 to.) X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 to.) X JIS B5 182 x 257 mm (7,17 x 10,1 to.) 2 Kladdi 1 279,4 x 4431,8 mm (11 x 17 to.) X Lögfræði (Legal) 1 215,9 x 355,6 mm (8,5 x 14 to.) X Bréf (Letter) 215,9 x 279,4 mm (8,5 x 11 to.) 2 Oficio (Mexico) 1 215,9 x 340,4 mm (8,5 x 13,4 to.) X Yfirlýsing 1 139,7 x 215,9 mm (5,5 x 8,5 to.) X Alhliða 3 3 3 7 3/4 umslag 98,4 x 190,5 mm (3,875 x 7,5 to.) X X X 9 umslag 98,4 x 225,4 mm (3,875 x 8,9 to.) X X X 10 umslag 104,8 x 241,3 mm (4,12 x 9,5 to.) X X X B5 umslag 176 x 250 mm (6,93 x 9,84 to.) X X X C5 umslag 162 x 229 mm (6,38 x 9,01 to.) X X X DL umslag 110 x 220 mm (4,33 x 8,66 to.) X X X Pappírsstærðir studdar af úttaksbökkum Pappírsstærð Staðalbakki Efri bakki Stafla Hliðrun Stafla 1  Hleðst eingöngu í stuttri brún. 2  Hleðst eingöngu í langri brún. 3  Styður við pappírsstærðir frá 88,9 x 98,38 mm (3,5 x 3,87 to.) til 296,93 x 482,6 mm (11,69 x 19 to.). 4  Styður við pappírsstærðir frá 88,9 x 98,38 mm (3,5 x 3,87 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). A3 1 297 x 420 mm (11,69 x 16,54 to.) A4 210 x 297 mm (8,27 x 11,7 to.) A5 148 x 210 mm (5,83 x 8,27 to.) A6 1 105 x 148 mm (4,13 x 5,83 to.) Stjórnunarleg (Executive) 184,2 x 266,7 mm (7,25 x 10,5 to.) Fólíó 1 215,9 x 330,2 mm (8,5 x 13 to.) Hagaki 1 100 x 148 mm (3,94 x 5,83 to.) JIS B4 1 257 x 364 mm (10,12 x 14,33 to.) JIS B5 182 x 257 mm (7,17 x 10,1 to.) Kladdi 1 279,4 x 4431,8 mm (11 x 17 to.) Lögfræði (Legal) 1 215,9 x 355,6 mm (8,5 x 14 to.) Bréf (Letter) 215,9 x 279,4 mm (8,5 x 11 to.) Oficio (Mexico) 1 215,9 x 340,4 mm (8,5 x 13,4 to.) Yfirlýsing 139,7 x 215,9 mm (5,5 x 8,5 to.) Alhliða 3 4 X 7 3/4 umslag 2 98,4 x 190,5 mm (3,875 x 7,5 to.) 9 umslag 2 98,4 x 225,4 mm (3,875 x 8,9 to.) 10 umslag 2 104,8 x 241,3 mm (4,12 x 9,5 to.) B5 umslag 2 176 x 250 mm (6,93 x 9,84 to.) C5 umslag 2 162 x 229 mm (6,38 x 9,01 to.) DL umslag 2 110 x 220 mm (4,33 x 8,66 to.) Pappírsstærðir studdar af frágangseiningum Pappírsstærð Heftarabúnaður Frágangseining með heftara og gatara Stafla Hliðrun Hefta Stafla Hliðrun Hefta Gatari 1  Hleðst eingöngu í stuttri brún. 2  Hleðst eingöngu í langri brún. 3  Styður við pappírsstærðir frá 88,9 x 98,38 mm (3,5 x 3,87 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). 4  Styður við pappírsstærðir frá 190 x 139,7 mm (7,48 x 5,5 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). 5  Styður við pappírsstærðir frá 202,9 x 182,03 mm (7,99 x 7,17 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). 6  Styður eingöngu við allt að 2 göt á gatara 7  Styður eingöngu við allt að 2 göt á gatara þegar hlaðið í stuttri brún. 8  Styður við pappírsstærðir frá 88,9 x 98,38 mm (3,5 x 3,87 to.) til 320,04 x 1320,8 mm (12,6 x 52 to.). 9  Styður við pappírsstærðir frá 209,97 x 148 mm (8,27 x 5,83 to.) til 296,93 x 431,8 mm (11,69 x 17 to.). A3 1 297 x 420 mm (11,69 x 16,54 to.) A4 210 x 297 mm (8,27 x 11,7 to.) A5 148 x 210 mm (5,83 x 8,27 to.) 2 X 2 2 6 A6 105 x 148 mm (4,13 x 5,83 to.) X X X X X Borði Hámarksbreidd: 215,9 mm (8,5 to.) Hámarkslengd: 1320,8 mm (52 to.) 1 X X 1 X X X Stjórnunarleg (Executive) 184,2 x 266,7 mm (7,25 x 10,5 to.) 2 2 2 2 2 2 Fólíó 1 215,9 x 330,2 mm (8,5 x 13 to.) Hagaki 100 x 148 mm (3,94 x 5,83 to.) X X X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 to.) JIS B5 182 x 257 mm (7,17 x 10,1 to.) 2 2 2 2 7 Kladdi 1 279,4 x 4431,8 mm (11 x 17 to.) Lögfræði (Legal) 1 215,9 x 355,6 mm (8,5 x 14 to.) Bréf (Letter) 215,9 x 279,4 mm (8,5 x 11 to.) Oficio (Mexico) 1 215,9 x 340,4 mm (8,5 x 13,4 to.) Yfirlýsing 139,7 x 215,9 mm (5,5 x 8,5 to.) 2 X X X X X Alhliða 3 4 5 8 9 9 X 7 3/4 umslag 98,4 x 190,5 mm (3,875 x 7,5 to.) X X X X X X 9 umslag 98,4 x 225,4 mm (3,875 x 8,9 to.) X X X X X X 10 umslag 104,8 x 241,3 mm (4,12 x 9,5 to.) X X X X X X B5 umslag 176 x 250 mm (6,93 x 9,84 to.) 2 X X X X X X C5 umslag 162 x 229 mm (6,38 x 9,01 to.) 1 X X X X X X DL umslag 110 x 220 mm (4,33 x 8,66 to.) X X X X X X studdar pappírsstærðir pappírsstærðir, studdar"},{"UUID":"63514c9f-beec-4aff-82ff-fcc169b39744","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Studdar pappírsgerðir Studdar pappírsgerðir Pappírsgerðir","descFull":"Studdar pappírsgerðir Studdar pappírsgerðir Pappírsgerðir studdar af staðalbakka, fjölnotamatara, skúffu fyrir umslög og prentun á tvær hliðar Pappírsgerð Staðalskúffa fyrir 520 blöð Fjölnotamatari Skúffa fyrir umslög Prentun á tvær hliðar Þykkur pappír X Þykkur pappír  X Litaður pappír X Sérsniðin gerð X Umslag X X Glanspappír X Þykkur glansandi X Mjög þykkur pappír X Miðar X X Bréfhaus X Þunnur pappír X Venjulegur pappír X Forprentaður X Endurunninn X Gróft umslag X X Grófur bómull X Vínýlmiðar X X X X Pappírsgerðir studdar af aukaskúffum Pappírsgerð 520-blaða aukaskúffa, 520-blaða aukaskúffa með skáp og 3 x 520-blaða aukaskúffa 2520‑blaða samstæðuskúffa sem er aukabúnaður Skúffa fyrir 2000 blöð sem er aukabúnaður Þykkur pappír Þykkur pappír  Litaður pappír Sérsniðin gerð Umslag X X X Glanspappír Þykkur glansandi Mjög þykkur pappír Miðar Bréfhaus Þunnur pappír Venjulegur pappír Forprentaður Endurunninn Gróft umslag X X X Grófur bómull Vínýlmiðar X X X Pappírsgerðir studdar af úttaksbökkum Pappírsgerð Staðalbakki Efri bakki Stafla Hliðrun Stafla Þykkur pappír Þykkur pappír  Litaður pappír Sérsniðin gerð Umslag Glanspappír Þykkur glansandi Mjög þykkur pappír Miðar Bréfhaus Þunnur pappír Venjulegur pappír Forprentaður Endurunninn Gróft umslag Grófur bómull Vínýlmiðar X X X Pappírsgerðir studdar af frágangseiningum Pappírsgerð Heftarabúnaður Frágangseining með heftara og gatara Stafla Hliðrun Hefta Stafla Hliðrun Hefta Gatari Þykkur pappír Þykkur pappír  X X Litaður pappír Sérsniðin gerð Umslag X X X X X X Glanspappír Þykkur glansandi X X Mjög þykkur pappír X X Miðar X X X X X Bréfhaus Þunnur pappír Venjulegur pappír Forprentaður Endurunninn Gróft umslag X X X X X X Grófur bómull X X Vínýlmiðar X X X X X X X studdar pappírsgerðir pappírsgerðir studdar"},{"UUID":"18a2e6ec-de3a-443b-81f1-72aaa6976a0b","title":"Val á pappír","link":"selecting-paper-group.html","desc":"Studdar pappírsþyngdir Pappírsþyngdir studdar af","descFull":"Studdar pappírsþyngdir Pappírsþyngdir studdar af prentaranum 520-blaða skúffa, 520-blaða skúffa með skáp, 3 x 520-blaða skúffa og 2520-blaða samstæðuskúffa Fjölnotamatari Skúffa fyrir umslög Skúffa fyrir 2000 blöð sem er aukabúnaður 60-256 g/m 2 (12–68 lb) 60–216 g/m 2 (12–57 lb) 75–90 g/m 2 (20–24 lb) 60–216 g/m 2 (12–57 lb) Fyrir 60–176 g/m 2  (16–47‑lb) þykkan pappír er mælt með löngum trefjum. Pappír sem er minna en 75 g/m 2  (20-lb þykkur) verður að prenta með  gerð pappírs  stillta á  þunnan pappír . Misbrestur á að gera það gæti valdið óhóflegri krullun sem getur leitt til villu við mötun, sérstaklega í rakara umhverfi. Prentun á tvær hliðar styður þyngd pappírs frá 60–162 g/m 2  (16–43‑lb þykkan) pappír. Hámarksþyngd 100% bómullarinnihalds er 90 g/m 2  (24‑lb þykkur). studdar pappírsþyngdir pappírsþyngdir studdar"},{"UUID":"c0331fb0-d901-40ac-acde-755449cd1c36","title":"Setja upp, setja inn og stilla","link":"selecting-location-printer-topic.html","desc":"Velja staðsetningu fyrir prentarann Skilja","descFull":"Velja staðsetningu fyrir prentarann Skilja eftir nægt pláss til að opna skúffur, hlífar og hurðir og til að setja upp valkosti vélbúnaðar. Settu prentarann upp nálægt rafmagnstengli. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Til að koma í veg fyrir hættu á raflosti, ekki setja þessa vöru upp eða nota nálægt vatni eða blautum stöðum. Gangið úr skugga um að loftflæði í herberginu uppfylli ASHRAE 62 staðal eða staðal CEN Technical Committee 156. Tryggið flatt, sterkt og stöðugt yfirborð. Haldið prentaranum: Hreinum, þurrum og lausum við ryk. Fjarri lausum heftum og pappírsklemmum. Fjarri beinu loftflæði frá loftræstitækjum, hiturum eða blásurum. Fjarri beinu sólarljósi eða miklum raka. Fylgið meðmæltu hitastigi og varist óstöðugleika: Meðmælt hitastig Umhverfishiti Geymsluhiti Haldið meðmæltu plássi umhverfis prentarann fyrir rétta loftræstingu: Meðmælt pláss í kring um prentarann 1 Ofan 2 Aftan 3 Hægri hlið 4 Framan 5 Vinstri hlið prentari velja staðsetningu fyrir velja staðsetningu fyrir prentarann prentari lágmarksmillibil færa prentarann"},{"UUID":"fe1d080e-c475-4ff0-8df9-20c5ed8cba13","title":"Setja upp, setja inn og stilla","link":"attaching-cables-topic.html","desc":"Tenging á köplum Til að","descFull":"Tenging á köplum Til að koma í veg fyrir hættu á raflosti skal ekki setja upp þessa vöru eða tengja einhverjar rafmagns- og kaplatengingar, svo sem rafmagnsleiðslu, faxeiginleika eða síma, á meðan á eldingarveður gengur yfir. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Til að koma í veg fyrir hættu á eldsvoða eða raflosti notið aðeins rafmagnssnúruna sem fylgdi með þessari vöru eða viðurkennda skiptivöru frá framleiðanda. Til að draga úr hættu á eldsvoða, notið aðeins 26 AWG eða stærri samskiptasnúru (RJ-11) þegar þessi vara er tengd við almennt símkerfi. Fyrir notendur í Ástralíu verður snúran að vera samþykkt af yfirvöldum samskipta og miðla í Ástralíu (Australian Communications and Media Authority). Til að forðast gagnatap eða truflun prentara, ekki snerta USB snúruna, millistykki fyrir þráðlaust net, eða prentarann á þeim svæðum sem eru sýnd þegar prentun er virk. Prentaratengi og innstungur og virkni þeirra Prentaratengi Virkni 1 USB-tengi Tengja lyklaborð eða einhvern samhæfan valkost. 2 USB-prentaratengi Tengja prentarann við tölvu. 3 Ethernet-tengi Tengja prentarann við netkerfi. 4 LINE-tengi Eingöngu í boði þegar faxkort er sett upp. Tengja prentarann við virka símalínu með venjulegt veggtengi (RJ-11), DSL-síu eða VoIP-millistykki eða eitthvað annað millistykki sem leyfir þér aðgengi að símalínu til að senda og taka á móti faxi. 5 Tengi fyrir straumsnúru Tengja prentarann við rétt jarðtengda rafmagnsinnstungu. tengja kapla prentaratengi USB-kapall Ethernet-kapall USB-tengi Ethernet-tengi tengi fyrir straumsnúru"},{"UUID":"0e0625e6-c93e-4c9a-8d89-54ed93b7dd53","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Nota heimaskjáinn Heimaskjárinn þinn getur","descFull":"Nota heimaskjáinn Heimaskjárinn þinn getur verið mismunandi eftir á sérstillingum á heimaskjánum, stjórnendauppsetningu og virkum innfelldum lausnum. Táknmyndir á heimaskjá og virkni þeirra # Tákn Virkni 1 Stopp-hnappur eða hnappur til að hætta við Hætta við núverandi verk. 2 Afritun Taka afrit. 3 Breyta um tungumál Breyta tungumálinu á skjá prentarans. 4 Tölvupóstur Senda tölvupósta. 5 Stillingar Aðgengi að valmyndum prentarans. 6 Fax Senda fax. 7 Heimilisfangabók Fara í, búa til og skipuleggja tengiliði. 8 Staða/birgðir Sýna viðvörun prentara eða villuskilaboð þegar prentari þarf íhlutun til að halda áfram vinnslu. Skoða frekari upplýsingar um viðvörun prentara eða skilaboð, og um hvernig á að hreinsa þau. Þú getur líka farið í þessa stillingu með því að snerta efsta hlutann á heimaskjánum. 9 Verk í bið Sýna öll núverandi prentverk í bið. 10 Verk í biðröð Sýna öll núverandi prentverk. Þú getur líka farið í þessa stillingu með því að snerta efsta hlutann á heimaskjánum. 11 USB-drif Skoða, velja eða prenta myndir og skjöl af minniskorti. 12 Prófílar skönnunar Skanna og vista skjöl beint á tölvunni. 13 FTP Skanna og vista skjöl beint á FTP-miðlara. 14 Bókmerki Skipuleggja öll bókarmerki. 15 Harður diskur Skoða, velja og stjórna skjölum af harða diskinum eða skynvæddu geymsludrifi. 16 Mappa netkerfis Skanna í möppu á netinu eða staðsetningar á netinu. 17 Start-hnappur Gangsetja verk, fer eftir hvaða stilling er valin. 18 Hnappaborð á skjánum Skrá tölur eða tákn í inntakssvæði. nota heimaskjáinn heimaskjár notar"},{"UUID":"dff2d07a-6880-441e-a450-6814843a161d","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Sérsníða heimaskjáinn Opnaðu vafra og","descFull":"Sérsníða heimaskjáinn Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Tæki Sýnileg tákn á heimaskjá . Gerðu eitt eða fleira af eftirfarandi: Til að bæta við tákni á heimaskjáinn, smelltu á  , veldu heitið á appinu, og smelltu síðan á  Bæta við . Til að fjarlægja tákn af heimaskjánum, veldu heitið á appinu, og smelltu síðan á  Fjarlægja . Til að sérsníða heiti á appi, veldu heitið á appinu, smelltu á  Breyta , og úthlutaðu heiti. Til að endurvekja heiti á appi, veldu heitið á appinu, smelltu á  Breyta , og veldu síðan  Endurvekja merki apps . Til að bæta við bili á milli appa, smelltu á  , veldu  AUTT BIL , og smelltu síðan á  Bæta við . Til að raða öppunum skaltu draga nöfn appanna í þá röð sem þú vilt. Til að endurheimta sjálfgefna heimaskjáinn, smelltu á  Endurheimta heimaskjáinn . Beittu breytingunum. tákn á heimaskjá sýnir tákn á heimaskjánum sýna heimaskjár sérsníða sýna öpp á heimaskjánum bæta öppum á heimaskjáinn"},{"UUID":"677c5613-58d3-4953-81a7-b141eee89f9c","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Studd forrit Skönnunarmiðstöð Miðstöð flýtivísa","descFull":"Studd forrit Skönnunarmiðstöð Miðstöð flýtivísa Afrita kort Afrita kort studd forrit"},{"UUID":"ec6f17f0-f77d-42f1-9d6d-e4999f686b7e","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Setja upp skönnunarmiðstöð Á heimaskjá","descFull":"Setja upp skönnunarmiðstöð Á heimaskjá prentarans, veldu  Skönnunarmiðstöð . Veldu og búðu til ákvörðunarstað og settu upp stillingarnar. Gakktu úr skugga um að þú staðfestir og stillir stillingar þar til engar villur eiga sér stað þegar þú ert að búa til ákvörðunarstað á netinu. Aðeins ákvörðunarstaðir búnir til frá innbyggða vefþjóninum eru vistaðir. Skoðaðu skjölin sem fylgdu með lausninni varðandi frekari upplýsingar. Beittu breytingunum. Skönnunarmiðstöð uppsetning"},{"UUID":"8c00f81c-3226-420a-9e79-92b769fc6475","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Búa til flýtivísi Á heimaskjá","descFull":"Búa til flýtivísi Á heimaskjá prentarans, veldu  Miðstöð flýtivísa . Tákn og heiti gæti hafa breyst. Hafðu samband við þinn kerfisstjóra varðandi frekari upplýsingar Veldu aðgerð prentara og snertu síðan  Búa til flýtivísi . Aðgerðin fyrir öruggan tölvupóst er ekki studd. Settu upp stillingarnar og snertu síðan  Vista . Skráðu einstakt heiti á flýtivísi. Til að komast hjá að klippt sé af heitum á heimaskjánum, skráðu aðeins allt að 25 staftáknum Snertu  OK . Forritið býr sjálfvirkt til einstakt númer á flýtivísi. Til að ræsa flýtivísi, ýttu á   , snertu  #  og skráðu síðan númer flýtivísis. búa til flýtivísa flýtivísar býr til flýtivísir Afritun flýtivísir Tölvupóstur flýtivísir Fax flýtivísir FTP"},{"UUID":"cbbc74db-0f46-4c34-abb4-33c4fcee02fe","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Setja upp afritun á korti","descFull":"Setja upp afritun á korti Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Forrit Afrita kort Setja upp . Vertu viss um að  sýna tákn  sé virkt. Vertu viss um að  stillingar fyrir tölvupóst  og  samnýtingu netkerfis  séu uppsettar. Þegar verið er að skanna kort, vertu viss um að upplausn í skönnun sé ekki meiri en 200 dpi fyrir lit, og 400 dpi fyrir svart og hvítt. Þegar verið er að skanna mörg kort, vertu viss um að upplausn í skönnun sé ekki meiri en 150 dpi fyrir lit, og 300 dpi fyrir svart og hvítt. Beittu breytingunum. Þú þarft harðan disk prentara eða skynvætt geymsludrif til að skanna mörg kort. Afrita kort uppsetning"},{"UUID":"f3fb1ab7-3a64-4194-9027-9f2595b5ae99","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Nota sérsnið á skjá Vertu","descFull":"Nota sérsnið á skjá Vertu viss um að gera eftirfarandi áður en forritið er notað: Í innbyggða vefþjóninum, smella á  Forrit Sérsníða skjá Setja upp . Virkja og setja upp stillingar fyrir skjáhvílu, myndasýningu og veggfóður. Stjórna myndum fyrir skjáhvílu og myndasýningu Í hluta fyrir myndir skjáhvílu og myndasýningar, bættu við, breyttu eða eyddu mynd. Þú getur bætt við allt að 10 myndum. Þegar virkt þá birtast stöðutákn aðeins á skjáhvílu þegar villur, viðvaranir eða tilkynningar frá skýi eru til staðar. Beittu breytingunum. Breyta um mynd veggfóðurs Á heimaskjá prentarans, veldu  Breyta um veggfóður . Veldu mynd til að nota. Beittu breytingunum. Keyra myndasýningu frá minniskorti Settu minniskort í USB-tengið. Frá heimaskjá, snertu  Myndasýning . Myndirnar birtast í stafrófsröð. Þú getur fjarlægt minniskortið eftir að myndasýningin byrjar en myndirnar eru ekki vistaðar í prentaranum. Ef myndasýningin stöðvast, settu minniskortið inn aftur til að skoða myndirnar. sérsníða skjá notar nota sérsnið á skjá sérsníða skjáinn breyta veggfóðrinu keyra myndasýningu stjórna skjáhvílu"},{"UUID":"e7416f59-8424-4fcc-90b4-1f43edee3923","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Nota Aðstoð við viðskiptavini Þetta","descFull":"Nota Aðstoð við viðskiptavini Þetta forrit er aðeins stutt í sumum gerðum prentara. Varðandi frekari upplýsingar, sjá  . Þetta forrit er aðeins stutt í sumum gerðum prentara. Upplýsingar um hvernig á að setja upp stillingar forritsins má sjá í  Stjórnendaleiðbeiningar fyrir aðstoð við viðskiptavini. Á heimaskjá prentarans, veldu  Aðstoð við viðskiptavini . Prenta upplýsingarnar eða senda í tölvupósti. Aðstoð við viðskiptavini notar nota  Aðstoð við viðskiptavini"},{"UUID":"a8fd15bd-3f06-4470-90be-fc67995169a9","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Setja upp kvóta tækis Þetta","descFull":"Setja upp kvóta tækis Þetta forrit er aðeins stutt í sumum gerðum prentara. Varðandi frekari upplýsingar, sjá  . Þetta forrit er aðeins stutt í sumum gerðum prentara. Upplýsingar um hvernig stilla á forritið má sjá í  Stjórnendaleiðbeiningar fyrir kvóta tækis . Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Forrit Kvótar tækis Setja upp . Í kaflanum  Reikningar notanda  bættu við eða breyttu notanda og stilltu síðan kvóta notanda. Beittu breytingunum. setja upp  kvóta tækis Kvótar tækis uppsetning"},{"UUID":"530430b7-2153-4316-acd7-c6fcc14ee67b","title":"Stjórna bókmerkjum","link":"using-home-screen-topic.html","desc":"Búa til bókmerki Nota bókmerki","descFull":"Búa til bókmerki Nota bókmerki til að prenta skjöl sem oft eru notuð og sem eru geymd á netþjónum eða á vefnum. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Bókmerki Bæta við bókmerki , og skráðu síðan nafn á bókmerki. Veldu gerð samskiptareglu  Vistfangs  og gerðu síðan eitt af eftirfarandi: Fyrir HTTP og HTTPS, skráðu vefsíðuslóðina sem þú vilt bókmerkja. Fyrir HTTPS, vertu viss um að nota heiti hýsils í stað IP-tölu. Til dæmis, skráðu  myWebsite.com/sample.pdf  í stað þess að skrá  123.﻿123.123.123/sample.pdf . Vertu einnig viss um að heiti hýsils samsvari einnig gildi almenns heitis (CN) í vottorði netþjóns. Nánari upplýsingar um að fá CN-gildi í vottorði netþjóns er að finna í hjálparupplýsingum fyrir vafrann þinn. Fyrir FTP, skráðu FTP vistfangið. Til dæmis,  myServer/myDirectory . Skráðu númer FTP-tengis. Tengi 21 er sjálfvalið tengi til að senda skipanir. Fyrir SMB, skráðu vistfang fyrir möppu netkerfis. Til dæmis,  myServer/myShare/myFile.pdf . Skráðu heiti á léni netkerfis. Ef þörf krefur, veldu gerð  sannvottunar  fyrir FTP og SMB. Skráðu PIN-númer til að takmarka aðgengi að bókmerkinu. Forritið styður eftirfarandi gerðir skráa: PDF, JPEG og TIFF. Aðrar gerðir á skrám, svo sem DOCX og XLSX eru studdar í sumum gerðum prentara. Smelltu á  Vista . bókmerki býr til búa til bókmerki"},{"UUID":"28cf5080-49a1-4c0a-9db0-fba705930d76","title":"Stjórna bókmerkjum","link":"using-home-screen-topic.html","desc":"Búa til möppur Opnaðu vafra","descFull":"Búa til möppur Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Bókmerki Bæta við möppu , og skrá síðan nafn á möppu. Skráðu PIN-númer til að takmarka aðgengi að möppunni. Smelltu á  Vista . Þú getur búið til möppur og bókmerki í möppu. Til að búa til bókmerki, sjá  . bókmerki búa til möppur fyrir búa til möppur fyrir bókmerki"},{"UUID":"68533b2f-430d-42a3-ad08-6bb333b1779d","title":"Setja upp og nota forrit á heimaskjánum","link":"using-home-screen-topic.html","desc":"Heimilisfangabók Stjórna tengiliðum Á heimaskjá","descFull":"Heimilisfangabók Stjórna tengiliðum Á heimaskjá prentarans, veldu  Heimilisfangabók. . Gerðu eitt eða fleira af eftirfarandi: Til að bæta við tengilið, snertu  efst á skjánum, og snertu síðan  Búa til tengilið . Skilgreindu innskráningaraðferð ef þörf krefur til að leyfa aðgengi að forritum. Til að eyða tengilið, snertu  efst á skjánum, snertu  Eyða tengiliðum , og veldu síðan tengiliðinn. Til að breyta upplýsingum um tengilið, snertu nafn tengiliðar. Til að búa til hóp, snertu  efst á skjánum, og snertu síðan  Búa til hóp . Skilgreindu innskráningaraðferð ef þörf krefur til að leyfa aðgengi að forritum. Til að eyða tengilið, snertu  efst á skjánum, snertu  Eyða hópum , og veldu síðan hópinn. Til að breyta tengiliðahóp, snertu  HÓPAR veldu heiti á hóp  veldu aðgerðina sem þú vilt gera. Beittu breytingunum. bæta við tengiliðum eyða tengiliðum bæta við hópum tengiliða eyða tengiliðahópum breyta tengiliðum Heimilisfangabók notar"},{"UUID":"de08be56-f0a0-42b7-83dd-59a8963579bd","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Virkja raddstýringu Frá heimaskjánum Í","descFull":"Virkja raddstýringu Frá heimaskjánum Í einni hreyfingu og með einum fingri, strjúktu hægt til vinstri og síðan upp á skjáinn þar til þú heyrir raddskilaboð. Notaðu tvo fingur, snertu  OK . Ef bendingin virkar ekki, beittu þá meiri þrýstingi. Frá hnappaborðinu Ýttu á og haltu  5  hnappinum þar til að talboð heyrast. Ýttu á  Tab  til að færa bendilinn á OK-hnappinn og ýttu síðan á  Enter . Þegar kveikt er á raddstýringu skaltu alltaf nota tvo fingur til að velja hvaða atriði sem er á skjánum. Raddstýring er takmarkaðan tungumálastuðning. raddstýring virkjar virkja raddstýringu"},{"UUID":"bce7ca51-87f1-462d-866d-9dbdba5623a8","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Slökkva á raddstýringu Í einni","descFull":"Slökkva á raddstýringu Í einni hreyfingu og með einum fingri, strjúktu hægt til vinstri og síðan upp á skjáinn þar til þú heyrir raddskilaboð. Notaðu tvo fingur til að gera annað hvort af eftirfarandi: Snertu  Raddstýring , snertu síðan  OK . Snertu  Hætta við . Ef bendingin virkar ekki, beittu þá meiri þrýstingi. Þú getur líka slökkt á raddstýringu með því að gera annað hvort af eftirfarandi: Tvísmelltu á heimaskjáinn með tveimur fingrum. Ýttu á straumtakkann til að setja prentarann í svefnstillingu eða stillingu í dvala. raddstýring gera óvirkt slökkva á raddstýringu"},{"UUID":"ce5f22b3-277a-457c-b561-0c48776dd7b2","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Fara um skjáinn með því","descFull":"Fara um skjáinn með því að nota bendingar Flestar bendingar eiga aðeins við þegar raddstýring er virk. Virkja stækkun til að nota bendingar aðdráttar og skimunar. Nota áþreifanlegt lyklaborð til að skrá staftákn og stillla ákveðnar stillingar. Bendingar og virkni þeirra Bending Virkni Strjúktu til vinstri og svo upp með einum fingri Kveikja á stillingu aðgengis. Nota sömu bendingu til að hætta í stillingu aðgengis. Þessi bending á einnig við þegar prentarinn er í venjulegri stillingu. Tvísmella með því að nota einn fingur Velja valkost eða hlut á skjánum. Tvísmella á heimatáknið með því að nota tvo fingur Slökkva á stillingu aðgengis. Þrísmella með því að nota einn fingur Aðdráttur inn eða út í texta eða myndum. Strjúktu til hægri eða strjúktu niður með einum fingri Fara í næsta hlut á skjánum. Strjúktu til vinstri eða strjúktu upp með einum fingri Fara í fyrri hlut á skjánum. Strjúktu upp og svo niður með einum fingri Fara í fyrsta hlutinn á skjánum. Skima Fara í hluta af mynd með aðdrætti sem eru fyrir utan mörk skjásins. Nota tvo fingur til að draga mynd með aðdrætti. Strjúktu upp og svo til hægri með einum fingri Hækka hljóðstyrkinn. Þessi bending á einnig við þegar prentarinn er í venjulegri stillingu. Strjúktu niður og svo til hægri með einum fingri Lækka hljóðstyrkinn. Þessi bending á einnig við þegar prentarinn er í venjulegri stillingu. Strjúktu upp og svo til vinstri með einum fingri Hætta í forriti og fara til baka í heimaskjá Strjúktu niður og svo til vinstri með einum fingri Fara til baka í fyrri stillingu. fara um skjáinn nota bendingar fara um skjáinn með því að nota bendingar"},{"UUID":"ee26980d-e060-4b4f-b5b9-737c223d70c4","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Nota hnappaborðið á skjánum Þegar","descFull":"Nota hnappaborðið á skjánum Þegar hnappaborðið á skjánum birtist, gerðu eitt af eftirfarandi: Snertu takka til að nota og slá inn staftákn í reitinn. Dragðu fingur yfir mismunandi staftákn til að nota og slá staftáknið inn í reitinn. Snertu textareit með tveimur fingrum til að nota stafina í reitnum. Snertu  Hnapp til baka  til að eyða staftáknum. hnappaborð á skjánum notar"},{"UUID":"858c8e90-03fb-4271-8f0d-759575651037","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Virkja stillingu stækkunar Í einni","descFull":"Virkja stillingu stækkunar Í einni hreyfingu og með einum fingri, strjúktu hægt til vinstri og síðan upp á skjáinn þar til þú heyrir raddskilaboð. Fyrir gerðir prentara án innbyggðra hátalara skaltu nota heyrnartól til að heyra skilaboðin. Notaðu tvo fingur, gerðu eftirfarandi: Snertu  Stækkunarstilling . Snertu  OK . Ef bendingin virkar ekki, beittu þá meiri þrýstingi. Varðandi frekari upplýsingar varðandi færslu á stækkuðum skjá, sjá  . Stækkunarstilling virkja virkja stækkunarstillingu"},{"UUID":"0c9c3e7c-eb83-4fcc-af3f-3a0c3ba009dd","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Stilla hraða á raddstýringu Frá","descFull":"Stilla hraða á raddstýringu Frá heimaskjánum, veldu  Stillingar Tæki Aðgengileiki Hraði raddstýringar . Veldu hraða tals. raddstýring hraði tals hraði raddstýringar stillir stilla hraða tals raddstýring"},{"UUID":"3846e269-94c4-4f5a-aee7-4a0182cceec6","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Stilla sjálfvalinn hljóðstyrk höfuðheyrnatóla Frá","descFull":"Stilla sjálfvalinn hljóðstyrk höfuðheyrnatóla Frá heimaskjánum, veldu  Stillingar Tæki Aðgengileiki . Stilla hljóðstyrk höfuðheyrnatóla. Hljóðstyrkur verður endurstilltur í sjálfgefið gildi eftir að notandinn fer úr stillingu aðgengis eða þegar prentarinn vaknar eftir svefn eða dvala. sjálfvalinn hljóðstyrkur höfuðheyrnartóla stillir stilla sjálfgefinn hljóðstyrk höfuðtól"},{"UUID":"0831f819-701e-49d0-8c19-df6e3c88d691","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Stilla sjálfvalinn hljóðstyrk innri hátalara","descFull":"Stilla sjálfvalinn hljóðstyrk innri hátalara Frá heimaskjá, snertu  . Stilla hljóðstyrkinn. Ef hljóðlát stilling er valin er slökkt á öllum hljóðviðvörunum. Þessi stilling hægir einnig á frammistöðu prentarans. Hljóðstyrkur verður endurstilltur í sjálfgefið gildi eftir að notandinn fer úr stillingu aðgengis eða þegar prentarinn vaknar eftir svefn eða dvala. sjálfvalinn hljóðstyrkur hátalara stillir stilla sjálfgefinn hljóðstyrk hátalari"},{"UUID":"afecfb8e-e0dd-472a-89d8-8ef982648bc9","title":"Setja upp og nota eiginleika aðgengis","link":"activating-voice-guidance-topic.html","desc":"Virkja töluð aðgangsorð eða persónuauðkennanleg","descFull":"Virkja töluð aðgangsorð eða persónuauðkennanleg númer (PIN) Frá heimaskjánum, snertu  Stillingar Tæki Aðgengileiki Tala aðgangsorð/persónuauðkennanleg númer (PIN) . Virkja stillinguna. töluð aðgangsorð virkja persónuauðkennanleg númer (PIN) virkja virkja töluð aðgangsorð virkja persónuauðkennanleg númer"},{"UUID":"2df6f150-998e-45fe-b41a-dcc90953f960","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Stutt fax Hliðstætt fax Þarfnast","descFull":"Stutt fax Hliðstætt fax Þarfnast uppsetts faxkorts. Hafðu samband við þann stað sem þú keyptir prentarann varðandi frekari upplýsingar. etherFAX Þarfnast áskriftar. Varðandi frekari upplýsingar, farðu á  https://www.etherfax.net/lexmark  eða hafðu samband við þann stað sem þú keyptir prentarann. Fax yfir IP (FoIP) Þarfnast uppsetts leyfispakka. Hafðu samband við þann stað sem þú keyptir prentarann varðandi frekari upplýsingar. Faxþjónn stutt fax"},{"UUID":"0a077222-8e3c-47fd-85cf-0883b0fb1e77","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Setja upp faxaðgerð sem notar","descFull":"Setja upp faxaðgerð sem notar hliðstætt fax Setja þarf upp faxkort til að prentarinn geti notað hliðrænt fax. Sumar aðferðir við tengingu eiga aðeins við í sumum löndum eða svæðum. Ef faxaðgerð er virk og ekki uppsett að fullu þá gæti gaumljósið blikkað með rauðu ljósi. Ef þú ert ekki með TCP/IP-umhverfi, notaðu þá stjórnborð prentara til að setja upp faxið. Til að forðast gagnatap eða truflun, ekki snerta snúrur eða prentarann á þeim svæðum sem eru sýnd þegar sending eða móttaka á faxi er virk. Nota valmyndina  Stillingar  í prentaranum Af heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Almennar stillingar á faxi . Settu upp stillingarnar. Nota innbyggða vefþjóninn Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjánum. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Fax Uppsetning á faxi Almennar stillingar á faxi . Settu upp stillingarnar. Beittu breytingunum. hliðstætt fax uppsetning uppsetning hliðstætt fax"},{"UUID":"912d1386-db10-435f-8871-eec57d8414b8","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Setja upp faxaðgerð sem notar","descFull":"Setja upp faxaðgerð sem notar etherFAX Fastbúnaður prentara verður að vera uppfærður í nýjustu útgáfu. Varðandi frekari upplýsingar, sjá  . Viðeigandi leyfispakki verður að vera uppsettur í prentaranum þínum. Varðandi frekari upplýsingar, hafðu samband við etherFAX. Gakktu úr skugga um að þú hafir skráð prentarann þinn í etherFAX gáttina. Varðandi frekari upplýsingar, farðu á  https://www.etherfax.net/lexmark . Raðnúmers prentara er krafist við skráningu. Til að finna raðnúmerið, sjá  . Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjánum. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Fax Uppsetning á faxi Almennar stillingar á faxi . Uppsetning á faxi  birtist aðeins ef  Fax-stilling  er stillt á  Fax . Í svæði  Heiti á faxi  skráðu einkvæmt heiti. Í svæði  Faxnúmer  skráðu faxnúmerið sem etherFAX lét í té. Í valmyndinni  Flutningur á faxi  veldu  etherFAX . Þessi valmynd birtist aðeins þegar fleiri en einn faxflutningur er tiltækur. Ef aðeins etherFAX er uppsett á prentaranum er það sjálfkrafa stillt. Beittu breytingunum. etherFAX setja upp faxaðgerð setja upp faxaðgerð nota etherFAX"},{"UUID":"151b2bb1-9d56-4aeb-a557-a7d39cc975a7","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Setja upp aðgerð á faxi","descFull":"Setja upp aðgerð á faxi með því að nota faxþjón Þessi aðgerð gerir þér kleift að senda faxskilaboð til faxþjónustuveitu sem styður móttöku tölvupósts. Þessi eiginleiki styður aðeins föx á útleið. Til að styðja við faxmóttöku skaltu ganga úr skugga um að þú hafir fax sem byggir á tæki, svo sem hliðrænt fax, etherFAX eða Fax yfir IP (FoIP), í prentaranum. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjánum. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Fax . Í valmyndinni  Faxstillingar  veldu  Faxþjónn , og smelltu síðan á  Vista . Smelltu á  Uppsetning faxþjóns . Í svæðinu  Til að sníða  skráðu  [#]@myfax.com , þar sem  [#]  er faxnúmerið og  myfax.com  er lén faxveitunnar. Ef þörf krefur, stilltu svæðin  Vistfang svars ,  Efni , eða  Skilaboð . Til að láta prentarann taka á móti faxskilaboðum skaltu virkja stillinguna fyrir tækið í prentaranum til að taka á móti faxi. Gangtu úr skugga um að þú sért með fax í prentaranum uppsett. Smelltu á  Vista . Smelltu á  Stillingar tölvupósts í faxþjóni , og gerðu síðan annað af eftirfarandi: Virkja  Nota SMTP þjón tölvupósts . Ef SMTP stillingar tölvupósts eru ekki stilltar, skoðaðu þá  . Stilla SMTP-stillingarnar. Hafðu samband við þína veitu tölvupósts varðandi frekari upplýsingar. Beittu breytingunum. faxþjónn, notar setja upp fax aðgerðina setja upp fax aðgerðina með því að nota faxþjón"},{"UUID":"6627b548-1cff-42fd-be0c-61c10dc15b11","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Setja upp fax með því","descFull":"Setja upp fax með því að nota venjulega símalínu. Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Varðandi frekari upplýsingar, sjá  . Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Til að koma í veg fyrir hættu á raflosti skal ekki setja upp þessa vöru eða tengja einhverjar rafmagns- og kaplatengingar, svo sem rafmagnsleiðslu, faxeiginleika eða síma, á meðan á eldingarveður gengur yfir. Til að koma í veg fyrir hættu á raflosti, notið ekki fax eiginleikann í þrumuveðri. Til að draga úr hættu á eldsvoða, notið aðeins 26 AWG eða stærri samskiptasnúru (RJ-11) þegar þessi vara er tengd við almennt símkerfi. Fyrir notendur í Ástralíu verður snúran að vera samþykkt af yfirvöldum samskipta og miðla í Ástralíu (Australian Communications and Media Authority). Uppsetning 1: Prentarinn er tengdur við sérnota faxlínu Tengdu annan endann á símasnúru við línutengi á prentaranum. Tengdu hinn enda símasnúrunnar í virkt hliðrænt veggtengi. Þú getur stillt prentarann til að taka við faxsendingum sjálfvirkt (stilling á  sjálfvirkri svörun  á  Kveikt ) eða handvirkt (stilling á  sjálfvirkri svörun  á  Slökkt  ). Ef þú vilt taka sjálfvirkt á móti faxsendingum, stilltu þá prentarann til að svara eftir tiltekinn fjölda hringinga. Uppsetning 2: Prentarinn er að deila línu með símsvara Ef þú ert áskrifandi að sérstakri hringiþjónustu vertu þá viss um að þú stilltir rétt hringimynstur fyrir prentarann. Að öðrum kosti tekur prentarinn ekki á móti faxsendingum jafnvel þótt þú hafir stillt hann til að taka sjálfvirkt við faxsendingum. Tengdur við annað veggtengi Tengdu annan endann á símasnúru við línutengi á prentaranum. Tengdu hinn enda símasnúrunnar í virkt hliðrænt veggtengi. Ef þú ert aðeins með eitt símanúmer á línunni þinni, þá þarf að stilla prentarann til að taka sjálfvirkt við faxsendingum. Stilltu prentarann til að taka við símhringingum tveimur hringingum á eftir símsvaranum. Til dæmis, ef símsvarinn svarar eftir fjórar hringingar þá á að setja stillingu prentarans í  Hringingar að svörun  á  6 . setja upp fax staðaltenging símalínu uppsetning á faxi staðaltenging símalínu símsvari uppsetning"},{"UUID":"38299fca-ddae-4b9f-a8e6-895709ccfb00","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Setja upp fax í löndum","descFull":"Setja upp fax í löndum eða svæðum með öðru vísi veggtengjum og tengjum. Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Varðandi frekari upplýsingar, sjá  . Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Til að koma í veg fyrir hættu á raflosti skal ekki setja upp þessa vöru eða tengja einhverjar rafmagns- og kaplatengingar, svo sem rafmagnsleiðslu, faxeiginleika eða síma, á meðan á eldingarveður gengur yfir. Til að koma í veg fyrir hættu á raflosti, notið ekki fax eiginleikann í þrumuveðri. Til að draga úr hættu á eldsvoða, notið aðeins 26 AWG eða stærri samskiptasnúru (RJ-11) þegar þessi vara er tengd við almennt símkerfi. Fyrir notendur í Ástralíu verður snúran að vera samþykkt af yfirvöldum samskipta og miðla í Ástralíu (Australian Communications and Media Authority). Staðalgerð veggtengis sem flest lönd eða svæði hafa tekið upp er RJ-11. Ef veggtengi eða búnaður á þínum stað er ekki með þessari tegund af tengi, notaðu þá símamillistykki. Millistykki fyrir land eða svæði kunna ekki að koma með prentarann, og þú gætir þurft að kaupa það sérstaklega. Það kann að vera millistykki uppsett í símatengi á prentaranum. Ekki fjarlægja millistykkið úr símatengi prentarans ef þú ert að tengjast raðtengdu eða keðjutengdu símakerfi. Hlutanúmer millistykkis Heiti hlutar Hlutanúmer Lexmark millistykki 40X8519 Tengja prentarann við veggtengi sem er ekki RJ-11. Tengdu annan endann á símasnúru við línutengi á prentaranum. Tengdu hinn enda símasnúrunnar í RJ-11 millistykkið, og tengdu síðan millistykkið í veggtengið. Ef þú vilt tengja annað tæki sem er ekki með RJ-11 tengi í sama veggtengi, tengdu það þá beint við símamillistykkið. uppsetning á faxi sérstakt fyrir land eða svæði setja upp fax sérstakt fyrir land eða svæði RJ‑11 millistykki millitengi"},{"UUID":"27dff845-411f-4d27-b4c8-86153ba446e0","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Tengjast sérstakri hringiþjónustu Sérstök hringiþjónusta","descFull":"Tengjast sérstakri hringiþjónustu Sérstök hringiþjónusta lætur þig fá mörg símanúmer á einni símalínu. Hvert símanúmer fær úthlutað mismunandi hringimynstri. Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Varðandi frekari upplýsingar, sjá  . Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Frá heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Móttökustillingar á faxi Stillingar stjórnanda Svara á . Veldu hringimynstur sérstök hringiþjónusta, fax virkja tengja prentara við sérstaka hringiþjónustu tengja prentarann við hringimynstur"},{"UUID":"f6f2d63b-c860-4d76-9604-20c304fe1130","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Stilla dagsetningu á faxi og","descFull":"Stilla dagsetningu á faxi og tíma Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Frá heimaskjánum, snertu  Stillingar Tæki Kjörstillingar Dagsetning og tími Setja upp . Settu upp stillingarnar. senda fax stilla dagsetningu og tíma dagsetning og tími faxstillingar"},{"UUID":"a3db4c93-7cc7-458c-9a67-88229c7a7df0","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Stilla sumartíma Gangtu úr skugga","descFull":"Stilla sumartíma Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Frá heimaskjánum, snertu  Stillingar Tæki Kjörstillingar Dagsetning og tími Setja upp . Í valmynd fyrir  Tímabelti  snertu  (UTC+notandi) sérsnið . Snertu  UTC (GMT) hliðrun , og settu upp stillingarnar. stilla sumartíma sumartími stillir"},{"UUID":"c3b551fe-9d49-4ed1-91fa-1e5dc0f31713","title":"Setja upp prentarann til að senda fax","link":"setting-up-printer-to-fax-group.html","desc":"Setja upp stillingar hátalara fyrir","descFull":"Setja upp stillingar hátalara fyrir fax Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Af heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Stillingar hátalara . Gerðu eftirfarandi: Stilltu  Stillingu hátalara  á  Alltaf á . Stilltu  Hljóðstyrk hátalara  á  Hátt . Virkja  hljóðstyrk hringingar . setja upp stillingar hátalara fyrir fax stillingar hátalara fyrir fax stillir"},{"UUID":"b68c6570-776a-4f07-8a02-2463c8a07f7f","title":"Setja upp, setja inn og stilla","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"Setja upp SMTP stillingar tölvupósts","descFull":"Setja upp SMTP stillingar tölvupósts Stillta SMTP-stillingar (Simple Mail Transfer Protocol) til að senda skannað skjal í tölvupósti. Stillingar eru mismunandi hjá hverri þjónustu tölvupósts. Áður en þú byrjar skaltu ganga úr skugga um að prentarinn sé tengdur við netkerfi og að netið sé tengt internetinu. Nota innbyggða vefþjóninn Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Tölvupóstur . Í kaflanum  Uppsetning á tölvupósti  stilltu stillingarnar. Hafðu samband við  lista yfir þína veitu tölvupósts  varðandi frekari upplýsingar. Fyrir tölvupóstþjónustur sem ekki eru á listanum skaltu hafa samband við þjónustuveituna þína og biðja um stillingarnar. Smelltu á  Vista . Nota valmyndina  Stillingar  í prentaranum Frá heimaskjánum, snertu  Stillingar Tölvupóstur Uppsetning tölvupósts . Settu upp stillingarnar. Hafðu samband við  lista yfir þína veitu tölvupósts  varðandi frekari upplýsingar. Fyrir tölvupóstþjónustur sem ekki eru á listanum skaltu hafa samband við þjónustuveituna þína og biðja um stillingarnar. Þjónustur tölvupósts AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live eða Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Ef þú lendir í villum með því að nota stillingarnar skaltu hafa samband við tölvupóstþjónustuna þína. Varðandi beitur tölvupóstþjónustu sem ekki eru á listanum hafðu samband við þjónustuveituna þína. AOL Mail Stilling fyrir AOL Mail Stilling Gildi Aðal SMTP-gátt smtp.aol.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð apps  Til að búa til aðgangsorð fyrir app, farðu á síðuna  AOL Account Security  skráðu þig inn á þinn reikning, og smelltu síðan á  Búa til aðgangsorð apps . Comcast Mail Stillingar fyrir Comcast Mail Stilling Gildi Aðal SMTP-gátt smtp.comcast.net Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð reiknings Gakktu úr skugga um að aðgangsöryggisstilling þriðja aðila sé virkjuð á reikningnum þínum. Varðandi frekari upplýsingar, farðu á  hjálparsíðu Comcast Xfinity Connect . Gmail Vertu viss um að tveggja þrepa sannvottun sé virk á þínum Google reikningi. Til að virkja tveggja þrepa sannvottun, farðu á síðuna  Google Account Security  skráðu þig inn á reikninginn þinn, og í kaflanum „ Skrá inn í Google “ smelltu á  2ja þrepa sannvottun . SMTP stillingar fyrir Gmail Stilling Gildi Aðal SMTP-gátt smtp.gmail.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð apps Til að búa til aðgangsorð fyrir app, farðu á síðuna  Google Account Security  skráðu þig inn á reikninginn þinn, og síðan frá kaflanum „ Skrá inn í Google ” smelltu á  Aðgangsorð apps . „ App passwords “ sést aðeins ef tveggja þrepa sannvottun er virk. iCloud Mail Gangtu úr skugga um að tveggja þrepa sannvottun sé virk á reikningnum þínum. Stillingar fyrir iCloud Mail Stilling Gildi Aðal SMTP-gátt smtp.mail.me.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð apps Til að búa til aðgangsorð fyrir app, farðu á síðuna  iCloud Account Management  skráðu þig inn á reikninginn þinn, og síðan frá kaflanum  Öryggi  smelltu á  Búa til aðgangsorð . Mail.com Stillingar fyrir Mail.com Stilling Gildi Aðal SMTP-gátt smtp.mail.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð reiknings NetEase Mail (mail.126.com) Gangtu úr skugga um að SMTP þjónusta sé virk á reikningnum þínum. Til að virkja þjónustuna, frá heimasíðu NetEase Mail, smelltu á  Stillingar POP3/SMTP/IMAP  og virkjaðu síðan annað hvort  IMAP/SMTP þjónustu  eða  POP3/SMTP þjónustu . Stillingar fyrir NetEase Mail (mail.126.com) Stilling Gildi Aðal SMTP-gátt smtp.126.com Aðaltengi SMTP-gáttar 465 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð heimildar Aðgangsorð heimildar er látið í té þegar  IMAP/SMTP þjónusta  eða  POP3/SMTP þjónusta  er virk. NetEase Mail (mail.163.com) Gangtu úr skugga um að SMTP þjónusta sé virk á reikningnum þínum. Til að virkja þjónustuna, frá heimasíðu NetEase Mail, smelltu á  Stillingar POP3/SMTP/IMAP  og virkjaðu síðan annað hvort  IMAP/SMTP þjónustu  eða  POP3/SMTP þjónustu . Stillingar fyrir NetEase Mail (mail.163.com) Stilling Gildi Aðal SMTP-gátt smtp.163.com Aðaltengi SMTP-gáttar 465 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð heimildar Aðgangsorð heimildar er látið í té þegar  IMAP/SMTP þjónusta  eða  POP3/SMTP þjónusta  er virk. NetEase Mail (mail.yeah.net) Gangtu úr skugga um að SMTP þjónusta sé virk á reikningnum þínum. Til að virkja þjónustuna, frá heimasíðu NetEase Mail, smelltu á  Stillingar POP3/SMTP/IMAP  og virkjaðu síðan annað hvort  IMAP/SMTP þjónustu  eða  POP3/SMTP þjónustu . Stillingar fyrir NetEase Mail (mail.yeah.net) Stilling Gildi Aðal SMTP-gátt smtp.yeah.net Aðaltengi SMTP-gáttar 465 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð heimildar Aðgangsorð heimildar er látið í té þegar  IMAP/SMTP þjónusta  eða  POP3/SMTP þjónusta  er virk. Outlook Live eða Microsoft 365 Þessar stillingar eiga við um lén outlook.com og hotmail.com og reikninga Microsoft 365. Stillingar fyrir Outlook Live eða Microsoft 365 Stilling Gildi Aðal SMTP-gátt smtp.office365.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð reiknings eða aðgangsorð apps Notaðu aðgangsorð reikningsins þíns fyrir reikninga með tveggja þrepa staðfestingu óvirka. Notaðu aðgangsorð apps fyrir reikninga outlook.com eða hotmail.com með tveggja þrepa staðfestingu virka. Til að búa til aðgangsorð apps, farðu á síðuna  Outlook Live Account Management  og skráðu þig síðan inn á reikninginn þinn. Fyrir frekari uppsetningarvalkosti fyrir fyrirtæki sem nota Microsoft 365, farðu á  hjálparsíðu Microsoft 365 . QQ Mail Gangtu úr skugga um að SMTP þjónusta sé virk á reikningnum þínum. Til að virkja þjónustuna, frá heimasíðu QQ Mail, smelltu á  Stillingar Reikningur . Í kaflanum  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  virkjaðu annað hvort  POP3/SMTP þjónustu  eða  IMAP/SMTP þjónustu . Stillingar fyrir QQ Mail Stilling Gildi Aðal SMTP-gátt smtp.qq.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Kóði heimildar Til að búa til kóða heimildar frá heimasíðu QQ Mail, smelltu á  Stillingar Reikningur , og síðan frá kaflanum  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service , smelltu á  Búa til kóða heimildar . Sina Mail Gangtu úr skugga um að POP3/SMTP þjónustan sé virk á þínum reikningi. Til að virkja þjónustuna, frá heimasíðu Sina Mail, smelltu á  Stillingar Fleiri stillingar POP/IMAP/SMTP endanotanda  og virkjaðu síðan  POP3/SMTP þjónustu . Stillingar fyrir Sina Mail Stilling Gildi Aðal SMTP-gátt smtp.sina.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Kóði heimildar Til að búa til kóða heimildar frá heimasíðu netfangs, smelltu á  Stillingar Fleiri stillingar POP/IMAP/SMTP endanotanda  og virkjaðu síðan  Stöðu kóða heimildar . Sohu Mail Gangtu úr skugga um að SMTP þjónusta sé virk á reikningnum þínum. Til að virkja þjónustuna, frá heimasíðu Sohu Mail, smelltu á  Valkostir Stillingar POP3/SMTP/IMAP  og virkjaðu síðan annað hvort  IMAP/SMTP þjónustu  eða  POP3/SMTP þjónustu . Stillingar fyrir Sohu Mail Stilling Gildi Aðal SMTP-gátt smtp.sohu.com Aðaltengi SMTP-gáttar 465 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Sjálfstætt aðgangsorð Sjálfstæða aðgangsorðið er veitt þegar  IMAP/SMTP þjónusta  eða  POP3/SMTP þjónusta  er virk. Yahoo! Mail Stillingar Yahoo! Mail Stilling Gildi Aðal SMTP-gátt smtp.mail.yahoo.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð apps  Til að búa til aðgangsorð apps, farðu á síðuna  Yahoo Account Security  skráðu þig inn á reikninginn þinn og smelltu síðan á  Búa til aðgangsorð apps . Zoho Mail Stillingar fyrir Zoho Mail Stilling Gildi Aðal SMTP-gátt smtp.zoho.com Aðaltengi SMTP-gáttar 587 Nota SSL/TLS Þarfnast Krefjast áreiðanlegs vottorðs Óvirkt Vistfang svörunar Þitt tölvupóstfang Sannvottun á SMTP-þjóni Innskráning / venjuleg Tölvupóstur að frumkvæði tækis Nota SMTP-réttindi tækis Notandaauðkenni tækis Þitt tölvupóstfang Aðgangsorð tækis Aðgangsorð reiknings eða aðgangsorð apps Notaðu aðgangsorð reikningsins þíns fyrir reikninga með tveggja þrepa staðfestingu óvirka. Notaðu aðgangsorð apps fyrir reikninga með tveggja þrepa staðfestingu virka. Til að búa til aðgangsorð apps, farðu á síðuna  Zoho Mail Account Security  skráðu þig inn á reikninginn þinn og síðan frá kaflanum  Application‑Specific Passwords  smelltu á  Búa til nýtt aðgangsorð . þjónustur tölvupósts setja upp stillingar miðlara tölvupósts SMTP stillingar stillir aðgerð tölvupósts uppsetning tölvupóstþjónn stillir"},{"UUID":"84d5659d-e34a-4b89-bdb3-52b440b5c366","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Stilla stærðir og gerð á","descFull":"Stilla stærðir og gerð á sérstökum miðli. Skúffurnar uppgötva sjálfkrafa stærð á venjulegum pappír. Fyrir sérstaka miðla eins og miða, þykkan pappír eða umslög, gerðu eftirfarandi: Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð  veldu uppruna pappírs. Stilltu stærð og gerð á sérstökum miðli. stilla pappírsstærðina stilla pappírsgerðina pappírsstærð stillir pappírsgerð stillir"},{"UUID":"90691515-3602-4d6a-9121-00cb7fed61b3","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Stilla alhliða pappírsstillingar Frá heimaskjánum,","descFull":"Stilla alhliða pappírsstillingar Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning á miðli Alhliða uppsetning . Settu upp stillingarnar. pappír Alhliða stærðarstilling stilla alhliða pappírsstærð Alhliða pappírsstærð stilling"},{"UUID":"bf91ea82-6467-4d81-928f-8ad89c105bad","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Virkja stillinguna  Margar alhliða","descFull":"Virkja stillinguna  Margar alhliða stærðir Á heimaskjánum, snertu  Stillingar Tæki Viðhald Valmynd uppsetningar Uppsetning skúffu . Virkjaðu stillinguna  Margar alhliða stærðir . Margar alhliða stærðir virkja stilla pappírsstærð Margar alhliða stærðir"},{"UUID":"2e45550f-85bf-4e10-bd77-c2ac1df45697","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Hlaða 520‑blaða skúffu Hlaðið í","descFull":"Hlaða 520‑blaða skúffu Hlaðið í hverja skúffu fyrir sig inn til að koma í veg fyrir óstöðugleika tækisins. Haldið öllum öðrum skúffum lokuðum þar til þörf er á. Dragðu skúffuna út. Ekki toga út skúffur þegar prentarinn er upptekinn, til að komast hjá flækjum. Stilltu stýringarnar til að samvara stærð á pappír sem verið er að hlaða. Notið vísun á stærð pappírs í botni skúffu til að staðsetja stýringarnar. Sveigðu, blaðaðu og jafnaðu pappírsbrúnir áður en pappírnum er hlaðið. Hlaðið pappírsstaflanum með prenthliðina upp. Þegar verið er að hlaða bréfhaus eða forstimplaðan pappír, gerðu annað af eftirfarandi: Fyrir prentun á eina hlið, löng brún Hladdu pappír með bréfhaus snúandi upp og í átt að aftari hluta skúffunnar. Hladdu forstimpluðum pappír snúandi upp með götin vinstra megin í skúffunni. Fyrir prentun á eina hlið, stutt brún Hladdu pappír með bréfhaus snúandi upp og í átt að vinstri hlið skúffunnar. Hladdu forstimpluðum pappír snúandi upp með götin í átt að framhlið skúffunnar. Fyrir prentun á tvær hliðar, löng brún Hladdu pappír með bréfhaus snúandi niður og í átt að aftari hluta skúffunnar. Hladdu forstimpluðum pappír snúandi niður með götin hægra megin í skúffunni. Fyrir prentun á tvær hliðar, stutt brún Hladdu pappír með bréfhaus snúandi niður og í átt að vinstri hlið skúffunnar. Hladdu forstimpluðum pappír snúandi niður með götin í átt að aftari hluta skúffunnar. Ekki renna pappírnum í skúffuna. Vertu viss um að hliðarstýringarnar passi þétt upp við pappírinn. Vertu viss um að hæð á stafla sé fyrir neðan vísun á hámarksfyllingu. Yfirfylling getur valdi flækju. Settu skúffuna inn. Ef þörf krefur, stilltu stærð pappírs og gerð til að samsvara pappír sem er í skúffunni. Þegar frágangseining er sett upp er myndunum snúið í 180° þegar þær eru prentaðar.when printed. 520‑blaða skúffa hlaða hlaða 520‑blaða skúffu hlaða skúffur"},{"UUID":"df16422e-fc47-41e6-a6f1-dc3c597eaa9f","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Hlaða 2520‑blaða samstæðuskúffu Hlaðið í","descFull":"Hlaða 2520‑blaða samstæðuskúffu Hlaðið í hverja skúffu fyrir sig inn til að koma í veg fyrir óstöðugleika tækisins. Haldið öllum öðrum skúffum lokuðum þar til þörf er á. Dragðu skúffuna út. Ekki toga út skúffur þegar prentarinn er upptekinn, til að komast hjá flækjum. Stilltu stýringarnar til að samvara stærð á pappír sem verið er að hlaða. Sveigðu, blaðaðu og jafnaðu pappírsbrúnir áður en pappírnum er hlaðið. Settu pappírinn í. Fyrir prentun á einni hlið, hladdu pappír með prenthliðina upp. Fyrir prentun á tvær hliðar, hladdu pappír með prenthliðina niður. Þegar verið er að hlaða bréfhaus eða forgötuðum pappír, gerðu annað af eftirfarandi: Fyrir prentun á einni hlið Hladdu pappír með bréfhaus snúandi upp og í átt að aftari hluta skúffunnar. Hladdu forgötuðum pappír snúandi upp með götin vinstra megin í skúffunni. Fyrir prentun á tvær hliðar Hladdu pappír með bréfhaus snúandi niður og í átt að aftari hluta skúffunnar. Hladdu forgötuðum pappír snúandi niður með götin hægra megin í skúffunni. Ekki renna pappírnum í skúffuna. Vertu viss um að hæð á stafla sé fyrir neðan vísun á hámarksfyllingu. Yfirfylling getur valdi flækju. Settu skúffuna inn. Ef þörf krefur, stilltu stærð pappírs og gerð til að samsvara pappír sem er í skúffunni. Þegar frágangseining er sett upp er myndunum snúið í 180° þegar þær eru prentaðar. 2520-blaða samstæðuskúffa hlaða hlaða 2520-blaða samstæðuskúffu hlaða skúffur"},{"UUID":"66703d97-769f-462a-9e62-b1af63e83579","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Hlaða 2000‑blaða skúffu Hlaðið í","descFull":"Hlaða 2000‑blaða skúffu Hlaðið í hverja skúffu fyrir sig inn til að koma í veg fyrir óstöðugleika tækisins. Haldið öllum öðrum skúffum lokuðum þar til þörf er á. Dragðu skúffuna út og opnaðu síðan hurðina á hlið skúffunnar. Ekki toga út skúffur þegar prentarinn er upptekinn, til að komast hjá flækjum. Stilltu stýringuna aftan á skúffunni. Gerðu það sama framan á skúffunni. Stilltu stöngina á hurðinni á hlið skúffunnar. Sveigðu, blaðaðu og jafnaðu pappírsbrúnir áður en pappírnum er hlaðið. Hlaðið pappírsstaflanum með prenthliðina upp. Þegar verið er að hlaða bréfhaus eða forgataðan pappír, gerðu annað af eftirfarandi: Fyrir prentun á einni hlið Hladdu pappír með bréfhaus snúandi niður og í átt að aftari hluta skúffunnar. Hladdu forgötuðum pappír snúandi niður með götin vinstra megin í skúffunni. Fyrir prentun á tvær hliðar Hladdu pappír með bréfhaus snúandi upp og í átt að aftari hluta skúffunnar. Hladdu forgötuðum pappír snúandi upp með götin vinstra megin í skúffunni. Vertu viss um að hæð á stafla sé fyrir neðan vísun á hámarksfyllingu. Yfirfylling getur valdi flækju. Lokaðu hurðinni á hlið skúffunnar og settu síðan inn skúffuna.. Ef þörf krefur, stilltu stærð pappírs og gerð til að samsvara pappír sem er í skúffunni. Þegar frágangseining er sett upp er myndunum snúið í 180° þegar þær eru prentaðar. 2520-blaða samstæðuskúffa hlaða hlaða 2520-blaða samstæðuskúffu"},{"UUID":"74021c85-86fa-4eb8-9a6b-3a96398927fa","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Hlaða skúffa fyrir umslög Hlaðið","descFull":"Hlaða skúffa fyrir umslög Hlaðið í hverja skúffu fyrir sig inn til að koma í veg fyrir óstöðugleika tækisins. Haldið öllum öðrum skúffum lokuðum þar til þörf er á. Dragðu skúffuna fyrir umslög út. Ekki toga út skúffur þegar prentarinn er upptekinn, til að komast hjá flækjum. Sveigðu, blaðaðu og jafnaðu umslög áður en þeim er hlaðið. Stilltu stýringarnar til að samvara stærð á umslagi sem verið er að hlaða. Notið vísun á stærð pappírs í botni skúffu til að staðsetja stýringarnar. Hladdu umslögum með hlið með flipa niður og að vinstri hlið á skúffunni. Vertu viss um að hliðarstýringarnar passi þétt upp við umslögin. Vertu viss um að hæð á stafla sé fyrir neðan vísun á hámarksfyllingu. Yfirfylling getur valdi flækju. Settu skúffuna inn. Ef þörf krefur, stilltu stærð pappírs og gerð til að samsvara umslaginu sem er í skúffunni. skúffa fyrir umslög hlaða hlaða skúffu fyrir umslög"},{"UUID":"558c628c-ec55-458c-b62e-e87bd1de4019","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Hlaða í fjölnotamatara Opnaðu fjölnotamatarann.","descFull":"Hlaða í fjölnotamatara Opnaðu fjölnotamatarann. Stilltu hliðarstýringarnar til að samvara stærð á pappír sem verið er að hlaða. Sveigðu, blaðaðu og jafnaðu pappírsbrúnir áður en pappírnum er hlaðið. Settu pappírinn í. Vertu viss um að hliðarstýringarnar passi þétt upp við pappírinn. Fyrir mötun með langri brún: Hlaðið pappír með bréfhaus snúandi niður og í átt að aftari hluta prentarans fyrir prentun á eina hlið. Hladdu forgötuðum pappír snúandi niður með götin hægra megin á pappírnum. Hladdu pappír með bréfhaus snúandi upp og í átt að aftari hluta prentarans fyrir prentun á báðar hliðar. Hladdu forgötuðum pappír snúandi upp með götin vinstra megin á pappírnum. Fyrir mötun með stuttri brún: Hladdu pappír með bréfhaus snúandi niður og í átt að vinstri hlið pappírsins fyrir prentun á eina hlið. Hladdu forgötuðum pappír snúandi niður með götin í átt að framhlið prentarans. Hladdu pappír með bréfhaus snúandi niður og í átt að hægri hlið pappírsins fyrir prentun á báðar hliðar. Hladdu forgötuðum pappír snúandi upp með götin í átt afturhlið prentarans. Þegar frágangseining er sett upp snýr prentarinn myndunum í 180°. fjölnotamatari hlaða hlaða fjölnotamatara hlaða bréfhaus hlaða forgötuðum pappír"},{"UUID":"d6ae14cf-85fe-4e29-94fe-ce404570f44e","title":"Setja í pappír og sérstaka miðla","link":"loading-trays-group.html","desc":"Tengja skúffur Frá heimaskjánum, snertu","descFull":"Tengja skúffur Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu veldu uppruna pappírs. Stilla sömu pappírsstærð og pappírsgerð fyrir skúffur sem þú ert að tengja. Á heimaskjánum, snertu  Stillingar Tæki Viðhald Valmynd uppsetningar Uppsetning skúffu Tenging skúffu . Snertu  Sjálfvirkt . Til að aftengja bakka skaltu ganga úr skugga um að engar skúffur séu með sömu stillingar á pappírsstærð eða gerð. Hitastig á hitagjafa er breytilegt og fer eftir skilgreindri pappírsgerð. Samstilltu stillingar á pappírsgerð í prentaranum við pappírinn sem hlaðið er í skúffuna til að komast hjá vandamálum í prentun. aftengir skúffur tengja skúffur skúffur tengir skúffur aftengir"},{"UUID":"e2fc1023-2384-4209-ad01-1cc8cf4ba50d","title":"Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað","link":"installing-printer-software-topic.html","desc":"Setja upp hugbúnað prentara Prentrekilinn","descFull":"Setja upp hugbúnað prentara Prentrekilinn er innifalinn í uppsetningarpakka hugbúnaðar. Fyrir Macintosh tölvur með macOS útgáfu 10.7 eða nýrri þarftu ekki að setja upp rekilinn til að prenta á AirPrint-vottaðan prentara. Ef þú vilt sértæka eiginleika prentunar, hladdu þá niður prentreklinum. Náðu í afrit af uppsetningarbúnaði hugbúnaðar. Á geisladiski hugbúnaðar sem fylgdi með prentaranum. Farðu á  www.lexmark.com/downloads . Farðu á  www.dell.com/support/printers . Á vefsíðunni okkar eða á þeim stað sem þú keyptir prentarann. Keyrðu uppsetningarforritið og fylgdu leiðbeiningum sem birtast á tölvuskjánum. setur upp hugbúnað prentara prenthugbúnaður setja upp setja upp rekil fyrir prentara prentrekill setja upp"},{"UUID":"5fc3fd61-8033-4751-8a22-d18787f99898","title":"Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað","link":"installing-printer-software-topic.html","desc":"Setja upp faxrekilinn Farðu á","descFull":"Setja upp faxrekilinn Farðu á  www.lexmark.com/downloads , leitaðu að þinni gerð prentara, og hladdu síðan niður viðeigandi uppsetningarpakka. Farðu á heimasíðu okkar eða staðinn þar sem þú keyptir prentarann og náðu í uppsetningarpakkann. Farðu á  www.dell.com/support , og hladdu síðan niður viðeigandi uppsetningarpakka. Á tölvunni þinni, smelltu á  Eiginleika prentara , og farðu síðan á flipann  Uppsetning . Keyrðu uppsetningarforritið og fylgdu leiðbeiningum sem birtast á tölvuskjánum. Veldu  Fax , og smelltus íðan á  Nota . faxrekill setja upp setja upp rekil fyrir fax"},{"UUID":"61077937-7170-44d5-8f36-fd625d0c7adf","title":"Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað","link":"installing-printer-software-topic.html","desc":"Uppfæra fastbúnað Uppfærðu fastbúnað prentarans","descFull":"Uppfæra fastbúnað Uppfærðu fastbúnað prentarans reglulega til að bæta frammistöðu prentarans og lagfæra vandamál. Varðandi nánari upplýsingar um uppfærslu á fastbúnaði, hafðu samband við þinn söluaðila Lexmark. Varðandi nánari upplýsingar um uppfærslu á fastbúnaði, hafðu samband við þinn söluaðila Dell. Varðandi nánari upplýsingar um uppfærslu á fastbúnaðinum, hafðu samband við þinn söluaðila. Til að sækja nýjasta fastbúnað, farðu á  www.lexmark.com/downloads , og leitaðu síðan að þinni gerð prentara. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Tæki Uppfæra fastbúnað . Gerðu annað hvort af eftirfarandi: Smelltu á  Athuga varðandi uppfærslur Ég samþykki, hefja uppfærslu . Hlaða upp flasskrá. Skoða flass-skrána. Vertu viss um að hafa dregið út zip-skrá fastbúnaðar. Smelltu á  Hlaða upp Byrja . uppfæra fastbúnað fastbúnaður, uppfæra"},{"UUID":"a5bf2227-e584-4346-bd11-27a7fcfbcc68","title":"Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað","link":"installing-printer-software-topic.html","desc":"Bæta prenturum við tölvu Gerðu","descFull":"Bæta prenturum við tölvu Gerðu eitt af eftirfarandi, áður en þú byrjar: Tengdu prentarann og tölvuna við sama netkerfi. Varðandi frekari upplýsingar um að tengja prebtarann við netkerfi, sjá  . Tengja tölvuna við prentarann. Varðandi frekari upplýsingar, sjá  . Tengdu prentarann við tölvuna með því að nota USB-kapal. Varðandi frekari upplýsingar, sjá  . USB-kapallinn er seldur sérstaklega. Fyrir Windows-notendur Frá tölvunni, settu upp prentrekilinn. Varðandi frekari upplýsingar, sjá  . Opnaðu  Prentarar og skannar , og smelltu síðan á  Bæta við prenarar eða skanner . Það fer eftir gerð á þínum prentara, gerðu eitt af eftirfarandi: Vedlu prentarann úr listanum, og smelltu síðan á  Bæta við tæki . Smelltu á  Sýna Wi‑Fi Direct prentara , veldu prentara, og smelltu síðan á  Bæta við tæki . Smelltu á  Prentarinn sem mig vantar er ekki á lista , og síðan í glugganum  Bæta við prentara  gerðu eftirfarandi: Veldu  Bæta við prentara sem notar TCP/IP-tölu eða hýsiheiti , og smelltu síðan á  Næst . Í svæðinu „ Hýsiheiti eða IP-tala “ skráðu IP-tölu prentarans, og smelltu síðan á Næst . Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Veldu prentrekil og smelltu síðan á  Næst . Veldu  Nota þann prentrekil sem er uppsettur núna (meðmælt) , og smelltu síðan á  Næst . Skráðu heiti prentara, og smelltu síðan á  Næst . Veldu valkost deilingar prentara, og smelltus íðan á  Næst . Smelltu á  Ljúka . Fyrir Macintosh-notendur Frá tölvunni, opnaðu  Prentarar og skannar . Pikkaðu á  , og veldu síðan prentara. Í valmynd  Nota , veldu prentrekil. Til að nota Macintosh prentrekilinn, veldu annað hvort  AirPrint  eða  Secure AirPrint . Ef þú vilt sértæka eiginleika prentunar, veldu þá Lexmark prentrekilinn. Til að setja upp rekilinn, sjá  . Ef þú vilt sértæka eiginleika prentunar, veldu þá prentrekilinn frá framleiðandanum. Til að setja upp rekilinn, sjá  . Bæta við prentara. bæta prenturum við tölvu"},{"UUID":"9a399e68-8938-4ba5-8123-723b4f6f7c45","title":"Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað","link":"installing-printer-software-topic.html","desc":"Flytja út eða flytja inn","descFull":"Flytja út eða flytja inn uppsetningarskrá. Þú getur flutt uppsetningarstillingar út í textaskrá, og flutt síðan skrána inn til að beita stillingum á aðra prentara. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Í innfellda vefþjóninum, smelltu á  Flytja út uppsetningu  eða  Flytja inn uppsetningu . Fylgdu leiðbeiningum á skjánum. Ef prentarinn styður forrit, framkvæmdu þá eftirfarandi: Smelltu á  Forrit veldu forritið Setja upp . Smelltu á  Flytja út  eða  Flytja inn . flytja út uppsetningarskrá notar innbyggða vefþjóninn flytja inn uppsetningarskrá. notar innbyggða vefþjóninn"},{"UUID":"76e6e403-a1c0-4e03-a167-2888eda78ca2","title":"Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað","link":"installing-printer-software-topic.html","desc":"Bæta við tiltækum valkostum í","descFull":"Bæta við tiltækum valkostum í prentrekli Fyrir Windows-notendur Opnaðu möppu fyrir prentara. Veldu prentarann sem þú vilt uppfæra, og gerðu síðan annað af eftirfarandi: Fyrir Windows 7 eða nýrra, veldu  Eiginleika prentara . Fyrir eldri gerðir, veldu  Eiginleikar . Farðu í flipa fyrir stillingar og veldu síðan  Uppfæra núna ‑ spyrja prentara . Beittu breytingunum. Fyrir Macintosh-notendur Frá kjörstillingum kerfis í Apple-valmyndinni, farðu í þinn prentara og veldu síðan  Valkostir & Birgðir . Farðu í lista yfir valkosti vélbúnaðar og bættu síðan við uppsettum valkostum. Beittu breytingunum. bæta við valkostum vélbúnaðar prentrekill prentrekill valkostir vélbúnaðar, bætir við bæta við innri valkostum prentrekill valkostir vélbúnaðar, bætir við prentrekill innri valkostir, bætir við prentrekill"},{"UUID":"6094cf11-40a1-4863-9ac3-9b565c7e9754","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp skúffu fyrir umslög","descFull":"Setja upp skúffu fyrir umslög Fjarlægðu staðalskúffuna. Ekki fleygja staðalskúffunni. Taktu skúffu fyrir umslög úr umbúðunum og fjarlægðu allar umbúðir. Settu skúffu fyrir umslög inn. Til að geta notað skúffu fyrir umslög fyrir prentun, farðu í heimaskjáinn og snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Stilling skúffu Uppsetning skúffu fyrir umslög Kveikt . setja upp skúffu fyrir umslög skúffa fyrir umslög setja upp valkostir vélbúnaðar skúffa fyrir umslög"},{"UUID":"6736000a-a543-4272-b6e9-ffc1f7a1e623","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp 520‑blaða skúffu sem","descFull":"Setja upp 520‑blaða skúffu sem aukabúnað Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu viðbótarskúffuna úr umbúðunum og fjarlægðu allar umbúðir. Stilltu prentarann af við skúffuna sem er aukabúnaður og láttu prentarann síga á sinn stað. Ef þyngd prentarans er meiri en 20kg (44lb), þá kann það að þarfnast tveggja eða fleiri manna til að lyfta honum á öruggan hátt. Fjarlægðu staðalskúffuna. Festu aukaskúffuna við prentarann með skrúfum. Settu staðalskúffuna á sinn stað. Fjarlægðu hlíf yfir tengi frá aftari hlið prentarans. Tengdu skúffutengið við prentarann og festu síðan hlífina á. Festu aftari hluta aukaskúffunnar við prentarann. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum. Bættu skúffunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . setja upp 520-blaða skúffu 520‑blaða skúffa setja upp valkostir vélbúnaðar 520‑blaða skúffa"},{"UUID":"7e374232-f9d3-4757-8056-fb257b9f27e3","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp 520-blaða skúffu með","descFull":"Setja upp 520-blaða skúffu með skáp sem er aukabúnaður Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu viðbótarskúffuna úr umbúðunum og fjarlægðu allar umbúðir. Læstu hjólinu til að koma í veg fyrir að skápurinn hreyfist. Stilltu prentarann af við skúffuna sem er aukabúnaður og láttu prentarann síga á sinn stað. Ef þyngd prentarans er meiri en 20kg (44lb), þá kann það að þarfnast tveggja eða fleiri manna til að lyfta honum á öruggan hátt. Fjarlægðu staðalskúffuna. Festu aukaskúffuna við prentarann með skrúfum. Settu staðalskúffuna á sinn stað. Fjarlægðu hlíf yfir tengi frá aftari hlið prentarans. Tengdu skúffutengið við prentarann og festu síðan hlífina á. Festu aftari hluta aukaskúffunnar við prentarann. Stilltu jöfnunarskrúfurnar til að tryggja að allar hliðar prentarans séu í sömu hæð. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum. Bættu skúffunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . setja upp 520‑blaða skúffu með skáp 520-blaða skúffa með skáp setja upp valkostur vélbúnaðar 520-blaða skúffa með skáp"},{"UUID":"24501e4b-f7bc-430f-a5d9-c3c0974e30e3","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp 3 x 520-blaða","descFull":"Setja upp 3 x 520-blaða skúffu sem er aukabúnað ur Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu viðbótarskúffuna úr umbúðunum og fjarlægðu allar umbúðir. Læstu hjólinu til að koma í veg fyrir að skúffan hreyfist. Stilltu prentarann af við skúffuna sem er aukabúnaður og láttu prentarann síga á sinn stað. Ef þyngd prentarans er meiri en 20kg (44lb), þá kann það að þarfnast tveggja eða fleiri manna til að lyfta honum á öruggan hátt. Fjarlægðu staðalskúffuna. Festu aukaskúffuna við prentarann með skrúfum. Settu staðalskúffuna á sinn stað. Fjarlægðu hlíf yfir tengi frá aftari hlið prentarans. Tengdu skúffutengið við prentarann og festu síðan hlífina á. Festu aftari hluta aukaskúffunnar við prentarann. Stilltu jöfnunarskrúfurnar til að tryggja að allar hliðar prentarans séu í sömu hæð. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum. Bættu skúffunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . setja upp 3 x 520-blaða skúffu 3 x 520-blaða skúffa setja upp valkostir vélbúnaðar 3 x 520-blaða skúffa"},{"UUID":"fc8dc515-02b1-4c25-8da8-a51030ba0278","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp 2520‑blaða samstæðuskúffu sem","descFull":"Setja upp 2520‑blaða samstæðuskúffu sem er aukabúnaður Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu viðbótarskúffuna úr umbúðunum og fjarlægðu allar umbúðir. Læstu hjólinu til að koma í veg fyrir að skúffan hreyfist. Stilltu prentarann af við skúffuna sem er aukabúnaður og láttu prentarann síga á sinn stað. Ef þyngd prentarans er meiri en 20kg (44lb), þá kann það að þarfnast tveggja eða fleiri manna til að lyfta honum á öruggan hátt. Fjarlægðu staðalskúffuna. Festu aukaskúffuna við prentarann með skrúfum. Settu staðalskúffuna á sinn stað. Fjarlægðu hlíf yfir tengi frá aftari hlið prentarans. Tengdu skúffutengið við prentarann og festu síðan hlífina á. Festu aftari hluta aukaskúffunnar við prentarann. Stilltu jöfnunarskrúfurnar til að tryggja að allar hliðar prentarans séu í sömu hæð. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum. Bættu skúffunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . setja upp 2520-blaða skúffu 2520‑blaða skúffa setja upp valkostir vélbúnaðar 2520‑blaða skúffa"},{"UUID":"ad272707-a28f-4b59-af74-8ec356b10839","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp 2000‑blaða skúffu sem","descFull":"Setja upp 2000‑blaða skúffu sem aukabúnað Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu viðbótarskúffuna úr umbúðunum og fjarlægðu allar umbúðir. Fjarlægðu jöfnunarskrúfuna frá vinstri hlið prentarans. Ekki fleygja skrúfunni. Festu festinguna við prentarann. Notaðu festinguna sem fylgdi með aukaskúffunni. Settu upp aukaskúffuna. Tengdu skúffutengið við prentarann. Stilltu jöfnunarskrúfurnar til að tryggja að skúffan sé í sömu hæð við prentarann. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum. Bættu skúffunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . setja upp 2000-blaða skúffu 2000‑blaða skúffa setja upp valkostir vélbúnaðar 2000‑blaða skúffa"},{"UUID":"a4e30e72-5877-4407-8634-31119ca32aca","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja faxkortið upp Setja faxkortið","descFull":"Setja faxkortið upp Setja faxkortið upp Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Fjarlægðu faxhlífina með því að nota skrúfjárn með beinum haus. Fjarlægðu hlífina fyrir harða diskinn Fjarlægðu hlíf fyrir stjórnborðið. Taktu faxkortið úr umbúðum. Festu faxkortið við hlífina á harða diskinum. Settu snúruna fyrir faxtengið inn í hólf stjórnborðsins. Festu hlífina fyrir harða diskinn Festu tengisnúru faxtengisins við stjórnborðið. Festu hlíf að stýrispjaldi. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum faxkort setja upp setja upp innri valkosti faxkort"},{"UUID":"3d0b6105-1298-40f3-ade1-a11e28a2f146","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp harðan disk prentara","descFull":"Setja upp harðan disk prentara Setja upp harðan disk prentara Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu harða diskinn úr umbúðunum og fjarlægðu síðan festinguna. Ekki snerta eða ýta á miðjuna á harða diskinum. Fjarlægðu hlífina fyrir harða diskinn Fjarlægðu hlíf fyrir stjórnborðið. Settu tengisnúruna fyrir harða diskinn inn í hólf stjórnborðsins. Settu harðadiskinn yfir festiopin og ýttu síðan þar til að hann  smellur  á sinn stað. Festu hlífina fyrir harða diskinn Tengdu tengisnúru harða disksins við stjórnborðið. Festu hlíf að stýrispjaldi. Tengdu straumsnúruna við rafmagnsinnstunguna og kveiktu síðan á prentaranum. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. harður diskur prentara setja upp setja upp valkosti harður diskur prentara"},{"UUID":"ff3acb06-1137-4df8-b48e-01feeb2ef9f2","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp vinnuhillu Slökktu á","descFull":"Setja upp vinnuhillu Slökktu á prentaranum. Fjarlægðu hlífar með því að nota skrúfjárn. Taktu vinnuhilluna úr umbúðunum. Festu vinnuhilluna við prentarann. Festu hilluna á prentarann. Kveiktu á prentaranum. setja upp vinnuhillu vinnuhilla setja upp"},{"UUID":"2ac5ba6c-aa44-4e39-b7ad-1ba442207511","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp tvöfalda móttökuhillu Taktu","descFull":"Setja upp tvöfalda móttökuhillu Taktu tvöföldu móttökuhilluna úr umbúðum. Festu tvöföldu móttökuhilluna við prentarann. Til að gera bakkann tiltækan fyrir prentverk, á heimaskjánum skaltu smella á  Stillingar Tæki Viðhald Uppsetningarvalmynd Stilling frágangseiningar Hætta í stillingu fyrir skúffu 2 Kveikt . setja upp tvöfalda móttökuhillu tvöföld móttökuhilla setja upp"},{"UUID":"1e91269c-20a8-4e3b-9235-9723f33bc238","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp frágangseiningu heftara Til","descFull":"Setja upp frágangseiningu heftara Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Fjarlægðu staðalbakka. Ekki fleygja bakkanum. Opnaðu hurð að framan, og fjarlægðu síðan bláa hnúðinn. Ekki fleygja hnúðnum. Fjarlægði hliðarhlíf yfir staðalbakka. Ekki fleygja hliðarhlíf yfir staðalbakka. Taktu frágangseiningu heftara úr umbúðunum og fjarlægðu síðan allar umbúðir. Settu frágangseiningu heftara á bakið og fjarlægðu síðan umbúðirnar. Stilltu festinguna. Settu frágangseininguna í. Lokaðu hurð að framan. Festu frágangseininguna við prentarann. Notaðu skrúfurnar sem fylgdu með frágangseiningunni. Festu snúru frágangseiningar við prentarann. Notaðu klemmurnar sem fylgdu með frágangseiningunni. Tengdu snúru frágangseiningar við prentarann. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum. Bættu frágangseiningunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . setja upp frágangseiningu heftara heftarabúnaður setja upp valkostir vélbúnaðar heftarabúnaður"},{"UUID":"dbbde40d-6b9e-4e1f-aedc-284c3d92ad87","title":"Setja upp valkosti vélbúnaðar","link":"installing-envelope-tray-topic.html","desc":"Setja upp frágangseiningu með heftara","descFull":"Setja upp frágangseiningu með heftara og gatara Til að koma í veg fyrir hættuna á raflosti, ef þú ert að fá aðgang að stjórnborði eða setja upp viðbótarvélbúnað eða minnisbúnað eftir að prentarinn var settur upp, þá skal slökkva á prentaranum og taka rafmagnssnúruna úr sambandi við rafmagn áður en haldið er áfram. Ef þú hefur einhverjar önnur tæki áföst prentaranum, þá skal einnig slökkva á þeim og taka snúrur sem fara í prentarann úr sambandi. Slökktu á prentaranum. Taktu straumsnúruna úr rafmagnsinnstungunni og síðan úr prentaranum. Taktu frágangseiningu heftara og gatara úr umbúðunum og fjarlægðu síðan allar umbúðir. Settu haldara fyrir heftarahylki í frágangseininguna. Notaðu skrúfjárn með beinum haus til að festa festingarnar við frágangseininguna. Settu bakkann í frágangseininguna. Fjarlægðu staðalbakka. Ekki fleygja staðalbakkanum. Opnaðu hurð að framan, og fjarlægðu síðan bláa hnúðinn. Ekki fleygja hnúðnum. Fjarlægði hliðarhlíf yfir staðalbakka. Ekki fleygja hliðarhlíf yfir staðalbakka. Notaðu skrúfjárn með beinum haus til að festa festingarnar við hægri hlið prentarans. Settu pappírsflutninginn inn og festu hann með skrúfunum. Notaðu skrúfurnar sem fylgdu með frágangseiningunni. Lokaðu hurð að framan. Festu frágangseininguna við prentarann. Stilltu jöfnunarskrúfurnar til að tryggja að allar hliðar frágangseiningar séu í sömu hæð við prentarann. Opnaðu hurð frágangseiningar og festu síðan skrúfuna á vinstri hlið frágangseiningarinnar. Lokaðu hurð á frágangseiningu. Tengdu kapal pappírsflutningur aftan á frágangseiningunni. Tengdu kapal frágangseiningar aftan á prentarann. Tengdu straumsnúru við prentarann og síðan við rétt jarðtengda rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Kveiktu á prentaranum Bættu frágangseiningunni handvirkt inn í prentararekilinn til að gera hana tiltæka fyrir prentverk. Varðandi frekari upplýsingar, sjá  . Til að get notað frágangseininguna fyrir prentun, farðu í heimaskjáinn og snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Stillingar frágangseiningar Stillingar gatara velja stillingu. setja upp frágangseiningu með heftara og gatara setja upp frágangseining með heftara og gatara"},{"UUID":"0b04e7e5-a525-40d1-a0a3-16f5d6bae3f9","title":"Setja upp þráðlausan prentþjón","link":"installing-envelope-tray-topic.html","desc":"Setja upp MarkNet N8372 þráðlausan","descFull":"Setja upp MarkNet N8372 þráðlausan prentþjónn Slökktu á prentaranum. Settu ísóprópýl alkóhól í mjúkan lófrían klút, og þurrkaðu síðan svæðið í kring um USB-tengið. Settu þráðlausu eininguna á sinn stað. Beittu góðum þrýstingi til að tryggja að límbandið festist við yfirborð prentarans. Gakktu úr skugga um að yfirborð prentarans sé þurrt og laust við raka. Einingin er best tengd við prentarann eftir 72 klst. Athugaðu hvort bil sé á milli einingarinnar og prentarans, festu síðan millibilseiningu ef þörf krefur. Tengja NFC-kortið. Kveiktu á prentaranum þráðlaus prentþjónn setja upp setja upp þráðlausan prentþjón MarkNet N8372 þráðlaus prentþjónn"},{"UUID":"6e23b9b1-7992-405c-ab8c-3cdbb78606cf","title":"Nettenging","link":"networking-intro-topic.html","desc":"Þessi vara er ekki með","descFull":"Þessi vara er ekki með þráðlausa nettækni. Til að virkja þráðlaust net skaltu kaupa og setja upp eftirfarandi valbúnað: Eftirfarandi leiðbeiningar eiga aðeins við ef valbúnaðurinn hefur verið settur upp. Frekari upplýsingar um uppsetningu valbúnaðarins eru í hlutanum „Setja upp þráðlausan prentþjón“."},{"UUID":"ec64c1a1-28ab-4447-b1cb-05d85cefda88","title":"Nettenging","link":"networking-intro-topic.html","desc":"Tengja prentarann við þráðlaust netkerfi","descFull":"Tengja prentarann við þráðlaust netkerfi (Wi‑Fi) Áður en þú byrjar, vertu viss um: Þráðlaus eining er uppsett í prentaranum þínum. Virktur tengibúnaður  sé stilltur á  Sjálfvirkt . Á heimaskjánum, snertu  Stillingar Netkerfi/tengi Yfirlit netkerfis Virkur tengibúnaður . Nota stjórnborð prentara Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi Þráðlaust Uppsetning á stjórnborði prentara Velja netkerfi . Veldu þráðlaust netkerfi og skráðu síðan aðgangsorð netkerfis. Fyrir prentara sem eru tilbúnir fyrir þráðlaus netkerfi (Wi-Fi) birtist kvaðning til að setja upp þráðlaust netkerfi við fyrstu uppsetningu. Nota „Lexmark Mobile Assistant“ Það fer eftir þínu fartæki, hladdu niður Lexmark Mobile Assistant forritinu annað hvort frá App Store eða  Google Play . Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi Þráðlaust Uppsetning með forriti fartækis Auðkenni prentara . Gangsettu forritið frá þínu fartæki og samþykktu síðan notkunarskilmálana. Fáðu heimildir ef þörf krefur. Pikkaðu á  Tengjast prentara Fara í stillingar fyrir þráðlaust net (Wi‑Fi) . Tengdu fartækið þitt við þráðlaust netkerfi prentara Farðu til baka í forritið og pikkaðu síðan á  Setja upp þráðlausa tengingu Veldu þráðlaust netkerfi og skráðu síðan aðgangsorð netkerfis. Pikkaðu á  Búið . þráðlaust netkerfi tengja prentarann við tengja prentarann við þráðlaust net þráðlaust netkerfi"},{"UUID":"ef266e40-35cb-4d1a-9df2-9f71ca15f500","title":"Nettenging","link":"networking-intro-topic.html","desc":"Tengja prentarann við þráðlaust netkerfi","descFull":"Tengja prentarann við þráðlaust netkerfi með því að nota verndaða þráðlausa uppsetningu (WPS) Áður en þú byrjar, vertu viss um: Aðgangsstaðurinn (þráðlaus beinir) sé vottaður sem vernduð þráðlaus uppsetning (WPS) eða WPS‑samhæfður. Skoðaðu skjölin sem fylgdu með aðgangsstaðnum varðandi frekari upplýsingar. Tengi fyrir þráðlaust net er uppsett í prentaranum þínum. Skoðaðu leiðbeiningarskjölin sem fylgdu með tenginu varðandi frekari upplýsingar. Virktur tengibúnaður  sé stilltur á  Sjálfvirkt . Á heimaskjánum, snertu  Stillingar Netkerfi/tengi Yfirlit netkerfis Virkur tengibúnaður . Nota stillingaraðferð með hnöppum Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi Þráðlaust Vernduð þráðlaus uppsetning (Wi‑Fi Protected Setup (WPS)) Aðferð með hnöppum . Fylgdu leiðbeiningum á skjánum. Nota aðferð persónuauðkennanlegs númers (PIN) Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi Þráðlaust Vernduð þráðlaus uppsetning (Wi‑Fi Protected Setup (WPS)) Aðferð með PIN . Afritaðu átta stafa PIN fyrir WPS. Opnaðu vafra og skráðu síðan IP-tölu aðgangsstaðarins í svæði vistfangs. Skoðaðu skjölin sem fylgdu með aðgangsstaðnum til að þekkja IP-töluna. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Aðgengi að WPS-stillingum. Skoðaðu skjölin sem fylgdu með aðgangsstaðnum varðandi frekari upplýsingar. Skráðu átta stafa PIN-númer, og vistaðu síðan breytingarnar. Vernduð þráðlaus uppsetning (Wi‑Fi Protected Setup (WPS)) þráðlaust netkerfi þráðlaust netkerfi Vernduð þráðlaus uppsetning (Wi‑Fi Protected Setup (WPS)) tengjast þráðlausu neti nota PIN-aðferð aðferð persónuauðkennanlegs númers (PIN) tengjast þráðlausu neti nota aðferð með hnöppum (PBC) aðferð með hnöppum"},{"UUID":"8142792d-c177-4a00-8f03-ff9b28abc4c4","title":"Nettenging","link":"networking-intro-topic.html","desc":"Stilla Wi‑Fi Direct Wi‑Fi Direct","descFull":"Stilla Wi‑Fi Direct Wi‑Fi Direct  er jafningjatækni byggð á Wi-Fi sem gerir þráðlausum tækjum kleift að tengjast beint við Wi-Fi Direct virkan prentara án þess að nota aðgangsstað (þráðlausan beini). Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi Þráðlaust Wi-Fi Direct. Settu upp stillingarnar. Virkja Wi‑Fi Direct —Gerir prentaranum kleift að senda út sitt eigið Wi-Fi Direct net. Wi‑Fi Direct heiti —Úthlutar heiti fyrir Wi‑Fi Direct netkerfið. Wi‑Fi Direct aðgangsorð —Úthlutar aðgangsorðinu til að semja um þráðlaust öryggi þegar notuð er tenging milli jafningja. Sýna aðgangsorð á uppsetningarsíðu —Sýnir aðgangsorðið á uppsetningarsíðu netkerfis. Samþykkja sjálfvirkt beiðni ýtihnappa —Lætur prentaranns amþykkja tengibeiðnir sjálfvirkt. Samþykki á beiðni ýtihnappa er ekki öruggt. Það ers jálfvalið að aðgangsorð netkerfis Wi-Fi Direct er ekki sýnilegt á skjá prentarans. Til að sýna aðgangsorðið, virkjaðu tákn sýnileika aðgangsorðs. Á heimaskjánum, snertu  Stillingar Öryggi Ýmislegt Virkja sýnileika aðgangsorðs/PIN . Til að vita aðgangsorð Wi-Fi Direct netkerfis án þess að sýna það á prentaraskjánum, snertu á heimaskjánum  Stillingar Skýrslur Netkerfi Uppsetningarsíða netkerfis . Wi‑Fi Direct stillir stilla Wi-Fi Direct"},{"UUID":"20e75dd8-ab0a-4dee-a318-c32321555d3a","title":"Nettenging","link":"networking-intro-topic.html","desc":"Tengja fartæki við prentarann Gangtu","descFull":"Tengja fartæki við prentarann Gangtu úr skugga um að Wi‑Fi Direct hafi verið sett upp áður en þú tengir fartækið þitt. Varðandi frekari upplýsingar, sjá  . Tengja með því að nota Wi‑Fi Direct Þessar leiðbeiningar eiga aðeins við um Android fartæki. Farðu í valmynd stillinga á fartækinu. Virkjaðu  Wi‑Fi , og smelltu síðan á  Wi‑Fi Direct . Veldu heiti á Wi-Fi Direct prentara. Staðfestu tenginguna á stjórnborði prentarans. Tengja með því að nota Wi‑Fi Farðu í valmynd stillinga á fartækinu. Smelltu á  Wi-Fi , veldu síðan heiti á Wi‑Fi Direct prentara. Strengnum DIRECT-xy (þar sem x og y eru tvö staftákn af handahófi) er bætt fyrir framan heitið á Wi-Fi prentaranum. Skráðu aðgangsorð Wi‑Fi Direct. tengja fartæki við prentara fartæki tengja við prentara Wi‑Fi Direct virkja virkja Wi‑Fi Direct"},{"UUID":"a618db56-059f-4edf-9486-fa4a4112235f","title":"Nettenging","link":"networking-intro-topic.html","desc":"Wi‑Fi Direct Tengja tölvu við","descFull":"Wi‑Fi Direct Tengja tölvu við prentarann Gangtu úr skugga um að Wi‑Fi Direct hafi verið uppsett áður en tölvan er tengd. Varðandi frekari upplýsingar, sjá  . Fyrir Windows-notendur Opnaðu  Prentarar og skannar , og smelltu síðan á  Bæta við prenarar eða skanner . Smelltu á  Sýna Wi-Fi Direct prentara , veldu síðan heiti á Wi‑Fi Direct prentara. Taktu eftir átta stafa PIN prentarans á skjá prentarans. Skráðu PIN á tölvunni. Ef prentrekill er ekki þegar uppsettur, þá hleður Windows niður viðeigandi rekli. Fyrir Macintosh-notendur Smelltu á þráðlausa táknið og veldu síðan heiti á Wi‑Fi Direct prentaranum. Strengnum DIRECT-xy (þar sem x og y eru tvö staftákn af handahófi) er bætt fyrir framan heitið á Wi-Fi prentaranum. Skráðu aðgangsorð Wi‑Fi Direct. Settu tölvuna aftur í fyrra netkerfi eftir að hafa aftengt frá netkerfi Wi-Fi Direct. tölva tengja við prentarann tengja tölvu við prentarann"},{"UUID":"a502be60-1dbc-485a-b98e-73f215a102f2","title":"Nettenging","link":"networking-intro-topic.html","desc":"WI-Fi netið gert óvirkt Á","descFull":"WI-Fi netið gert óvirkt Á heimaskjánum, snertu  Stillingar Netkerfi/tengi Yfirlit netkerfis Virkur tengibúnaður Staðalnetkerfi . Fylgdu leiðbeiningum á skjánum. Wi‑Fi netkerfi gera óvirkt gera WI-Fi netið óvirkt"},{"UUID":"cbb4a19e-5e71-4896-af51-0bc3a1d84997","title":"Nettenging","link":"networking-intro-topic.html","desc":"Athugun á tengingu prentarans Frá","descFull":"Athugun á tengingu prentarans Frá heimaskjánum, snertu  Stillingar Skýrslur Netkerfi Uppsetningarsíða netkerfis . Athugaðu fyrsta kaflann í uppsetningarsíðu netkerfis, og staðfestu að staðan sé Tengdur. Ef staðan er ekki tengdur, þá kann tengistaður við netið að vera ekki virkur eða netkapalinn er ekki tengdur eða í lagi. Hafðu samband við þinn kerfisstjóra varðandi aðstoð. prentar uppsetningarsíða netkerfis prenta uppsetningarsíðu netkerfis uppsetningarsíða netkerfis prentar"},{"UUID":"292a486a-9e55-4a3b-a573-44ef0213f7f4","title":"Setja upp, setja inn og stilla","link":"setting-up-serial-printing-topic.html","desc":"Setja upp prentun á raðtengi","descFull":"Setja upp prentun á raðtengi (aðeins Windows) Áður en þú byrjar, vertu viss um að tengi fyrir innri lausnir sé uppsett í prentaranum þínum. Stilla breytur í prentaranum. Frá stjórnborði, farðu í valmynd fyrir stillingar á tengjum. Finndu valmynd fyrir stillingar á raðtengi og stilltu tengingarnar ef þörf er á. Beittu breytingunum. Frá tölvunni, opnaðu möppu fyrir prentara og veldu þinn prentara. Opnaðu eiginleika prentara, og veldu síðan COM-tengið í listanum. Stilltu breytur fyrir COM-tengið í Tækjastjóra. Prentun um raðtengi hægir á prenthraðanum. Vertu viss um að kapall fyrir raðtengi sé tengdur við raðtengið á prentaranum þínum. setja upp prentun um raðtengi prentun um raðtengi uppsetning"},{"UUID":"f756860e-81e6-4749-8432-f3697ce8247d","title":"Gera prentarann öruggan","link":"locating-security-slot-topic.html","desc":"Finna öryggistengi Prentarinn er búinn","descFull":"Finna öryggistengi Prentarinn er búinn eiginleika öryggislæsingar. Festu öryggislæsingu sem er samhæfð við flestar fartölvur á staðinn sem er sýndur til að tryggja prentarann og harða diskinn á staðnum. öryggistengi finna finna öryggistengi"},{"UUID":"64dc5959-5961-4979-b073-17637edb26f2","title":"Gera prentarann öruggan","link":"erasing-printer-memory-topic.html","desc":"Eyða minni prentara Til að","descFull":"Eyða minni prentara Til að eyða gögnum í lausheldnu minni eða biðminni, slökktu á prentaranum. Til að eyða fastheldnu minni, stillingum tækis og nets, öryggisstillingum og innbyggðum lausnum skaltu gera eftirfarandi: Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Eyða utan þjónustu . Snertu gátreitinn  Hreinsa allar upplýsingar á fastheldnu minni  og snertu síðan  EYÐA . Snertu  Gangsetja upphaflega leiðsagnarforrit uppsetningar  eða  Láta prentarann vera utan nets , og snertu síðan  Næst . Gangsetja aðgerðina. Þetta ferli eyðileggur einnig dulkóðunarlykilinn sem er notaður til að vernda notendagögn. Að eyða dulkóðunarlyklinum gerir gögnin óafturkræf. óstöðugt minni eyðir fastheldið minni eyðir minni prentara eyðir eyðir minni prentara"},{"UUID":"12b0f82c-d4a5-4cb6-b023-df2816efb231","title":"Gera prentarann öruggan","link":"erasing-printer-storage-drive-topic.html","desc":"Eyða af geymsludrifi prentara Frá","descFull":"Eyða af geymsludrifi prentara Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Eyða utan þjónustu . Það fer eftir geymsludrifinu sem er uppsett á prentaranum þínum, gerðu annað hvort af eftirfarandi: Fyrir harða diskinn, snertu  Hreinsa allar upplýsingar á hörðum diski  gátreitinn, snertu  EYÐA  og veldu síðan aðferð til að eyða gögnum. Ferlið að hreinsa harða diskinn getur tekið frá nokkrum mínútum í allt að meira en klukkustund, þar sem prentarinn verður ekki tiltækur fyrir önnur verkefni notenda. Fyrir skynvætt geymsludrif (ISD) snertu  Eyða skynvæddu geymsludrifi  og snertu síðan  EYÐA  til að eyða öllum gögnum notanda. Gangsetja aðgerðina. geymsludrif eyðir eyða af geymsludrifi prentara harður diskur eyðir skynvætt geymsludrif eyðir"},{"UUID":"5f746e8e-ad02-48f5-98d2-2395f4d266b8","title":"Gera prentarann öruggan","link":"restoring-factory-default-settings-topic.html","desc":"Endurheimta sjálfgefnar verksmiðjustillingar Á heimaskjánum,","descFull":"Endurheimta sjálfgefnar verksmiðjustillingar Á heimaskjánum, snertu  Stillingar Tæki Endurheimta sjálfgildi frá verksmiðju . Snertu  Endurheimta stillingar veldu stillingarnar sem þú vilt endurheimta ENDURHEIMTA . Gangsetja aðgerðina. sjálfvaldar verksmiðjustillingar endurheimtir stillingar prentara endurheimta sjálfgildi frá verksmiðju"},{"UUID":"aec8b67a-002c-402a-8fc5-10b781a5e0c1","title":"Gera prentarann öruggan","link":"statement-of-volatility-topic.html","desc":"Yfirlýsing varðandi óstöðugleika Gerðir minnis","descFull":"Yfirlýsing varðandi óstöðugleika Gerðir minnis og lýsingar þess Gerð minnis Lýsing Óstöðugt minni Prentarinn þinn notar staðalgerð vinnsluminnis (RAM) til að geyma gögn tímabundið í biðminni við einföld prentverk og afritun. Fastheldið minni Prentarinn þinn kann að nota tvær gerðir af fastheldnu minni: EEPROM og NAND (skyndiminni). Báðar gerðir geyma stýrikerfið, stillingar prentara og upplýsingar um netið. Þær geyma einnig stillingar skanna og bókamerkja og innbyggðar lausnir. Harður geymsludiskur Sumir prentarar eru með uppsettan harðan disk. Harður diskur prentara er ætlaður fyrir sérstaka prent-virkni tækisins. Harður diskur lætur prentarann viðhalda gögnum í biðminni varðandi flókin prentverk, jafnt sem gögn varðandi eyðublöð og leturgerðir. Skynvætt geymsludrif (ISD) Sumir prentarar eru með ISD uppsett. ISD notar fastheldið minni til að geyma notendagögn úr flóknum prentverkum, eyðublaðagögnum og leturgögn. Eyðið innihaldi í uppsettu minni prentara við eftirfarandi aðstæður: Prentarinn er tekinn úr notkun. Skipt er um harða diskinn eða ISD í prentaranum. Prentarinn er fluttur í aðra deild eða staðsetningu. Prentarinn er þjónustaður af einhverjum fyrir utan þitt fyrirtæki. Prentarinn er fluttur úr þínu húsnæði vegna þjónustu. Prentarinn er seldur til annars fyrirtækis. Til að farga geymsludrifi skaltu fylgja reglum og verklagsreglum fyrirtækisins þíns. yfirlýsing varðandi óstöðugleika óstöðugt minni fastheldið minni harður geymsludiskur skynvætt geymsludrif eyðir minni prentara tryggja gögn prentara"},{"UUID":"677af9d7-a7b9-4d40-b9b8-471317c648b8","title":"Prenta","link":"printing-from-computer-h2-topic.html","desc":"Prentun frá tölvu Fyrir miða,","descFull":"Prentun frá tölvu Fyrir miða, þykkan pappír og umslög, stilltu pappírsstærð og gerð í prentaranum áður en skjalið er prentað. Opnaðu Prentsamskipti úr því skjali sem þú ert að reyna að prenta. Breyttu stillingum ef þörf krefur. Prentaðu skjalið. prentun frá tölvu skjöl, prentun frá tölvu prentun frá tölvu"},{"UUID":"40837bee-5305-4c3a-999f-6c0865e44cab","title":"Prentun frá fartæki","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Prenta frá fartæki með því","descFull":"Prenta frá fartæki með því að nota Lexmark Mobile Print Prenta frá fartæki með því að nota Lexmark Mobile Print Lexmark  Mobile Print leyfir þér að senda skjöl og myndir beint til studds Lexmark prentara. Opnaðu skjalið og sendu eða deildu því til Lexmark Mobile Print. Sum forrit frá þriðja aðila kunna ekki að styðja eiginleika deilingar eða sendingar. Skoðaðu skjölin sem fylgdu með forritinu varðandi frekari upplýsingar. Veldu prentara. Prentaðu skjalið. Lexmark Mobile Print notar skjöl, prentun frá fartæki fartæki prentar frá"},{"UUID":"e8845af3-a3b8-4eba-8922-30a1a5d734bb","title":"Prentun frá fartæki","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Prenta frá fartæki með því","descFull":"Prenta frá fartæki með því að nota Lexmark Print Lexmark  Print er prentlausn fartækja fyrir fartæki sem nota  Android  útgáfu 6.0 eða nýrri. Það gerir þér kleift að senda skjöl og myndir til nettengdra prentara og prentstjórnunarþjóna. Gættu þess að hlaða niður Lexmark Print forritinu frá  Google Play  versluninni og gera það virkt á fartækinu. Vertu viss um að prentarinn og fartækið séu tengd við sama netkerfið. Í fartækinu þínu, veldu skjal í skráarstjóranum. Sendu eða deildu skjalinu til Lexmark Print. Sum forrit frá þriðja aðila kunna ekki að styðja eiginleika deilingar eða sendingar. Skoðaðu skjölin sem fylgdu með forritinu varðandi frekari upplýsingar. Veldu prentara og stilltu stillingar ef þörf er á. Prentaðu skjalið. Lexmark Print notar skjöl, prentun frá fartæki fartæki prentar frá"},{"UUID":"0f10ab9f-6844-43a8-871f-4278312f7454","title":"Prentun frá fartæki","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Prenta frá fartæki með því","descFull":"Prenta frá fartæki með því að nota Mopria Print Service Mopria  Print Service er prentlausn fartækja fyrir fartæki sem nota  Android  útgáfu 5.0 eða nýrri. Hún leyfir þér að prenta beint á einhvern Mopria‑vottaðan prentara. Tryggðu að þú hlaðið niður Mopria Print Service forritinu frá  Google Play  versluninni og gerir það virkt á fartækinu. Opnaðu samhæft forrit í Android fartækinu þínu eða veldu skjal í þínum skráarstjóra. Pikkaðu á  Prenta . Veldu prentara og stilltu stillingar ef þörf er á. Pikkaðu á  . Mopria-prentþjónusta prentar frá fartæki fartæki prentar frá prentar nota Mopria-prentþjónustu"},{"UUID":"8cd8c882-c3de-4f61-b5cd-4f0472ff18a5","title":"Prentun frá fartæki","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Prenta frá fartæki með því","descFull":"Prenta frá fartæki með því að nota AirPrint AirPrint-hugbúnaður er prentlausn fyrir fartæki sem leyfir þér að prenta beint frá Apple-tækjum á AirPrint-vottuðum prentara. Vertu viss um að Apple-tækið og prentarinn séu tengd við sama netkerfið. Ef netið er með margar þráðlausar miðstöðvar skaltu ganga úr skugga um að bæði tækin séu tengd við sama undirnet. Þetta forrit er aðeins stutt í sumum tækjum Apple. Frá fartækinu þínu veldu skjal frá þinni skjalastjórnun eða ræstu samhæft forrit. Pikkaðu á  Prenta . Veldu prentara og stilltu stillingar ef þörf er á. Prentaðu skjalið. AirPrint notar prentar frá fartæki fartæki prentar frá"},{"UUID":"e15b8f50-54c7-4daa-8ff3-98874cf4093e","title":"Prentun frá fartæki","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Prenta frá fartæki með því","descFull":"Prenta frá fartæki með því að nota Wi‑Fi Direct® Wi‑Fi Direct  er prentþjónusta fartækja sem gerir þér mögulegt til að prenta á hvaða Wi‑Fi Direct-tilbúnum prentara sem er. Tryggðu að fartækið sé tengt við þráðlaust netkerfi prentara. Varðandi frekari upplýsingar, sjá  . Opnaðu samhæft forrit í fartækinu þínu eða veldu skjal í þínum skráarstjóra. Það fer eftir gerð á þínu fartæki, gerðu eitt af eftirfarandi: Pikkaðu á  Prenta . Pikkaðu á  Prenta . Pikkaðu á  Prenta . Veldu prentara og stilltu stillingar ef þörf er á. Prentaðu skjalið. Wi‑Fi Direct Prentun frá fartæki prentar frá fartæki fartæki prentar frá prentar nota Wi‑Fi Direct"},{"UUID":"b1861e79-272e-441b-a10c-9523536046ca","title":"Prenta","link":"printing-from-flash-drive-topic.html","desc":"Prentun af minniskorti Settu inn","descFull":"Prentun af minniskorti Settu inn minniskort. Ef þú setur inn minniskortið þegar villuskilaboð birtast, hunsar prentarinn minniskortið. Ef þú setur inn minniskort þegar prentarinn er að vinna önnur prentverk, þá birtist  Upptekinn  á skjánum. Snertu skjalið á skjánum sem þú vilt prenta. Stilltu stillingar prentara ef þörf krefur. Prentaðu skjalið. Til að prenta annað skjal, snertu  USB-drif . Til að forðast gagnatap eða truflun, ekki snerta minniskortið eða prentarann á þeim svæðum sem eru sýnd þegar prentun, lestur eða skrif er virk frá minniskorti. prentar frá minniskorti minniskort prentar frá"},{"UUID":"6070d148-fa3c-4ae6-a5fd-05d7bafb683d","title":"Prenta","link":"supported-flash-drives-and-file-types-topic.html","desc":"Studd minniskort og skráargerðir Minniskort","descFull":"Studd minniskort og skráargerðir Minniskort Lexar JumpDrive S70 (16GB og 32GB) SanDisk Cruzer Micro (16GB og 32GB) PNY Attaché (16GB and 32GB) Prentarinn styður háhraða minniskort með fullum háhraðastaðli. Minniskort verða að styðja kerfi skráarúthlutunartöflu (FAT). Skráargerðir Studdar skráargerðir Skjöl Myndir PDF (útgáfa 1.7 eða eldri) Microsoft skráarsnið (DOC, DOCX, XLS, XLSX, PPT, PPTX)* JPEG eða JPG TIFF eða TIF GIF BMP PNG PCX DCX studd minniskort minniskort studdar studdar skráargerðir skráargerðir studdar"},{"UUID":"c21d1b58-5090-4d9f-8920-31bb418f5d51","title":"Prenta","link":"configuring-confidential-jobs-topic.html","desc":"Setja upp trúnaðarverk Frá heimaskjánum,","descFull":"Setja upp trúnaðarverk Frá heimaskjánum, snertu  Stillingar Öryggi Uppsetning á prentun trúnaðarverka . Settu upp stillingarnar. Atriði valmyndar  Uppsetningar trúnaðarprentunar  og lýsingar þeirra Stilling Lýsing Hámark ógildra PIN-númera Stilla mörkin á að skrá inn ógilt PIN. Þegar mörkunum er náð er prentverkum fyrir það notandaheiti eytt. Gildislok trúnaðarverka Stilltu einstakan tíma gildisloka fyrir hvert verk sem er í bið áður en því er sjálfkrafa eytt úr minni prentara, af harða disknum eða skynvædda geymsludrifinu. Verk í bið er annað hvort  Trúnaðarverk ,  Endurtekið ,  Frestað , eða  Staðfest . Gildislok endurtekinna verka Stilla tíma gildisloka fyrir prentverk sem þú vilt endurtaka. Gildislok staðfestra verka Stilla tíma fyrir gildislok til að prenta afrit af verki til að athuga gæði þess áður en þú prentar afritin sem eftir eru. Gildislok frestaðra verka Stilla tíma fyrir gildislok fyrir verk sem þú vilt geyma í prentaranum til að prenta síðar. Krefjast að öll verk séu geymd Stillir prentarann til að geyma öll prentverk. Geyma afrit skjala Stilla prentarann til að geyma öll skjöl með sama skráarheiti. trúnaðarprentverk stillir verk í bið stilla tíma gildisloka vistar prentverk endurtaka prentverk staðfesta prentverk"},{"UUID":"49ece34f-d35c-4659-a8ef-fcc1161e58ea","title":"Prenta","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Prentun á trúnaðarmálum og öðrum","descFull":"Prentun á trúnaðarmálum og öðrum vernduðum verkum Fyrir Windows-notendur Með skjalið opið, smelltu á  Skrá Prenta . Veldu prentara og smelltu síðan á  Eiginleikar ,  Kjörstillingar ,  Valkostir , eða  Uppsetning . Smelltu á  Prenta og vernda . Veldu  Nota Prenta og vernda  og úthlutaðu notandaheiti. Veldu gerð prentverks (trúnaðarmál, endurtaka, frestað eða staðfest). Ef þú velur  Trúnaðarmál , tryggðu þá prentverkið með persónulegu auðkennisnúmeri (PIN). Smelltu á  OK  eða  Prenta . Sendu prentverkið frá heimaskjá prentarans. Fyrir trúnaðarprentverk, snertu  Verk í bið  veldu þitt notandaheiti Trúnaðarmál  skráðu PIN  veldu prentverkið  settu upp stillingarnar Prenta . Fyrir önnur prentverk, snertu  Verk í bið  veldur þitt notandaheiti  veldu prentverkið  settu upp stillingarnar Prenta . Fyrir Macintosh-notendur Noat AirPrint Með skjalið opið, veldu  Skrá Prenta . Veldu prentara, og síðan frá felligluggavalmynd sem kemur á eftir valmyndinni  Stefna  veldu  Prentun með PIN . Virkja  Prentun með PIN , og skráðu fjögurra stafa PIN. Smelltu á  Prenta . Sendu prentverkið frá heimaskjá prentarans. Snertu  Verk í bið  veldu nafnið á þínum prentara Trúnaðarmál  skráðu PIN velduprentverkið Prenta . Nota rekil fyrir prentara Með skjalið opið, veldu  Skrá Prenta . Veldu prentara, og síðan frá felligluggavalmynd sem kemur á eftir valmyndinni  Stefna  veldu  Prenta og bið . Veldu  Trúnaðarprentun , og skráðu síðan fjögurra stafa PIN. Smelltu á  Prenta . Sendu prentverkið frá heimaskjá prentarans. Snertu  Verk í boð  veldu heiti prentarans þíns Trúnaðarmál veldu prentverkið  skráðu PIN Prent . prentar verk í bið prentar trúnaðarprentverk trúnaðarprentverk prentar verk í bið prentar"},{"UUID":"30932651-7299-412b-8632-6f3ae26019c9","title":"Prenta","link":"printing-font-sample-list-h2-topic.html","desc":"Prenta lista yfir sýnishorn leturgerða","descFull":"Prenta lista yfir sýnishorn leturgerða Frá heimaskjánum, snertu  Stillingar  Skýrslur Prenta Prenta leturgerðir . Snertu  PCL-leturgerðir  eða  PS-leturgerðir . prentar listi yfir sýnishorn leturgerða prenta lista yfir sýnishorn leturgerða listi yfir sýnishorn leturgerða prentar"},{"UUID":"b7aa3fb7-592e-4397-bb52-dd9f24749722","title":"Prenta","link":"printing-directory-list-h2-topic.html","desc":"Prenta lista skráasafns Frá heimaskjánum,","descFull":"Prenta lista skráasafns Frá heimaskjánum, snertu  Stillingar Skýrslur Prenta Prenta skráasafn . prentar listi skráasafns prenta lista skráasafns listi skráasafns prentar"},{"UUID":"4c2bb228-cf8b-4aca-8693-52cef7f85c22","title":"Prenta","link":"placing-separator-sheets-topic.html","desc":"Setja aðskilnaðarsíður á milli afrita","descFull":"Setja aðskilnaðarsíður á milli afrita Á heimaskjánum, snertu  Stillingar Prenta Útlit Aðskilnaðarsíður Á milli afrita . Prentaðu skjalið. aðskilnaðarsíður staðsetning setja aðskilnaðarsíður"},{"UUID":"8878a6be-c842-4ff9-8b4a-18f9122a7fc3","title":"Prenta","link":"stapling-printed-sheets-topic.html","desc":"Hefta prentuð blöð Fyrir Windows-notendur","descFull":"Hefta prentuð blöð Fyrir Windows-notendur Með skjalið opið, smelltu á  Skrá Prenta . Veldu prentara og smelltu síðan á  Eiginleikar ,  Kjörstillingar ,  Valkostir , eða  Uppsetning . Smelltu á  Pappír/frágangseining . Aðlagaðu pappírsstillingar ef þörf krefur. Veldu stillingar heftara í valmynd frágangseiningar. Smelltu á  OK  eða  Prenta . Fyrir Macintosh-notendur Með skjalið opið, veldu  Skrá Prenta . Veldu prentara, og síðan frá felligluggavalmynd sem kemur á eftir valmyndinni  Stefna  veldu  Frágangur . Smelltu á  Hefta , og veldu síðan stillinguna. Smelltu á  Prenta . hefta prentuð blöð prentuð blöð heftun"},{"UUID":"837d41b3-51d2-4250-a7b6-f86160175c89","title":"Prenta","link":"punching-holes-printed-sheets-topic.html","desc":"Gata prentuð blöð Vertu viss","descFull":"Gata prentuð blöð Vertu viss um að stillingar fyrir gatara séu uppsettar áður en þú byrjar. Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Stilling frágangseiningar Stilling gatara   og veldu stillingu. Fyrir Windows-notendur Með skjalið opið, smelltu á  Skrá Prenta . Veldu prentara og smelltu síðan á  Eiginleikar ,  Kjörstillingar ,  Valkostir , eða  Uppsetning . Smelltu á  Pappír/frágangseining . Aðlagaðu pappírsstillingar ef þörf krefur. Veldu stillingar gatara í valmynd frágangseiningar. Smelltu á  OK  eða  Prenta . Fyrir Macintosh-notendur Með skjalið opið, veldu  Skrá Prenta . Veldu prentara, og síðan frá felligluggavalmynd sem kemur á eftir valmyndinni Stefna veldu  Frágangur . Smelltu á  Gatari , og veldu síðan stillinguna. Smelltu á  Prenta . gatar prentuð blöð prentuð blöð götun"},{"UUID":"036e3497-2b39-4a11-b523-426dc1960442","title":"Prenta","link":"using-offset-stacking-printed-sheets-topic.html","desc":"Nota hliðrunarstöflun í prentuðum blöðum","descFull":"Nota hliðrunarstöflun í prentuðum blöðum Fyrir Windows-notendur Með skjalið opið, smelltu á  Skrá Prenta . Veldu prentara og smelltu síðan á  Eiginleikar ,  Kjörstillingar ,  Valkostir , eða  Uppsetning . Smelltu á  Pappír/frágangseining . Aðlagaðu pappírsstillingar ef þörf krefur. Veldu stillingar hliðrunar í valmynd frágangseiningar. Smelltu á  OK  eða  Prenta . Fyrir Macintosh-notendur Með skjalið opið, veldu  Skrá Prenta . Veldu prentara, og síðan frá felligluggavalmynd sem kemur á eftir valmyndinni  Stefna  veldu  Frágangur . Smelltu á  Hliðrun , og veldu síðan stillinguna. Smelltu á  Prenta . hliðrunarstöflun í prentuðum blöðum prentuð blöð hliðrunarstöflun"},{"UUID":"0ac1f048-0711-47d6-915a-6d2c09ddda32","title":"Prenta","link":"canceling-print-job-topic.html","desc":"Hætta við verk í prentun","descFull":"Hætta við verk í prentun Frá heimaskjá, snertu  . Veldu verkið sem á að hætta við. Þú getur einnig hætt við verk með því að snerta  Biðröð verks . prentverk hætta við hætta við verk í prentun"},{"UUID":"6389ab44-f7bd-4208-8118-90e8b3cbb498","title":"Prenta","link":"adjusting-toner-darkness-topic.html","desc":"Stilla svertustig prentdufts Frá heimaskjánum,","descFull":"Stilla svertustig prentdufts Frá heimaskjánum, snertu  Stillingar Prenta Gæði . Stilltu stillinguna í valmynd fyrir svertustig prentdufts. svertustig prentdufts stillir stilla svertustig prentdufts"},{"UUID":"7f6207da-dc1c-4abe-9ed9-68f3ebf3d61b","title":"Afritun","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Nota sjálfvirkan matara skjala (ADF)","descFull":"Nota sjálfvirkan matara skjala (ADF) og Hlaða pappír í skúffu sjálfvirks matara og á gler skannans Sjálfvirkur matari skjala (ADF) Gler á skanna Nota sjálfvirkan matara fyrir skjöl með mörgum síðum eða á báðum hliðum. Hlaða upphaflegu skjali snúandi upp. Fyrir skjöl með mörgum síðum, gætið þess að stilla af upphafsbrún fyrir hleðslu. Vertu viss um að stilla stýringarnar í sjálfvirka mataranum til að samvara breidd á pappír sem verið er að hlaða. Nota gler á skanna fyrir einnar síðu skjöl, bókarsíður, minni hluti (svo sem póstkort eða myndir), glærur, ljósmyndapappír eða þunnt efni (svo sem úrklippur úr tímaritum). Setja skjalið snúandi niður í hornið með örinni. afritun nota sjálfvirkan matara skjala (ADF) afritun nota gler á skanna"},{"UUID":"5cb212e6-69a6-43c0-a3db-ae7951bc1421","title":"Afritun","link":"making-copies-topic.html","desc":"Taka afrit Settu upprunalega skjalið","descFull":"Taka afrit Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Til að forðast skurð á mynd, vertu viss um að upprunalega skjalið og útprentunin séu með sömu stærð pappírs. Á heimaskjánum, snertu  Afrit , og skilgreindu síðan fjölda á afritum. Aðlagaðu stillingar afritunar ef þörf krefur. Afritaðu skjalið. Til að taka fljótlegt afrit frá heimaskjánum, snertu  . taka afrit nota sjálfvirka matarann afritun nota gler á skanna afritun afrita frá velja skúffu afrita mismunandi pappírsstærðir mismunandi pappírsstærðir, afritun"},{"UUID":"2e5420cb-006e-4034-b926-ff2b53255c72","title":"Afritun","link":"copying-photos-topic.html","desc":"Afritun á myndum Settu ljósmynd","descFull":"Afritun á myndum Settu ljósmynd á gler skannans. Á heimaskjánum, snertu  Afrit Innihald Gerð innihalds Ljósmynd .. Snertu  uppruna innihalds , veldu síðan stillinguna sem passar best við upprunalegu myndina. Afritaðu myndina. afritun ljósmyndir ljósmyndir, afritun"},{"UUID":"8f2431ea-c6c9-4a75-9f60-c624160d8b3b","title":"Afritun","link":"copying-transparencies-or-letterhead-topic.html","desc":"Afritun á bréfhaus Settu upprunalega","descFull":"Afritun á bréfhaus Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjánum, snertu  Afrit Afrita frá og veldu stærðina á upphaflega skjalinu. Snertu  Afrita til , og veldu síðan uppruna pappírs sem inniheldur bréfhausinn. Ef þú hlóðst bréfhausnum í fjölnota matarann skaltu snerta  Afrita til fjölnotamatara veldu pappírsstærð Bréfhaus . Afritaðu skjalið. afritun á bréfhaus bréfhaus afrita á"},{"UUID":"7087c101-b3e3-4af2-beb9-05d7d3509edd","title":"Afritun","link":"copying-on-both-sides-of-paper-topic.html","desc":"Afritun á báðar hliðar á","descFull":"Afritun á báðar hliðar á pappírnum Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Frá heimaskjánum, snertu  Afrit Hliðar . Veldu  1 hlið til 2 hliðar  eða  2 hliðar til 2 hliðar . Afritaðu skjalið. afritun á báðar hliðar á pappírnum afritun á tvær hliðar"},{"UUID":"7808d33a-c645-4204-8ee1-c68475dd8ea7","title":"Afritun","link":"reducing-enlarging-copies-topic.html","desc":"Minnka eða stækka afrit Settu","descFull":"Minnka eða stækka afrit Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Frá heimaskjá, snertu  Afrit Kvörðun veldu gildi kvörðunar. Breyting á stærð á upprunalega skjalinu eða útprentun eftir stillingu á  kvörðun  endurheimtir gildið í  Sjálfvirkt . Afritaðu skjalið. minnka stærð afrits stækka stærð afrits"},{"UUID":"350461a5-6d32-4b7b-8f0f-86684c9411b9","title":"Afritun","link":"collating-copies-topic.html","desc":"Samraða afritum Settu upprunalega skjalið","descFull":"Samraða afritum Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjánum, snertu  Afrit Samraða Kveikt [1,2,1,2,1,2] . Afritaðu skjalið. samraða afritum raða mörgum afritum"},{"UUID":"c9ee9e29-d2fa-43f3-8056-096f02499c9d","title":"Afritun","link":"placing-separator-sheets-between-copies-topic.html","desc":"Setja aðskilnaðarsíður á milli afrita","descFull":"Setja aðskilnaðarsíður á milli afrita Settu upprunalega skjalið í sjálfvirka matarann eða á gler skannans. Á heimaskjá prentarans, snertu  Afrit Aðskilnaðarsíður . Aðlagaðu stillingarnar. Sendu verkið sem verið er að afrita. setja aðskilnaðarsíður á milli afrita afritun"},{"UUID":"15c719dc-47d4-44c4-a429-0c357deb4fc7","title":"Afritun","link":"saving-paper-topic.html","desc":"Afrita margar síður á eina","descFull":"Afrita margar síður á eina örk Settu upprunalega skjalið í sjálfvirka matarann eða á gler skannans. Á heimaskjánum, snertu  Afrita Síður á hlið . Aðlagaðu stillingarnar. Afritaðu skjalið. afrita margar síður á eina síðu spara pappír spara prentlit"},{"UUID":"215da77d-56e0-4fd0-8048-cff4e6b85c5a","title":"Afritun","link":"copying-cards-topic.html","desc":"Afrita kort Settu kort á","descFull":"Afrita kort Settu kort á gler skannans. Á heimaskjá prentarans, snertu  Afrit Afrita frá . Snertu  ID kort . Afritaðu kortið. afritun kort kort afritun"},{"UUID":"2933fced-ada1-4e31-8e18-05dc3f6e5548","title":"Afritun","link":"stapling-copies-topic.html","desc":"Hefta afrit Settu upprunalega skjalið","descFull":"Hefta afrit Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Til að forðast skurð á mynd, vertu viss um að upprunalega skjalið og útprentunin séu með sömu stærð pappírs. Á heimaskjánum, snertu  Afrit , og skilgreindu síðan fjölda á afritum. Aðlagaðu stillingar afritunar ef þörf krefur. Snertu  Frágangur Hefta , og veldu síðan stillingu heftara. Afritaðu skjalið. hefta afrit eintök heftun"},{"UUID":"a16cd564-a5ec-4a3d-88b5-37c910187fb0","title":"Afritun","link":"punching-holes-copies-topic.html","desc":"Gata afrit Settu upprunalega skjalið","descFull":"Gata afrit Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Til að forðast skurð á mynd, vertu viss um að upprunalega skjalið og útprentunin séu með sömu stærð pappírs. Á heimaskjánum, snertu  Afrit , og skilgreindu síðan fjölda á afritum. Aðlagaðu stillingar afritunar ef þörf krefur. Snertu  Frágangur Gata , og veldu síðan stillingu gatara. Afritaðu skjalið. gata afrit eintök götun"},{"UUID":"80dcb439-b631-44f7-b37f-10bb0008e661","title":"Afritun","link":"using-offset-stacking-copies-topic.html","desc":"Nota hliðrunarstöflun í afritum Settu","descFull":"Nota hliðrunarstöflun í afritum Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Til að forðast skurð á mynd, vertu viss um að upprunalega skjalið og útprentunin séu með sömu stærð pappírs. Á heimaskjánum, snertu  Afrit , og skilgreindu síðan fjölda á afritum. Aðlagaðu stillingar afritunar ef þörf krefur. Snertu  Hliðraðar síður , og veldu síðan stillinguna. Afritaðu skjalið. hliðrunarstöflun í afritum eintök hliðrunarstöflun"},{"UUID":"293eb240-4b5e-4241-b327-9247565a0a36","title":"Afritun","link":"creating-copy-shortcut-topic.html","desc":"Búa til flýtivísi afritunar Á","descFull":"Búa til flýtivísi afritunar Á heimaskjá prentarans, snertu  Afrit . Aðlagaðu stillinguna og snertu síðan  . Búa til flýtivísi. búa til flýtivísi afritun bæta við flýtivísi afritun flýtivísir, búa til afritun"},{"UUID":"810b1f60-7f32-4605-a603-4ef627f09b44","title":"Tölvupóstur","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"Nota sjálfvirkan matara skjala (ADF)","descFull":"Nota sjálfvirkan matara skjala (ADF) og Hlaða pappír í skúffu sjálfvirks matara og á gler skannans Sjálfvirkur matari skjala (ADF) Gler á skanna Nota sjálfvirkan matara fyrir skjöl með mörgum síðum eða á báðum hliðum. Hlaða upphaflegu skjali snúandi upp. Fyrir skjöl með mörgum síðum, gætið þess að stilla af upphafsbrún fyrir hleðslu. Vertu viss um að stilla stýringarnar í sjálfvirka mataranum til að samvara breidd á pappír sem verið er að hlaða. Nota gler á skanna fyrir einnar síðu skjöl, bókarsíður, minni hluti (svo sem póstkort eða myndir), glærur, ljósmyndapappír eða þunnt efni (svo sem úrklippur úr tímaritum). Setja skjalið snúandi niður í hornið með örinni. senda tölvupóst nota sjálfvirkan matara skjala (ADF) senda tölvupóst nota gler á skanna"},{"UUID":"35e282a3-f598-4ae7-b794-568b26c9a9cf","title":"Tölvupóstur","link":"sending-email-topic.html","desc":"Senda tölvupóst Vertu viss um","descFull":"Senda tölvupóst Vertu viss um að SMTP stillingar séu uppsettar áður en þú byrjar. Varðandi frekari upplýsingar, sjá  . Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjá, snertu  Tölvupóstur , og skráðu upplýsingar sem þörf er á. Aðlagaðu stillingar skönnunar ef þörf krefur. Sendu tölvupóstinn. tölvupóstur senda senda tölvupóst"},{"UUID":"28e80755-e5a0-46e8-aa61-a1b15dee4597","title":"Tölvupóstur","link":"creating-email-shortcut-topic.html","desc":"Búa til flýtivísi fyrir tölvupóst","descFull":"Búa til flýtivísi fyrir tölvupóst Á heimaskjá prentarans, veldu  Tölvupóstur . Aðlagaðu stillinguna og snertu síðan  . Búa til flýtivísi. býr til flýtivísi tölvupóstur bæta við flýtivísi tölvupóstur flýtivísir, búa til tölvupóstur flýtivísir tölvupósts býr til"},{"UUID":"87454d4c-e0e1-41dd-ae26-b96e333e4774","title":"Fax","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Nota sjálfvirkan matara skjala (ADF)","descFull":"Nota sjálfvirkan matara skjala (ADF) og Hlaða pappír í skúffu sjálfvirks matara og á gler skannans Sjálfvirkur matari skjala (ADF) Gler á skanna Nota sjálfvirkan matara fyrir skjöl með mörgum síðum eða á báðum hliðum. Hlaða upphaflegu skjali snúandi upp. Fyrir skjöl með mörgum síðum, gætið þess að stilla af upphafsbrún fyrir hleðslu. Vertu viss um að stilla stýringarnar í sjálfvirka mataranum til að samvara breidd á pappír sem verið er að hlaða. Nota gler á skanna fyrir einnar síðu skjöl, bókarsíður, minni hluti (svo sem póstkort eða myndir), glærur, ljósmyndapappír eða þunnt efni (svo sem úrklippur úr tímaritum). Setja skjalið snúandi niður í hornið með örinni. senda fax nota sjálfvirkan matara skjala (ADF) senda fax nota gler á skanna"},{"UUID":"cfef31a9-3a6a-4d88-a3c7-8e0b0a3eeead","title":"Fax","link":"sending-fax-topic.html","desc":"Senda fax Gangtu úr skugga","descFull":"Senda fax Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Nota stjórnborð prentara Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjá, snertu  Fax , og skráðu upplýsingar sem þörf er á. Breyttu stillingum ef þörf krefur. Sendu faxið. Nota tölvuna Gangtu úr skugga um að faxrekill sé uppsettur áður en þú byrjar. Varðandi frekari upplýsingar, sjá  . Fyrir Windows-notendur Opnaðu samskipti  Prenta  úr því skjali sem þú ert að reyna að faxa. Veldu prentarann og smelltu síðan á  Eiginleikar ,  Kjörstillingar ,  Valkostir , eða  Uppsetning . Smelltu á  Fax Virkja fax Ávallt sýna faxstillingar áður en fax er sent , og skráðu númer viðtakanda. Stilltu aðrar faxstillingar ef þörf krefur. Sendu faxið. Fyrir Macintosh-notendur Með skjalið opið, veldu  Skrá Prenta . Veldu prentara sem er með  ‑ Fax  á eftir heiti sínu. Í svæði  Til , skráðu númer viðtakanda. Stilltu aðrar faxstillingar ef þörf krefur. Sendu faxið. senda fax fax senda"},{"UUID":"ca79cae4-36b8-4961-8434-7e01292f9faf","title":"Fax","link":"scheduling-fax-topic.html","desc":"Skipuleggja fax Gangtu úr skugga","descFull":"Skipuleggja fax Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjá, snertu  Fax Til skráðu faxnúmerið Búið . Snertu  Tími sendingar , stilltu dagsetningu og tíma og veldu síðan  OK . Sendu faxið. skipuleggja fax fax, skipuleggja"},{"UUID":"b5bbb837-37b1-4704-946e-d2529a5ca8a0","title":"Fax","link":"creating-fax-destination-shortcut-topic.html","desc":"Búa til flýtivísi fyrir ákvörðunarstað","descFull":"Búa til flýtivísi fyrir ákvörðunarstað á faxi Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Frá heimaskjá, snertu  Fax Til . Skráðu númer viðtakanda og snertu síðan  Búið . Aðlagaðu stillinguna og snertu síðan  . Búa til flýtivísi. býr til flýtivísi ákvörðunarstaður fyrir fax bæta við flýtivísi ákvörðunarstaður fyrir fax flýtivísir, búa til ákvörðunarstaður fyrir fax flýtivísir fyrir ákvörðunarstað fyrir fax býr til"},{"UUID":"53f9cc26-f05d-4b3c-96d1-528a15d1e11b","title":"Fax","link":"changing-fax-resolution-topic.html","desc":"Breyta upplausn í faxi Gangtu","descFull":"Breyta upplausn í faxi Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjá, snertu  Fax , og skráðu upplýsingar sem þörf er á. Snertu  Upplausn , og veldu síðan stillinguna. Sendu faxið. upplausn á faxi breyta breyta upplausn í faxi"},{"UUID":"914938a4-d990-451b-8790-581bdb3bb2f5","title":"Fax","link":"adjusting-fax-darkness-topic.html","desc":"Stilla svertustig á faxi Gangtu","descFull":"Stilla svertustig á faxi Gangtu úr skugga um að fax sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Á heimaskjá, snertu  Fax , og skráðu upplýsingar sem þörf er á. Snertu  Svertustigs , og aðlagaðu síðan stillinguna. Sendu faxið. stilla svertustig á faxi svertustig á faxi stillir"},{"UUID":"d7a198f5-7fd4-4478-b984-a3e0f0adab39","title":"Fax","link":"printing-fax-log-topic.html","desc":"Prenta atvikaskrá fyrir fax Gakktu","descFull":"Prenta atvikaskrá fyrir fax Gakktu úr skugga um að hliðrænt fax eða etherFAX sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Frá heimaskjánum, snertu  Stillingar Skýrslur Fax . Snertu  Atvikaskrá fyrir fax  eða  Atvikaskrá yfir faxhringingar . atvikaskrá fyrir fax prentar prenta atvikaskrá fyrir fax"},{"UUID":"ebb3ca96-67c6-47d3-ab43-a5b20677a266","title":"Fax","link":"blocking-junk-faxes-topic.html","desc":"Loka á ruslföx Gakktu úr","descFull":"Loka á ruslföx Gakktu úr skugga um að hliðrænt fax eða etherFAX sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Frá heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Móttökustillingar á faxi Stýringar stjórnanda . Stilltu  Loka á föx án nafns  á  Kveikt . ruslföx loka á loka á ruslföx"},{"UUID":"104069f1-f7dd-4fa2-ba5c-c35a3da6a9dd","title":"Fax","link":"holding-faxes-topic.html","desc":"Geyma föx Gakktu úr skugga","descFull":"Geyma föx Gakktu úr skugga um að hliðrænt fax eða etherFAX sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Frá heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi  Móttökustillingar á faxi Geyma föx . Veldu stillingu. geyma föx móttekin föx setja í bið fax setja í bið"},{"UUID":"745a6cfa-cc17-4f04-b9fe-3dd8bc36e57d","title":"Fax","link":"forwarding-fax-topic.html","desc":"Framsenda fax Gakktu úr skugga","descFull":"Framsenda fax Gakktu úr skugga um að hliðrænt fax eða etherFAX sé uppsett. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Búa til flýtivísi fyrir ákvörðunarstað. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjánum. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Flýtivísar Bæta við flýtivísi . Veldu gerð flýtivísis og settu síðan upp stillingarnar. Skráðu númerið á flýtivísinum. Beittu breytingunum. Smelltu á  Stillingar Fax Uppsetning á faxi Móttökustillingar á faxi Stýringar stjórnanda . Í valmyndinni  Áframsending á faxi  veldu  Áframsenda  eða  Prenta og áframsenda . Í valmyndinni  Áframsenda til  veldu gerð ákvörðunarstaðar og skráðu síðan númer á flýtivísi. Beittu breytingunum. framsenda fax fax framsending"},{"UUID":"4250b037-7acc-40e7-b70e-2f159e477e64","title":"Skönnun","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Nota sjálfvirkan matara skjala (ADF)","descFull":"Nota sjálfvirkan matara skjala (ADF) og Hlaða pappír í skúffu sjálfvirks matara og á gler skannans Sjálfvirkur matari skjala (ADF) Gler á skanna Nota sjálfvirkan matara fyrir skjöl með mörgum síðum eða á báðum hliðum. Hlaða upphaflegu skjali snúandi upp. Fyrir skjöl með mörgum síðum, gætið þess að stilla af upphafsbrún fyrir hleðslu. Vertu viss um að stilla stýringarnar í sjálfvirka mataranum til að samvara breidd á pappír sem verið er að hlaða. Nota gler á skanna fyrir einnar síðu skjöl, bókarsíður, minni hluti (svo sem póstkort eða myndir), glærur, ljósmyndapappír eða þunnt efni (svo sem úrklippur úr tímaritum). Setja skjalið snúandi niður í hornið með örinni. skönnun nota sjálfvirkan matara skjala (ADF) skönnun nota gler á skanna"},{"UUID":"6c25eea6-80e7-4a2d-9a1f-dc862f868bbf","title":"Skönnun","link":"scanning-to-computer-topic.html","desc":"Skanna til tölvu Vertu viss","descFull":"Skanna til tölvu Vertu viss um að tölvan og prentarinn séu tengd við sama netkerfið áður en þú byrjar. Fyrir Windows-notendur Nota Lexmark „ScanBack“ þjónustu Keyrðu Lexmark „Scanback“ þjónustu frá tölvunni, og smelltu síðan  Næst . Til að hlaða niður þjónustunni, farðu á  www.lexmark.com/downloads . Smelltu á  Uppsetning , og bættu síðan við IP-tölu prentarans. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Smelltu á  Loka Næst . Veldu stærðina á upphaflega skjalinu, og smelltu síðan á  Næst . Veldu skráarsnið og upplausn í skönnun, og smelltu síðan á  Næst . Skráðu einkvæmt nafn á skönnunarprófíl, og smelltu síðan á  Næst . Flettu að þeim stað þar sem þú vilt vista skannaða skjalið, búðu til heiti skjals og smelltu síðan á  Næst . Til að endurnota skönnunarprófíl, virkjaðu  Búa til flýtivísi , og skráðu síðan einkvæmt nafn á flýtivísi. Smelltu á  Ljúka . Settu upprunalega skjalið í sjálfvirkan matara skjal eða á gler skannans. Frá heimaskjá prentara, snertu  Skanna prófíla Skanna til tölvu , og veldu síðan skönnunarprófíl. Gakktu úr skugga um að  Skönnunarprófílar  sé bætt við heimaskjáinn. Varðandi frekari upplýsingar, sjá  . Fyrir Windows-notendur Nota Windows Fax og skönnun Vertu viss um að prentaranum hafi verið bætt við tölvuna. Varðandi frekari upplýsingar, sjá  . Settu upprunalega skjalið í sjálfvirkan matara skjal eða á gler skannans. Í tölvunni, opnaðu  Windows Fax og skönnun . Í valmynd  Uppruni , veldu uppruna skanna. Breyttu stillingum skönnunar ef þörf krefur. Skannaðu skjalið. Fyrir Macintosh-notendur Vertu viss um að prentaranum hafi verið bætt við tölvuna. Varðandi frekari upplýsingar, sjá  . Settu upprunalega skjalið í sjálfvirkan matara skjal eða á gler skannans. Frá tölvunni, gerðu annað af eftirfarandi: Opna  Image Capture . Opna  Prentara og scannar , og velja síðan prentara. Smelltu á  Skanna Opna skanna . Í glugga fyrir  skanna , gerðu eitt af eftirfarandi: Veldu hvar þú vilt vista skannaða skjalið. Veldu stærðina á upphaflega skjalinu. Til að skanna frá sjálfvirka matara skjala (ADF), veldu  Matari skjals  í  Valmynd skönnunar  eða virkjaðu  Nota matara skjala . Aðlagaðu stillingar skönnunar ef þörf krefur. Smelltu á  Skanna . skönnun til tölvu tölva, skannar til Lexmark „ScanBack“ þjónusta notar"},{"UUID":"7e0f9b12-53df-4b2c-9173-29fcc7e0214d","title":"Skönnun","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Skanna til FTP-miðlara Settu upprunalega","descFull":"Skanna til FTP-miðlara Settu upprunalega skjalið í skúffu sjálfvirka matarans eða á gler skannans. Á heimaskjá, snertu  FTP , og skráðu síðan upplýsingar sem þarf. Stilltu aðrar FTP-stillingar ef þörf krefur. Sendu FTP-verkið. FTP-miðlari, skanna til notar stjórnborð prentara skönnun til FTP-miðlara skanna til FTP-miðlara notar stjórnborð prentara"},{"UUID":"5c736d33-1605-498e-854a-f5fbd21af905","title":"Skönnun","link":"creating-FTP-shortcut-topic.html","desc":"Búa til FTP-flýtivísi Frá heimaskjá,","descFull":"Búa til FTP-flýtivísi Frá heimaskjá, snertu  FTP . Skráðu vistfang á FTP-miðlara og snertu síðan  . Búa til flýtivísi. býr til flýtivísi FTP vistfang bæta við flýtivísi FTP vistfang FTP vistfang býr til flýtivísi flýtivísir, búa til FTP vistfang"},{"UUID":"cfb9e0d9-5089-44a9-ba84-45878152c8c0","title":"Skönnun","link":"s2a-scanning-to-network-folders-topic.html","desc":"Skanna í möppu á netinu","descFull":"Skanna í möppu á netinu Settu upprunalega skjalið í sjálfvirka matarann eða á gler skannans. Á heimaskjá prentarans, veldu  Skönnunarmiðstöð . Tákn og heiti gæti hafa breyst. Hafðu samband við þinn kerfisstjóra varðandi frekari upplýsingar Gerðu annað hvort af eftirfarandi: Veldu ákvörðunarstað. Fyrir SFTP, stilltu númer á gátt á  22 . Nota flýtivísi með því að snerta  , og veldu síðan flýtivísi á listanum. Skannaðu skjalið. skanna í möppu á netinu SMB skönnun"},{"UUID":"7417fc59-d1d5-4683-a87a-b9f927404753","title":"Skönnun","link":"creating-network-folder-shortcut-topic.html","desc":"Búa til flýtivísi fyrir möppu","descFull":"Búa til flýtivísi fyrir möppu netkerfis Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Flýtivísar Bæta við flýtivísi . Í valmynd fyrir flýtivísa, veldu  Mappa netkerfis  og settu síðan upp stillingarnar. Beittu breytingunum. mappa netkerfis búa til flýtivísi búa til flýtivísi mappa netkerfis"},{"UUID":"eec79407-71d3-418d-bf58-ade4bf325db1","title":"Skönnun","link":"scanning-to-flash-drive-topic.html","desc":"Skanna til minniskorts Settu upprunalega","descFull":"Skanna til minniskorts Settu upprunalega skjalið í skúffu á sjálfvirka mataranum eða á gler skannans. Settu inn minniskort. Snertu  Skanna til USB  og aðlagaðu stillingar ef þarf. Til að vista skannaðs kjal í möppu, snertu  Skanna til , veldu möppu, og snertu síðan  Skanna hér . Ef skjámynd fyrir  USB-drif  birtist ekki, snertu þá  USB-drif  á stjórnborðinu. Skannaðu skjalið. Til að forðast gagnatap eða truflun, ekki snerta minniskortið eða prentarann á þeim svæðum sem eru sýnd þegar prentun, lestur eða skrif er virk frá minniskorti. skönnun til minniskorts minniskort skanna til"},{"UUID":"5cda36b4-9ae9-4851-93ae-c69d59574e74","title":"Nota valmyndir prentarans","link":"menu-map-mfp-topic.html","desc":"Yfirlit valmynda Tæki Kjörstillingar sparnaðarstilling","descFull":"Yfirlit valmynda Tæki Kjörstillingar sparnaðarstilling Fjarstýrt stjórnborð Tilkynningar Orkustýring Nafnlaus söfnun gagna Aðgengileiki Endurheimta sjálfgefnar verksmiðjustillingar Viðhald Sérsnið á heimaskjá Um þennan prentara Prenta Útlit Frágangur Uppsetning Gæði Verkreikningar PDF PostScript PCL Mynd Pappír Uppsetning skúffu Uppsetning á miðli Afritun Sjálfgildi afritunar Fax Sjálfgildi fax Tölvupóstur Uppsetning tölvupósts Sjálfgildi tölvupósts Uppsetning veftengils FTP Sjálfgildi FTP USB-drif Skönnun frá minniskorti Prentun frá minniskorti Netkerfi/tengi Yfirlit netkerfis Þráðlaust Wi‑Fi Direct AirPrint Stjórnun þjónustu fartækja Ethernet TCP/IP SNMP IPSec 802.1x LPD-uppsetning HTTP/FTP-stillingar ThinPrint USB Takmarka ytra aðgengi að netkerfi Öryggi Aðferðir innskráningar Skipuleggja USB-tæki Eftirlitsskrá öryggis Hömlur á innskráningu Uppsetning trúnaðarprentunar Dulkóðun disks Eyða tímabundnum gagnaskrám Stillingar LDAP-lausna Ýmislegt Skýjaþjónustur Skráning í skýjaþjónustu Skýrslur Síða yfir stillingar valmyndar Tæki Prenta Flýtivísar Fax Netkerfi Bilanaleit Prenta gæðaprófunarsíður Skanninn hreinsaður valmyndir prentara"},{"UUID":"2b8c840a-2396-49bf-ab2e-1b7941409d0b","title":"Tæki","link":"preferences-topic.html","desc":"Kjörstillingar Atriði valmyndar  kjörstillinga","descFull":"Kjörstillingar Atriði valmyndar  kjörstillinga  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Tungumál á skjá [Listi yfir tungumál] Stillir tungumál texta sem birtist á skjánum. Land/svæði [Listi yfir lönd eða svæði] Auðkennir landið eða svæðið sem prentarinn er settur upp fyrir. Keyra byrjunaruppsetningu Slökkt * Kveikt Keyra leiðsagnarforrit uppsetningar. Lyklaborð Gerð lyklaborðs [Listi yfir tungumál] Velja tungumál sem gerð lyklaborðs. Öll gildi yfir  gerð lyklaborðs  kunna ekki að birtast eða gætu krafist þess að sérstakur vélbúnaður sé uppsettur til að birtast. Upplýsingar á skjá Skjátexti 1  ( IP-tala *) Skjátexti 2  ( Dags/Timi *) Sérsniðinn texti 1 Sérsniðinn texti 2 Skilgreina upplýsingar sem á að birtast á heimaskjánum. Dagsetning og tími Setja upp Núverandi dagsetning og tími Stilla dagsetningu og tíma handvirkt Snið dagsetningar  (MM‑DD‑ÁÁÁÁ*) Snið tíma  (12 klst. F.H./E.H.*) Tímabelti  (UTC-5:00*) Samskiptatími netkerfis (NTP) Virkja samskiptatíma netkerfis (NTP)  ( kveikt *) NTP-þjónn Virkja sannvottun  ( Engin *) Stilla dagsetningu og tíma prentarans og samskiptatími netkerfis. Pappírsstærðir U.S. * Metramál Skilgreinir mælieiningar fyrir pappírsstærðir. Land eða svæði sem þú valdir í leiðsagnarforriti uppsetningar í byrjun ákvarðar upphafsstillingar á pappírsstærð. Birtustig á skjá 20–100% (100*) Stilla birtustig á úttaki. Aðgengi að minniskorti Óvirkt Virkt * Virkja aðgengi að minniskorti. Leyfa að fjarlægja bakgrunn Slökkt Kveikt * Skilgreina hvort fjarlæging á bakgrunni sé leyfð. Leyfa skönnun á sérsniðnum verkum Slökkt Kveikt * Skilgreina hvort stilling á  Skönnun á sérsniðnu verki  birtist fyrir afritun, skönnun og fax. Þessi stilling valmyndar birtist aðeins þegar harður diskur prentara er uppsettur. Einnar síðu skönnun á flötum skanna Slökkt * Kveikt Stilltu prentarann til að skanna hvers konar gerð verks sem felur í sér glers skanna sem eina síðu. Prentarinn snýr aftur á heimaskjáinn eftir að hafa gert eina flatskönnun í stað þess að sýna fyrirmæli. Hljóð tækis Þagga öll hljóð  ( Slökkt *) Hnappur fyrir svörun  ( Kveikt *) Svörun fyrir aðgang tækis  ( Kveikt *) Hljóðstig  (5*) Hljóðmerki fyrir hleðslu á sjálfvirkum matara  ( Kveikt *) Stýring á viðvörunum  ( Einfalt *) Viðvörun hylkis  ( Einfalt *) Stilling hátalara  ( Alltaf kveikt *) Hljóðstyrkur hringingar  ( slökkt *) Setja upp hljóðstillingar prentarans. Tímarof á skjá 5–300 sekúndur (60*) Stilla aðgerðalausan tíma í sekúndum áður en skjáinn sýnir heimaskjáinn, eða áður en prentari skráir sjálfkrafa út af notandareikningi. valmynd Kjörstillingar"},{"UUID":"4588f7dd-9a43-47a5-8a48-a295e5bc023d","title":"Tæki","link":"preferences-topic.html","desc":"Sparnaðarstilling Atriði og lýsingar valmyndar","descFull":"Sparnaðarstilling Atriði og lýsingar valmyndar  Sparnaðarstilling Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Prenta Hliðar 1‑hlið * 2‑hliðar Skilgreina hvort prentað er á eina hlið eða báðar hliðar á pappír. Prenta Síður á hlið Slökkt * 2 síður á hlið 3 síður á hlið 4 síður á hlið 6 síður á hlið 9 síður á hlið 12 síður á hlið 16 síður á hlið Prenta margar síðumyndir á einni hlið á pappírsörk. Prenta Svertustig prentdufts 1–10 (8*) Ákvarða stig birtu eða svertu í textamyndum. Afritun Hliðar 1 hlið til 1 hliðar * 1 hlið til 2 hliðar 2 hlið til 1 hliðar 2 hlið til 2 hliðar Skilgreina hegðun skönnunar byggt á upphaflegu skjali. Afritun Síður á hlið Slökkt * 2 síður með skammsniði 4 síður með skammsniði 2 síður með langsniði 4 síður með langsniði Skilgreina hegðun skönnunar byggt á upphaflegu skjali. Afritun Svertustig 1–9 (5*) Skilgreina svertustig á skönnuðum textamyndum. valmynd sparnaðarstilling"},{"UUID":"5b3a1ab7-ddbe-4ebb-93cf-f94ab55b3431","title":"Tæki","link":"preferences-topic.html","desc":"Fjarstýrt stjórnborð Atriði valmyndar fyrir","descFull":"Fjarstýrt stjórnborð Atriði valmyndar fyrir  Fjarstýrt stjórnborð  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Ytri VNC-tenging Ekki leyfa * Leyfa Tengja ytri „Virtual Network Computing“ (VNC) biðlara við fjarstýrt stjórnborð. Gerð sannprófunar Engin * Staðal sannprófun Stilla gerð sannprófunar þegar tengst er við VNC-þjón biðlara. Aðgangsorð VNC Skilgreina aðgangsorð til að tengjast við VNC-þjón biðlara. Þetta atriði valmyndar birtist aðeins ef  Gerð sannprófunar  er stillt á  Staðalgerð sannprófunar . valmynd Fjarstýrt stjórnborð"},{"UUID":"8e211f81-4d37-4605-81c9-d6ce93cb20ab","title":"Tæki","link":"preferences-topic.html","desc":"Tilkynningar Atriði valmyndar  Tilkynningar","descFull":"Tilkynningar Atriði valmyndar  Tilkynningar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Hljóðmerki fyrir hleðslu á sjálfvirkum matara Slökkt Kveikt * Virkja hljóð þegar pappír er hlaðið í sjálfvirkan matara. Stýring á viðvörunum Slökkt Einföld * Stöðug Stilltu fjölda sem viðvörun hljómar þegar prentari krefst íhlutunar notanda. Rekstrarvörur Sýna áætlaðar rekstrarvörur Sýna áætlun * Ekki sýna áætlun Sýna áætlaða stöðu á rekstrarvörum. Rekstrarvörur Viðvörun hylkis  ( Einfalt *) Viðvörun heftara  ( Slökkt *) Viðvörun fyrir gatara  ( Slökkt *) Stilltu fjölda skipta sem viðvörunin heyrist þegar blekhylki er með lága stöðu, heftahylkið er tómt eða móttakari götunar er fullt eða vantar, í þessari röð. Viðvörun fyrir gatara  og  Viðvörun gatara  birtast aðeins þegar úttaksvalkostir eru uppsettir. Rekstrarvörur Sérsniðnar tilkynningar rekstrarvöru Stilla eininguna sem prentarinn notar til að áætla notkun á rekstrarvöru og gangsetja tilkynningar þegar þörf er á íhlutun notanda. Þetta atriði valmyndar birtist aðeins í innbyggða vefþjóninum. Uppsetning viðvarana í tölvupósti Uppsetning tölvupósts Aðal SMTP-gátt Aðaltengi SMTP-gáttar  (25*) Auka SMTP-gátt Aukatengi SMTP-gáttar  (25*) SMTP tímarof  (30 sekúndur*) Vistfang svörunar Nota ávallt sjálfvalið vistfang svörunar SMTP  ( Slökkt *) Nota SSL/TLS  ( Óvirkt *) Krefjast áreiðanlegs vottorðs  ( Kveikt *) Sannvottun SMTP þjóns  ( Engrar sannvottunar krafist *) Tölvupóstur að frumkvæði tækis  ( Engin *) Tölvupóstur að frumkvæði notanda  ( Enginn *) Nota virk vottorð skráarsafns tækis  ( Slökkt *) Notandaauðkenni tækis Aðgangsorð tækis Kerberos 5 REALM NTLM-lén Gera villu „SMTP-þjónn ekki uppsettur“ óvirka  ( Slökkt *) Setja upp tölvupóststillingar prentarans. Uppsetning viðvarana í tölvupósti Uppsetning tölvupóstslista og viðvarana Tölvupóstslisti 1 Tölvupóstslisti 2 Atvik tölvupósts Skilgreina netföng tölvupósts og virkja viðvörunaratvik tölvupóstsins. Þetta atriði valmyndar birtist aðeins í innbyggða vefþjóninum. Komist hjá villum Hjálp við flækju Slökkt Kveikt * Stilla prentarann til að senda sjálfkrafa auðar síður eða síður með prentun að hluta eftir að flæktri síðu hefur verið eytt. Komist hjá villum Halda áfram sjálfvirkt Slökkt Kveikt * (5 sekúndur) Láta prentarann halda áfram að vinna eða prenta verk sjálfkrafa eftir að hreinsa ákveðin prentunarskilyrði sem þarfnast íhlutunar notanda. Komist hjá villum Sjálfvirk endurræsing Sjálfvirk endurræsing Endurræsing þegar óvirkur Ávallt endurræsa * Aldrei endurræsa Stilla prentarann til að endurræsa þegar villa á sér stað. Komist hjá villum Sjálfvirk endurræsing Hám. sjálfvirkar endurræsingar 1–20 (2*) Stilla fjölda sjálfvirkra endurræsinga sem prentarinn getur framkvæmt. Komist hjá villum Sjálfvirk endurræsing Gluggi sjálfvirkrar endurræsingar 1–525600 sekúndur (720*) Stilla tímann áður en prentarinn framkvæmir sjálfvirka endurræsingu. Komist hjá villum Sjálfvirk endurræsing Teljari sjálfvirkrar endurræsingar Sýna eingöngu lesnar upplýsingar um teljara endurræsingar. Komist hjá villum Sjálfvirk endurræsing Endurstilla teljara sjálfvirkrar endurræsingar Hætta við Halda áfram Endurstilla teljara  sjálfvirkrar endurræsingar . Komist hjá villum Sýna villu varðandi of stuttan pappír Kveikt Sjálfvirk hreinsun * Stilla prentarann til að sýna skilaboð þegar villan of stuttur pappír á sér stað. Of stuttur pappír á við um pappír sem verið er að hlaða. Komist hjá villum Verndun síðu Slökkt * Kveikt Stilla prentarann til að vinna alla síðuna í minni áður en hún er prentuð. Endurheimta innihald flækju Endurheimta flækju Slökkt Kveikt Sjálfvirkt * Stilla prentarann til að endurprenta flæktar síður. Endurheimta innihald flækju Endurheimta flækju í skanna Stig verks Stig síðu * Skilgreina hvernig á að endurræsa verk í skönnun eftir að pappírsflækja er leyst. valmynd Tilkynningar"},{"UUID":"4d7f1ac7-03d3-4342-a099-4765180a7a64","title":"Tæki","link":"preferences-topic.html","desc":"Orkustýring Atriði valmyndar  orkustillingar","descFull":"Orkustýring Atriði valmyndar  orkustillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Prófíll svefnstillingar Prenta úr svefnstillingu Halda vakandi eftir prentun Fara í svefnstillingu eftir prentun * Stilla prentarann til að haldast vakandi eða fara aftur til baka í Svefnstillingu eftir prentun. Prófíll svefnstillingar Snertu til að vekja úr djúpri svefnstillingu Slökkt * Kveikt Vekja prentarann úr djúpri svefnstillingu með því að snerta prentaraskjáinn. Tímarof Svefnstilling 1–114 mínútur (15*) Stilla tímalengd aðgerðarleysis áður en prentarinn fer í svefnstöðu. Tímarof Tímarof stillingar í dvala Óvirkt 1 klst. 2 klst. 3 klst. 6 klst. 1 dagur 2 dagar 3 dagar * 1 vika 2 vikur 1 mánuður Stilla tímann áður en það slokknar á prentaranum. Tímarof Tímarof dvala í tengingu Setja í dvala Ekki setja í dvala * Stilla  Tímarof dvala  til að slökkva á prentaranum þegar virk Ethernet-tenging er til staðar. Tímastilla straumstillingar Skipulag Bæta við nýju skipulagi Tímastilla þegar prentarinn á að fara í svefnstillingu eða stillingu í dvala. valmynd Orkustýring"},{"UUID":"cacb921a-5235-4c55-a935-fde44655f2ff","title":"Tæki","link":"preferences-topic.html","desc":"Nafnlaus söfnun gagna Atriði valmyndar","descFull":"Nafnlaus söfnun gagna Atriði valmyndar  Nafnlausrar söfnunar gagna  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Nafnlaus söfnun gagna Notkun tækis og upplýsingar um frammistöðu Engin * Senda upplýsingar um notkun prentarans og frammistöðu til Lexmark. Senda upplýsingar um notkun prentarans og frammistöðu til framleiðandans. Senditími nafnlausra gagna  birtist aðeins þegar þú stillir  Nafnlausa söfnun gagna  á  Notkun tækis og frammistaða . Senditími nafnlausra gagna Upphafstími Lokatími valmynd Nafnlaus söfnun gagna"},{"UUID":"eba7b911-a34a-49b0-be6b-951ac58147e7","title":"Tæki","link":"preferences-topic.html","desc":"Aðgengileiki Atriði valmyndar aðgengis og","descFull":"Aðgengileiki Atriði valmyndar aðgengis og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Millibil endurtekins ásláttar lykils 0–5 (0*) Stilltu bilið í sekúndum þar sem prentari hunsar endurtekinn þrýsting á lykil á áföstu lyklaborði. Upphaflegur biðtími endurtekins ásláttar á lykil 0,25–5 (1*) Stilla upphaflegan biðtíma í sekúndum áður en endurtekinn lykill byrjar endurtekningu. Þetta atriði valmyndir birtist aðeins þegar lyklaborð er áfast prentaranum. Hlutfall endurtekins lykils 0,5–30 (30*) Stilla fjölda hve oft á sekúndu er ýtt á endurtekinn lykil. Þetta atriði valmyndir birtist aðeins þegar lyklaborð er áfast prentaranum. Lengja tímarof á skjá Slökkt * Kveikt Láta notandann vera kyrran á sama stað og endurstilla tímastillingu fyrir  tímarof á skjá  í stað þess að fara til baka í heimaskjá. Hljóðstig heyrnartóla 1–10 (5*) Stilla hljóðstyrk höfuðheyrnatóla. Þetta atriði valmyndar birtist aðeins þegar höfuðheyrnartól er áfast prentaranum. Leyfa raddstýringu þegar höfuðheyrnartólk eru tengd Slökkt * Kveikt Leyfa raddstýringu þegar höfuðheyrnartólk eru tengd prentara. Tala aðgangsorð/PIN-númer Slökkt * Kveikt Stilla prentarann til að tala aðgangsorð eða persónuauðkennanleg númer upphátt. Þetta atriði valmyndar birtist aðeins þegar höfuðheyrnartól eða hátalari eru áföst prentaranum. Hraði tals Mjög hægt Hægt Venjuleg * Hratt Hraðara Mjög hratt Ör Mjög ör Hraðast Stilla hraða tals í raddstýringu Þetta atriði valmyndar birtist aðeins þegar höfuðheyrnartól eða hátalari eru áföst prentaranum. valmynd Aðgengileiki"},{"UUID":"1d17b352-79c1-40a4-8153-c4344c4edf0c","title":"Tæki","link":"preferences-topic.html","desc":"Endurheimta sjálfgefnar verksmiðjustillingar Atriði valmyndar","descFull":"Endurheimta sjálfgefnar verksmiðjustillingar Atriði valmyndar fyrir  endurheimtu á sjálfgefnum verksmiðjustillingum  og lýsingar þeirra Atriði valmyndar Lýsing Endurheimta stillingar Endurheimta allar stillingar Endurheimta stillingar prentarans Endurheimta stillingar netkerfisins. Endurheimta faxstillingar Endurheimta stillingar forrits Endurheimta sjálfgefnar stillingar frá verksmiðju. valmynd Endurheimta sjálfgefnar verksmiðjustillingar"},{"UUID":"29895600-48e7-4bad-adc2-a1f280179dea","title":"Viðhald","link":"preferences-topic.html","desc":"Uppsetningarvalmynd Atriði valmyndar  Uppsetningar","descFull":"Uppsetningarvalmynd Atriði valmyndar  Uppsetningar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. USB-uppsetning USB PnP 1* 2 Breyta stillingu á USB-rekli prentarans til að bæta samhæfni við einkatölvu. USB-uppsetning Skanna USB staðbundið Kveikt * Slökkt Stilla hvort rekill USB-tækisstjóra teljist sem einfalt USB-tæki (eitt tengi) eða sem samsett USB-tæki (margar tengingar). USB-uppsetning USB-hraði Fullur Sjálfvirkt * Stilla USB-tengið til að virka á fullum hraða og gera háhraðagetu þess óvirka. Uppsetning skúffu Skynjun stærðar Skúffa [x] skynjun Slökkt Kveikt * Oficio/Fólíó skynjun Fólíó * Oficio (Mexico) Yfirlýsing/A5 skynjun Yfirlýsing skynjunar * Skynja A5 Stjórnunarleg (Executive)/B5 skynjun Skynja Exec * Skynja B5 Stilla bakkann þannig að hann skynji sjálfkrafa pappírsstærðina sem er hlaðin í hann. Uppsetning skúffu Tenging á skúffum Sjálfvirkt * Slökkt Stilla prentarann til að tengja skúffur sem eru með stillingar á sömu pappírsgerð og pappírsstærð. Uppsetning skúffu Sýna skilaboð um innsetningu á skúffu Slökkt Aðeins fyrir óþekktar stærðir * Alltaf Birta skilaboð sem gerir notanda kleift að breyta pappírsstærð og pappírsgerð eftir að bakkinn er settur inn. Uppsetning skúffu Pappírskvaðingar Sjálfvirkt * Fjölnotamatari Handvirk stilling pappírs Stilla uppruna pappírs sem notandinn fyllir á þegar kvaðning birtist um að hlaða pappír. Til að  Fjölnotamatari  birtist í valmynd fyrir  Pappír  stilltu  Stilltu MP  á  Kasettu . Uppsetning skúffu Kvaðningar umslags Sjálfvirkt * Fjölnotamatari Handvirk stilling umslags Stilla uppruna pappírs sem notandinn fyllir á þegar kvaðning birtist um að hlaða umslagi. Til að  Fjölnotamatari  birtist í valmynd fyrir  Pappír  stilltu  Stilltu MP  á  Kasettu . Uppsetning skúffu Aðgerð vegna kvaðninga Kvaðning notanda * Halda áfram Nota núverandi Stilla prentarann til að leysa kvaðningar vegna pappírs eða umslaga. Uppsetning skúffu Uppsetning skúffu fyrir umslög Slökkt * Kveikt Kveikja á skúffu fyrir umslög til að prenta umslög. Uppsetning skúffu Margar alhliða stærðir Slökkt * Kveikt Stilla skúffuna á að styðja margar alhliða pappírsstærðir. Skýrslur Síða yfir stillingar valmyndar Atvikaskráning Samantekt atvikaskrár Prentar skýrslur um stillingar á valmynd prentara, stöðu og atvikaskráningu. Notkun rekstrarvöru og teljarar Hreinsa notkunarsögu rekstrarvöru Endurstilla ferilssögu rekstrarvöru, svo sem fjölda síðna og daga eftir, í stillingu frá verksmiðju. Notkun rekstrarvöru og teljarar Stillingar á stórum miðli Slökkt * Kveikt Leyfa breytingar þegar prentað er á stórt eða þykkt efni. Herming prentara PPDS-herming Slökkt * Kveikt Stilla prentarann til að bera kennsl á og nota PPDS-gagnastreymi. Herming prentara PS-herming Slökkt Kveikt * Stilla prentarann til að bera kennsl á og nota PS-gagnastreymi. Herming prentara Virkja Prescribe Slökkt * Kveikt Kveikja á PRESCRIBE. Leyfi PRESCRIBE verður að vera uppsett. Herming prentara Öryggi hermingar Tímarof síðu 0–60 (60*) Stilla tímarof síðu við hermingu. Herming prentara Öryggi hermingar Endurstilla hermingu eftir verk Slökkt * Kveikt Endurstilla hermingu eftir verk í prentun. Herming prentara Öryggi hermingar Gera aðgengi skilaboða prentara óvirk Slökkt Kveikt * Gera aðgengi að skilaboðum prentara óvirkt á meðan á hermingu stendur. Uppsetning á faxi Stuðningur fax við litla straumnotkun Gera svefn óvirkan Leyfa svefn Sjálfvirkt * Stilla fax til að fara í svefnstillingu þegar prentarinn ákvarðar að það skuli gerast. Uppsetning á faxi Staðsetning á faxgeymslu NAND Diskur * Stilla staðsetningu á geymslu fyrir öll föx. Þetta atriði valmyndar birtist aðeins þegar harður diskur eða ISD er til staðar. Uppsetning prentunar Skerping leturs 0–150 (24*) Stilla gildi fyrir punktastærð texta fyrir neðan hátíðnirasta sem er notaður við prentun leturgagna. Til dæmis ef gildið er 24, þá notar allt letur í 24 punkta stærð eða minna hátíðnirasta. Notkun tækis Hljóðlát stilling Slökkt * Kveikt Stilla prentarann til að vinna í  hljóðlátri stillingu . Virkjun á þessari stillingu hægir á heildarafköstum prentarans. Notkun tækis Valmyndir stjórnborðs Slökkt Kveikt * Virkja aðgang að valmyndum prentara frá stjórnborðinu. Notkun tækis Örugg stilling Slökkt * Kveikt Stilla prentarann til notkunar í sérstakri stillingu, þar sem hann reynir að halda áfram að bjóða upp á eins mikla virkni og mögulegt er, þrátt fyrir þekkt vandamál. Til dæmis, þegar stillt á  kveikt  og mótor fyrir tvíhliða prentun (duplex) er ekki virkur, prentar prentarinn með einar hliðar prentun á skjölunum, jafnvel þótt verkið sé tvíhliða prentun. Notkun tækis Lágmarksminni afritunar 20 MB* 30 MB 50 MB 80 MB 100 MB Stilla úthlutun lágmarksminnis fyrir vistun á verkum í afritun. Notkun tækis Hreinsa stöðu sérstillingar Hreinsa notendaskilgreinda strengi fyrir sérsniðnar  sjálfvaldar  eða  aðrar  tilkynningar. Notkun tækis Hreinsa öll fjarstillt skilaboð Hreinsa skilaboð sem sett hafa verið inn með fjarstillingu. Notkun tækis Sýna skjámyndir villu sjálfvirkt Slökkt Kveikt * Sýna núverandi villuboð á skjánum eftir að prentarinn er óvirkur á heimaskjánum í ákveðinn tíma. Notkun tækis Virða stefnu á hraðafritun Slökkt * Kveikt Virkja prentarann til að nota stillingu á stefnu í valmynd  Afrit  þegar verið er að senda verk í hraðafritun. Uppsetning forrita LES-forrit Slökkt Kveikt * Virkja forrit fyrir innbyggðar lausnir Lexmark (LES). Stilling frágangseiningar Hætta í stillingu fyrir skúffu 2 Slökkt * Kveikt Kveikja á notkun annars úttaksbakka. Uppsetning á skanna Handvirk stilling á skanna Prenta fljótvirka prófun Prenta marksíðu fyrir fljótvirka prófun. Gangið úr skugga um að spássíubil á marksíðunni sé eins allt í kring um takmarkið. Ef ekki gæti verður að endurstilla spássíur prentarans. Uppsetning á skanna Handvirk stilling á skanna Stilling á sjálfvirkum matara að framan Stilling á sjálfvirkum matara að aftan Stilling á flatskanna Stilla flatskanna og sjálfvirkan matara handvirkt eftir að hafa komið sjálfvirkum matara, gleri skanna eða stýrispjaldi fyrir á sinn stað. Uppsetning á skanna Endurstilla viðhaldsteljara Endurstillið teljarann eftir að skipt hefur verið um viðhaldssett fyrir sjálfvirkan matara. Uppsetning á skanna Eyða brún Eyða brún á flatskanna  (3*) Eyða brún í sjálfvirkum matara  (3*) Stilla stærð, í millímetrum, á svæði án prentunar í verki í sjálfvirkum matara eða á flatskanna. Uppsetning á skanna Gera skanna óvirkan Nei * Já Aðeins sjálfvirkur matari (ADF ) Gera skannann óvirkan ef hann virkar ekki rétt. Uppsetning á skanna Röð Tiff-bæta Endasnið CPU (Endianness) * Lítið endasnið Stórt endasnið Ákvarða röð bæta í TIFF‑sniðnu úttaki skönnunar. Uppsetning á skanna Nákvæmni Tiff-raða á umferð Kveikt * Slökkt Stilla gildi fyrir röð á umferð á TIFF‑sniðnu úttaki skönnunar. valmynd Uppsetningarvalmynd"},{"UUID":"98741ecc-95fc-40a8-ab60-b4c24b1154dd","title":"Viðhald","link":"preferences-topic.html","desc":"Eyða utan þjónustu Atriði valmyndar","descFull":"Eyða utan þjónustu Atriði valmyndar  Eyða utan þjónustu  og lýsingar þeirra Atriði valmyndar Lýsing Eyða utan þjónustu Minni síðast hreinsað Harður diskur síðast hreinsaður Skynvætt geymsludrif síðast hreinsað Sýna skrifvarðar upplýsingar um hvenær prentaraminni eða geymsludrifinu var síðast eytt. Harður diskur síðast hreinsaður  birtist aðeins þegar harður diskur er uppsettur. Eyða utan þjónustu Hreinsa allar upplýsingar á fastheldnu minni Eyða öllum stillingum fyrir prentara og netkerfi Eyða öllum forritum og stillingum forrita Eyða öllum flýtivísum og stillingum fyrir flýtivísa Hreinsa allar upplýsingar á hörðum diski Eyða niðurhali (eyða öllum fjölvum, leturgerðum, PFO o.s.frv.) Eyða verkum í biðminni Eyða verkum í bið Eða skynvæddu geymsludrifi Hreinsa allar upplýsingar á fastheldnu minni og á geymsludrifinu. Hreinsa allar upplýsingar á hörðum diski  birtist aðeins þegar harður diskur er uppsettur. valmynd Eyða utan þjónustu"},{"UUID":"72bf9939-59ea-4cae-815e-5c63822f85b3","title":"Tæki","link":"preferences-topic.html","desc":"Sérsnið á heimaskjá Þessi valmynd","descFull":"Sérsnið á heimaskjá Þessi valmynd birtist aðeins í innbyggða vefþjóninum. Valmynd  Sérsnið á heimaskjá  og lýsingar hennar Valmynd Lýsing Afritun Tölvupóstur Fax Föx í bið Sleppa geymdum faxsendingum Staða/birgðir Verk í biðröð Stillingar Breyta um tungumál Heimilisfangabók Bókmerki Verk í bið USB-drif FTP Prófílar skönnunar Læsa tæki Skönnunarmiðstöð Afrita kort Miðstöð flýtivísa Skilgreina hvaða tákn á að sýna á heimaskjánum. valmynd Sérsnið á heimaskjá"},{"UUID":"466dc60e-0580-48e8-b3b8-29c41f9332a4","title":"Tæki","link":"preferences-topic.html","desc":"Um þennan prentara Atriði valmyndar","descFull":"Um þennan prentara Atriði valmyndar  Um þennan prentara  og lýsingar þeirra Atriði valmyndar Lýsing Flipi eignar Skilgreina auðkenni á prentaranum. Hámarkslengd er 32 staftákn. Staðsetningu prentarans Skilgreina staðsetningu prentarans. Hámarkslengd er 63 staftákn. Hafa samband við Skilgreina upplýsingar tengiliðar fyrir prentarann. Hámarkslengd er 63 staftákn. Útgáfa fastbúnaðar Sýna fastbúnaðarútgáfuna sem er uppsett á prentaranum. Vél Sýna númer vélar prentarans. Raðnúmer Sýna raðnúmer prentarans. Flytja út uppsetningarskrá til USB Flytja út uppsetningarskrár á minniskort. Flytja út þjappaða atvikaskrá til USB Flytja út þjappaða atvikaskrá á minniskort. Senda atvikaskrár Senda upplýsingar um atvikaskrá pentara til Lexmark. valmynd Um þennan prentara"},{"UUID":"8c50740c-11ca-43d5-b53d-860f7a96e9f9","title":"Prenta","link":"layout-topic.html","desc":"Útlit Atriði valmyndar  Útlit","descFull":"Útlit Atriði valmyndar  Útlit  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Hliðar 1‑hlið * 2‑hliðar Skilgreina hvort prentað er á eina hlið eða báðar hliðar á pappírinn. Veltistíll Löng brún * Stutt brún Ákvarða hvaða hlið á pappír er bundin þegar prentað er á báðar hliðar. Auðar síður Prenta Ekki prenta * Prenta auðar síður sem eru innifaldar í prentverki. Raða Slökkt [1,1,1,2,2,2] Kveikt [1,2,1,2,1,2] * Stafla síðum í prentverki í röð þegar verið er að prenta mörg eintök af verkinu.. Aðskilnaðarsíður Engin * Á milli eintaka Á milli verka Á milli síðna Setja inn auðar aðskilnaðarsíður við prentun. Uppruni aðskilnaðarsíðu Skúffa  [x] (1*) Fjölnotamatari Skilgreina uppruna pappírs á aðskilnaðarsíðum. Síður á hlið Slökkt * 2 síður á hlið 3 síður á hlið 4 síður á hlið 6 síður á hlið 9 síður á hlið 12 síður á hlið 16 síður á hlið Prenta margar síðumyndir á einni hlið á pappírsörk. Röðun á síðum á hlið Lárétt * Öfugt lárétt Lóðrétt Öfugt lóðrétt Skilgreina staðsetningu á mörgum síðum þegar verið er að nota vamynd  Síður á hlið . Stefna á síðum á hlið Sjálfvirkt * Langsnið Skammsnið Skilgreina staðsetningu á mörgum síðum þegar verið er að nota valmynd  Síður á hlið . Spássía á síðum á hlið Engin * Heil Prenta spássíu á hverja síðumynd þegar verið er að nota valmynd  Síður á hlið . Eintök 1–9999 (1*) Skilgreina fjölda eintaka fyrir hvert prentverk. Prentsvæði Venjuleg * Láta passa á síðu Heil síða Stilla prentanlegt svæði á pappírsörk. valmynd Útlit"},{"UUID":"06f44867-3823-4166-b000-1a5a0e4ddd9f","title":"Prenta","link":"layout-topic.html","desc":"Frágangur Atriði valmyndar  frágangs","descFull":"Frágangur Atriði valmyndar  frágangs  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Hefta verk Slökkt * 1 hefti, efra vinstra horni 2 hefti, vinstra megin 1 hefti, efra hægra horni 2 hefti, efst 1 hefti, neðra vinstra horni 2 hefti, neðst 1 hefti, neðst í hægra horni 2 hefti, hægra megin Skilgreina staðsetningu hefta fyrir öll prentverk. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara er til staðar. Prófun á heftun Gangsetja Ákvarða hvort frágangseining heftara sé að vinna rétt. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara er til staðar. Gatari Slökkt * Kveikt Setur göt á brún prentaðs úttaks. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara, gatari er til staðar. Stilling fyrir gatara 2 göt 3 göt 4 göt Stillir úttak gatara fyrir prentverk. 3 göt er  sjálfvalin verksmiðjustilling fyrir Bandaríkin.  4 göt  er sjálfvalin alþjóðleg stilling frá verksmiðju. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara, gatari er til staðar. Hliðraðar síður Engin * Á milli afrita Á milli verka Hliðrar úttaki á hverju prentverki eða hverju eintaki á prentverki. Á milli afrita  hliðrar hverju prentverki ef  Samröðun  er stillt á  Kveikt  [1,2,1,2,1,2]. Ef  Samröðun  er stillt á  Slökkt  [1,1,1,2,2,2], þá er hverju setti á prentuðum síðum hliðrað, svo sem allar síður merktar 1 eða allar síður merktar 2. Milli verka  verka setur sömu stöðu í hliðrun fyrir allt verkið í prentun óháð fjölda eintaka sem eru prentuð. valmynd Frágangur"},{"UUID":"1c23c54d-773b-4a5d-a06f-43c7b501af8f","title":"Prenta","link":"layout-topic.html","desc":"Uppsetning Atriði valmyndar  Uppsetning","descFull":"Uppsetning Atriði valmyndar  Uppsetning  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Tungumál prentara PCL-herming * PS-herming Stilla tungumál prentara. Stilling á sjálfgefnu tungumáli prentara kemur ekki í veg fyrir að hugbúnaður sendi prentverk sem nota annað tungumál prentara. Verk í bið Slökkt * Kveikt Geyma prentverk sem þarfnast rekstrarvöru þannig að hægt sé að prenta verk sem ekki þarfnast rekstrarvöru. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Tímarof verk í bið 0–255 ( 30 *) Stilla tímann í sekúndum sem prentarinn bíður eftir íhlutun notanda áður en hann setur verk í bið sem krefjast ótiltækra tilfanga og heldur áfram að prenta önnur verk í prentbiðröðinni. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Hlaða niður marki Vinnsluminni (RAM) * Diskur Skilgreina hvar á að vista öll varanleg aðföng, svo sem leturgerðir og fjölva, sem hefur verið hlaðið niður í prentarann. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Vista aðföng Slökkt * Kveikt Skilgreina hvað prentarinn gerir með niðurhlaðin aðföng, svo sem leturgerðir og fjölva, þegar hann fær verk sem krefst meira minnis en er tiltækt. Þegar stillt á  Slökkt  þá geymir prentarinn niðurhlaðin aðföng aðeins þar til að þörf er á meira minni. Aðföngum sem eru tengd óvirku tungumáli prentara er eytt. Þegar stillt á  Kveikt  geymir prentarinn öll varanleg aðföng þvert á allar tungumálastillingar. Þegar þörf krefur sýnir prentarinn skilaboð um fullt minni í stað þess að eyða varanlegum aðföngum. Skipun prenta allt Í stafrófsröð * Nýjast fyrst Það elsta fyrst Skilgreina í hvaða röð geymd verk og trúnaðarmál eru prentuð þegar Prenta allt allt er valið. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. valmynd Uppsetning"},{"UUID":"64ab96ab-3d63-40d1-beb4-0e30a571877c","title":"Prenta","link":"layout-topic.html","desc":"Gæði Atriði valmyndar fyrir ","descFull":"Gæði Atriði valmyndar fyrir  Gæði  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Prentupplausn 600 dpi * 1200 myndgæði 1200 dpi Stilla upplausn fyrir texta og myndir í prentuðu úttaki. Upplausn er ákvörðuð í punktum á tommu eða gæðum myndar. Svertustig prentdufts 1–10 (8*) Ákvarða stig birtu eða svertu í textamyndum. Hálftóna Venjuleg * Smáatriði Bæta prentað úttak til að vera með mjúkar línur með skörpum brúnum. Birtustig ‑6 til 6 (0*) Skilgreina birtustig á prentuðu úttaki. Birtuskil 0–5 (0*) Skilgreina birtuskil á prentuðu úttaki. Grátónaleiðrétting Sjálfvirkt * Slökkt Stilla bætta skerpustillingu sem stillt er á myndum. valmynd Gæði"},{"UUID":"68d1f28a-d85f-4cae-b4ef-d63180192ca5","title":"Prenta","link":"layout-topic.html","desc":"Verkreikningar Atriði valmyndar  Verkreikninga","descFull":"Verkreikningar Atriði valmyndar  Verkreikninga  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Verkreikningar Slökkt * Kveikt Stilla prentarann til að búa loggskrá yfir prentverk sem hann tekur á móti. Þetta atriði valmyndar birtist aðeins þegar minniskort eða harður diskur prentara eru uppsett. Tíðni loggskrár verkreikninga Daglega Vikulega Mánaðarlega * Skilgreina hve oft prentarinn býr til loggskrá. Aðgerð loggskrár við lok á tíðni. Engin * Senda núverandi loggskrá í tölvupósti Senda núverandi loggskrá í tölvupósti og eyða Senda núverandi loggskrá í pósti Senda núverandi loggskrá í pósti og eyða Stilla hvernig prentarinn bregst við þegar mörk tíðni renna út. Gildið sem er skilgreint í  tíðni loggskrár reiknings  ákvarðar hvenær þessi aðgerð er gangsett. Loggskrá nærri því að verða full Slökkt Kveikt  (5)* Skilgreina hámarksstærð á loggskrá áður en prentarinn sendir viðvörunina um að  loggskrá nærri því að verða full . Þetta atriði valmyndar birtist aðeins þegar minniskort eða harður diskur prentara eru uppsett. Aðgerð loggskrár þegar nærri því full Engin * Senda núverandi loggskrá í tölvupósti Senda núverandi loggskrá í tölvupósti og eyða Senda elstu loggskrá í tölvupósti og eyða Senda núverandi loggskrá í pósti Senda núverandi loggskrá í pósti og eyða Senda elstu loggskrá í pósti og eyða Eyða núverandi loggskrá Eyða elstu loggskrá Eyða öllu nema núverandi Eyða öllum loggskrám Stilla hvernig prentarinn bregst við þegar harði diskurinn er nánast fullur. Gildið sem er skilgreint í   loggskrá nærri því full   ákvarðar hvenær þessi aðgerð er gangsett. Aðgerð loggskrár þegar full Engin * Senda núverandi loggskrá í tölvupósti og eyða Senda elstu loggskrá í tölvupósti og eyða Senda núverandi loggskrá í pósti og eyða Senda elstu loggskrá í pósti og eyða Eyða núverandi loggskrá Eyða elstu loggskrá Eyða öllu nema núverandi Eyða öllum loggskrám Stilla hvernig prentarinn bregst við þegar notkun á hörðum diski nálgast hámarksmörk (100MB). Vefslóð til að senda loggskrár í pósti Skilgreina hvert prentarinn sendir loggskrár verkreikninga. Tölvupóstfang til að senda loggskrár Skilgreina netfangið sem tækið sendir loggskrár verkreikninga. Forskeyti á loggskrá Skilgreina forskeytið sem þú setur á heiti loggskrár. Núverandi hýsisnafn skilgreint í  TCP/IP  -valmyndinni er notað sem sjálfvalið forskeyti á loggskrár. valmynd Verkreikningar"},{"UUID":"3b070af9-9d6d-4da8-a42b-fc2499514a6d","title":"Prenta","link":"layout-topic.html","desc":"PDF Atriði  PDF -valmyndar","descFull":"PDF Atriði  PDF -valmyndar og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Kvarða til að passa Slökkt * Kveikt Kvarða innihald síðu til að passa á valda pappírsstærð. Glósur Prenta Ekki prenta * Skilgreina hvort prenta á glósur á PDF. Villa prentun PDF Slökkt Kveikt * Virkja prentun á PDF-villu. valmynd PDF"},{"UUID":"ac03359a-4a7b-4a78-bacb-7f3c0e1e9bde","title":"Prenta","link":"layout-topic.html","desc":"PostScript Atriði  PostScript -valmyndar","descFull":"PostScript Atriði  PostScript -valmyndar og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Villa prentun PS Slökkt * Kveikt Prenta síðu sem lýsir PostScript®-villunni. Þegar villa kemur upp hættir vinnsla á verkinu, prentari prentar villuskilaboð og restin af prentuninni er sleppt. Lágmarkslínubreidd 1–30 (2*) Stilla lágmarksbreidd slaga. Verk sem prentuð eru í 1200 dpi nota gildið beint. Læsa PS-gangsetningarstillingu Slökkt Kveikt * Gera SysStart-skrá óvirka. Virkjun á SysStart-skrá gerir prentarann eða netið útsett fyrir öryggishættu. Sléttun mynda Slökkt * Kveikt Bæta birtuskil og skerpu á myndum með lága upplausn. Þessi stilling hefur engin áhrif á myndir með upplausn 300 dpi eða hærri. Forgangur leturtegundar Vistfast * Skyndiminni/diskur Setja upp leitarröð leturtegunda. Vistfast  stillir prentarann til að leita í sínu minni að umbeðinni leturgerð áður en leitað er á harða diskinum eða skynvædda geymsludrifinu (ISD). Skyndiminni/diskur  stillir prentarann til að leita á harða diskinum eða ISD að umbeðinni leturgerð áður en leitað er í minni prentarans. Þetta atriði valmyndar birtist aðeins þegar harður diskur eða ISD er til staðar. Tímarof í bið Slökkt Kveikt * ( 40 sekúndur ) Virkja prentarann til að bíða eftir fleiri gögnum áður en hætt er við prentverk. valmynd PostScript"},{"UUID":"3025c845-0fd3-4a1b-b410-751828a6f6f9","title":"Prenta","link":"layout-topic.html","desc":"PCL Atriði valmyndar  PCL","descFull":"PCL Atriði valmyndar  PCL  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Uppruni leturgerða Vistfast * Diskur Niðurhal Minniskort Allt Velja uppruna sem inniheldur sjálfvalið val á leturgerð. Diskur  og  Flass  birtast aðeins þegar ógallaður, óvarinn harður diskur eða flassminni sem innihalda letur eru uppsett. Niðurhal  birtist aðeins ef niðurhalaðar leturgerðir eru til staðar í minni prentarans. Heiti leturgerðar [Listi yfir tiltækar leturgerðir] ( Courier *) Veldu leturgerð úr skilgreindum uppruna leturs. Stilling á tákni [Listi yfir tiltæk sett tákna] (10U PC‑8*) Skilgreina tákn sem er stillt fyrir hvert heiti leturgerðar. Stilling á tákni er sett staftákna stafrófs og talna, punkta og sérstakra tákna. Stilling tákna styður mismunandi tungumál eða sérstök kerfi, svo sem reiknitákn eða vísindatexta. Halli 0,08–100,00 (10,00*) Skilgreina halla á leturgerðum með föstu eða jafnbreiðu millibili. Halli  á við um staftákn með föstu millibili á gerð láréttrar færslu. Stefna Skammsnið * Langsnið Viðsnúið skammsnið Viðsnúið langsnið Skilgreina stefnu á texta og myndefni á síðu. Línur á síðu 1–255 Skilgreina fjölda af línum af texta fyrir hverja síðu sem prentuð er í gegnum PCL® gagnastrauminn. Þetta valmyndaratriði virkjar lóðrétta stýringu sem veldur því að valinn fjöldi af umbeðnum línum er prentaður á milli sjálfgefinna spássía á síðunni. 60 er sjálfvalin verksmiðjustilling fyrir Bandaríkin. 64 er sjálfvalin alþjóðleg stilling frá verksmiðju. PCL5 lágmarksbreidd á línu 1–30 (2*) Stillir lágmark upphafsbreiddar slaga. PCLXL lágmarksbreidd á línu 1–30 (2*) A4 breidd 198 mm* 203 mm Stillir breidd á rökrænni síðu þegar prentað er á A4‑stærð pappírs. Rökræn síða er plássið á raunverulegri síðu þegar gögn eru prentuð. Sjálfvirk ný lína (CR) eftir línuskipti (LF) Kveikt Slökkt * Stillir prentarann til að framkvæma sjálfvirkt stýriskipunina ný lína (CR) eftir línuskipti (LF). Ný lína er búnaður sem stjórnar prentara til að færa stöðu bendilsins í fyrstu stöðu á sömu línu. Sjálfvirk ný lína (LF) eftir línuskipti (CR) Kveikt Slökkt * Stilla prentarann til að framkvæma sjálfvirkt stýriskipunina línuskipti (LF) eftir nýja línu (CR). Endurvelja númer á skúffu Úthluta fjölnotamatara Úthluta skúffu  [x] Úthluta handvirkum pappír Úthluta handvirkri stillingu umslags Stilla prentarann til að vinna með öðrum prentrekli eða sérsniðnu forriti sem notar annað sett af úthlutun verka til að biðja um tiltekinn uppruna pappírs. Endurvelja númer á skúffu Skoða sjálfgefnar verksmiðjustillingar Sýna sjálfvalda verksmiðjustillingu úthlutaða fyrir hvern uppruna pappírs. Endurvelja númer á skúffu Endurheimta sjálfvaldar stillingar Endurvekja endurval á númeri fyrir skúffu í sjálfval frá verksmiðju. Tímarof prentunar Slökkt Kveikt * (90 sekúndur) Stilla prentarann til að ljúka við prentverk eftir að hann hefur verið í aðgerðarleysi í tilgreindan tíma. valmynd PCL"},{"UUID":"a9acfde3-cc93-40ea-bebb-5c22b3dc3b8b","title":"Prenta","link":"layout-topic.html","desc":"Mynd Atriði valmyndar fyrir ","descFull":"Mynd Atriði valmyndar fyrir  mynd  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Sjálfvirk aðlögun Kveikt Slökkt * Velja bestu tiltæku pappírsstærð og stillingu á stefnu fyrir mynd. Þegar þetta er stillt á  Kveikt  mun þetta valmyndaratriði yfirkeyra stillingar fyrir kvörðun og stefnu fyrir myndina. Snúa við Slökkt * Kveikt Snúa við tvítóna einlitum myndum. Þessi stilling á ekki við um GIF eða JPEG snið fyrir myndir. Kvörðun Festipunktur efst vinstra megin Besta aðlögun * Festipunktur í miðju Láta hæð/breidd passa Lát hæð passa Láta breidd passa Stilla mynd til að passa í prentanlegt svæði. Þegar  sjálfvirk aðlögun  er stillt á  kveikt , er  kvörðun  sjálfkrafa stillt á  bestu aðlögun . Stefna Skammsnið * Langsnið Viðsnúið skammsnið Viðsnúið langsnið Skilgreina stefnu á texta og myndefni á síðu. valmynd Mynd"},{"UUID":"53bc4580-739b-429b-abe0-56d4281dec68","title":"Pappír","link":"tray-configuration-topic.html","desc":"Uppsetning skúffu Atriði valmyndar ","descFull":"Uppsetning skúffu Atriði valmyndar  uppsetningar skúffu  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Sjálfvalinn uppruni Skúffa  [x] (1*) Fjölnotamatari Handvirk stilling pappírs Handvirk stilling umslags Stilla uppruna fyrir öll prentverk. Pappírsstærð/gerð Skúffa  [x] Fjölnotamatari Handvirk stilling pappírs Handvirk stilling umslags Skilgreina pappírsstærð eða pappír sem hlaðið er í hvern uppruna pappírs. Stærð í staðinn Slökkt Yfirlýsing/A5 Bréf (Letter)/A4 11 x 17/A3 Allt uppgefið * Stilltu prentara til að setja tiltekna pappírsstærð í staðinn ef umbeðinni stærð er ekki hlaðið í neinn uppruna pappírs. Slökkt  setur kvaðningu til notanda að hlaða pappírsstærð sem beðið er um. Allt uppgefið  leyfir allar tiltækar skiptingar. Setja upp fjölnotaprentara (MP) Kasetta * Handvirkt Fyrst Ákvarða hegðun fjölnotamatara. Kasetta  stillir fjölnotamatarann sem sjálfvirkan uppruna pappírs. Handvirkt  stillir fjölnotamatarann aðeins fyrir handvirka fæðingu prentverka. Fyrst  stillir fjölnotamatarann sem aðaluppruna pappírs. valmynd Uppsetning skúffu"},{"UUID":"8dad8819-971b-45c0-9a15-8e4faed5e967","title":"Uppsetning á miðli","link":"tray-configuration-topic.html","desc":"Alhliða uppsetning Atriði valmyndar ","descFull":"Alhliða uppsetning Atriði valmyndar  alhliða uppsetningar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Mælieiningar Tommur Millímetrar Skilgreinir mælieiningar fyrir alhliða pappír. Tommur  er sjálfvalin verksmiðjustilling fyrir Bandaríkin.  Millímetrar  er sjálfvalin alþjóðleg stilling frá verksmiðju. Breidd á skammsniði 3,5–19 tommur (8,5*) 88,9–482,6 mm (216*) Stilla breidd á skammsniði á alhliða pappír. Hæð á skammsniði 3,5–19 tommur (14*) 88,9–482,6 mm (356*) Stilla hæð á skammsniði á alhliða pappír. Stefna færslu Stutt brún * Löng brún Stilla prentarann til að grípa pappír frá stuttri brún eða langri brún. Löng brún  birtist aðeins þegar lengsta brún er styttri en hámarks breidd sem er studd. Margar alhliða stærðir Skúffa [x] Fjölnotamatari Úthlutaðu sérstakri stærð fyrir margar alhliða stærðir sem er hlaðið í hvern uppruna pappírs. Þessi stilling birtist eingöngu þegar kveikt er á henni í valmyndinni  Tæki . Á heimaskjánum, snertu  Stillingar Tæki Viðhald Valmynd uppsetningar Uppsetning skúffu Margar alhliða stærðir . valmynd Alhliða uppsetning"},{"UUID":"8c0c23a0-4322-4009-81aa-496c0360036d","title":"Uppsetning á miðli","link":"tray-configuration-topic.html","desc":"Sérsniðnar stærðir skönnunar Atriði valmyndar","descFull":"Sérsniðnar stærðir skönnunar Atriði valmyndar  sérsniðinna stærða skönnunar  og lýsingar þeirra Atriði valmyndar Lýsing Sérsniðin stærð skönnunar  [x] Heiti á stærð skönnunar Breidd 1–8.5 tommur (8,5*) 25.4–215.9 mm (215.9*) Hæð 1–25 tommur (11*) 25,4–635 mm (279,4*) Stefna Skammsnið * Langsnið Tvær skannanir á hlið Slökkt * Kveikt Úthluta heiti á stærð skönnunar og setja upp stillingar skönnunar. valmynd Sérsniðnar stærðir skönnunar"},{"UUID":"5b4da505-8b63-4dc7-8b6d-77777ffb6bcd","title":"Uppsetning á miðli","link":"tray-configuration-topic.html","desc":"Gerðir miðla Atriði valmyndar yfir","descFull":"Gerðir miðla Atriði valmyndar yfir  Gerðir miðla  og lýsingar þeirra Atriði valmyndar Lýsing Venjulegur Þykkur pappír Endurunninn Glanspappír Miðar Þykkur pappír Umslag Gróft umslag Bréfhaus Forprentaður Litaður pappír Létt Þung Grófur/bómull Sérsniðin gerð  [X] Skilgreina áferð, þyngd og stefnu á pappírnum. valmynd Gerðir miðla"},{"UUID":"01790222-2537-4c26-89cd-f9e8a88d131b","title":"Afritun","link":"copy-defaults-topic.html","desc":"Sjálfgildi afritunar Atriði valmyndar fyrir","descFull":"Sjálfgildi afritunar Atriði valmyndar fyrir  Sjálfgildi afritunar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Gerð innihalds Texti Texti/ljósmynd * Ljósmynd Gröf/teikningar Bæta útkomu úttaks byggt á innihaldi upphafslegs skjals. Uppruni innihalds Svart/hvítur leysiprentari * Litaleysiprentari Bleksprautuprentari Ljósmynd/filma Tímarit Dagblað Prentvél Annað Bæta útkomu úttaks byggt á uppruna upphafslegs skjals. Hliðar 1 hlið til 1 hliðar * 1 hlið til 2 hliðar 2 hlið til 1 hliðar 2 hlið til 2 hliðar Skilgreina hegðun skönnunar byggt á upphaflegu skjali. Aðskilnaðarsíður Engin * Á milli afrita Á milli verka Á milli síðna Skilgreina hvort setja eigi auðar aðskilnaðarsíður við prentun. Uppruni aðskilnaðarsíðu Skúffa  [x] (1*) Fjölnotamatari Skilgreina uppruna pappírs á aðskilnaðarsíðum. Síður á hlið Slökkt * 2 síður með skammsniði 4 síður með skammsniði 2 síður með langsniði 4 síður með langsniði Skilgreina fjölda á síðumyndum sem á að prenta á einni hlið á pappír. Prenta síðuspássíur Slökkt * Kveikt Setja spássíu í kring um hverja mynd þegar margar síður eru prentaðar á eina örk af pappír. Raða Slökkt [1,1,1,2,2,2] Kveikt [1,2,1,2,1,2] * Prenta mörg afrit í röð. Hliðraðar síður Engin * Á milli afrita Á milli verka Aðskilja úttak á hverju prentverki eða hverju eintaki af prentverki. Á milli afrita  hliðrar hverju afriti af prentverki ef  samröðun  er stillt á  Kveikt [1,2,1,2,1,2] . Ef  Samröðun  er stillt á  Slökkt [1,1,1,2,2,2] , þá er hverju setti á prentuðum síðum hliðrað, svo sem allar síður merktar 1 eða allar síður merktar 2. Milli verka  verka setur sömu stöðu í hliðrun fyrir allt verkið í prentun óháð fjölda eintaka sem eru prentuð. Hefta Slökkt * 1 hefti, efra vinstra horni 2 hefti, vinstra megin 1 hefti, efra hægra horni 2 hefti, efst 1 hefti, neðra vinstra horni 2 hefti, neðst 1 hefti, neðst í hægra horni 2 hefti, hægra megin 4 hefti Skilgreina staðsetningu hefta fyrir öll prentverk. Þetta atriði valmyndar birtist aðeins þegar frágangseining er til staðar. Gatari Slökkt * 2 göt 3 göt 4 göt Gata prentað blað. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara, gatari er til staðar. „Afrita frá“ stærð [Listi yfir pappírsstærðir] Stilla pappírsstærð á upphaflega skjalinu. Bréf (Letter)  er sjálfvalin verksmiðjustilling fyrir Bandaríkin.  A4  er sjálfvalin alþjóðleg stilling frá verksmiðju. „Afrita til“ uppruna Skúffa  [x] (1*) Fjölnotamatari Samsvara sjálfvirkt stærð Skilgreina uppruna pappírs fyrir afritunarverk. Hitastig ‑4 til 4 (0*) Skilgreina hvor það á að búa til kaldara eða heitara úttak. Svertustig 1 til 9 (5*) Skilgreina svertustig á skannaðri mynd. Fjöldi eintaka 1–9999 (1*) Skilgreina fjölda eintaka. Haus/fótur Vinstri haus Haus í miðju Hægri haus Vinstri fótur Fótur í miðju Hægri fótur Skilgreina upplýsingar um haus eða fót á skönnuðu myndinni. Yfirlögn Trúnaðarverk Afritun Drög Mikilvægt Sérsniðið Slökkt * Skilgreina texta yfirlagnar sem á að prenta á hvert eintak. Sérsniðin yfirlögn Skráðu textann fyrir  Sérsniðið  val í valmynd  Yfirlögn . Þróuð myndvinnsla Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Brottfall á lit Brottfall á lit  ( Ekkert *) Sjálfvalin mörk á rauðu  (128*) Sjálfvalin mörk á grænu  (128*) Sjálfvalin mörk á bláu  (128*) Skilgreina hvaða litur á að falla út við skönnun og stilla stillingu á brottfalli fyrir þann lit. Birtuskil Best fyrir innihald * 0–5 Skilgreina birtuskil á skannaðri mynd. Fjarlægja bakgrunn Uppgötvun bakgrunns Byggt á innihaldi* Fast Stig ‑4 til 4 (0*) Fjarlægja bakgrunnslit eða truflun úr upprunalegu skjali. Byggt á innihaldi  fjarlægir bakgrunnslit úr upprunalega skjalinu. Fast  fjarlægir truflanir úr mynd. Sjálfvirk miðjun Slökkt * Kveikt Stilla sjálfvirkt innihald í miðju á síðu. Speglun á mynd Slökkt * Kveikt Búa til speglaða mynd af upphaflega skjalinu. Andhverf mynd Slökkt * Kveikt Búa til andhverfa mynd af upphaflega skjalinu. Atriði skugga ‑4 til 4 (0*) Stilla atriði skugga í upphaflegu skjali. Skanna brún í brún Slökkt * Kveikt Skanna upphaflegt skjal frá brún til brún. Skerpa 1–5 (3*) Stilla magn skerpu á skannaðri mynd. Stýringar stjórnanda Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Leyfa forgangsafrit Slökkt Kveikt * Rjúfa prentverk til að afrita. Skönnun á sérsniðnu verki Slökkt * Kveikt Stilltu prentarann til að skanna fyrsta settið af upphaflegum skjölum með tilgreindum stillingum og skannaðu síðan næsta sett með sömu eða mismunandi stillingum. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Leyfa Vista sem flýtivísi Slökkt Kveikt * Vista afritunarstillingar sem flýtivísi. Sýnishorn afritunar Slökkt * Kveikt Prentaðu sýnishorn afrits til að kanna gæði áður en afritin sem eru eftir eru prentuð. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. valmynd Sjálfgildi afritunar"},{"UUID":"040ba296-70cb-40d9-aa44-c0eb71ea2c90","title":"Sjálfgildi fax","link":"fax-defaults-subgroup.html","desc":"Fax-stilling Atriði valmyndar fyrir ","descFull":"Fax-stilling Atriði valmyndar fyrir  faxstillingu  og lýsing þess Atriði valmyndar Lýsing Fax-stilling Fax Faxþjónn Óvirkt Veldu stillingu fyrir fax. Sjálfvalin verksmiðjustilling getur verið breytileg, en það fer eftir þinni gerð prentara. valmynd Fax-stilling"},{"UUID":"4aa67de7-9bda-44e4-ae11-aaa16dc99045","title":"Sjálfgildi fax","link":"fax-defaults-subgroup.html","desc":"Uppsetning á faxi Þessi valmynd","descFull":"Uppsetning á faxi Þessi valmynd er eingöngu í prenturum sem eru skráðir í etherFax gáttina eða eru með faxkort uppsett. Almennar faxstillingar Atriði valmyndar fyrir  almennar faxstillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Heiti á faxi Auðkenna þitt faxtæki. Faxnúmer Auðkenna þitt faxnúmer. Auðkenni á faxi Heiti á faxi Faxnúmer * Tilkynna viðtakendum á faxi um þitt heiti á faxi eða faxnúmer. Virkja handvirkt fax Slökkt * Kveikt Kveikja á handvirkri aðgerð í prentaranum. Þetta atriði valmyndar þarfnast línudeilis og símtækis. Nota venjulegan síma til að svara faxi á innleið og til að hringja í faxnúmer. Til að fara beint í aðgerð handvirks fax, snertu  #  og  0  á hnappaborðinu. Notkun á minni Taka við öllu Aðallega móttaka Jafnt * Aðallega senda Senda allt Stilla magn á innra minni sem er úthlutað fyrir fax. Þetta atriði valmyndar kemur í veg fyrir ástand á biðminni og að föx mistakist. Hætta við föx Leyfa * Ekki leyfa Hætta við föx á útleið og innleið. Símanúmerabirtir Slökkt Kveikt önnur Kveikja á símanúmerabirti. Þessi stilling birtist eingöngu þegar landið eða svæðið sem var valið við upphaflega uppsetningu styður við símanúmerabirtingu. Möskun á faxnúmeri Slökkt * Frá vinstri Frá hægri Skilgreina sniðið fyrir möskun í útsendu faxnúmeri. Staftákn sem á að maska 0–58 (0*) Skilgreina fjölda staftákna sem á að maska í útsendu faxnúmeri. Virkja uppgötvun á tengdri línu Slökkt Kveikt * Ákvarða hvort símalína sé tengd við prentarann. Atvik greinast strax. Virkja uppgötvun á að lína sé í röngu tengi Slökkt Kveikt * Ákvarða hvort símalína sé tengd við rétt tengi á prentaranum. Atvik greinast strax. Leyfa framlengingu í stuðningi notkunar Slökkt Kveikt * Ákveða hvort símalína sé notuð af öðru tæki eins og öðrum síma á sömu línu. Atvik greinast strax. Hámarka samhæfni á faxi Stilla virkni á faxi prentarans fyrir bestu samhæfni við önnur faxtæki. Flutningur á faxi T.38 Hliðræn G.711 etherFAX Stilla aðferð flutnings á faxi. Þetta atriði valmyndar birtist aðeins ef leyfispakki etherFAX eða Fax over IP (FoIP) er uppsettur í prentaranum. HTTPS faxstillingar Þessi valmynd birtist aðeins ef  Flutningur á faxi  er stillt á  etherFax . Atriði valmyndar fyrir  HTTPS faxstillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Vefslóð HTTPS þjónustu Skilgreina vefslóð etherFAX þjónustu. HTTPS Proxy Skilgreina vefslóð proxy þjóns. Notandi HTTPS Proxy Skilgreina nafnið og aðgangsorðið fyrir proxy þjóninn. Aðgangsorð HTTPS Proxy Dulkóðun sendingar á faxi Óvirkt Virkt * Þarfnast Virkja dulkóðun á faxskilaboðumá útleið. Dulkóðun á móttöku á faxi Óvirkt Virkt * Þarfnast Virkja dulkóðun fyrir innkomandi faxskilaboð. Staða á HTTPS Faxi Sýna stöðu samskipta á etherFAX. Sendistillingar á faxi Atriði valmyndar fyrir  sendistillingar á faxi  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Upplausn Staðal * Fínt Mjög fínt Ofur fínt Skilgreina upplausn á skannaðri mynd. Staðal  og  Mjög fínt  birtast eingöngu þegar stillingin  Virkja faxskönnun í lit  er stillt á  Sjálfvalið slökkt . Meiri upplausn eykur tíma faxsendingar og þarfnast meira minnis. Upphafleg stærð [Listi yfir pappírsstærðir] (Blandaðar stærðir*) Skilgreina stærð á upphaflega skjalinu. Stefna Skammsnið * Langsnið Skilgreina stefnu á upphaflega skjalinu. Hliðar Slökkt * Stutt brún Löng brún Skilgreina stefnu á upphaflega skjalinu þegar verið er að skanna báðar hliðar á skjalinu. Gerð innihalds Texti * Texti/ljósmynd Ljósmynd Gröf/teikningar Bæta útkomu úttaks byggt á innihaldi upphafslegs skjals. Uppruni innihalds Svart/hvítur leysiprentari * Litaleysiprentari Bleksprautuprentari Ljósmynd/filma Tímarit Dagblað Prentvél Annað Bæta útkomu úttaks byggt á uppruna upphafslegs skjals. Svertustig 1-9 (5*) Skilgreina svertustig á skannaðri mynd. Fyrir aftan PABX-símstöð Kveikt Slökkt * Stilla prentarann til að hringja í faxnúmer án þess að bíða eftir því að þekkja hringitóninn. „Private Automated Branch Exchange“ (PABX) er símkerfi sem leyfir að eitt aðgangsnúmer bjóði margar línur til utanaðkomandi aðila. Stilling hringingar Tónn * Púls Skilgreina stillingu hringingar fyrir föx á inn- og útleið. Þróuð myndvinnsla Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Litajafnvægi Blágrænn - Rauður -4 til 4 (0*) Blárauður - Grænn -4 til 4 (0*) Gulur - Blár -4 til 4 (0*) Stilla litaþéttleika við skönnun. Brottfall á lit Brottfall á lit  ( Ekkert *) Sjálfvalin mörk á rauðu  (128*) Sjálfvalin mörk á grænu  (128*) Sjálfvalin mörk á bláu  (128*) Skilgreina hvaða litur á að falla út við skönnun og stilla stillingu á brottfalli fyrir þann lit. Birtuskil Best fyrir innihald * 0 1 2 3 4 5 Stilla birtuskil á úttaki. Fjarlægja bakgrunn Stig ‑4 til 4 (0*) Stilla hve mikið af bakgrunni sést á skannaðri mynd. Speglun á mynd Slökkt * Kveikt Búa til speglaða mynd af upphaflega skjalinu. Andhverf mynd Slökkt * Kveikt Búa til andhverfa mynd af upphaflega skjalinu. Atriði skugga ‑4 til 4 (0*) Stilla magn af skugga sem er sýnilegt á skannaðri mynd. Skanna brún í brún Kveikt Slökkt * Leyfa skönnun brún-í-brún á upphaflegu skjali. Skerpa 1–5 (3*) Stilla magn skerpu á skannaðri mynd. Hitastig ‑4 til 4 (0*) Skilgreina hvor það á að búa til kaldara eða heitara úttak. Stýringar stjórnanda Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Sjálfvirkt endurval 0–9 (5*) Stilla fjölda tilrauna til endurhringinga byggt á virknistigi á faxtækjum viðtakanda. Tíðni endurvals 1–200 mínútur (3*) Auktu tímann á milli endurtekinna tilrauna til að auka möguleika á að senda fax með góðum árangri. Virkja stillingu villuleiðréttingar (ECM) Kveikt * Slökkt Virkja stillingu villuleiðréttingar (ECM) fyrir faxverk. ECM skynjar og leiðréttir villur í sendingarferli á faxi sem stafa af hávaða á símalínu og lélegs sendistyrks. Virkja faxskönnun Kveikt * Slökkt Faxa skjöl sem eru skönnuð í prentaranum. Rekill fyrir fax Kveikt * Slökkt Leyfa rekli prentarans að senda föx. Leyfa Vista sem flýtivísi Kveikt * Slökkt Vista faxnúmer sem flýtivísa á prentaranum. Hámarkshraði 33600 * 14400 9600 4800 2400 Stilla hámarkshraða fyrir sendingu á faxi. Skönnun á sérsniðnu verki Slökkt * Kveikt Kveikja á að skönnun á sérsniðnum verkum sé sjálfvalið. Þetta atriði valmyndar birtist aðeins þegar harður diskur eða skynvætt geymsludrif (ISD) eru uppsettir. Forskoðun skönnunar Slökkt * Kveikt Sýna forskoðun af skönnun á skjánum. Þetta atriði valmyndar birtist aðeins þegar harður diskur eða ISD er til staðar. Virkja faxskönnun í lit Sjálfvalið slökkt * Sjálfvalið kveikt Nota aldrei Nota alltaf Virkja litaskönnun fyrir fax. Breyta sjálfvirkt föxum í lit í einn lit Kveikt * Slökkt Breyta öllum föxum á útleið í svart-hvítt. Staðfesta faxnúmer Slökkt * Kveikt Biðja notandann að staðfesta faxnúmerið. Forvalsnúmer Stilla forvalsnúmer hringingar. Reglur varðandi forvalsnúmer Búa til reglu varðandi forval. Móttökustillingar á faxi Atriði valmyndar fyrir  Stillingar á móttöku á faxi  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Faxverk bíður Engin * Prentduft Prentduft og birgðir Fjarlægja faxverk sem óska eftir sérstökum ótiltækum úrræðum úr biðröð prentunar. Hringingar fyrir svörun 1–25 (3*) Stilla fjölda hringinga áður en tækið svarar símtölum. Sjálfvirk minnkun Kveikt * Slökkt Kvarða föx á innleið svo að þau passi á síðu. Uppruni pappírs Skúffa  [X] Sjálfvirkt * Stilla uppruna pappírs fyrir prentun á föxum á innleið. Hliðar Kveikt Slökkt * Prentaðu á báðar hliðar á pappírnum. Aðskilnaðarsíður Engin * Fyrir verk Á eftir verki Skilgreina hvort setja eigi auðar aðskilnaðarsíður við prentun. Uppruni aðskilnaðarsíðu Skúffa  [X] (1*) Skilgreina uppruna pappírs á aðskilnaðarsíðum. Úttaksbakki Staðalbakki Skilgreina úttaksbakka fyrir móttekin föx. Fax-fótur Kveikt Slökkt * Prenta upplýsingar um sendinguna neðst á hverri síðu á mótteknu faxi. Tímastimpill á faxfæti Móttaka * Prenta Prenta tímastimpil neðst á hverri síðu á mótteknu faxi. Gatari Slökkt * 2 göt 3 göt 4 göt Tilgreina götun fyrir föx sem berast. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara, gatari er til staðar. Hefta Slökkt * 1 hefti 2 hefti 4 hefti Tilgreina heftun fyrir föx sem berast. Þetta atriði valmyndar birtist aðeins þegar frágangseining er til staðar. Föx í bið Stilling fyrir föx í bið Slökkt * Alltaf kveikt Handvirkt Skipulagt Hafa föx í bið fyrir prentun þar til að þeim er sleppt. Föx í bið Skipulag fyrir föx í bið Úthluta áætlun fyrir bið á föxum. Þessi stilling birtist aðeins þegar  Stilling fyrir föx í bið  er stillt á  Skipulagt . Stýringar stjórnanda Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkja móttöku á faxi Kveikt * Slökkt Stilla prentarann til að taka á móti faxi. Virkja móttöku á faxi í lit Kveikt * Slökkt Stilla prentarann til að taka á móti faxi í lit. Virkja símanúmerabirti Kveikt Slökkt * Sýna símanúmer þess sem hringir í stjórnborðinu. Loka á föx án nafns Kveikt Slökkt * Virkja lokun á föx á innleið frá tækjum án auðkennis stöðvar eða skilgreindu auðkenni á faxi. Listi yfir bönnuð föx Bæta við bönnuðu faxi Skilgreina símanúmer sem þú vilt loka á. Svörun á Allar hringingar * Aðeins ein hringing Aðeins tvær hringingar Aðeins þrjár hringingar Aðeins ein eða tvær hringingar Aðeins ein eða þrjár hringingar Aðeins tvær eða þrjár hringingar Stilla sérstakt hringimynstur fyrir fax á innleið. Sjálfvirk svörun Kveikt * Slökkt Stilla prentarann til að taka sjálfvirkt á móti faxi. Kóði handvirkrar svörunar 0–9 (9*) Skrá kóða handvirkt á takkaborð síma til að byrja að taka við faxi. Þetta atriði valmyndar birtist aðeins þegar prentarinn deilir línu með síma. Þetta atriði valmyndar birtist aðeins þegar þú stillir prentarann til að taka handvirkt á móti faxi. Áframsending á faxi Prenta * Prenta og áframsenda Framsenda Skilgreina hvort að framsenda skuli móttekið fax. Framsenda til Ákvörðunarstaður 1 Ákvörðunarstaður 2 Skilgreina hvert á að framsenda móttekið fax. Þetta atriði valmyndar birtist aðeins þegar  Framsending á faxi  er stillt á  Prenta og framsenda  eða  Framsenda . Hámarkshraði 33600* 14400 9600 4800 2400 Stilla hámarkshraða fyrir sendingu á faxi. Forsíða á faxi Atriði  valmyndar forsíðu á faxi  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Forsíða á faxi Sjálfvalið slökkt * Sjálfvalið kveikt Nota aldrei Nota alltaf Setja upp stillingar fyrir forsíðu á faxi. Innifela svæði Til Slökkt * Kveikt Innifela svæði Frá Slökkt * Kveikt Frá Innifela svæði skilaboða Slökkt * Kveikt Skilaboð: Innifela lógó Slökkt * Kveikt Innifela fót [x] Slökkt * Kveikt Fótur [x] Stillingar á atvikaskrá fyrir föx Atriði valmyndar fyrir  atvikaskrá fyrir föx  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Tíðni atvikaskrár sendinga Ávallt * Aldrei Aðeins vegna villu Skilgreina hve oft prentarinn býr til atvikaskrá sendinga. Aðgerð atvikaskrár sendinga Prenta Slökkt Kveikt * Tölvupóstur Slökkt * Kveikt Prenta atvikaskrá fyrir heppnaða faxsendingu eða flutningsvillu. Villuatvikaskrá móttöku Aldrei prenta * Prenta við villu Prenta atvikaskrá fyrir móttöku faxsendinga sem hafa misfarist. Sjálfvirk prentun á atvikaskrám Kveikt * Slökkt Prenta alla virkni á faxi. Atvikaskrá uppruna pappírs Skúffa  [x] (1*) Skilgreina uppruna pappírs fyrir prentun á atvikaskrám. Sýna atvikaskrár Heiti fjartengds fax * Númer sem hringt var í Auðkenna sendanda með heiti fjartengds fax eða faxnúmeri. Virkja atvikaskrá Kveikt * Slökkt Skoða yfirlit yfir öll faxverk. Virkja atvikaskrá faxhringinga Kveikt * Slökkt Skoða yfirlit yfir sögu faxhringinga. Atvikaskrá fyrir úttaksbakka Staðalbakki * Bakki [x] Skilgreina úttaksbakka fyrir prentaðar atvikaskrár. Stillingar hátalara Atriði valmyndar fyrir  stillingar hátalara  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Stilling hátalara Alltaf slökkt * Alltaf kveikt Á þar til tengt Stilla stillingu á hátalara á faxi. Hljóðstig hátalara Lágt * Hátt Stilla hljóðstyrk hátalara á faxi. Hljóðstyrkur hringingar Slökkt * Kveikt Virkja hljóðstyrk hringingar. VoIP Stillingar Atriði valmyndar fyrir  VoIP Stillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. VoIP samskiptaaðferð SIP * H.323 Stilla VoIP samskiptaaðferð. STUN þjónn Tilgreindu STUN þjóninn til að fara yfir eldvegg. Stilling fyrir þvinguð föx Slökkt Kveikt * Skiptu VoIP-gátt úr hliðrænu yfir í T.38 í upphafi faxsímtals. Bið á stillingu fyrir þvinguð föx 0–15 (7*) Stilltu tímatöfina í sekúndum þegar þú sendir annað boð um  Stillingu fyrir þvinguð föx  . SIP-stillingar Atriði valmyndar fyrir  SIP stillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Proxy Tilgreindu IP tölu kerfisins sem breytir símanúmerinu í IP tölu sem faxið er sent til. Skrásetjari Tilgreina heiti eða IP tölu kerfisins sem sér um skráningu SIP þjóns. Notandi Tilgreina notandanafn fyrir SIP staðgengilsþjón. Aðgangsorð Tilgreina aðgangsorðið sem er notað í SIP skrá. Sannvottun auðkennis Skilgreina nafn notanda fyrir SIP skrá. Ef stillingin sannvottun auðkennis er ekki stillt notar stillingin notandanafn reitsins  Notanda  í staðinn. Flutningur fyrir skráningu UDP * TCP Stillir SIP gerð flutnings fyrir skráningu. Flutningur fyrir símtöl á innleið UDP * TCP UDP og TCP Stillir SIP gerð flutnings fyrir símtöl á innleið. Flutningur fyrir símtöl á útleið UDP * TCP Stillir SIP gerð flutnings fyrir símtöl á útleið. Proxy á útleið Tilgreindu proxy á útleið til að framsenda öll SIP samskipti. Hafa samband við Skilgreina nafn tengiliðar fyrir SIP. Vettvangur Skilgreina nafn vettvangs fyrir SIP. Ef stilling fyrir vettvang er ekki stillt notar stillingin nafnið á  Tengilið  í staðinn. Staða SIP skráningar Sýna stöðu á skráningu SIP. H.323 stillingar Atriði valmyndar fyrir  H.323 stillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Gátt Skilgreina IP-tölu fyrir H.323 gáttina. Hliðvörður Skilgreina hliðvörð fyrir H.323. Notandi Skilgreina nafn notanda sem notað er með H.323 gátt. Aðgangsorð Skilgreina aðgangsorð fyrir H.323 gáttina. Virkja hraða gangsetningu Slökkt * Kveikt Virkja hraða gangsetningu. Afvirkja H.245 smugun Slökkt * Kveikt Afvirkja H.323 smugun. Afvirkja uppgötvun hliðvarðar Slökkt Kveikt * Afvirkja uppgötvun H.323 hliðvarðar. T.38 stillingar Atriði valmyndar fyrir  T.38 stillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Endurtekning vísunar 0–5 (3*) Stilltu fjölda skipta sem vísun á faxi er endurtekin í T.38 samskiptum. Endurtekning lágs hraða 0–5 (3*) Stilltu fjölda skipta sem gögn lágs hraða eru endurtekin í T.38 samskiptum. Endurtekning hærri hraða 0–5 (1*) Stilltu fjölda skipta sem gögn hærri hraða eru endurtekin í T.38 samskiptum. valmynd Uppsetning á faxi"},{"UUID":"6ffefceb-ca9d-413a-919f-a55ca9541e7d","title":"Sjálfgildi fax","link":"fax-defaults-subgroup.html","desc":"Uppsetning faxþjóns Uppsetning faxþjóns Almennar","descFull":"Uppsetning faxþjóns Uppsetning faxþjóns Almennar faxstillingar Atriði valmyndar fyrir  almennar faxstillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Til að sníða Skilgreina viðtakanda á faxi. Ef þú vilt nota faxnúmerið, skráðu þá númeratáknið (#) fyrir framan númerið. Vistfang svörunar Skilgreina vistfang svörunar fyrir sendingu á faxi. Efni Skilgreina efni í faxi og skilaboð. Skilaboð Virkja hliðræna móttöku Slökkt * Kveikt Stilla prentarann til að taka á móti hliðrænum faxverkum. Stillingar tölvupósts faxþjóns Atriði valmyndar  stillinga tölvupósts faxþjóns  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Nota SMTP þjón tölvupósts Kveikt Slökkt * Notaðu SMTP-stillingar (Simple Mail Transfer Protocol) fyrir tölvupóst við móttöku og sendingu á faxi. Þegar stillt á  Kveikt , eru allar aðrar stillingar í valmynd Stillingum tölvupósts faxþjóns  ekki sýndar. Aðal SMTP-gátt Skráðu inn IP-tölu eða hýsingarheiti aðal SMTP-miðlara. Aðaltengi SMTP-gáttar 1–65535 (25*) Skráðu númer á gátt fyrir aðal SMTP-miðlara. Auka SMTP-gátt Sláðu inn IP-tölu eða hýsingarheiti á vara eða öryggisafriti SMTP-miðlara. Aukatengi SMTP-gáttar 1–65535 (25*) Sláðu inn númer tengis á vara eða öryggisafriti SMTP-miðlara. Tímarof SMTP 5–30 (30*) Stilla tímann hversu lengi prentarinn er með tímarof ef SMTP-þjónninn svarar ekki. Vistfang svörunar Skilgreina vistfang svörunar fyrir sendingu á faxi. Nota SSL/TLS Óvirkt * Framselja Þarfnast Skilgreina hvort senda eigi fax með því að nota dulkóðaðan tengil. Krefjast áreiðanlegs vottorðs Slökkt Kveikt * Skilgreina áreiðanlegt vottorð þegar tengst er SMTP þjóni. Sannvottun á SMTP-þjóni Ekki þörf á sannvottun * Innskráning / venjuleg NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Stilla gerð sannprófunar fyrir SMTP þjón. Tölvupóstur að frumkvæði tækis Engin * Nota SMTP-réttindi tækis Stilla hvort þörf er á vottorðum fyrir tölvupóst að frumkvæði tækis. Tölvupóstur að frumkvæði notanda Engin * Nota SMTP-réttindi tækis Nota notandaauðkenni lotu og aðgangsorð Nota tölvupóstfang lotu og aðgangsorð Kvaðning notanda Stilla hvort þörf er á vottorðum fyrir tölvupóst að frumkvæði notanda. Nota virk vottorð skráarsafns tækis Slökkt * Kveikt Virkja vottorð notanda og úthlutun hóps til að tengjast við SMTP-þjóninn. Notandaauðkenni tækis Skilgreina auðkenni notanda og aðgangsorð til að tengjast SMTP-þjóni. Aðgangsorð tækis Kerberos 5 REALM Skilgreina svið fyrir samskiptareglur Kerberos 5 sannvottunar. NTLM-lén Skilgreina heiti fyrir samskipti NTLM öryggis. Gera villu „SMTP-þjónn ekki uppsettur“ óvirka Slökkt* Kveikt Fela villuboð „SMTP-þjónn ekki uppsettur“. Stillingar skönnunar faxþjóns Atriði valmyndar  stillinga tölvupósts faxþjóns  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Snið myndar TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Skilgreina skráarsnið á skannaðri mynd. Gerð innihalds Texti * Texti/ljósmynd Ljósmynd Gröf/teikningar Bæta útkomu úttaks byggt á innihaldi upphafslegs skjals. Uppruni innihalds Svart/hvítur leysiprentari * Litaleysiprentari Bleksprautuprentari Ljósmynd/filma Tímarit Dagblað Prentvél Annað Bæta útkomu úttaks byggt á uppruna upphafslegs skjals. Upplausn á faxi Staðal * Fínt Mjög fínt Ofur fínt Stilla upplausn í faxi Hliðar Slökkt * Stutt brún Löng brún Skilgreina stefnu á upphaflega skjalinu þegar verið er að skanna báðar hliðar á skjalinu. Svertustig 1-9 (5*) Stilla svertustig á úttaki. Stefna Skammsnið * Langsnið Skilgreina stefnu á texta og myndefni á síðu. Upphafleg stærð [Listi yfir pappírsstærðir] Stilla pappírsstærð á upphaflega skjalinu. Blandaðar stærðir  er sjálfvalin verksmiðjustilling fyrir Bandaríkin. A4 er sjálfvalin alþjóðleg stilling frá verksmiðju. Þessi stilling getur verið breytileg eftir þinni gerð prentara. Nota TIFF fyrir margar síður Slökkt Kveikt * Velja á milli TIFF-skrá fyrir eina síðu og TIFF-skrám fyrir margar síður. valmynd Uppsetning faxþjóns"},{"UUID":"c90d1443-ce6f-4805-9c27-fd452a3c5f9b","title":"Tölvupóstur","link":"email-setup-topic.html","desc":"Uppsetning tölvupósts Atriði valmyndar ","descFull":"Uppsetning tölvupósts Atriði valmyndar  Uppsetningar tölvupósts  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Aðal SMTP-gátt Sláðu inn IP-tölu eða hýsingarheiti aðal SMTP-miðlara til að senda tölvupóst. Aðaltengi SMTP-gáttar 1–65535 (25*) Skráðu númer á gátt fyrir aðal SMTP-miðlara. Auka SMTP-gátt Sláðu inn IP-tölu eða hýsingarheiti á vara eða öryggisafriti SMTP-miðlara. Aukatengi SMTP-gáttar 1–65535 (25*) Sláðu inn númer tengis á vara eða öryggisafriti SMTP-miðlara. Tímarof SMTP 5–30 sekúndur (30*) Stilla tímann hversu lengi prentarinn er með tímarof ef SMTP-þjónninn svarar ekki. Vistfang svörunar Skilgreina vistfang svörunar í tölvupósti. Nota ávallt sjálfvalið vistfang svörunar SMTP Kveikt Slökkt * Nota ávallt sjálfvalið vistfang svörunar í SMTP þjóninum. Nota SSL/TLS Óvirkt * Framselja Þarfnast Skilgreina hvort senda eigi tölvupóst með því að nota dulkóðaðan tengil. Krefjast áreiðanlegs vottorðs Slökkt Kveikt * Krefjast áreiðanlegs vottorðs þegar tengst er SMTP þjóni. Sannvottun á SMTP-þjóni Ekki þörf á sannvottun * Innskráning / venjuleg NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Stilla gerð sannprófunar fyrir SMTP þjón. Tölvupóstur að frumkvæði tækis Engin * Nota SMTP-réttindi tækis Stilla hvort þörf er á vottorðum fyrir tölvupóst að frumkvæði tækis. Tölvupóstur að frumkvæði notanda Engin * Nota SMTP-réttindi tækis Nota notandaauðkenni lotu og aðgangsorð Nota tölvupóstfang lotu og aðgangsorð Kvaðning notanda Stilla hvort þörf er á vottorðum fyrir tölvupóst að frumkvæði notanda. Nota virk vottorð skráarsafns tækis Slökkt * Kveikt Stilla hvort þörf er á vottorðum fyrir tölvupóst að frumkvæði notanda. Notandaauðkenni tækis Skilgreina auðkenni notanda og aðgangsorð til að tengjast SMTP-þjóni. Aðgangsorð tækis Kerberos 5 REALM Skilgreina svið fyrir samskiptareglur Kerberos 5 sannvottunar. NTLM-lén Skilgreina heiti fyrir samskipti NTLM öryggis. Gera villu „SMTP-þjónn ekki uppsettur“ óvirka Slökkt * Kveikt Fela villuboð „SMTP-þjónn ekki uppsettur“. valmynd Uppsetning tölvupósts"},{"UUID":"fe5fe3fa-3dab-4662-bd2d-efd8fcfd21d5","title":"Tölvupóstur","link":"email-setup-topic.html","desc":"Sjálfgildi tölvupósts Atriði valmyndar ","descFull":"Sjálfgildi tölvupósts Atriði valmyndar  Sjálfgildi tölvupósts  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Efni: Skilgreina efni tölvupósts og skilaboð. Skilaboð: Skráarheiti Skilgreina skráarheiti á skönnuðu skjali. Snið JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Skilgreina skráarsniðið á skönnuðu skjali. Atriði valmyndar geta verið breytileg eftir þinni gerð prentara. Altækar OCR-stillingar Viðurkennd tungumál Sjálfvirkur snúningur Hreinsa bletti Sjálfvirk bæting birtuskila Setja upp stillingarnar fyrir sjónræna stafgreiningu (OCR). Þetta atriði valmyndar birtist aðeins ef þú hefur keypt og sett upp OCR lausn. PDF-stillingar PDF útgáfa  (1.5*) Skjalasafnsútgáfa  (A‑1a*) Mjög þjappað  ( Off *) Öruggt  ( Off *) Skjalasafn (PDF/A)  ( Off *) Stilla PDF-stillingarnar á skönnuðu skjali. Skjalasafnsútgáfa  og  Skjalasafn (PDF/A)  eru aðeins studd  PDF-útgáfa  er stillt á 1.4. Mikil þjöppun  birtist aðeins þegar harður diskur er uppsettur. Gerð innihalds Texti Texti/ljósmynd * Ljósmynd Gröf/teikningar Bæta útkomu úttaks byggt á gerð innihalds í upphafslegu skjali. Uppruni innihalds Svart/hvítur leysiprentari * Litaleysiprentari Bleksprautuprentari Ljósmynd/filma Tímarit Dagblað Prentvél Annað Bæta útkomu úttaks byggt á uppruna innihalds upphafslegs skjals. Litur Svart/hvítt Grátt Litur * Sjálfvirkt Stilla prentarann til að grípa innihald skráar í lit eða í einlit. Upplausn 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Skilgreina upplausn á skannaðri mynd. Svertustig 1–9 (5*) Skilgreina svertustig á skannaðri mynd. Stefna Skammsnið * Langsnið Skilgreina stefnu á upphaflega skjalinu. Upphafleg stærð Blandaðar stærðir * Stilla pappírsstærð á upphaflega skjalinu. Hliðar Slökkt * Stutt brún Löng brún Skilgreina stefnu á upphaflega skjalinu þegar verið er að skanna báðar hliðar á skjalinu. Þróuð myndvinnsla Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Litajafnvægi Blágrænn  (0*) Blárauður  (0*) Gult  (0*) Stilla litstyrkinn fyrir blágrænan, blárauðan og gulan. Brottfall á lit Brottfall á lit Engin * Rauður Grænn Blár Sjálfvalin mörk á rauðu 0–255 (128*) Sjálfvalin mörk á grænu 0–255 (128*) Sjálfvalin mörk á bláu 0–255 (128*) Skilgreina hvaða litur á að falla út við skönnun og stilla stillingu á brottfalli fyrir þann lit. Sjálfvirk uppgötvun á lit Litanæmni 1–9 (5*) Næmni á svæði 1–9 (5*) Bitadýpt tölvupósts 1 bita * 8 bita Lágmarksupplausn í skönnun 75 dpi 150 dpi 200 dpi 300 dpi * Stilla stillingu á sjálfvirkri uppgötvun á lit. JPEG-gæði Best fyrir innihald * 5–95 Stilla JPEG-gæði á skannaðri mynd. Birtuskil Best fyrir innihald * 0–5 Skilgreina birtuskil á skannaðri mynd. Fjarlægja bakgrunn Uppgötvun bakgrunns Byggt á innihaldi * Fast Stig  ‑4 til 4 (0*) Fjarlægja bakgrunnslit eða truflun úr upprunalegu skjali. Byggt á innihaldi  fjarlægir bakgrunnslit úr upprunalega skjalinu. Fast  fjarlægir truflanir úr mynd. Speglun á mynd Slökkt * Kveikt Búa til speglaða mynd af upphaflega skjalinu. Andhverf mynd Slökkt * Kveikt Búa til andhverfa mynd af upphaflega skjalinu. Atriði skugga ‑4 til 4 (0*) Stilla atriði skugga í skannaðri mynd. Skanna brún í brún Slökkt * Kveikt Skanna upphaflegt skjal frá brún til brún. Skerpa 1–5 (3*) Stilla magn skerpu í skannaðri mynd. Hitastig ‑4 til 4 (0*) Búða til blárra eða rauðara úttak af upprunalega skjalinu. Auðar síður Fjarlægja auða síðu  ( Ekki fjarlægja *) Skynja auða síðu  (5*) Stilla næmi skannanna í hlutfalli við auðar síður í upphaflega skjalinu. Stýringar stjórnanda Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Hámarksstærð tölvupósts 0–65535 (0*) Stilla leyfilega stærð á skrá fyrir hvern tölvupóst. Villuboð stærðar Skilgreina villuboð sem prentarinn sendir þegar tölvupóstur fer yfir leyfilega stærð. Þú getur skráð allt að 1024 staftákn. Takmörkun ákvörðunarstaða Takmarka sendingu á tölvupósti aðeins til skilgreinds lista yfir heiti á léni. Nota kommu til að aðgreina hvert lén. Sendu mér afrit Birtist aldrei * Sjálfvalið kveikt Sjálfvalið slökkt Alltaf kveikt Senda afrit af tölvupóstinum til þín. Leyfa aðeins eigin tölvupóst Slökkt * Kveikt Stilla prentarann til að senda aðeins tölvupóst til þín sjálfs. Nota samrit:/aukasamrit: Slökkt * Kveikt Virkja afrit og lokað afrit í tölvupósti. Nota TIFF fyrir margar síður Slökkt Kveikt * Virkja skönnun á mörgum TIFF myndum í einni TIFF skrá. TIFF-þjöppun JPEG LZW * Skilgreina gerð þjöppunar fyrir TIFF-skrár. Sjálfvalið fyrir texta 5–95 (75*) Stilla gæði á texta í innihaldið sem er skannað. Texti/mynd sjálfvalið 5–95 (75*) Stilla Ljósmynd gæði á texta og ljósmynd í innihaldið sem er skannað. Sjálfvalið fyrir mynd 5–95 (50*) Stilla gæði á ljósmynd í innihaldið sem er skannað. Stilla skekkingu frá sjálfvirkum matara Slökkt * Kveikt Stilltu prentarann til að aðlaga skekkju á myndum úr skjölum sem eru skönnuð úr sjálfvirkum matara. Atvikaskrá sendinga Prenta atvikaskrá * Ekki prenta atvikaskrá Prenta aðeins vegna villu Prenta atvikaskrá sendinga feyrir skönnun á tölvupósti. Atvikaskrá uppruna pappírs Skúffa  [x] (1*) Fjölnotamatari Skilgreina uppruna pappírs fyrir prentun á atvikaskrá tölvupóstsendinga. Skönnun á sérsniðnu verki Slökkt * Kveikt Stilltu prentarann til að skanna fyrsta settið af upphaflegum skjölum með tilgreindum stillingum og síðan næsta sett með sömu eða mismunandi stillingum. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Forskoðun skönnunar Slökkt Kveikt * Sýna forskoðun skönnunar á upphaflega skjalinu. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Leyfa Vista sem flýtivísi. Slökkt Kveikt * Vista tölvupóstfang sem flýtivísi. Senda myndir í tölvupósti sem Viðhengi * Veftengil Skilgreina hvernig senda á myndirnar sem eru innifaldar í tölvupóstinum. Endurstilla upplýsingar um tölvupóst eftir sendingu Slökkt Kveikt * Endurstilla reitina Til, Efni, Skilaboð og Skráarheiti á sjálfgefin gildi eftir að þú hefur sent tölvupóst. valmynd Sjálfgildi tölvupósts"},{"UUID":"d2412da2-a2f7-4184-8082-93d90359156a","title":"Tölvupóstur","link":"email-setup-topic.html","desc":"Uppsetning veftengils Atriði valmyndar ","descFull":"Uppsetning veftengils Atriði valmyndar  Uppsetningar veftengiils  og lýsingar þeirra Atriði valmyndar Lýsing Þjónn Skilgreina skilríki netþjónsins sem hýsir myndirnar sem eru innifaldar í tölvupóstinum. Innskráning Aðgangsorð Slóð Skráarheiti Veftengil valmynd Uppsetning veftengils"},{"UUID":"94528937-e90b-48cc-9dd2-789c61f1d090","title":"FTP","link":"ftp-defaults-topic.html","desc":"Sjálfgildi FTP Atriði valmyndar fyrir","descFull":"Sjálfgildi FTP Atriði valmyndar fyrir  sjálfgildi FTP  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Snið JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Skilgreina skráarsnið á skannaðri mynd. Atriði valmyndar geta verið breytileg eftir þinni gerð prentara. Altækar OCR-stillingar Viðurkennd tungumál Sjálfvirkur snúningur Hreinsa bletti Sjálfvirk bæting birtuskila Setja upp stillingarnar fyrir sjónræna stafgreiningu (OCR). Þetta atriði valmyndar birtist aðeins ef þú hefur keypt og sett upp OCR lausn. PDF-stillingar PDF útgáfa  (1.5*) Skjalasafnsútgáfa  ( A‑1a *) Mjög þjappað  ( Off *) Öruggt  ( Slökkt *) Skjalasafn (PDF/A)  ( Slökkt *) Stilla PDF-stillingar fyrir skannaða mynd. Skjalasafnsútgáfa  og  Skjalasafn (PDF/A)  eru aðeins studd  PDF-útgáfa  er stillt á 1.4. Mikil þjöppun  birtist aðeins þegar harður diskur er uppsettur. Gerð innihalds Texti Texti/ljósmynd * Ljósmynd Gröf/teikningar Bæta útkomu úttaks byggt á gerð innihalds í upphafslegu skjali. Uppruni innihalds Svart/hvítur leysiprentari * Litaleysiprentari Bleksprautuprentari Ljósmynd/filma Tímarit Dagblað Prentvél Annað Bæta útkomu úttaks byggt á uppruna innihalds upphafslegs skjals. Litur Svart/hvítt Grátt Litur * Sjálfvirkt Stilla prentarann til að grípa innihald skráar í lit eða í einlit. Upplausn 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Skilgreina upplausn á skannaðri mynd. Svertustig 1-9 (5*) Skilgreina svertustig á skannaðri mynd. Stefna Skammsnið * Langsnið Skilgreina stefnu á upphaflega skjalinu. Upphafleg stærð Blandaðar stærðir * Stilla pappírsstærð á upphaflega skjalinu. Hliðar Slökkt * Löng brún Stutt brún Skilgreina stefnu þegar verið er að skanna báðar hliðar á skjalinu. Skráarheiti Skilgreina skráarheiti á skannaðri mynd. Þróuð myndvinnsla Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Litajafnvægi Blágrænn  (0*) Blárauður  (0*) Gult  (0*) Stilla litstyrkinn fyrir blágrænan, blárauðan og gulan. Brottfall á lit Brottfall á lit Engin * Rauður * Grænn * Blár * Sjálfvalin mörk á rauðu 0–255 (128*) Sjálfvalin mörk á grænu 0–255 (128*) Sjálfvalin mörk á bláu 0–255 (128*) Skilgreina hvaða litur á að falla út við skönnun og stilla stillingu á brottfalli fyrir þann lit. Sjálfvirk uppgötvun á lit Litanæmni 1-9 (5*) Næmni á svæði 1-9 (5*) Bitadýpt FTP 1 bita * 8 bita Lágmarksupplausn í skönnun 75 dpi 150 dpi 200 dpi 300 dpi * Stilla stillingu á sjálfvirkri uppgötvun á lit. JPEG-gæði Best fyrir innihald * 5–95 Stilla JPEG-gæði á skannaðri mynd. Birtuskil Best fyrir innihald * 0 1 2 3 4 5 Skilgreina birtuskil á skannaðri mynd. Fjarlægja bakgrunn Uppgötvun bakgrunns  Byggt á innihaldi * Fast Stig ‑4 til 4 (0*) Fjarlægja bakgrunnslit eða truflun úr upprunalegu skjali. Byggt á innihaldi  fjarlægir bakgrunnslit úr upprunalega skjalinu. Fast  fjarlægir truflanir úr mynd. Speglun á mynd Slökkt * Kveikt Búa til speglaða mynd af upphaflega skjalinu. Andhverf mynd Slökkt * Kveikt Búa til andhverfa mynd af upphaflega skjalinu. Atriði skugga ‑4 til 4 (0*) Stilla atriði skugga í skannaðri mynd. Skanna brún í brún Slökkt * Kveikt Leyfa skönnun brún-í-brún á upphaflegu skjali. Skerpa 1–5 (3*) Stilla magn skerpu í skannaðri mynd. Hitastig ‑4 til 4 (0*) Búða til blárra eða rauðara úttak af upprunalega skjalinu. Auðar síður Fjarlægja auða síðu Ekki fjarlægja * Fjarlægja Skynja auða síðu 1-9 (5*) Stilla næmi skannanna í hlutfalli við auðar síður í upphaflega skjalinu. Stýringar stjórnanda Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Sjálfvalið fyrir texta 5–95 (75*) Stilla gæði á texta á skannaðri mynd. Texti/mynd sjálfvalið 5–95 (75*) Stilla gæði á texta og ljósmynd á skannaðri mynd. Sjálfvalið fyrir mynd 5-95 (50*) Stilla gæði á ljósmynd á skannaðri mynd. Nota TIFF fyrir margar síður Kveikt * Slökkt Virkja skönnun á mörgum TIFF myndum í einni TIFF skrá. TIFF-þjöppun LZW * JPEG Skilgreina gerð þjöppunar fyrir TIFF-skrár. Atvikaskrá sendinga Prenta atvikaskrá * Ekki prenta atvikaskrá Prenta aðeins vegna villu Prenta atvikaskrá sendinga fyrir FTP skannanir. Atvikaskrá uppruna pappírs Skúffa  [x] (1*) Fjölnotamatari Skilgreina uppruna pappírs fyrir prentun á atvikaskrá FTP. Atvikaskrá fyrir úttaksbakka Staðalbakki * Bakki [x] Skilgreina úttaksbakka fyrir prentaðar FTP atvikaskrár. Skönnun á sérsniðnu verki Slökkt * Kveikt Kveikja á að skönnun á sérsniðnum verkum sé sjálfvalið. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Forskoðun skönnunar Slökkt Kveikt * Sýna forskoðun af skönnun á skjánum. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Leyfa Vista sem flýtivísi Slökkt Kveikt * Vista FTP-vistfang sem flýtivísi. valmynd Sjálfgildi FTP"},{"UUID":"f932d176-6ccc-45f5-9e28-706e022a1fac","title":"USB-drif","link":"flash-drive-scan-topic.html","desc":"Skönnun frá minniskorti Atriði valmyndar","descFull":"Skönnun frá minniskorti Atriði valmyndar  Skönnunar frá minniskorti  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Snið JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) Skilgreina skráarsnið á skannaðri mynd. Altækar OCR-stillingar Viðurkennd tungumál Sjálfvirkur snúningur Hreinsa bletti Sjálfvirk bæting birtuskila Setja upp stillingarnar fyrir sjónræna stafgreiningu (OCR). Þessi valmynd birtist aðeins ef þú hefur keypt og sett upp OCR lausn. PDF-stillingar PDF útgáfa  (1.5*) Skjalasafnsútgáfa  (A‑1a*) Mjög þjappað  ( Off *) Öruggt  ( Slökkt *) Skjalasafn (PDF/A)  ( Slökkt *) Stilla PDF-stillingu á skannaðri mynd. Skjalasafnsútgáfa  og  Skjalasafn (PDF/A)  eru aðeins studd  PDF-útgáfa  er stillt á 1.4. Mikil þjöppun  birtist aðeins þegar harður diskur er uppsettur. Gerð innihalds Texti Texti/ljósmynd * Gröf/teikningar Ljósmynd Bæta útkomu úttaks byggt á gerð innihalds í upphafslegu skjali. Uppruni innihalds Svart/hvítur leysiprentari * Litaleysiprentari Bleksprautuprentari Ljósmynd/filma Tímarit Dagblað Prentvél Annað Bæta útkomu úttaks byggt á uppruna innihalds upphafslegs skjals. Litur Svart/hvítt Grátt Litur * Sjálfvirkt Stilla prentarann til að grípa innihald skráar í lit eða í einlit. Upplausn 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Skilgreina upplausn á skannaðri mynd. Svertustig 1-9 (5*) Skilgreina svertustig á skannaðri mynd. Stefna Skammsnið * Langsnið Skilgreina stefnu á upphaflega skjalinu. Upphafleg stærð Blandaðar stærðir * Stilla pappírsstærð á upphaflega skjalinu. Hliðar Slökkt * Löng brún Stutt brún Skilgreina stefnu á upphaflega skjalinu þegar verið er að skanna báðar hliðar á skjalinu. Skráarheiti Skilgreina skráarheiti á skannaðri mynd. Þróuð myndvinnsla Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Litajafnvægi Blágrænn (0*) Blárauður (0*) Gulur (0*) Stilla litstyrkinn fyrir blágrænan, blárauðan og gulan. Brottfall á lit Brottfall á lit  ( Ekkert *) Sjálfvalin mörk á rauðu (128*) Sjálfvalin mörk á grænu (128*) Sjálfvalin mörk á bláu (128*) Skilgreina hvaða litur á að falla út við skönnun og stilla stillingu á brottfalli fyrir þann lit. Sjálfvirk uppgötvun á lit Litanæmni (5*) Næmni á svæði  (5*) Bitadýpt skönnunar  (1 bit*) Lágmarks upplausn í skönnun  (300 dpi*) Stilla stillingu á sjálfvirkri uppgötvun á lit. JPEG-gæði Best fyrir innihald * 5–95 Stilla JPEG-gæði á skannaðri mynd. Birtuskil Best fyrir innihald * 0–5 Skilgreina birtuskil á skannaðri mynd. Fjarlægja bakgrunn Uppgötvun bakgrunns ( Byggt á innihaldi * Fast Stig (0*) Fjarlægja bakgrunnslit eða truflun úr upprunalegu skjali. Byggt á innihaldi  fjarlægir bakgrunnslit úr upprunalega skjalinu. Fast  fjarlægir truflanir úr mynd. Speglun á mynd Slökkt * Kveikt Búa til speglaða mynd af upphaflega skjalinu. Andhverf mynd Slökkt * Kveikt Búa til andhverfa mynd af upphaflega skjalinu. Atriði skugga ‑4 til 4 (0*) Stilla atriði skugga í skannaðri mynd. Skanna brún í brún Slökkt * Kveikt Skanna upphaflegt skjal frá brún til brún. Skerpa 1–5 (3*) Stilla magn skerpu í skannaðri mynd. Hitastig ‑4 til 4 (0*) Búða til blárra eða rauðara úttak af upprunalega skjalinu. Auðar síður Fjarlægja auða síðu  ( Fjarlægja *) Skynja auða síðu  (5*) Stilla næmi skannanna í hlutfalli við auðar síður í upphaflega skjalinu. Stýringar stjórnanda Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Sjálfvalið fyrir texta 5–95 (75*) Stilla gæði á texta á skannaðri mynd. Texti/mynd sjálfvalið 5–95 (75*) Stilla gæði á texta og ljósmynd á skannaðri mynd. Sjálfvalið fyrir mynd 5-95 (50*) Stilla gæði á ljósmynd á skannaðri mynd. Nota TIFF fyrir margar síður Slökkt Kveikt * Virkja skönnun á mörgum TIFF myndum í einni TIFF skrá. TIFF-þjöppun LZW * JPEG Skilgreina gerð þjöppunar fyrir TIFF-skrár. Skönnun á sérsniðnu verki Slökkt * Kveikt Stilltu prentarann til að skanna fyrsta settið af upphaflegum skjölum með tilgreindum stillingum og skannaðu síðan næsta sett með sömu eða mismunandi stillingum. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Forskoðun skönnunar Slökkt Kveikt * Sýna forskoðun skönnunar á upphaflega skjalinu. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. valmynd Skönnun frá minniskorti"},{"UUID":"96278a54-59c8-496f-93c0-90a431061b89","title":"USB-drif","link":"flash-drive-scan-topic.html","desc":"Prentun frá minniskorti Atriði valmyndar","descFull":"Prentun frá minniskorti Atriði valmyndar  Prentunar frá minniskorti  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Fjöldi eintaka 1–9999 (1*) Stilla fjölda eintaka. Uppruni pappírs Skúffa  [x] (1*) Fjölnotamatari Handvirk stilling pappírs Handvirk stilling umslags Stilla uppruna pappírs fyrir prentverk. Raða (1,1,1) (2,2,2) (1,2,3) (1,2,3)* Stafla síðum í prentverki í röð þegar verið er að prenta mörg eintök af verkinu.. Hliðar 1‑hlið * 2‑hliðar Skilgreina hvort prentað er á eina hlið eða báðar hliðar á pappírinn. Hefta Slökkt * 1 hefti, efra vinstra horni 2 heftir, vinstra megin 1 hefti, efra hægra horni 2 hefti, efst 1 hefti, neðra vinstra horni 2 hefti, neðst 1 hefti, neðst í hægra horni 2 hefti, hægra megin 4 hefti Skilgreina staðsetningu hefta fyrir öll prentverk. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara er til staðar. Gatari Slökkt * 2 göt 3 göt 4 göt Stilla stillingu götunar fyrir öll prentverk. Þetta atriði valmyndar birtist aðeins þegar frágangseining heftara, gatari er til staðar. Hliðraðar síður Engin * Á milli afrita Á milli verka Hliðrar úttaki á hverju prentverki eða hverju eintaki á prentverki. Á milli afrita  hliðrar hverju prentverki ef  Samröðun  er stillt á  Kveikt  [1,2,1,2,1,2]. Ef  Samröðun  er stillt á  Slökkt  [1,1,1,2,2,2], þá er hverju setti á prentuðum síðum hliðrað, svo sem allar síður merktar 1 eða allar síður merktar 2. Milli verka  verka setur sömu stöðu í hliðrun fyrir allt verkið í prentun óháð fjölda eintaka sem eru prentuð. Veltistíll Löng brún * Stutt brún Ákvarða hvaða hlið á pappír er bundin þegar prentað er á báðar hliðar. Síður á hlið Slökkt * 2 síður á hlið 3 síður á hlið 4 síður á hlið 6 síður á hlið 9 síður á hlið 12 síður á hlið 16 síður á hlið Prenta margar síðumyndir á einni hlið á pappírsörk. Röðun á síðum á hlið Lárétt * Öfugt lárétt Öfugt lóðrétt Lóðrétt Skilgreina staðsetningu á mörgum síðum þegar verið er að nota valmynd  Síður á hlið . Stefna á síðum á hlið Sjálfvirkt * Langsnið Skammsnið Skilgreina staðsetningu á mörgum síðum þegar verið er að nota valmynd  Síður á hlið . Spássía á síðum á hlið Engin * Heil Prenta spássíu á hverja síðumynd þegar verið er að nota valmynd  Síður á hlið . Aðskilnaðarsíður Slökkt * Á milli afrita Á milli verka Á milli síðna Setja inn auðar aðskilnaðarsíður við prentun. Uppruni aðskilnaðarsíðu Skúffa  [x] (1*) Fjölnotamatari Skilgreina uppruna pappírs á aðskilnaðarsíðum. Auðar síður Ekki prenta * Prenta Prenta auðar síður í prentverki. valmynd Prentun frá minniskorti"},{"UUID":"bd865a89-0ac0-4552-be12-883f3dcd1297","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"Yfirlit netkerfis Atriði valmyndar ","descFull":"Yfirlit netkerfis Atriði valmyndar  Yfirlits netkerfis  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkur tengibúnaður Sjálfvirkt * Staðalnetkerfi Þráðlaust Skilgreina gerð af tengingu netkerfis. Þráðlaust  er aðeins í boði í gerðum prentara sem eru tengdir við þráðlaust net. Staða netkerfis Sýna stöðu tengingar við netkerfi prentarans. Sýna stöðu netkerfis á prentara Slökkt Kveikt * Sýna stöðu netkerfis á skjánum. Hraði, Duplex Sýna hraðann á núverandi virku netkorti. IPv4 Sýna IPv4-vistfangið. Öll IPv6-vistföng Sýna öll IPv6-vistföng. Endurstilla prentþjón Endurstilla allar virkar nettengingar prentarans. Þessi stilling fjarlægir allar uppsetningarstillingar netkerfis. Tímarof verks í netkerfi Slökkt Kveikt * (90  sekúndur ) Stilla tímann áður en prentarinn hættir við prentverk á netinu. Upplýsingasíða Slökkt * Kveikt Prenta upplýsingasíðu. Skanna til tengisviðs PC Skilgreina gilt svið tengis fyrir prentara sem eru á bak við eldvegg sem lokar á tengi. Virkja nettengingar Slökkt Kveikt * Virkja tengingu á prentaranum við netkerfi. Virkja LLDP Slökkt * Kveikt Virkja LLDP (Link Layer Discovery Protocol) í prentaranum. valmynd Yfirlit netkerfis"},{"UUID":"8a75dfb8-bff5-411a-9b64-f9191ecc2377","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"Þráðlaust Þessi valmynd er aðeins","descFull":"Þráðlaust Þessi valmynd er aðeins tiltæk í gerðum prentara sem er tengdur við þráðlaust net eða prenturum sem eru með tengi fyrir þráðlaust net. Stillingar fyrir  Þráðlaust  og lýsingar þeirra Atriði valmyndar Lýsing Uppsetning með því að nota forrit fyrir fartæki Stilla tengingu við þráðlaust net með því að nota Lexmark Mobile Assistant. Uppsetning á stjórnborði prentara Velja netkerfi Bæta við þráðlausu netkerfi Heiti netkerfis Stilling netkerfis Grunnkerfi Öryggisstilling þráðlausrar tengingar Óvirkt * WEP WPA2/WPA - Persónulegt WPA2 - Persónulegt 802.1x - RADIUS Stilla þráðlausa tengingu með því að nota stjórnborðið. Aðeins er hægt að stilla  802.1x - RADIUS  frá innbyggða vefþjóninum. Vernduð þráðlaus uppsetning (Wi‑Fi Protected Setup (WPS)) Sjálfvirk uppgötvun WPS Slökkt Kveikt * Aðferð gangsetningar með hnöppum Gangsetning með PIN-aðferð Koma á þráðlaustu neti og virkja öryggi netkerfis Sjálfvirk uppgötvun WPS  birtist aðeins þegar  Öryggisstilling þráðlausrar tengingar  er stillt á  WEP . Aðferð gangsetningar með hnöppum  tengir prentara við þráðlaust net þegar ýtt er á hnappa á bæði prentara og aðgangsstað (þráðlausum beini) innan ákveðins tíma. Gangsetning með  PIN-aðferð  tengir prentara við þráðlaust net þegar PIN-númer á prentaranum er skráð í þráðlausar stillingar á aðgangsstaðnum. Stilling netkerfis BSS-gerð Grunnkerfi * Skilgreina stillingu netkerfis. Samhæfni 802.11b/g/n (2.4GHz) * 802.11a/b/g/n/ac (2.4GHz/5GHz) 802.11a/n/ac (5GHz) Skilgreina staðal fyrir þráðlaust netkerfi. 802.11a/b/g/n/ac (2.4GHz/5GHz)  og  802.11a/n/ac (5GHz)  birtast aðeins þegar þráðlaus valkostur er uppsettur. Öryggisstilling þráðlausrar tengingar Óvirkt * WEP WPA2/WPA-Persónulegt WPA2-Persónulegt 802.1x - RADIUS Stilla öryggisstillingu til að tengja prentarann við þráðlaus tæki. Aðeins er hægt að stilla  802.1x - RADIUS  frá innbyggða vefþjóninum. WEP staðfestingarstilling Sjálfvirkt * Opin Sameiginleg Stilla tegund þráðlausrar dulkóðunar (WEP) fyrir prentarann. Þetta atriði valmyndar birtist aðeins þegar  öryggisstilling þráðlausrar tengingar  er stillt á  WEP . Stilla WEP-lykil Skilgreina aðgangsorð WEP fyrir örugga þráðlausa tengingu. WPA2/WPA Persónulegt AES Virkja þráðlaust öryggi með öruggu þráðlausu aðgengi (WPA). Þetta atriði valmyndar birtist aðeins þegar  öryggisstilling þráðlausrar tengingar  er stillt á  WPA2/WPA-Persónulegt . Stilla fyrir fram sameiginlegan lykil Stilla aðgangsorð fyrir örugga þráðlausa tengingu. WPA2-Persónulegt AES Virkja þráðlaust öryggi með WPA2. Þetta atriði valmyndar birtist aðeins þegar  öryggisstilling þráðlausrar tengingar  er stillt á  WPA2-Persónulegt . 802.1x dulkóðunarstilling WPA+ WPA2 * Virkja þráðlaust öryggi með 802.1x staðli. Þetta atriði valmyndar birtist aðeins þegar  öryggisstilling þráðlausrar tengingar  er stillt á  802.1x - RADIUS . Aðeins er hægt að stilla  802.1x - RADIUS  frá innbyggða vefþjóninum. IPv4 Virkja DHCP Kveikt * Slökkt Stilla fasta IP-tölu IP-tala Netsía Gátt Virkja og stilla IPv4-stillingar í prentaranum. IPv6 Virkja IPv6 Kveikt * Slökkt Virkja DHCPv6 Kveikt Slökkt * Sjálfvirk uppsetning vistfangs án staðsetningar Kveikt * Slökkt DNS-tala netþjóns Handvirkt úthlutað IPv6 vistfang Handvirkt úthlutaður IPv6 beinir Forskeyti vistfangs Öll IPv6-vistföng Öll IPv6-vistföng beinis. Virkja og stilla IPv6-stillingar í prentaranum. Vistfang netkerfis UAA LAA Skoða vistföng netkerfis. PCL SmartSwitch Slökkt Kveikt * Stilla prentarann til skipta sjálfkrafa í PCL-hermingu þegar prentverk krefst þess, án tillits til sjálfgefins tungumáls prentara. Ef slökkt er á  PCL SmartSwitch  skoðar prentarinn ekki gögn á innleið og notar sjálfvalið tungumál prentara sem er skilgreint í valmynd  Uppsetning . PS SmartSwitch Slökkt Kveikt * Stilla prentarann til skipta sjálfkrafa í PS-hermingu þegar prentverk krefst þess, án tillits til sjálfgefins tungumáls prentara. Ef slökkt er á  PS SmartSwitch  skoðar prentarinn ekki gögn á innleið og notar sjálfvalið tungumál prentara sem er skilgreint í valmynd  Uppsetning . Verki í biðminni Kveikt Slökkt * Vista verk tímabundið á hörðum diski prentara fyrir prentun. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Mac Binary PS Sjálfvirkt * Kveikt Slökkt Stillir prentarann til að vinna úr Macintosh binary PostScript prentverkum. Kveikt  vinnur úr raw binary PostScript prentverkum. Slökkt  síar prentverk sem nota staðalsamskipti. valmynd Þráðlaust"},{"UUID":"881fb4c5-f1bc-424f-b058-595519e37e6f","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Atriði valmyndar um","descFull":"Wi‑Fi Direct Atriði valmyndar um  Wi-Fi Direct  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkja beint þráðlaust net (Wi‑Fi) Kveikt Slökkt * Stilla prentarann til að tengjast beint við tæki með þráðlausu neti (Wi-Fi). Heiti Wi‑Fi Direct Skilgreina heiti fyrir Wi-Fi Direct netkerfi. Wi‑Fi Direct aðgangsorð Setja aðgangsorð til að sannvotta og sannreyna notendur á Wi‑Fi tengingu. Sýna aðgangsorð á uppsetningarsíðu Slökkt Kveikt * Sýna  Wi‑Fi Direct aðgangsorð  á  uppsetningarsíðu netkerfisins . Forgangsrásarnúmer 1–11 Sjálfvirkt * Stilla æskilega rás í þráðlausa netkerfinu. IP-tala eiganda hóps Skilgreina IP-tölu fyrir eiganda hóps. Samþykkja sjálfvirkt beiðni ýtihnappa Slökkt * Kveikt Samþykkja beiðnir til að tengjast netkerfi sjálfvirkt. Sjálfvirkt samþykki viðskiptavina er ekki öruggt. valmynd Wi‑Fi Direct"},{"UUID":"ce7a1a52-35b0-4c3e-81f6-9789f509cb34","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"AirPrint Þessi valmynd birtist aðeins","descFull":"AirPrint Þessi valmynd birtist aðeins í innbyggða vefþjóninum. Atriði valmyndar um  AirPrint  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Allar AirPrint aðgerðir Sýna AirPrint stöðu prentarans. Virkja AirPrint Kveikt * Slökkt Virkja AirPrint aðgerð. Þetta atriði valmyndar birtist eingöngu ef slökkt er á Internet Printing Protocol (IPP) eða mDNS. Bonjour Nafn Auðkenna heiti og staðsetningu prentara. Heiti fyrirtækis Fyrirtækiseining Staðsetning prentara Breiddargráða prentara Lengdargráða prentara Hæð prentara yfir sjávarmáli Fleiri valkostir valmynd AirPrint"},{"UUID":"60d57034-55f0-484b-b93e-b9999eef0525","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"Stjórnun þjónustu fartækja Þessi valmynd","descFull":"Stjórnun þjónustu fartækja Þessi valmynd birtist aðeins í innbyggða vefþjóninum. Atriði valmyndar fyrir  Stjórnun þjónustu fartækja  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkja IPP prentun Kveikt * Slökkt Leyfa prentun frá fartækjum með því að nota Internet Printing Protocol (IPP). Virkja IPP fax Kveikt * Slökkt Leyfa faxsendingar með því að nota Internet Printing Protocol (IPP). Virkja IPP Over USB Kveikt * Slökkt Leyfa að prenta eða skanna verk með því að nota USB tengingu. Virkja skönnun Kveikt * Slökkt Leyfa skönnun með eSCL. Virkja Mopria uppgötvun Kveikt * Slökkt Leyfa tækjum með virkjað Mopria að finna prentarann. valmynd Stjórnun þjónustu fartækja"},{"UUID":"f6f26d03-4266-469b-9ebc-5f3138a45680","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"Ethernet Atriði valmyndar  Ethernets","descFull":"Ethernet Atriði valmyndar  Ethernets  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Hraði netkerfis Sýna hraða á virkum tengibúnaði netkerfis. IPv4 Virkja samskiptatíma netkerfis (DHCP)  ( kveikt *) Stilla fasta IP-tölu Stilla IPv4-stillingarnar. IPv6 Virkja IPv6  ( kveikt *) Virkja DHCPv6  ( slökkt  *) Sjálfvirk uppsetning vistfangs án staðsetningar  ( kveikt *) DNS-tala netþjóns Handvirkt úthlutað IPv6 vistfang Handvirkt úthlutaður IPv6 beinir Forskeyti vistfangs (64*) Öll IPv6-vistföng Öll IPv6-vistföng beinis. Stilla IPv6-stillingarnar. Vistfang netkerfis UAA LAA Skilgreina vistfang netkerfis. PCL SmartSwitch Slökkt Kveikt * Stilla prentarann til skipta sjálfkrafa í PCL-hermingu þegar prentverk krefst þess, án tillits til sjálfgefins tungumáls prentara. Þegar þessi stilling er óvirk skoðar prentarinn ekki gögn á innleið og notar sjálfvalið tungumál prentara sem er skilgreint í valmynd  Uppsetning . PS SmartSwitch Slökkt Kveikt * Stilla prentarann til skipta sjálfkrafa í PostScript-hermingu þegar prentverk krefst þess, án tillits til sjálfgefins tungumáls prentara. Þegar þessi stilling er óvirk skoðar prentarinn ekki gögn á innleið og notar sjálfvalið tungumál prentara sem er skilgreint í valmynd  Uppsetning . Verki í biðminni Slökkt * Kveikt Vista verk tímabundið á hörðum diski fyrir prentun. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Mac Binary PS Sjálfvirkt * Kveikt Slökkt Stillir prentarann til að vinna úr Macintosh binary PostScript prentverkum. Sjálfvirkt  vinnur prentverkum frá tölvum sem nota annað hvort stýrikerfi frá Windows eða Macintosh. Slökkt  síar PostScript-prentverk sem nota staðalsamskipti. Ethernet með orkuskilvirkni Kveikt Slökkt Sjálfvirkt * Draga úr orkunotkun þegar prentarinn tekur ekki við gögnum frá Ethernet-netkerfi. valmynd Ethernet"},{"UUID":"14be5e0b-0363-4384-a09a-b1142ea1369f","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"TCP/IP Þessi valmynd birtist aðeins","descFull":"TCP/IP Þessi valmynd birtist aðeins í nettengdum prenturum eða prenturum sem eru tengdir prentþjónum. Atriði og lýsingar  TCP/IP -valmyndar Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Stilla heiti hýsis. Stilla núverandi hýsisnafn TCP/IP. Heiti léns Stilla heiti léns Leyfa DHCP/BOOTP að uppfæra NTP-þjón Kveikt * Slökkt Leyfa DHCP og BOOTP biðlurum að uppfæra NTP-stillingar á prentaranum. Nafn núllstillingar Skilgreina þjónustuheiti fyrir núllstillt netkerfi. Virkja sjálfvirka IP-tölu Kveikt * Slökkt Úthlutar IP-tölu sjálfvirkt. DNS-tala netþjóns Skilgreina núverandi DNS-tölu netþjóns. Afrit DNS-tölu netþjóns Skilgreina afritun á DNS-tölu netþjóna. Afrit DNS-tölu netþjóns 2 Afrit DNS-tölu netþjóns 3 Leitarröð léns Skilgreina lista yfir lén til að finna prentara og tilföng hans sem eru í mismunandi lénum á netinu. Virkja DDNS Slökkt * Kveikt Uppfæra breytilegar DNS-stillingar. DDNS TTL 300–31536000 sekúndur (3600*) Skilgreina núverandi DDNS-stillingar. Sjálfvalið TTL 5–254 sekúndur (254*) Endurnýjunartími DDNS 300–31536000 sekúndur (604800*) Virkja mDNS Kveikt * Slökkt Uppfæra stillingar DNS margvarps. WINS-tala netþjóns Skilgreina vistfang fyrir Windows Internet Name Service (WINS). Virkja BOOTP Slökkt * Kveikt Leyfa BOOTP að úthluta IP-tölu prentara. Listi yfir takmarkanir netþjóns Skilgreina IP-tölu fyrir TCP-tengingar Nota kommu til að aðgreina hverja IP-tölu. Þú getur bætt við allt að 50 IP-tölum. Listi yfir valkosti takmarkana netþjóns Loka á öll tengi * Loka aðeins á prentun Loka aðeins á prentun og HTTP Skilgreina hvernig IP-tölur á listanum geta fengið aðgengi að virkni prentarans. MTU 256–1500 (1500*) Skilgreina breytu hámarkseiningu samskipta (MTU) fyrir TCP-tengingar. Raw-prentaratengi 1–65535 (9100*) Skilgreina númer raw-tengis fyrir prentara sem tengdir eru netkerfi. Hámarkshraði umferðar á útleið Óvirkt * Virkt 100–1000000 (100000*) Virkja hámarksflutningshraða prentarans. Virkja TLSv1.0 Kveikt * Slökkt Virkja TLSv1.0 samskiptamátann Virkja TLSv1.1 Kveikt * Slökkt Virkja TLSv1.1 samskiptamátann SSL dulmálslisti Skilgreina algrím dulmáls til að nota við SSL eða TLS tengingar. valmynd TCP/IP"},{"UUID":"2280e63c-9336-4420-9c3c-e36f06bd0c08","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"SNMP Þessi valmynd birtist aðeins","descFull":"SNMP Þessi valmynd birtist aðeins í nettengdum prenturum eða prenturum sem eru tengdir prentþjónum. Atriði  SNMP -valmyndar og lýsingar Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. SNMP útgáfa 1 og 2c Virkt Slökkt Kveikt * Leyfa stillingu SNMP Slökkt Kveikt * Virkja PPM MIB Slökkt Kveikt * SNMP umhverfi Setja upp „Simple Network Management Protocol“ (SNMP) útgáfur 1 og 2c til að setja upp prentrekla og forrit. SNMP útgáfa 3 Virkt Slökkt Kveikt * Samhengisheiti Stilla skírteini lesa/skrifa Nafn notanda Aðgangsorð sannvottunar Aðgangsorð persónuverndar Stilla skírteini aðeins lesa Nafn notanda Aðgangsorð sannvottunar Aðgangsorð persónuverndar Myllutákn vottunar MD5 SHA1 * Lágmarksstig sannvottunar Engin sannvottun, engin gagnaleynd Sannvottun, engin gagnaleynd Sannvottun, gagnaleynd * Algrím gagnaleyndar DES AES‑128 * Stilla SNMP útgáfu 3 til að setja upp og uppfæra öryggi prentara. valmynd SNMP"},{"UUID":"af31988a-a7f5-4c15-b667-35d1f74e88de","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"IPSec Þessi valmynd birtist aðeins","descFull":"IPSec Þessi valmynd birtist aðeins í nettengdum prenturum eða prenturum sem eru tengdir prentþjónum. Atriði valmyndar  IPSec  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkja IPSec Slökkt * Kveikt Virkja „Internet Protocol Security“ (IPSec). Grunnuppsetning Sjálfvalið * Samhæfni Öruggt Stilla grunnuppsetningu IPSec. Þetta atriði valmyndar birtist aðeins þegar  Virkja IPSec  er stillt á  Kveikt . DH (Diffie‑Hellman) uppástunga hóps modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Stilla grunnuppsetningu IPSec. Þetta atriði valmyndar birtist aðeins þegar  Grunnuppsetning  er stillt á  Samhæfi . Tillaga um dulkóðunaraðferð 3DES AES * Stilla aðferð dulkóðunar. Þetta atriði valmyndar birtist aðeins þegar  Grunnuppsetning  er stillt á  Samhæfi . Tillaga um staðfestingaraðferð SHA1 SHA256 * SHA512 Stilla aðferð sannvottunar. Þetta atriði valmyndar birtist aðeins þegar  Grunnuppsetning  er stillt á  Samhæfi . IKE SA líftími (klst) 1 2 4 8 24* Skilgreina tímabil gildisloka IKE SA. Þetta atriði valmyndar birtist aðeins þegar  Grunnuppsetning  er stillt á  Öruggt . IPSec SA líftími (klst) 1 2 4 8* 24 Skilgreina tímabil gildisloka IPSec SA. Þetta atriði valmyndar birtist aðeins þegar  Grunnuppsetning  er stillt á  Öruggt . Skírteini IPSec-tækis Skilgreina IPSec vottorð. Þetta atriði valmyndar birtist aðeins þegar  Virkja IPSec  er stillt á  Kveikt . Fyrir fram samnýttar lykilvottaðar tengingar Hýsill  [x] Setja upp staðfestar tengingar á prentaranum. Þessi atriði valmyndar birtast aðeins þegar  Virkja IPSec  er stillt á  Kveikt . Votta staðfestar tengingar Hýsill  [x]  Vistfang[/undirnet] valmynd IPSec"},{"UUID":"28458efc-ecfd-439b-acf5-3a24098c58d9","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"802.1x Þessi valmynd birtist aðeins","descFull":"802.1x Þessi valmynd birtist aðeins í nettengdum prenturum eða prenturum sem eru tengdir prentþjónum. Atriði valmyndar fyrir  802.1x  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkt Slökkt * Kveikt Láta prentarann tengjast netkerfum sem þarfnast sannvottunar áður en aðgengi er leyft. 802.1x sannvottun Innskráningarnafn tækis Aðgangsorð innskráningar tækis Staðfesta vottorð þjónustu  ( Kveikt *) Virka atvikaskráningu  ( Slökkt *) 802.1x skírteini tækis Setja upp stillingarnar fyrir sannvottun á 802.1x tengingu. Leyfilegt auðkenningarkerfi EAP ‑ MD5  ( Kveikt *) EAP - MSCHAPv2  ( Kveikt *) LEAP  ( Kveikt *) PEAP  ( Kveikt *) EAP - TLS  ( Kveikt *) EAP - TTLS  ( Kveikt *) TTLS auðkenningaraðferð  ( MSCHAPv2 *) Stilla leyfilegt auðkenningarkerfi fyrir 802.1x tenginguna. valmynd 802.1x"},{"UUID":"2321363b-4cd1-4ab0-ad93-a202df5825af","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"LPD-uppsetning Þessi valmynd birtist aðeins","descFull":"LPD-uppsetning Þessi valmynd birtist aðeins í nettengdum prenturum eða prenturum sem eru tengdir prentþjónum. Atriði valmyndar  LPD-uppsetningar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Tímarof LPD 0–65535 sekúndur (90*) Stilla gildi tímarofs til að stöðva að Line Printer Daemon-miðlarinn (LPD) sé að bíða endalaust fetir föstum eða ógildum prentverkum. Upplýsingasíða LPD Slökkt * Kveikt Prenta upplýsingasíðu fyrir öll LPD prentverk Upplýsingasíða er fyrsta blaðsíðu prentunar sem notað er sem aðskilnaðarsíða prentverka og til að bera kennsl á upphaf beiðni prentunar. Lokasíða LPD Slökkt * Kveikt Prenta lokasíðu fyrir öll LPD prentverk Lokasíða er síðasta síðan í prentverki. Umbreyting á nýrri línu LPD Slökkt * Kveikt Virkja umbreytingu á nýrri línu Ný lína er búnaður sem stjórnar prentara til að færa stöðu bendilsins í fyrstu stöðu á sömu línu. valmynd LPD-uppsetning"},{"UUID":"b6831b8b-7d68-4772-8cbb-c3d04dfc417c","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"HTTP/FTP-stillingar Atriði valmyndar fyrir ","descFull":"HTTP/FTP-stillingar Atriði valmyndar fyrir  HTTP/FTP-stillingar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Proxy IP-tala HTTP Proxy HTTP sjálfvalið IP-tengi IP-tala FTP Proxy FTP sjálfvalið IP-tengi Sannvottun Nafn notanda Aðgangsorð Staðbundin lén Setja upp stillingar fyrir HTTP- og FTP-þjón. Aðrar stillingar Virkja HTTP-þjón  ( Kveikt *) Aðgengi að innbyggðum vefþjón til að fylgjast með og stjórna prentaranum. Aðrar stillingar Virkja samskiptatíma netkerfis (HTPPS)  ( Kveikt *) Virkja „Hypertext Transfer Protocol Secure“ (HTTPS) til að dulkóða gögn til og frá prentþjóni. Aðrar stillingar Þvinga HTTPS-tengingar  ( Slökkt *) Þvinga prentarann til að nota HTTPS-tengingar. Aðrar stillingar Virkja FTP/TFTP  ( Kveikt *) Senda skrár með því að nota FTP/TFTP. Aðrar stillingar Skírteini HTTPS-tækis  ( sjálfvalið *) Skoða HTTP skírteini tækis sem notað er á prentaranum. Aðrar stillingar Tímarof fyrir HTTP/FTP beiðnir  (30*) Skilgreina tímann áður en tenging þjóns stöðvast. Aðrar stillingar Beiðnir fyrir endurtengingu HTTP/FTP  (3*) Stilla fjölda á tilraunum til endurtengingar á HTTP/FTP-þjón. valmynd HTTP/FTP-stillingar"},{"UUID":"cbcd4559-d8db-4b5b-8da5-861d7609cffe","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"ThinPrint Atriði valmyndar um ","descFull":"ThinPrint Atriði valmyndar um  ThinPrint  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkja ThinPrint Slökkt * Kveikt Prenta með því að nota ThinPrint. Númer á tengi 4000–4999 (4000*) Stilla númer á tengi fyrir ThinPrint-þjóninn. Bandbreidd (bitar/sek) 100–1000000 (0*) Stilla hraða fyrir sendingu á gögnum í ThinPrint-umhverfi. Pakkastærð (kbæti) 0–64000 (0*) Stilla pakkastærð fyrir sendingu á gögnum. valmynd ThinPrint"},{"UUID":"8a9abb2a-3d8e-41ec-baf9-48f111e4de11","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"USB Atriði valmyndar  USB","descFull":"USB Atriði valmyndar  USB  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. PCL SmartSwitch Slökkt Kveikt * Stilla prentarann til skipta sjálfkrafa í PCL-hermingu þegar prentverk sem tekið er á móti í gegnum USB-tengi krefst þess, án tillits til sjálfgefins tungumáls prentara. Þegar þessi stilling er óvirk skoðar prentarinn ekki gögn á innleið og notar sjálfvalið tungumál prentara sem er skilgreint í valmynd  Uppsetning . PS SmartSwitch Slökkt Kveikt * Stilla prentarann til skipta sjálfkrafa í PostScript-hermingu þegar prentverk sem tekið er á móti í gegnum USB-tengi krefst þess, án tillits til sjálfgefins tungumáls prentara. Þegar þessi stilling er óvirk skoðar prentarinn ekki gögn á innleið og notar sjálfvalið tungumál prentara sem er skilgreint í valmynd  Uppsetning . Verki í biðminni Slökkt * Kveikt Vista verk tímabundið á hörðum diski fyrir prentun. Þetta atriði valmyndar birtist aðeins þegar harður diskur er til staðar. Mac Binary PS Sjálfvirkt * Kveikt Slökkt Stillir prentarann til að vinna úr Macintosh binary PostScript prentverkum. Sjálfvirkt  vinnur prentverkum frá tölvum sem nota annað hvort stýrikerfi frá Windows eða Macintosh. Slökkt  síar PostScript-prentverk sem nota staðalsamskipti. Virkja USB-tengi Slökkt Kveikt * Virkja USB-tengi að framan. valmynd USB"},{"UUID":"d4e41e40-cc4e-40f4-92b7-b4743aac3e84","title":"Netkerfi/tengi","link":"network-overview-topic.html","desc":"Takmarka ytra aðgengi að netkerfi","descFull":"Takmarka ytra aðgengi að netkerfi Atriði valmyndar  Takmarka ytra aðgengi að netkerfi  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Takmarka ytra aðgengi að netkerfi Slökkt * Kveikt Takmarka aðgengi að svæðum á netinu Ytra vistfang netkerfis Skilgreina vistföng netkerfis með takmarkað aðgengi. Tölvupóstfang fyrir tilkynningu Skilgreina tölvupóstfang til að senda tilkynningu um skráð atvik. Ping-tíðni 1–300 (10*) Skilgreina millibil leitar í netkerfi í sekúndum. Efni Skilgreina efni og skilaboð í tilkynningartölvupósti. Skilaboð valmynd Takmarka ytra aðgengi að netkerfi"},{"UUID":"90e4b174-7065-4257-96c1-d045b6b047bc","title":"Skýjaþjónustur","link":"cloud-services-enrollment-topic.html","desc":"Skráning í skýjaþjónustu Atriði valmyndar","descFull":"Skráning í skýjaþjónustu Atriði valmyndar  Skráning í skýjaþjónustu  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Skoða frekari upplýsingar Skoða frekari upplýsingar um notkun skýjaþjónustu Lexmark. Virkja samskipti við skýjaþjónustu Lexmark Slökkt * Kveikt Gera prentaranum kleift að eiga samskipti við skýjaþjónustu Lexmark. Skoða núverandi stöðu Skoða stöðu á tengingu milli prentarans og skýjaþjónustu Lexmark. valmynd Skráning í skýjaþjónustu"},{"UUID":"95370a67-accb-46e4-8019-c95b0c810357","title":"Aðferðir innskráningar","link":"login-methods-subgroup.html","desc":"Stjórna heimildum Atriði valmyndar ","descFull":"Stjórna heimildum Atriði valmyndar  stjórnunar reikninga  og lýsingar þeirra Atriði valmyndar Lýsing Aðgengi að aðgerðum Aðgengi að heimilisfangabók í forritum Breyta heimilisfangabók. Stjórna flýtivísum Stofna prófíla Stjórna bókarmerkjum Prentun frá minniskorti Litaprentun frá minniskorti Skönnun frá minniskorti Aðgerð afritunar Afrita litaprentun Brottfall á lit Aðgerð tölvupósts Fax-aðgerð FTP-aðgerð Sleppa geymdum faxsendingum Aðgengi að verkum í bið Nota prófíla Hætta við verk við tækið Breyta um tungumál Samskiptaaðferð internetprentunar (IPP) Fjarstýra gangsetningu skönnunar Svart-hvít prentun Litaprentun Mappa á neti - Skanna Diskadrif - Prenta Diskadrif - Litaprentun Diskadrif - Skanna Stjórna aðgengi að aðgerðum prentarans Sum atriði valmyndar birtast aðeins þegar harður diskur eða skynvætt geymsludrif (ISD) eru uppsettir. Stjórnunarlegar valmyndir Öryggisvalmynd Valmynd fyrir netkerfi/tengi Pappírsvalmynd Skýrsluvalmynd Valmyndir uppsetningar aðgerða Valmynd rekstrarvöru Valmynd aukakorts SE-valmynd Valmynd tækis Stjórna aðgengi að stillingarvalmynd prentarans Stjórnun tækis Fjarstýrð stjórnun Uppfærsla fastbúnaðar Uppsetning forrita Stjórnborðslæsing stjórnanda Aðgengi að innbyggðum vefþjóni Flytja inn / flytja út allar stillingar Eyða utan þjónustu Skráning í skýjaþjónustu Stjórna aðgengi að stjórnunarvalkostum prentarans Forrit Ný forrit Skyggnusýning Breyta um veggfóður Skjáhvíla Afrita kort Skönnunarmiðstöð Skönnunarmiðstöð sérsnið  [x] Stjórna aðgengi að forritum prentarans valmynd Stjórna heimildum"},{"UUID":"e07cff98-8b81-449b-b9ae-fc0fb04e7530","title":"Aðferðir innskráningar","link":"login-methods-subgroup.html","desc":"Staðbundnir reikningar Atriði valmyndar ","descFull":"Staðbundnir reikningar Atriði valmyndar  Staðbundinna reikninga  og lýsingar þeirra Atriði valmyndar Lýsing Stjórna hópum/heimildum Sýna lista yfir alla vistaða hópa í prentaranum. Bæta við notanda Nafn notanda/aðgangsorð Nafn notanda Aðgangsorð PIN-númer Búa til staðbundna reikninga og skilgreina aðgengi þeirra að aðgerðum prentarans, stjórnunarlegum valmyndum, valkostum stjórnunar prentarans og forritum. valmynd Staðbundnir reikningar"},{"UUID":"3ce3b92a-860c-401d-9c24-767a9da36332","title":"Aðferðir innskráningar","link":"login-methods-subgroup.html","desc":"Sjálfvaldar aðferðir innskráningar Þessi valmynd","descFull":"Sjálfvaldar aðferðir innskráningar Þessi valmynd birtist aðeins þegar þú stillir stillingar í valmynd  Staðbundnir reikningar . Atriði valmyndar  sjálfvaldra aðferða innskráningar  og lýsingar þeirra Atriði valmyndar Lýsing Stjórnborð Nafn notanda/aðgangsorð Nafn notanda Aðgangsorð PIN-númer Skilgreina sjálfvalda aðferð innskráningar til að komast á stjórnborðið. Vafri Nafn notanda/aðgangsorð Nafn notanda Aðgangsorð PIN-númer Skilgreina sjálfvalda aðferð innskráningar til að komast í vafrann. valmynd Sjálfvaldar aðferðir innskráningar"},{"UUID":"3f882aac-b1d9-4af2-9ee0-b239151f9e3a","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Skipuleggja USB-tæki Valmynd til að","descFull":"Skipuleggja USB-tæki Valmynd til að  skipuleggja USB-tæki  og lýsingar hennar Atriði valmyndar Lýsing Skipulag Bæta við nýju skipulagi Skipuleggja aðgengi að USB-tengjum að framan. valmynd Skipuleggja USB-tæki"},{"UUID":"75901fa6-5abc-44b8-a4bc-a23583330eee","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Eftirlitsskrá öryggis Atriði valmyndar ","descFull":"Eftirlitsskrá öryggis Atriði valmyndar  eftirlitsskrár öryggis  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Virkja eftirlit Slökkt * Kveikt Skrá atvik í örugga atvikaskrá eftirlits og fjartengda atvikaskrá kerfis. Virkja fjartengda kerfisskrá Slökkt * Kveikt Senda atvikaskrár eftirlits til fjartengds þjóns. Þjónn fjartengdrar kerfisskrár Skilgreina þjón fjartengdrar kerfisskrár Tengi fjartengdrar kerfisskrár 1–65535 (514*) Skilgreina tengi fjartengdrar kerfisskrár Aðferð fjartengdrar kerfisskrár Venjulegt UDP * Stunnel Skilgreina aðferð kerfisskrár til að senda skráð atvik til fjartengds þjóns. Aðstaða fjartengdrar kerfisskrár 0 ‑ Kjarnaskilaboð 1 ‑ Skilaboð á stigi notanda 2 ‑ Póstkerfi 3 ‑ Kerfispúkar 4 ‑ Skilaboð öryggis/sannvottunar * 5 ‑ Innri skilaboð búin til af kerfisskrám 6 ‑ Undirkerfi línuprentara 7 ‑ Undirkerfi fréttanetkerfis 8 ‑ UUCP-undirkerfi 9 ‑ Klukkupúki 10 ‑ Skilaboð öryggis/sannvottunar 11 ‑ FTP-púki 12 ‑ NTP-undirkerfi 13 ‑ Atvikaskrá endurskoðunar 14 ‑ Atvikaskrá viðvörunar 15 ‑ Klukkupúki 16 ‑ Staðbundin notkun 0 (local0) 17 ‑ Staðbundin notkun 1 (local1) 18 ‑ Staðbundin notkun 2 (local2) 19 ‑ Staðbundin notkun 3 (local3) 20 ‑ Staðbundin notkun 4 (local4) 21 ‑ Staðbundin notkun 5 (local5) 22 ‑ Staðbundin notkun 6 (local6) 23 ‑ Staðbundin notkun 7 (local7) Skilgreina aðgerðarkóða sem prentari notar þegar hann sendir atvikaskrár til fjarlægs miðlara. Alvarleiki atvika sem á að skrá 0 ‑ Neyð 1 ‑ Aðvörun 2 ‑ Alvarleg 3 ‑ Villa 4 ‑ Viðvörun * 5 ‑ Tilkynning 6 ‑ Til upplýsingar 7 ‑ Aflúsa Skilgreina stig afmörkunar forgangs fyrir skráningu á skilaboðum og atvikum. Óskráð atvik fjartengdar kerfisskrár Slökkt * Kveikt Senda öll atvik óháð stigi alvarleika til fjartengds þjóns. Tölvupóstfang stjórnanda Senda tilkynningu í tölvupósti um skráð atvik til stjórnandans. Viðvörun loggskrár í tölvupósti um hreinsuð atvik Slökkt * Kveikt Senda tilkynningu í tölvupósti um skráð atvik til stjórnandans þegar atvik eru hreinsuð. Viðvörun í tölvupósti skrifað yfir viðvörun Slökkt * Kveikt Senda tilkynningu í tölvupósti um skráð atvik til stjórnandans þegar atvikaskrá er full og byrjar að skrifa yfir atvik. Skrá fulla hegðun Skrifa yfir elstu innfærslur * Senda loggskrá í tölvupósti og eyða öllum færslum Leysa geymsluvandamál þegar atvikaskrá fyllir úthlutað pláss. Tölvupóstur % full viðvörun Slökkt * Kveikt Senda tilkynningu í tölvupósti til stjórnandans þegar atvikakrá fyllir úthlutað minni. % stig fullrar viðvörunar 1–99 (90*) Útflutt viðvörun loggskrár í tölvupósti Slökkt * Kveikt Senda tilkynningu í tölvupósti til stjórnandans þegar atvikaskrá er send. Viðvörun stillingum loggskrár breytt í tölvupósti Slökkt * Kveikt Senda tilkynningu í tölvupósti til stjórnandans þegar  virkja endurskoðun  er stillt. Endingar línuskráninga í atvikaskrá LF (\\n) * CR (\\r) CRLF (\\r\\n) Skilgreina hvernig atvikaskrá lokar hverri línuendingu. Undirrita útflutning stafrænt Slökkt * Kveikt Bæta við stafrænni undirritun við hverja útflutta skrá. Hreinsa atvikaskrá Eyða öllum endurskoðunarskrám. Flytja út loggskrá Atvikaskrá kerfis (Syslog) (RFC 5424) Atvikaskrá kerfis (Syslog) (RFC 3164) CSV Flytja út öryggisskrá á minniskort. valmynd Eftirlitsskrá öryggis"},{"UUID":"4f3e7d92-e1b7-4f21-ba37-ef1faf93787d","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Hömlur á innskráningu Atriði valmyndar","descFull":"Hömlur á innskráningu Atriði valmyndar fyrir  Hömlur á innskráningu  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Misheppnaðar innskráningar 1–10 (3*) Skilgreina fjölda misheppnaðra innskráningartilrauna áður en notendur eru læstir úti. Misheppnaður tímarammi 1–60 mínútur (5*) Skilgreina tímaramma á milli misheppnaðra innskráningartilrauna áður en notendur eru læstir úti. Tími læsingar 1–60 mínútur (5*) Skilgreina tímalengd lokunar. Tímarof fjartengdrar innskráningar 1–120 mínútur (10*) Skilgreina biðtíma fyrir fjartengda innskráningu áður en notandi er útskráður sjálfvirkt. valmynd Hömlur á innskráningu"},{"UUID":"01708884-ac5d-4acb-bc09-40c5f46c100f","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Uppsetning trúnaðarprentunar Atriði valmyndar ","descFull":"Uppsetning trúnaðarprentunar Atriði valmyndar  Uppsetningar trúnaðarprentunar  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Hámark ógildra PIN-númera 2–10 Stilla mörkin á að skrá inn ógilt PIN. Þegar mörkunum er náð er prentverkum fyrir það notandaheiti eytt. Gildislok trúnaðarverka Slökkt * 1 klst. 4 klst. 24 klst. 1 vika Stilltu einstakan tíma gildisloka fyrir hvert verk sem er í bið áður en því er sjálfkrafa eytt úr minni prentara eða af harða disknum. Verk í bið er annað hvort  Trúnaðarverk ,  Endurtekið ,  Frestað , eða  Staðfest . Gildislok endurtekinna verka Slökkt * 1 klst. 4 klst. 24 klst. 1 vika Stilla tíma gildisloka fyrir prentverk sem þú vilt endurtaka. Gildislok staðfestra verka Slökkt * 1 klst. 4 klst. 24 klst. 1 vika Stilla tíma fyrir gildislok til að prenta afrit af verki til að athuga gæði þess áður en þú prentar afritin sem eftir eru. Gildislok frestaðra verka Slökkt * 1 klst. 4 klst. 24 klst. 1 vika Stilla tíma fyrir gildislok fyrir verk sem þú vilt geyma í prentaranum til að prenta síðar. Krefjast að öll verk séu geymd Slökkt * Kveikt Stillir prentarann til að geyma öll prentverk. Geyma afrit skjala Slökkt * Kveikt Stilla prentarann til að geyma öll skjöl með sama skráarheiti. valmynd Uppsetning trúnaðarprentunar"},{"UUID":"9c1cdef6-fb0d-4c79-ae70-13da518e133c","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Dulkóðun disks Þessi valmynd birtist","descFull":"Dulkóðun disks Þessi valmynd birtist aðeins þegar harður diskur eða skynvætt geymsludrif eru uppsett. Atriði valmyndar  Dulkóðunar disks  og lýsingar þeirra Atriði valmyndar Lýsing Harður diskur Sýna stöðu dulkóðunar á harða disknum. Skynvætt geymsludrif Sýna stöðu dulkóðunar á skynvæddu geymsludrifi (ISD). Skynvætt geymsludrif er gert óvirkt sjálfkrafa þegar harður diskur er settur upp. valmynd Dulkóðun disks"},{"UUID":"75af655e-3fa3-4602-9c63-0595cb0baf31","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Eyða tímabundnum gagnaskrám Atriði valmyndar","descFull":"Eyða tímabundnum gagnaskrám Atriði valmyndar Eyða tímabundnum gagnaskrám og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Vistað í minni á staðnum Slökkt * Kveikt Eyða öllum skrám sem eru vistaðar í minni prentara. Vistuð á hörðum diski 1 umferð eyðingar * 3 umferðir eyðingar 7 umferðir eyðingar Eyða öllum skrám sem geymdar eru á hörðum diski prentarans. Þetta atriði valmyndar birtist aðeins þegar harður diskur prentara er uppsettur. valmynd Eyða tímabundnum gagnaskrám"},{"UUID":"83da66a9-b7ad-4b0a-bf32-aecab6733cdc","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Stillingar LDAP-lausna Atriði valmyndar fyrir","descFull":"Stillingar LDAP-lausna Atriði valmyndar fyrir  Lausnir LDAP-stillinga  og lýsingar þeirra Atriði valmyndar Lýsing Fylgja tilvísunum LDAP Slökkt * Kveikt Leita á mismunandi þjónum í léninu að innþráðum notendareikningum. LDAP staðfesting vottorðs Já Nei * Virkja staðfestingu á LDAP-vottorðum. valmynd Stillingar LDAP-lausna"},{"UUID":"736d5236-fa34-4f26-8fd3-fd1bdc5df1cb","title":"Öryggi","link":"login-methods-subgroup.html","desc":"Ýmislegt Atriði valmyndar fyrir ","descFull":"Ýmislegt Atriði valmyndar fyrir  Ýmislegt  og lýsingar þeirra Atriði valmyndar Lýsing Stjarna (*) næst gildi gefur til kynna sjálfvalda stillingu frá verksmiðju. Verndaðir eiginleikar Sýna * Fela Sýna alla þá eiginleika sem aðgangsstjórnun aðgerða (FAC) verndar óháð öryggisheimildum sem notandinn hefur. Fela  sýnir aðeins FAC‑vernda eiginleika sem notandinn hefur aðgengi að. Prentheimildir Slökkt * Kveikt Láta stjórnandann skrá sig inn fyrir prentun. Sjálfvalin innskráning prentheimilda Nafn notanda/aðgangsorð * Nafn notanda Stilla sjálfvalda innskráningu fyrir  Prentheimildir . Öryggisendurstilling Virkja aðgengi „gesta“ * Engin áhrif Skilgreina aðgengi notenda að prentaranum. Virkja aðgengi „gesta“  veitir öllum aðgengi að öllum atriðum prentarans. Engin áhrif  getur gert aðgengi að prentaranum ómögulegt þegar nauðsynlegar öryggisupplýsingar eru ekki tiltækar. Nota skynvætt geymsludrif fyrir gögn notanda Slökkt Kveikt * Virkja skynvætt geymsludrif til að geyma gögn notanda. Þetta atriði valmyndar er óvirkt þegar harður diskur er til staðar. Lágmarkslengd aðgangsorðs 0–32 (0*) Skilgreina lengd á aðgangsorði. Virkja birtingu á aðgangsorði/PIN Slökkt * Kveikt Sýna aðgangsorð eða persónuauðkennanlegt númer (PIN). valmynd Ýmislegt"},{"UUID":"43e38a2b-95b4-4cd1-8898-95db18f329e8","title":"Skýrslur","link":"menu-settings-page-topic.html","desc":"Síða yfir stillingar valmyndar Stillingarsíða","descFull":"Síða yfir stillingar valmyndar Stillingarsíða  valmyndar og lýsingar hennar Atriði valmyndar Lýsing Stillingarsíða valmyndar Prenta skýrslu sem inniheldur valmyndir prentara. valmynd Stillingarsíða valmyndar"},{"UUID":"b0bbc7dc-2bc0-49df-89f9-596569c82142","title":"Skýrslur","link":"menu-settings-page-topic.html","desc":"Tæki Tæki Atriði valmyndar fyrir","descFull":"Tæki Tæki Atriði valmyndar fyrir  tæki  og lýsingar þeirra Atriði valmyndar Lýsing Upplýsingar um tæki Prenta skýrslu sem inniheldur upplýsingar um prentarann. Tölfræði tækis Prenta skýrslu um notkun prentarans og stöðu á rekstrarvörum. Listi yfir prófíla Prenta lista yfir prófíla sem eru vistaðir í prentaranum. Eignaskýrsla Prenta greiningartól fyrir vandamál við prentun. Til að forðast að klippa innihaldið skaltu prenta skýrsluna á pappír í „letter“- eða A4-stærð. valmynd Tæki"},{"UUID":"2f5e1234-1a64-4938-a8ba-875393eab320","title":"Skýrslur","link":"menu-settings-page-topic.html","desc":"Prenta Atriði valmyndar Prenta og","descFull":"Prenta Atriði valmyndar Prenta og lýsingar þeirra Atriði valmyndar Lýsing Leturgerðir prentunar PCL-leturgerðir PS-leturgerðir Prenta sýnishorn og upplýsingar um leturgerðir sem eru tiltækar í hverju tungumáli prentarans. Sýnishorn prentunar Sýnishornasíða Prenta síðu sem sýnir getu prentarans og studdar lausnir. Prentskrá Prenta tilföng sem eru vistuð á minniskorti eða á hörðum diski prentarans. Þetta atriði valmyndar birtist aðeins þegar minniskort eða harður diskur prentara eru uppsettur. valmynd Prenta"},{"UUID":"10aa996d-7bfe-46b3-8e70-b5360da13f14","title":"Skýrslur","link":"menu-settings-page-topic.html","desc":"Flýtivísar Atriði valmyndar  flýtivísa","descFull":"Flýtivísar Atriði valmyndar  flýtivísa  og lýsingar þeirra Atriði valmyndar Lýsing Allir flýtivísar Prenta skýrslu sem sýnir alla flýtivísa sem eru vistaðir í prentaranum. Flýtivísar fax  birtast aðeins þegar fax er uppsett. Flýtivísar fax Flýtivísar afritunar Flýtivísar tölvupósts Flýtivísar FTP Flýtivísar möppu á neti valmynd Flýtivísar"},{"UUID":"3d71dc41-3302-4b19-be2f-cd840e9f7cc4","title":"Skýrslur","link":"menu-settings-page-topic.html","desc":"Fax Þessi valmynd birtist aðeins","descFull":"Fax Þessi valmynd birtist aðeins ef fax er uppsett, og  Virkja atvikaskrá  er stillt á  Kveikt . Atriði valmyndar fyrir  fax  og lýsingar þeirra Atriði valmyndar Lýsing Atvikaskrá faxverka Prenta skýrslu yfir síðustu 200 faxverk sem lokið var við. Atvikaskrá faxhringinga Prenta skýrslu sem er með upplýsingar um síðustu 100 reyndu, mótteknu og lokuðu hringingar. valmynd Fax"},{"UUID":"0e2b0cf4-e493-4d87-b21d-a5801c8b65ad","title":"Skýrslur","link":"menu-settings-page-topic.html","desc":"Netkerfi Atriði valmyndar  netkerfis","descFull":"Netkerfi Atriði valmyndar  netkerfis  og lýsingar þeirra Atriði valmyndar Lýsing Uppsetningarsíða netkerfis Prenta síðu sem uppsett net og þráðlausar stillingar á prentara. Þetta atriði valmyndar birtist aðeins í nettengdum prenturum eða prenturum sem eru tengdir prentþjónum. Tengdir biðlarar Wi‑Fi Direct Prenta síðu sem sýnir lista yfir tæki sem eru tengd við prentarann með því að nota Wi‑Fi Direct. Þetta atriði valmyndar birtist aðeins þegar  Virkja Wi‑Fi Direct  er stillt á  Kveikt . valmynd Netkerfi"},{"UUID":"99b97091-316e-40a0-8dd5-426d7efa244b","title":"Nota valmyndir prentarans","link":"troubleshooting-menu-topic.html","desc":"Bilanaleit Atriði valmyndar fyrri bilanaleit","descFull":"Bilanaleit Atriði valmyndar fyrri bilanaleit og lýsingar þeirra Atriði valmyndar Lýsing Prenta gæðaprófunarsíður Prenta sýnishornasíður til að finna og leiðrétta galla í prentgæðum. Skanninn hreinsaður Prenta leiðbeiningar hvernig hreinsa á skannann. valmynd Bilanaleit Prenta gæðaprófunarsíður Skanninn hreinsaður"},{"UUID":"4a1eea1d-e8f8-4b4e-86c2-85012bd40207","title":"Nota valmyndir prentarans","link":"printing-menu-settings-page-topic.html","desc":"Prentar  Stillingarsíðu valmyndar Frá","descFull":"Prentar  Stillingarsíðu valmyndar Frá heimaskjánum, snertu  Stillingar Skýrslur  Síða yfir stillingar valmyndar . prentar Síða yfir stillingar valmyndar Síða yfir stillingar valmyndar prentar valmyndir prentara"},{"UUID":"ade580f2-8456-41eb-817a-a106bcacae1b","title":"Viðhald á prentaranum","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Athugun á stöðunni á hlutum","descFull":"Athugun á stöðunni á hlutum og rekstrarvörum Á heimaskjánum, ýttu á  Staða/rekstrarvörur . Veldu hlutina eða rekstrarvöru sem þú vilt merkja við. Þú getur líka farið í þessa stillingu með því að snerta efsta hlutann á heimaskjánum. athugun á stöðu á hlutum og rekstrarvörum staða á rekstrarvörum athugar staða hluta athugar"},{"UUID":"dafde04d-ed5e-400c-83b4-dd2313f14664","title":"Viðhald á prentaranum","link":"configuring-supply-notifications-topic.html","desc":"Stilla tilkynningar varðandi rekstrarvöru Opnaðu","descFull":"Stilla tilkynningar varðandi rekstrarvöru Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Tæki Tilkynningar . Í valmynd fyrir rekstrarvöru, smelltu á  Sérstilla tilkynningar varðandi rekstrarvöru . Veldu tilkynningu fyrir hvert atriði rekstrarvöru. Beittu breytingunum. tilkynningar varðandi rekstrarvöru stillir stilla tilkynningar varðandi rekstrarvöru"},{"UUID":"2cf02844-84f7-4782-9834-94c4c0389af9","title":"Viðhald á prentaranum","link":"setting-up-e-mail-alert-topic.html","desc":"Setja upp viðvaranir tölvupósts Stilla","descFull":"Setja upp viðvaranir tölvupósts Stilla prentarann til að senda viðvaranir í tölvupósti þegar birgðir eru litlar eða þegar verður að breyta pappír eða bæta við eða þegar það er pappírsflækja. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjá prentarans. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Stillingar Tæki Tilkynningar Uppsetning á viðvörun tölvupósts , og settu síðan upp stillingarnar. Hafðu samband við tölvupóstþjónustu þína til að fá frekari upplýsingar um SMTP-stillingar. Beittu breytingunum. Smelltu á  Uppsetning á tölvupóstlista og viðvörunum , og settu síðan upp stillingarnar. Beittu breytingunum. viðvaranir tölvupósts uppsetning setja upp viðvaranir tölvupósts"},{"UUID":"c39a17ef-ea1d-40b4-85ba-e80dca5be900","title":"Viðhald á prentaranum","link":"viewing-reports-topic.html","desc":"Skoða skýrslur Frá heimaskjánum, snertu","descFull":"Skoða skýrslur Frá heimaskjánum, snertu  Stillingar Skýrslur . Veldu skýrsluna sem þú vilt prenta. skoða skýrslur skýrslur staða prentara skýrslur notkun prentara"},{"UUID":"d35452f2-e55f-4837-9ff3-4124a4be0206","title":"Pöntun á hlutum og rekstrarvörum","link":"ordering-parts-and-supplies-group.html","desc":"Til að panta rekstrarvörur í","descFull":"Til að panta rekstrarvörur í Bandaríkjunum, hafið samband við Lexmark í 1-800-539-6275 varðandi viðurkenndan dreifingaraðila á vottuðum rekstrarvörum fyrir Lexmark á þínu svæði. Í öðrum löndum eða svæðum, farið á  www.lexmark.com  eða hafið samband við þann stað sem prentarinn var keyptur. Til að panta rekstrarvörur, hafðu samband við þann stað sem þú keyptir prentarann. Áætlun um endingu á rekstrarvörum prentara miðað við prentun á venjulegan pappír í bréfa- eða A4-stærð. Misbrestur á að viðhalda bestu frammistöðu prentara, eða við að skipta út hlutum og rekstrarvörum, getur valdið skemmdum á prentaranum. upprunalegir hlutir og rekstrarvörur"},{"UUID":"81908e4c-67f5-47ed-abaa-12c884408746","title":"Pöntun á hlutum og rekstrarvörum","link":"ordering-parts-and-supplies-group.html","desc":"Nota upprunalega hluti og rekstarvörur","descFull":"Nota upprunalega hluti og rekstarvörur frá Lexmark Lexmark prentarinn þinn er hannaður til að virka best með upprunalegum hlutum og rekstrarvörum frá Lexmark. Notkun á rekstrarvörum eða hlutum frá þriðja aðila getur haft áhrif á afköst, áreiðanleika eða endingu prentarans og myndeiningar hans. Það getur einnig haft áhrif á gildi ábyrgðar. Ábyrgðin nær ekki yfir skemmdir sem verða vegna notkunar á rekstrarvörum eða hlutum frá þriðja aðila. Allar vísanir á endingu eru hannaðar til að virka með rekstrarvörum eða hlutum frá Lexmark og geta því gefið ónákvæmar niðurstöður ef rekstrarvörur eða hlutir frá þriðja aðila eru notaðir. Notkun á hlutum myndeiningar umfram ætlaða endingu geta skaðað Lexmark-prentarann þinn eða tengda hluti. Rekstrarvöru og íhluti án skilakerfis er hægt að endurstillta og endurframleiða. Hins vegar nær ábyrgð framleiðanda ekki yfir tjón sem stafar af rekstrarvörum eða íhlutum sem eru ekki upprunalegir. Endurstilling teljara á rekstrarvöru eða íhlutum án réttrar endurvinnslu getur valdið skemmdum á prentara. Eftir endurstillingu á teljara fyrir rekstrarvöru eða íhlut getur prentari sýnt villu sem sýnir tilvist endurstilla hlutarins. nota upprunalega íhluti og rekstarvörur frá Lexmark Upprunalegir íhlutir og rekstarvörur frá Lexmark"},{"UUID":"fcacd6b4-919f-4ecc-a70e-d53e87d2aad7","title":"Pöntun á hlutum og rekstrarvörum","link":"ordering-parts-and-supplies-group.html","desc":"Pöntun á blekhylki Áætluð ending","descFull":"Pöntun á blekhylki Áætluð ending blekhylkis er byggð á ISO/IEC 19752 staðlinum. Einstaklega lítil þekja um langan tíma kann að hafa neikvæð áhrif á raunverulega endingu. Til að panta blekhylki, hafðu samband við staðinn þar sem þú keyptir prentarann. Blekhylki og hlutanúmer þess Hlutur Á heimsvísu 37K blekhylki 63D0H00 rekstrarvörur, panta blekhylki blekhylki panta"},{"UUID":"704549ba-563d-4893-b5ca-d9b85601c1b0","title":"Pöntun á hlutum og rekstrarvörum","link":"ordering-parts-and-supplies-group.html","desc":"Pöntun á myndvals Afar lítil","descFull":"Pöntun á myndvals Afar lítil þekja prentunar um lengri tíma getur hugsanlega valdið því að hlutir myndeiningar bili áður en prentlitur klárast í prenthylkinu. Til að panta myndvals, hafðu samband við þann stað sem þú keyptir prentarann. Myndeining og hlutanúmer hennar Hlutur Hlutanúmer Myndeiningarsett 63D0Z00 myndvals panta panta rekstrarvörur myndvals"},{"UUID":"88f8dc24-f19b-45f0-9fcc-85d994f445d6","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipt um blekhylki Opnaðu hurð","descFull":"Skipt um blekhylki Opnaðu hurð að framan. Fjarlægðu notaða blekhylkið. Taktu nýja blekhylkið úr umbúðunum og fjarlægðu síðan allar umbúðir. Hristu blekhylkið til að jafna prentlitinn. Settu nýja blekhylkið á sinn stað. Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Settu þurrku prentarahaussins aftur í. Lokaðu hurðinni. blekhylki skipt um skipt um rekstrarvörur blekhylki"},{"UUID":"45b0b0ef-fa1b-41c3-8e61-fb99026cebef","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipt um myndvalsinn Opnaðu hurð","descFull":"Skipt um myndvalsinn Opnaðu hurð A. Opnaðu hurð að framan. Fjarlægðu notaða myndeiningarsettið. Taktu nýju myndeininguna úr umbúðunum og fjarlægðu síðan allar umbúðir. Ekki láta myndvalsinn vera í beinu ljósi meira en 10 mínútur. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Settu inn nýja myndeiningu og læstu síðan neðri hlutanum. Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Settu þurrku prentarahaussins aftur á sinn stað og lokaðu síðan hurð að framan. Loka hurð A. myndvals skipt um skipt um rekstrarvörur myndvals"},{"UUID":"d9691e78-267a-4bcc-ae9a-95ce950faf53","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um innskot í 520‑blaða","descFull":"Skipta um innskot í 520‑blaða skúffu Skipta um innskot í 520‑blaða skúffu Fjarlægðu notaða innskotið. Taktu nýja innskotið úr umbúðunum og fjarlægðu síðan allar umbúðir. Settu nýja innskotið á sinn stað. skipt um hluti innskot í 520‑blaða skúffu innskot í 520‑blaða skúffu skipt um"},{"UUID":"c24c9145-b03e-4efe-a27b-112a1b8010ec","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipt um hitagjafann Slökktu á","descFull":"Skipt um hitagjafann Slökktu á prentaranum. Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Opnaðu notaða hitagjafann. Fjarlægðu notaða hitagjafann. Taktu nýja hitagjafann úr umbúðum. Settu nýja hitagjafann á sinn stað. Læstu nýja hitagjafanum. Lokaðu hurðinni. Kveiktu á prentaranum. hitagjafi skipt um skipt um hluti hitagjafi"},{"UUID":"39100496-4761-493a-9a78-9740cbd31ccd","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipt um færslurúllu Slökktu á","descFull":"Skipt um færslurúllu Slökktu á prentaranum. Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Fjarlægðu notuðu færslurúlluna. Taktu nýju færslurúlluna úr umbúðum. Settu nýju færslurúlluna inn þar til að hún  smellur  á sinn stað. Lokaðu hurð A og lokaðu hurð að framan. Kveiktu á prentaranum. skipt um hluti færslurúlla færslurúlla skipt um"},{"UUID":"6eae4439-735e-442f-a9da-c1e4dc61d1f9","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um rúllusett skúffu Skipta","descFull":"Skipta um rúllusett skúffu Skipta um rúllusett skúffu Slökktu á prentaranum. Fjarlægðu staðalskúffuna. Fjarlægðu notað rúllusett skúffu. Til að koma í veg fyrir skemmdir frá rafstöðuhleðslu, skaltu snerta einhvern sýnilegan málmramma í prentaranum áður en þú nálgast eða snertir innri hluta prentarans. Taktu nýja rúllusett skúffu úr umbúðum. Settu nýtt rúllusett skúffu inn þar til að það  smellur  á sinn stað. Settu skúffuna inn. Kveiktu á prentaranum. rúllusett skúffu skipt um skipt um hluti rúllusett skúffu"},{"UUID":"adef24ba-e6c4-4989-8e9e-7e31b6e5a66a","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um rúllur sjálfvirks matara","descFull":"Skipta um rúllur sjálfvirks matara skjala Slökktu á prentaranum. Opnaðu efri hlíf á sjálfvirkum matara. s Fjarlægðu hlíf á aðskilnaðarrúllu. Fjarlægðu notaða aðskilnaðarrúllu. Taktu nýju aðskilnaðarrúlluna úr umbúðum. Settu nýju aðskilnaðarrúlluna á sinn stað. Settu lok á aðskilnaðarrúllu sjálfvirks matara á sinn stað þar til að það  smellur  á sinn stað. Fjarlægðu notaða samstæðu aðskilnaðarrúllu. Taktu nýju samstæðu aðskilnaðarrúllu úr umbúðum. Settu nýja aðskilnaðarrúllu sjálfvirks matara á sinn stað þar til að hún  smellur  á sinn stað. Lokaðu efra loki á sjálfvirkum matara. Kveiktu á prentaranum. rúllusett sjálfvirks matara skipt um skipt um hluti rúllusett sjálfvirks matara aðskilnaðarrúlla skipt um samstæða aðskilnaðarrúllu skipt um"},{"UUID":"f72acc39-ced7-486f-9d40-2ea0ac9554df","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um þurrku prentarahauss Opnaðu","descFull":"Skipta um þurrku prentarahauss Opnaðu hurð að framan. Fjarlægðu notaða þurrku prentarahauss. Taktu nýja þurrku prentarahauss úr umbúðunum. Settu nýja þurrku prentarahauss í. Lokaðu hurðinni. skipt um hluti þurrka prentarahauss þurrka prentarahauss skipt um"},{"UUID":"c3408191-2084-4fb1-8969-34a91f8a6485","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um rúllusett í 2000‑blaða","descFull":"Skipta um rúllusett í 2000‑blaða skúffu Skipta um rúllusett í 2000‑blaða skúffu Slökktu á prentaranum. Renndu skúffunni til vinstri. Opnaðu hurð J og opnaðu síðan hlíf yfir rúllusetti. Finndu og fjarlægðu notaða rúllusettið. Taktu nýja rúllusettið úr umbúðum. Settu nýja rúllusettið á sinn stað. Lokaðu hlíf yfir rúllusetti og lokaðu síðan hurð J. Renndu skúffunni aftur á sinn stað. Kveiktu á prentaranum. rúllusett fyrir 2000‑blaða skúffu skipt um skipt um hluti rúllusett fyrir 2000‑blaða skúffu"},{"UUID":"68af4549-ea93-4bc6-aa8c-bdb088b81a89","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um hlíf á aðskilnaðarrúllu","descFull":"Skipta um hlíf á aðskilnaðarrúllu sjálfvirks matara Skipta um hlíf á aðskilnaðarrúllu sjálfvirks matara Opnaðu efri hlíf á sjálfvirkum matara. Fjarlægðu notaða hlíf á aðskilnaðarrúllu sjálfvirks matara. Taktu nýju hlífina á aðskilnaðarrúllu úr umbúðum. Settu hlíf á aðskilnaðarrúllu sjálfvirks matara á sinn stað þar til að hún  smellur  á sinn stað. Lokaðu efra loki á sjálfvirkum matara. hlíf yfir aðskilnaðarrúllu sjálfvirks matara skipt um skipt um hluti hlíf yfir aðskilnaðarrúllu sjálfvirks matara"},{"UUID":"e64bb34c-6e9a-4a09-8642-393d1a1de542","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um hlíf yfir neðra","descFull":"Skipta um hlíf yfir neðra tengi að aftan Skipta um hlíf yfir neðra tengi að aftan Fjarlægðu notuðu hlífina yfir neðra tengi að aftan. Taktu nýju hlífina yfir neðra tengi að aftan úr umbúðum. Settu nýju hlífina yfir neðra tengi að aftan á sinn stað þar til að hún  smellur  á sinn stað. skipt um hluti hlíf yfir neðra tengi að aftan hlíf yfir neðra tengi að aftan skipt um"},{"UUID":"c106d0e3-2561-4121-bafe-650c8a50b519","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um pappírsstoppara í bakka","descFull":"Skipta um pappírsstoppara í bakka sjálfvirks matara Fjarlægðu notaða pappírsstopparann í bakka sjálfvirks matara. Taktu nýjan pappírsstoppara í bakka sjálfvirks matara úr umbúðum. Settu inn nýjan pappírsstoppara í bakka sjálfvirks matara. skipt um hluti pappírsstoppari í bakka sjálfvirks matara pappírsstoppari í bakka sjálfvirks matara skipt um"},{"UUID":"a534f51d-37a6-4b7b-8fc4-f5c5485db390","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Endurstilla teljara viðhalds Frá heimaskjánum,","descFull":"Endurstilla teljara viðhalds Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Notkun rekstrarvöru og teljarar . Snertu  Endurstilla viðhaldsteljara . teljari viðhalds endurstilla endurstilla teljara viðhalds"},{"UUID":"bfc4d61a-1a4d-49f0-8b1b-0628b6d589a0","title":"Skipta um hluti og rekstrarvörur","link":"replacing-toner-cartridge-topic.html","desc":"Endurstilla teljara notkunar rekstrarvöru Frá","descFull":"Endurstilla teljara notkunar rekstrarvöru Frá heimsskjánum, snertið  Stillingar Tæki Viðhald Uppsetningarvalmynd Notkun rekstrarvöru og teljarar . Veldu teljarann sem á að endurstilla. Rekstrarvöru og íhluti án skilakerfis er hægt að endurstillta og endurframleiða. Hins vegar nær ábyrgð framleiðanda ekki yfir tjón sem stafar af rekstrarvörum eða íhlutum sem eru ekki upprunalegir. Endurstilling teljara á rekstrarvöru eða íhlutum án réttrar endurvinnslu getur valdið skemmdum á prentara. Eftir endurstillingu á teljara fyrir rekstrarvöru eða íhlut getur prentari sýnt villu sem sýnir tilvist endurstilla hlutarins. Samningsskilmála fyrir rekstrarvöru og íhluti án kerfis nota-og-skila er hægt að endurstillta og endurframleiða. Hins vegar nær ábyrgð framleiðanda ekki yfir tjón sem stafar af rekstrarvörum eða íhlutum sem eru ekki upprunalegir. Endurstilling teljara á rekstrarvöru eða íhlutum án réttrar endurvinnslu getur valdið skemmdum á prentara. Eftir endurstillingu á teljara fyrir rekstrarvöru eða íhlut getur prentari sýnt villu sem sýnir tilvist endurstilla hlutarins. teljarar notkunar rekstrarvöru endurstilla endurstilla teljara notkunar rekstrarvöru"},{"UUID":"3655e87f-c0dd-4e5f-bffb-810c706df950","title":"Skipta um hylki fyrir hefti","link":"replacing-toner-cartridge-topic.html","desc":"Skipt um hylki fyrir hefti","descFull":"Skipt um hylki fyrir hefti í frágangseiningu heftara Opnaðu hurð á frágangseiningu. Fjarlægðu haldara fyrir heftarahylki. Fjarlægðu tóma heftarahylkið. Taktu nýja heftarahylkið úr umbúðunum. Settu nýja heftarahylkið í haldarann þar til að það  smellur  á sinn stað. Settu haldara fyrir heftarahylki inn þar til að hann  smellur  á sinn stað. Lokaðu hurðinni. skipt um rekstrarvörur hylki fyrir hefti hylki fyrir hefti skipt um"},{"UUID":"9a9a30c8-e915-48c3-a002-34dde01ffe42","title":"Skipta um hylki fyrir hefti","link":"replacing-toner-cartridge-topic.html","desc":"Skipt um haldara fyrir hefti","descFull":"Skipt um haldara fyrir hefti í heftara- og gatarabúnaði Opnaðu hurð á frágangseiningu. Fjarlægðu haldara fyrir heftarhylki. Fjarlægðu tóma heftarahylkið. Taktu nýja heftarahylkið úr umbúðunum. Settu nýja hylkið fyrir hefti á sinn stað þar til að það  smellur  á sinn stað. Settu haldara fyrir heftarahylki á sinn stað. Lokaðu hurðinni. skipt um rekstrarvörur hylki fyrir hefti hylki fyrir hefti skipt um"},{"UUID":"bc77aa92-9f62-41c2-ba4b-a945a0c804ef","title":"Skipta um hylki fyrir hefti","link":"replacing-toner-cartridge-topic.html","desc":"Skipta um staðlaðan haldara hylkis","descFull":"Skipta um staðlaðan haldara hylkis fyrir hefti Skipta um staðlaðan haldara hylkis fyrir hefti Opnaðu hurð á frágangseiningu. Fjarlægðu notaða haldara hylkis fyrir hefti. Fjarlægðu heftarahylkið. Taktu nýja hylkið fyrir hefti úr umbúðunum. Settu hylkið fyrir hefti í nýja haldarann þar til að það  smellur  á sinn stað. Settu nýja haldara hylkis fyrir hefti inn þar til að hann  smellur  á sinn stað. Lokaðu hurð á frágangseiningu. skipt um hluti haldari hylkis fyrir hefti haldari hylkis fyrir hefti skipt um"},{"UUID":"c57563d7-2654-43d0-a8cf-4ddf694b989b","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Prentarinn hreinsaður Til að koma","descFull":"Prentarinn hreinsaður Til að koma í veg fyrir hættu á raflosti þegar verið er að þrífa prentarann að utan, takið rafmagnssnúruna úr sambandi úr innstungunni og aftengið allar snúrur frá prentaranum áður en haldið er áfram. Framkvæmdu þetta verk á nokkurra mánaða fresti. Skemmdir á prentaranum af völdum óviðeigandi meðhöndlunar fellur ekki undir ábyrgð prentarans. Slökktu á prentaranum og taktu síðan rafmagnssnúruna úr sambandi við rafmagn. Fjarlægðu pappír úr staðalskúffu og fjölnotamataranum. Fjarlægið allt ryk, ló og pappírssnifsi í prentaranum með mjúkum bursta eða ryksugu. Þurrkaðu af prentaranum að utan með rökum mjúkum og lófríum klút. Ekki nota hreinsiefni eða sápu, þar sem slík efni geta skemmt ytra byrði prentarans. Vertu viss um að öll svæði prentarans séu þurr eftir hreinsun. Tengdu straumsnúruna við rafmagnsinnstunguna og síðan við prentarann. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. prentarinn hreinsaður hreinsun prentarinn að innan hreinsun prentarinn að utan"},{"UUID":"b1487427-f69a-472a-a079-5bb59d0bc9f2","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Hreinsun á snertiskjánum Til að","descFull":"Hreinsun á snertiskjánum Til að koma í veg fyrir hættu á raflosti þegar verið er að þrífa prentarann að utan, taktu rafmagnssnúruna úr sambandi úr innstungunni og aftengdu allar snúrur frá prentaranum áður en haldið er áfram. Slökktu á prentaranum og taktu síðan rafmagnssnúruna úr sambandi við rafmagn. Notaðu rakan, mjúkan og lófrían klút, þurrkaðu af snertiskjánum. Ekki nota hreinsiefni eða sápu, þar sem slík efni geta skemmt snertiskjáinn. Gangtu úr skugga um að snertiskjárinn sé þurr eftir hreinsunina. Tengdu straumsnúruna við rafmagnsinnstunguna og kveiktu síðan á prentaranum. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. snertiskjár hreinsun snertiskjárinn hreinsaður"},{"UUID":"42fe9538-e94a-424f-b145-138aa0b6715b","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Skanninn hreinsaður Opnaðu lokið á","descFull":"Skanninn hreinsaður Opnaðu lokið á skannanum. Notaðu rakan, mjúkan og lófrían klút, þurrkaðu af eftirfarandi svæðum: Púða fyrir sjálfvirkan matara Púði fyrir gler skannans Gler á sjálfvirkum matara Gler á skanna Lokaðu loki á skannanum. skanni hreinsun prentgæði skanninn hreinsaður skanninn hreinsaður"},{"UUID":"41b479ee-d46b-43a1-93f5-d84af2a995ba","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Hreinsa auga á prenthaus Hreinsa","descFull":"Hreinsa auga á prenthaus Hreinsa auga á prenthaus Opnaðu hurð að framan. Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Settu þurrku prentarahaussins aftur í. Lokaðu hurð að framan. auga á prenthaus hreinsun hreinsa auga á prenthaus"},{"UUID":"c9c0cbf1-1a74-4922-ad68-c45157f2ccb0","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Hreinsa rúllusett skúffu Slökktu á","descFull":"Hreinsa rúllusett skúffu Slökktu á prentaranum. Fjarlægðu staðalskúffuna. Fjarlægðu rúllusett skúffu. Til að koma í veg fyrir skemmdir frá rafstöðuhleðslu, skaltu snerta einhvern sýnilegan málmramma í prentaranum áður en þú nálgast eða snertir innri hluta prentarans. Settu vatn í mjúkan lófrían klút, og þurrkaðu síðan af mötunarrúllunum. Settu rúllusettið á sinn stað þar til að það  smellur  á sinn stað. Settu skúffuna inn. Kveiktu á prentaranum. rúllusett skúffu hreinsun hreinsa rúllusett skúffu"},{"UUID":"903777be-2468-476e-b9da-3cf2a1523c67","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Hreinsa rúllusett sjálfvirks matara Slökktu","descFull":"Hreinsa rúllusett sjálfvirks matara Slökktu á prentaranum. Opnaðu efri hlíf á sjálfvirkum matara. Fjarlægðu hlíf á aðskilnaðarrúllu. Fjarlægðu aðskilnaðarrúlluna. Settu vatn í mjúkan lófrían klút, og þurrkaðu síðan af rúllusettinu. Settu aðskilnaðarrúlluna á sinn stað. Settu lok á aðskilnaðarrúllu sjálfvirks matara á sinn stað þar til að það  smellur  á sinn stað. Fjarlægðu samstæðu aðskilnaðarrúllu. Settu vatn í mjúkan lófrían klút, og þurrkaðu síðan af rúllusettinu. Settu aðskilnaðarrúllu á sinn stað þar til að hún  smellur  á sinn stað. Lokaðu efra loki á sjálfvirkum matara. Kveiktu á prentaranum. rúllusett sjálfvirks matara hreinsun hreinsa rúllusett sjálfvirks matara"},{"UUID":"e09e5833-ca57-4536-bc85-401561b0dd77","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Hreinsa rúllusett í 2000‑blaða skúffu","descFull":"Hreinsa rúllusett í 2000‑blaða skúffu Slökktu á prentaranum. Renndu skúffunni til vinstri. Opnaðu hurð J og opnaðu síðan hlíf yfir rúllusetti. Finndu og fjarlægðu rúllusettið. Settu vatn í mjúkan lófrían klút, og þurrkaðu síðan af rúllusettinu. Settu rúllusettið á sinn stað. Lokaðu hlíf yfir rúllusetti og lokaðu síðan hurð J. Renndu skúffunni aftur á sinn stað. Kveiktu á prentaranum. mötunarrúllur í 2000‑blaða skúffu hreinsun hreinsa rúllur í 2000‑blaða skúffu"},{"UUID":"3d2eab43-b690-4814-ab17-ca1b4efcd4e6","title":"Hreinsun á hlutum prentarans","link":"cleaning-printer-topic.html","desc":"Tæming á boxi fyrir gatara","descFull":"Tæming á boxi fyrir gatara Lyftu hlíf F yfir pappírsflutningi. Fjarlægðu og tæmdu síðan box fyrir gatara. Settu box fyrir gatara á sinn stað. Lokaðu lokinu. box fyrir gatara tæming tæming á boxi fyrir gatara"},{"UUID":"e61dd9f4-af11-4779-82a8-1c954f6140e1","title":"Spara orku og pappír","link":"configuring-power-save-mode-settings-topic.html","desc":"Setja upp stillingar orkusparnaðar Svefnstilling","descFull":"Setja upp stillingar orkusparnaðar Svefnstilling Frá heimaskjánum, snertu  Stillingar Tæki Orkustýring Tímarof Svefnstilling . Skrá tímalengd sem prentarinn er iðjulaus áður en hann fer í  Svefnstillingu . Stilling í dvala Frá heimaskjánum, snertu  Stillingar Tæki Orkustýring Tímarof Tímarof stillingar í dvala . Skrá tímalengd sem prentarinn er iðjulaus áður en hann fer í stillingu í dvala. Til að  Tímarof í dvala  virki, stilltu  Tímarof í dvala á tengingu  í  Dvala . Innbyggði vefþjónninn er óvirkur þegar prentarinn er í stillingu fyrir  Dvala . Svefnstilling stillir Stilling í dvala stillir umhverfisstillingar stillingar orkusparnaðar stillir"},{"UUID":"f6849d94-fc87-47db-8755-9014771a8b90","title":"Spara orku og pappír","link":"configuring-power-save-mode-settings-topic.html","desc":"Stilla birtustig á skjánum Frá","descFull":"Stilla birtustig á skjánum Frá heimaskjánum, snertu  Stillingar Tæki Kjörstillingar . Aðlagaðu stillinguna í valmynd fyrir  birtustig á skjá . birtustig á skjá stillir stilla birtustig á skjá"},{"UUID":"deb58319-5aa3-46af-b4dc-23f53a4ab5cb","title":"Spara orku og pappír","link":"configuring-power-save-mode-settings-topic.html","desc":"Spara rekstrarvörur Prentaðu á báðar","descFull":"Spara rekstrarvörur Prentaðu á báðar hliðar á pappírnum. Prentun á báðar hliðar er sjálfvalin stilling í rekli prentarans. Prentaðu margar síður á eina pappírsörk. Notaðu eiginleika forskoðunar til að sjá hvernig skjalið lítur áður en það er prentað. Prentaðu eitt eintak af skjalinu til að athuga innihald þess og snið varðandi nákvæmni. spara rekstrarvörur rekstrarvörur spara"},{"UUID":"b129be8a-bda9-4d70-bfbb-50b3a9e0da67","title":"Viðhald á prentaranum","link":"moving-printer-topic.html","desc":"Prentarinn færður á aðra staðsetningu","descFull":"Prentarinn færður á aðra staðsetningu Prentarinn færður á aðra staðsetningu Ef þyngd prentarans er meiri en 20 kg (44 lb), þá kann það að þarfnast tveggja eða fleiri manna til að lyfta honum á öruggan hátt. Til að koma í veg fyrir hættu á eldsvoða eða raflosti notið aðeins rafmagnssnúruna sem fylgdi með þessari vöru eða viðurkennda skiptivöru frá framleiðanda. Fylgdu þessum leiðbeiningum þegar verið er að flytja prentarann til að koma í veg fyrir slys eða skemmdir á prentaranum: Gangið úr skugga um að allar hurðir og skúffur séu lokaðar. Slökktu á prentaranum og taktu síðan rafmagnssnúruna úr sambandi við rafmagn. Aftengdu allar snúrur og kapla frá prentaranum. Ef prentarinn er með aðskildar viðbótarskúffur standandi á gólfi eða áfesta úttaksvalkosti, þá á að aftengja þá áður en prentarinn er fluttur. Ef prentarinn er á hjólavagni, rúllið þá honum varlega á nýja staðinn. Sýnið aðgát þegar farið er yfir þröskulda og mishæðir í gólfi. Ef prentarinn er ekki á hjólavagni en er uppsettur með viðbótarskúffum eða úttaksvalkostum, fjarlægðu úttaksvalkostina og lyftu honum af skúffunum. Reynið ekki að lyfta prentaranum og neinum valkostum samtímis. Notið ávallt handföngin á prentaranum til að lyfta honum. Sérhver vagn sem er notaður til að færa prentarann verður að vera fær um að styðja undir allan prentarann. Sérhver vagn sem notaður er til að færa vélbúnaðarvalkosti verður að vera með yfirborð sem er fært um að bera búnaðinn. Haldið prentaranum í uppréttri stöðu. Varist allar harkalegar hreyfingar. Gangið úr skugga um að fingurnir séu ekki undir prentarann þegar hann er settur niður. Gangið úr skugga um að það sé fullnægjandi pláss í kringum prentarann. Skemmdir á prentaranum af völdum óviðeigandi tilfærslu fellur ekki undir ábyrgð prentarans. færa prentarann"},{"UUID":"112e4cac-73ff-45e4-ad16-75069c913228","title":"Viðhald á prentaranum","link":"shipping-printer-topic.html","desc":"Flutningur á prentaranum Varðandi flutningsupplýsingar,","descFull":"Flutningur á prentaranum Varðandi flutningsupplýsingar, farðu á  http://support.lexmark.com  eða hafðu samband við þjónustu viðskiptavina. Þegar prentarinn er fluttur, notaðu upprunalegu umbúðirnar eða hafðu samband við söluaðilann þar sem þú keyptir prentarann varðandi flutningsumbúðir. prentari flutningur flutningur á prentaranum"},{"UUID":"5e82d929-dac2-45a3-b385-419107de7181","title":"Leysa vandamál","link":"print-quality-problems-picker-topic.html","desc":"Vandamál varðandi prentgæði Finndu myndina","descFull":"Vandamál varðandi prentgæði Finndu myndina sem líkist vandamáli prentgæða sem þú ert með og smelltu síðan á tengilinn fyrir neðan hana til að lesa skref til lausnar vandanum. vandamál varðandi prentgæði bilanaleit vandamál varðandi prentgæði villuleit prentunar vandamál varðandi prentgæði"},{"UUID":"158b6752-bb68-454a-8e8d-653d81dedfd6","title":"Leysa vandamál","link":"printer-error-codes-topic.html","desc":"Villukóðar prentara Villukóðar prentara Villukóðar","descFull":"Villukóðar prentara Villukóðar prentara Villukóðar og hvernig á að leysa þá Villukóðar Villuboð Lausn 2.01 Þörf á birgðum. Snertu  Hætta við verk  og pantaðu þær birgðir sem þarf. Varðandi frekari upplýsingar, sjá  . 3.01 Staðalúttaksbakkinn er fullur. Fjarlægðu pappír úr bakkanum og snertu síðan  Halda áfram . 3.21, 3.22, 3.23, 3.24 Fjarlægðu pappír fyrir aftan skúffuna [x]. Fjarlægðu tilgreinda skúffu. Fjarlægðu flæktan pappír á svæðinu.  Settu skúffuna inn. 7.13, 7.23, 7.33, 7.43, 7.53 Setja inn skúffu [x]. Reyndu annað af eftirfarandi: Settu tilgreinda skúffu í. Hætta við núverandi verk í prentun. 8.01 Lokaðu hurð að framan. Haltu hurð að framan lokaðri nema þegar viðhald er framkvæmt. 8.02, 8.03, 8.04, 8.05 Lokaðu hurð [x]. Haltu tilgreindri hurð lokaðri nema þegar viðhald er framkvæmt. 8.06 Tengdu skúffu 5. Renndu skúffunni til vinstri og renndu henni síðan aftur á sinn stað. 8.07 Lokaðu hlíf F yfir pappírsflutningi. Hafðu hlíf % yfir pappírsflutningi lokaða nema verið sé að framkvæma viðhald. 8.08 Lokaðu hurð að framan fyrir heftarabúnað. Haltu hurð að framan lokaðri nema þegar viðhald er framkvæmt. 8.09 Lokaðu loki að ofan fyrir frágangseiningu með heftara og gatara. Haltu loki að ofan lokuðu nema þegar viðhald er framkvæmt. 9.00 Prentarinn þurfti að endurræsast. Síðasta verk kann að vera ófullkomið. Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. 11.11, 11.21, 11.31, 11.41, 11.51 Hlaða [source] með [type] [size]. Fylla á merkta skúffu með pappír Varðandi frekari upplýsingar, sjá  . 11.12, 11.22, 11.32, 11.42, 11.52 Hlaða [source] með [type] [size] [orientation]. 11.81, 11.91 Hlaða fjölnotamatara með [type] [size]. Settu pappír í fjölnotamatarann. Varðandi frekari upplýsingar, sjá  . 11.82, 11.92 Hlaða fjölnotamatara með [type] [size] [orientation]. 12.11, 12.21, 12.31, 12.41, 12.51 Breyta [source] í [type] [size]. Togaðu út tilgreindan bakka, fjarlægðu pappír og settu síðan rétta pappírsgerð og stærð. Varðandi frekari upplýsingar, sjá  . 12.12, 12.22, 12.32, 12.42, 12.52 Breyta [source] í [type] [size] [orientation]. 12,91 Breyta fjölnotamatara í [type] [size]. Fjarlægðu pappír og settu síðan rétta pappírsgerð og stærð. Varðandi frekari upplýsingar, sjá  . 12,92 Breyta fjölnotamatara í [type] [size] [orientation]. 31.00 Setja inn box fyrir gatara. Opnaðu hlíf F yfir pappírsflutningi. Fjarlægðu boxið fyrir gatara. Settu box fyrir gatara á sinn stað. 31.40 Setja svart hylki sem vantar eða svarar ekki inn aftur. Opnaðu hurð að framan. Fjarlægðu hylkið. Setja hylkið í. Lokaðu hurð að framan. 31,60 Setja upp aftur svarta myndeiningu sem vantar eða svarar ekki. Opnaðu hurð A. Opnaðu hurð að framan. Aflæstu og fjarlægðu síðan myndeininguna. Settu inn myndeiningu og læstu síðan neðri hlutanum. Lokaðu hurð að framan og hurð A. 32.40 Skipt um óstutt svart hylki. Sjá  . 34.00 Pappír of stuttur. Stilltu samsvarandi stærð á pappír og á pappírnum sem var hlaðið í skúffuna. Frá heimaskjánum, snertu  Stillingar Pappírs skúffa Uppsetning Pappírsstærð/gerð . 34.10, 34.20, 34.30, 34.40, 34.50 Athugaðu [source], stilltu stýringar og snúningsátt. Togaðu tilgreinda skúffu út og gættu þess að pappír sé rétt hlaðið í. Varðandi frekari upplýsingar, sjá  . 34.90 Athugaðu fjölnotamatara, stilltu stýringar og snúningsátt. Vertu viss um að pappír sé rétt hlaðið í. Varðandi frekari upplýsingar, sjá  . 37.10 Ekki nægt minni til að samraða verki. Reyndu annað af eftirfarandi: Snertu  Halda áfram  til að prenta hluta verks sem er þegar vistað og byrja að samraða afgangnum af prentverkinu. Hætta við núverandi verk í prentun. 37.30 Ekki nægt minni, sumum verkum í bið var eytt. Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. 38.10 Minni fullt. Reyndu eitt eða fleira af eftirfarandi: Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. Hætta við núverandi verk í prentun. Settu upp meira minni prentara. Fækkaðu fjölda á síðum sem eru í prentverkinu. 39.10 Margþætt síða, sum gögn kunna að hafa ekki náð að prentast. Reyndu eitt eða fleira af eftirfarandi: Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. Hætta við núverandi verk í prentun. Settu upp meira minni prentara. Minnkaðu margbreytileika og stærð prentverksins áður en þú sendir það í prentun aftur. Fækkaðu fjölda á síðum sem eru í prentverkinu. Minnkaðu fjölda og stærð allra niðurhalaðra leturgerða. Eyddu óþarfa leturgerðum eða fjölvum úr prentverkinu. Fækkaðu fjölda á gröfum/teikningum sem eru í prentverkinu. 51 Bilað minniskort uppgötvað. Reyndu eitt eða fleira af eftirfarandi: Skiptu um minniskort. Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. Hætta við núverandi verk í prentun. 52 Ekki nægilegt pláss á minniskorti fyrir tilföng. Reyndu eitt eða fleira af eftirfarandi: Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. Eyða leturgerðum, fjölvum og öðrum gögnum á minniskortinu. Settu harðan disk á sinn stað. Varðandi frekari upplýsingar, sjá  . Niðurhlöðnum leturtegundum og fjölvum sem eru ekki áður vistuð á minniskorti er eytt. 55,1 Villa við lestur á USB-kubb. Fjarlægja USB Fjarlægja minniskort til að halda áfram. 55,2 Villa við lestur á USB-tengistöð. Fjarlægja tengistöð. Fjarlægja USB-tengistöð til að halda áfram. 55.3 Taktu úr sambandi og skiptu um stillingu. 61 Fjarlægja gallaðan disk. Skiptu út gallaða geymsludrifinu. 62 Diskur fullur. Reyndu eitt eða fleira af eftirfarandi: Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. Eyða leturgerðum, fjölvum og öðrum gögnum sem vistuð eru á hörðum diski. Settu harðan disk á sinn stað. Varðandi frekari upplýsingar, sjá  . 63 Forsníða diskinn. Forsníða núna eyðir öllum upplýsingum af geymsludrifinu. Til að forsníða geymsludrifið skaltu gera eftirfarandi: Snertu  Stillingar Tæki Viðhald Eyða úr þjónustu . Snertu  Hreinsa allar upplýsingar á hörðum diski  og snertu síðan  EYÐA . 71,01 Stöðvarheiti á faxi ekki sett upp. Hafðu samband við kerfisstjóra. Sjá  . 71.02 Stöðvarnúmer á faxi ekki sett upp. Hafðu samband við kerfisstjóra. 71.03 Engin hliðræn lína tengd við mótald, fax óvirkt Athugaðu tenginguna og línuna fyrir merki. Varðandi frekari upplýsingar, sjá  . 71,06 Get ekki tengst HTTPS faxþjóni. Tenging við HTTPS Fax Server er aftengd. Athuga internet-tengingu prentarans. 71.07 Prentari er ekki skráður á HTTPS Fax Server. Gættu þess að prentaranum sé bætt við í tækjalistanum í gátt HTTPS Fax Server. Hafðu samband við kerfisstjórann. 71.11 Svæði fyrir fax. Svæði fyrir fax virkar ekki. Hafðu samband við kerfisstjórann. 71.12 Minni fullt, get ekki prentað föx. Snertu  Prenta allt  til að prenta eins mörg af föxunum og hafa verið vistuð. 71.13 Minni fullt. Get ekki sent föx. Reyndu annað af eftirfarandi: Haltu áfram og reyndu að senda faxið aftur. Skannaðu upprunalega skjalið eina síðu í einu, hringdu í faxnúmerið og faxaðu síðan skjalið. 71.40 Tími prentara er rangur. Setja tíma prentarans. Frá heimaskjánum, snertu  Stillingar Tæki Kjörstillingar Dagsetning og tími Setja upp . 72.01 SMTP-þjónn tölvupósts ekki uppsettur. Hafðu samband við kerfisstjóra.  Reyndu annað af eftirfarandi: Setja upp þína aðgerð fyrir tölvupóst Varðandi frekari upplýsingar, sjá  . Gera villuboðin óvirk. Varðandi frekari upplýsingar, sjá  . 72.02 Þjónn veftengingar ekki uppsettur. Hafðu samband við kerfisstjóra. Hafðu samband við kerfisstjóra. 72.04 Faxþjónn Fyrir snið ekki uppsettur Hafðu samband við kerfisstjóra. Reyndu annað af eftirfarandi: Snertu  Stillingar Fax Uppsetning faxþjóns Almennar faxstillingar .  Settu upp  Fyrir snið  stillinguna. Hafðu samband við kerfisstjóra. 81.31 Skiptu um rúllusett, farið yfir meðmælta endingu. Sjá  . 83.20 Lítið að heftum eða þau vantar. Reyndu annað af eftirfarandi: Fjarlægðu hylki með heftum og settu inn aftur. Skipta um hylki fyrir hefti Varðandi frekari upplýsingar, sjá  . 83.30 Hefti tóm eða rangt sett í. Reyndu annað af eftirfarandi: Fjarlægðu hylki með heftum og settu inn aftur. Skipta um hylki fyrir hefti Varðandi frekari upplýsingar, sjá  . 84.01 Myndeining nálægt lágri stöðu.  Snertu  Halda áfram  til að hreinsa skilaboðin. 84.11 Staða myndeiningar lág.  84.21 Staða myndeiningar mjög lág.  84.31 Skiptu um myndeiningu, farið yfir meðmælta endingu. Sjá  . 86.23 Brátt er þörf á viðhaldi skanna. Snertu  Halda áfram  til að hreinsa skilaboðin. 86.33 Skiptu um ADF-sett, farið yfir meðmælta endingu. Sjá  . 87.20 Box fyrir gatara næstum fullt. Snertu  Halda áfram  til að hreinsa skilaboðin. 87.30 Tæma boxið fyrir gatara. Opnaðu hlíf F yfir pappírsflutningi.  Fjarlægðu box fyrir gatara og tæmdu það síðan. Settu box fyrir gatara á sinn stað. Lokaðu lokinu. 200.03, 240.06 Pappírsflækja [flækja í haus]. Sjá  . 200.16[x], 241.16a Pappírsflækja [flækja í haus]. Sjá  . 200.26[x], 200.36[x], 200.46[x], 200.56a, 202.95[x], 242.26, 242.33, 242.43, 243.33, 243.36, 243,43, 244,43, 244,46 Pappírsflækja [flækja í haus]. Sjá  . 200.56a, 245.53[x], 245,56 Pappírsflækja [flækja í haus]. Sjá  . 200.95, 201.96, 202.93, 202.94, 221.93, 221.95, 232.93, 240.25, 240.35, 240.55 Pappírsflækja [flækja í haus]. Sjá  . 280.06 Settu upphafleg skjöl aftur í í ADF og endurræstu verkið. Reyndu eitt eða fleira af eftirfarandi: Fjarlægðu og settu skjalið aftur í ADF. Skannaðu skjalið í gleri á skanna. Ljúktu verkinu án þess að skanna eftirstandandi síður. Hætta við verk. 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95,\t281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13,\t283.15, 283.91, 283.93, 283.95, 284.11, 284.13, 284.15, 284.91, 284.93,\t284.95, 288.10,\t288.90, 295.01, 680.10 Flækja í skanna. Sjá  . 280.13Q, 280.15Q, 295.01Q, 680.20Q Skiptu um upphafleg skjöl sem flækt eru. Reyndu eitt eða fleira af eftirfarandi: Fjarlægðu og settu skjalið aftur í ADF. Skannaðu skjalið í gleri á skanna. Ljúktu verkinu án þess að skanna eftirstandandi síður. Hættu við verkið. 280.13K, 280.15K, 680.20K, 680.40K, 295.01K,  Settu upphafleg skjöl aftur í og endurræstu. Reyndu annað af eftirfarandi: Fjarlægðu og settu skjalið aftur í ADF eða gler á skanna. Hættu við verkið. 420.11a, 420.13a, 420.15a, 420.15b, 420.54a, 420.54b, 425.13a Pappírsflækja [flækja í haus]. Sjá  . 400.13, 400.13b, 420.13b, 420.15b, 420.54c, 450.23b, 450.91b, 451.33b, 454.23b, 454.25b, 457.25b Pappírsflækja [flækja í haus]. Sjá  . 457.35b Pappírsflækja [flækja í haus]. Ef þú settir upp heftarabúnað, sjá þá  . Ef þú settir upp frágangseiningu með heftara og gatara, sjá þá  . villukóðar villuboð"},{"UUID":"eab93be4-0e07-4daa-9e59-0d8a382d42ea","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Auðar eða hvítar síður Prenta","descFull":"Auðar eða hvítar síður Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit  Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Er prentarinn að prenta auðar eða hvítar síður? Vandamálið er leyst. Fjarlægðu myndeininguna. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Settu myndeininguna á sinn stað. Prentaðu skjalið. Er prentarinn að prenta auðar eða hvítar síður? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar auðar síður villuleit, gæði prentunar hvítar síður villuleit varðandi prentgæði hvítar síður villuleit varðandi prentgæði svartar síður auðar síður hvítar síður"},{"UUID":"02019677-27ba-4223-96df-2b45510b7bac","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Dökk prentun Prenta gæðaprófunarsíður áður","descFull":"Dökk prentun Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit  Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Það fer eftir þínu stýrikerfi, dragðu úr svertustigi prentdufts í kjörstillingum prentunar eða í samskiptum prentunar. Þú getur einnig breytt stillingunum á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Prenta Gæði Svertustig prentdufts . Prentaðu skjalið. Er prentun of dökk? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingar samsvari pappírnum sem var hlaðið í skúffuna. Þú getur einnig breytt stillingunum á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Er prentun of dökk? Farðu í skref 6. Vertu viss um að pappírinn sé ekki með neina áferð eða að hann sé grófur. Eru að prenta á pappír með áferð eða sem er grófur? Farðu í skref 6. Skiptu út pappír með áferð eða grófum með venjulegum pappír. Prentaðu skjalið. Er prentun of dökk? Vandamálið er leyst. Settu í pappír úr nýjum pakka. Pappírinn dregur til sín raka vegna þess að rakastig er hátt. Geymdu pappír í upphaflegum umbúðum þar til það á að nota hann. Prentaðu skjalið. Er prentun of dökk? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar dökk prentun villuleit varðandi prentgæði dökk prentun dökk prentun"},{"UUID":"b560c8e5-bcb0-42df-af7e-de9223d879e3","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Fínar línur prentast ekki rétt","descFull":"Fínar línur prentast ekki rétt Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Prentast fínar línur rétt? Vandamálið er leyst. Auka svertustig prentdufts Frá heimaskjánum, snertu  Stillingar Prenta Gæði Svertustig prentdufts . Prentaðu skjalið. Prentast fínar línur rétt? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit, gæði prentunar fínar línur prentast ekki rétt villuleit varðandi prentgæði fínar línur prentast ekki rétt fínar línur prentast ekki rétt"},{"UUID":"dc81db91-57a3-42a6-8f8e-099fbbeb2337","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Brotinn eða krumpaður pappír Prenta","descFull":"Brotinn eða krumpaður pappír Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Er pappírinn brotinn eða krumpaður? Vandamálið er leyst. Settu í pappír úr nýjum pakka. Pappírinn dregur til sín raka vegna þess að rakastig er hátt. Geymdu pappír í upphaflegum umbúðum þar til það á að nota hann. Prentaðu skjalið. Er pappírinn brotinn eða krumpaður? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Er pappírinn brotinn eða krumpaður? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar brotinn eða krumpaður pappír villuleit varðandi prentgæði brotinn eða krumpaður pappír brotinn pappír krumpaður pappír"},{"UUID":"a8d67a8c-182b-4c09-87ca-cd6c62be7f83","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Grár bakgrunnur Prenta gæðaprófunarsíður áður","descFull":"Grár bakgrunnur Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Draga úr svertustigi prentdufts Frá heimaskjánum, snertu  Stillingar Prenta Gæði Svertustig prentdufts . Prentaðu skjalið. Birtist grár bakgrunnur á útprentun? Vandamálið er leyst. Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Birtist grár bakgrunnur á útprentun? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Birtist grár bakgrunnur á útprentun? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Birtist grár bakgrunnur á útprentun? Vandamálið er leyst. Uppfæra fastbúnað prentarans. Varðandi frekari upplýsingar, sjá  . Prentaðu skjalið. Birtist grár bakgrunnur á útprentun? Vandamálið er leyst. Skiptu um myndeininguna. Prentaðu skjalið. Birtist grár bakgrunnur á útprentun? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. grár bakgrunnur á því sem verið er að prenta villuleit, gæði prentunar grár bakgrunnur á því sem verið er að prenta villuleit varðandi prentgæði grár bakgrunnur á því sem verið er að prenta"},{"UUID":"9e81ade5-c6e2-49bf-a9e5-a248c7e5bf07","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Rangar spássíur Skref til að","descFull":"Rangar spássíur Skref til að leysa vandamálið Aðgerð Já Nei Færðu stýringar í skúffunni í rétta stöðu fyrir pappír sem var hlaðið. Prentaðu skjalið. Eru spássíur réttar? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu pappírsstærð í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Eru spássíur réttar? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . rangar spássíur villuleit prentunar rangar spássíur villuleit, prentun rangar spássíur"},{"UUID":"57896967-9e5c-45fb-94fd-fde5afa9f8c9","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Ljós prentun Prenta gæðaprófunarsíður áður","descFull":"Ljós prentun Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Er prentunin ljós? Vandamálið er leyst. Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Auka svertustig prentdufts Frá heimaskjánum, snertu  Stillingar Prenta Gæði Svertustig prentdufts . Prentaðu skjalið. Er prentunin ljós? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Er prentunin ljós? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu upplausn prentunar í kjörstillingum prentunar eða í samskiptum prentunar. Stilltu upplausnina á  600 dpi . Prentaðu skjalið. Er prentunin ljós? Vandamálið er leyst. Fjarlægðu myndeininguna. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi getur valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Hristu myndeininguna vel til að jafna prentduftið. Settu myndeininguna á sinn stað. Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Prentaðu skjalið. Er prentunin ljós? Vandamálið er leyst. Athuga stöðuna á blekhylkinu. Frá heimaskjánum, snertu  Stillingar Skýrslur Tæki Tölfræði tækis . Athugaðu stöðuna á blekhylkinu í kafla upplýsingar um rekstrarvörur á prentuðu síðunum. Er blekhylkið að nálgast mörk líftíma? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Skiptu um blekhylki. Prentaðu skjalið. Er prentunin ljós? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. ljós prentun villuleit, gæði prentunar ljós prentun villuleit varðandi prentgæði ljós prentun"},{"UUID":"623d50e7-67ae-4f03-b51d-65093535d793","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Flekkótt prentun og punktar Prenta","descFull":"Flekkótt prentun og punktar Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Er prentunin flekkótt? Vandamálið er leyst. Athugaði varðandi mengun vegna leka á prentlit. Er prentarinn laus við leka á prentlit? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Athuga stöðuna á myndeiningunni. Frá heimaskjánum, snertu  Stillingar Skýrslur Tæki Tölfræði tækis . Athugaðu stöðuna á myndeiningunni í kafla upplýsingar um rekstrarvörur á prentuðu síðunum. Er myndvalsinn að nálgast mörk líftíma? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Skiptu um myndeininguna. Prentaðu skjalið. Er prentunin flekkótt? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar flekkótt prentun og punktar villuleit varðandi prentgæði flekkótt prentun og punktar flekkótt prentun punktar á útprentun"},{"UUID":"7c949aab-2eba-4a45-bdd1-46092deb2cc8","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Pappír krullast Skref til að","descFull":"Pappír krullast Skref til að leysa vandamálið Aðgerð Já Nei Færðu stýringar í skúffunni í rétta stöðu fyrir pappír sem var hlaðið. Prentaðu skjalið. Er pappírinn krullaður? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Er pappírinn krullaður? Vandamálið er leyst. Prentið á hina hliðina á pappírnum. Fjarlægið pappírinn, snúið honum við og hlaðið honum aftur. Prentaðu skjalið. Er pappírinn krullaður? Vandamálið er leyst. Settu í pappír úr nýjum pakka. Pappírinn dregur til sín raka vegna þess að rakastig er hátt. Geymdu pappír í upphaflegum umbúðum þar til það á að nota hann. Prentaðu skjalið. Er pappírinn krullaður? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar pappír krullast villuleit varðandi prentgæði pappír krullast"},{"UUID":"153ff739-bee8-464e-acb2-052c59d1c55f","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Útprentun skáhallandi eða skökk Prenta","descFull":"Útprentun skáhallandi eða skökk Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Dragðu skúffuna út. Fjarlægðu pappírinn og settu síðan í pappír úr nýjum umbúðum. Pappírinn dregur til sín raka vegna þess að rakastig er hátt. Geymdu pappír í upphaflegum umbúðum þar til það á að nota hann. Færðu stýringar í skúffunni í rétta stöðu fyrir pappír sem var hlaðið. Settu skúffuna inn. Prentaðu skjalið. Er útprentun skáhallandi eða skökk? Vandamálið er leyst. Gakktu úr skugga um að þú sért að prenta á studda gerð af pappír. Prentaðu skjalið. Er útprentun skáhallandi eða skökk? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar skáhallandi prentun villuleit varðandi prentgæði skáhallandi prentun villuleit, gæði prentunar bogin prentun villuleit varðandi prentgæði bogin prentun bogin prentun skáhallandi prentun"},{"UUID":"5c7dc3d3-c705-4377-9b93-99d818347fe0","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Heilar svartar síður Prenta gæðaprófunarsíður","descFull":"Heilar svartar síður Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Er prentarinn að prenta heilar svartar síður? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Er prentarinn að prenta heilar svartar síður? Vandamálið er leyst. Athugaðu myndvalsinn varðandi skemmdir. Athugaðu að ljósnæma tromlan sé ekki bogin eða í rangri staðsetningu. Er myndeiningin skemmd? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Skiptu um myndeininguna. Prentaðu skjalið. Er prentarinn að prenta heilar svartar síður? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. heilar svartar síður villuleit, gæði prentunar heilar svartar síður villuleit varðandi prentgæði heilar svartar síður"},{"UUID":"155a40cd-ed66-466d-b98b-39706732dd2c","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Skorið af texta eða myndum","descFull":"Skorið af texta eða myndum Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Er textinn eða myndin klippt? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Er textinn eða myndin klippt? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu pappírsstærð í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið í skúffuna. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Er textinn eða myndin klippt? Vandamálið er leyst. Skiptu um myndeininguna. Prentaðu skjalið. Er textinn eða myndin klippt? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar skorið af texta eða myndum villuleit varðandi prentgæði skorið af texta eða myndum skorið af texta í útprentun skorið af myndum í útprentun"},{"UUID":"96c16b51-e85a-4cd9-889d-0087663b855d","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Prentlitur nuddast auðveldlega af Prenta","descFull":"Prentlitur nuddast auðveldlega af Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Nuddast prentlitur auðveldlega af? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Nuddast prentlitur auðveldlega af? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar prentlitur nuddast auðveldlega af villuleit varðandi prentgæði prentlitur nuddast auðveldlega af prentlitur nuddast auðveldlega af"},{"UUID":"73fae84c-8840-424d-b673-45ae2c311ec5","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Láréttar ljósar rendur Prenta gæðaprófunarsíður","descFull":"Láréttar ljósar rendur Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Eru láréttar ljósar rendur að birtast á því sem verið er að prenta? Vandamálið er leyst. Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Prentaðu skjalið. Eru láréttar ljósar rendur að birtast á því sem verið er að prenta? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Eru láréttar ljósar rendur að birtast á því sem verið er að prenta? Vandamálið er leyst. Skiptu um myndeininguna. Prentaðu skjalið. Eru láréttar ljósar rendur að birtast á því sem verið er að prenta? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar láréttar ljósar rendur villuleit varðandi prentgæði láréttar ljósar rendur láréttar ljósar rendur"},{"UUID":"59ffb902-7175-494e-8c4e-9daeeadfc535","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Lóðréttar ljósar rendur Prenta gæðaprófunarsíður","descFull":"Lóðréttar ljósar rendur Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Prentaðu skjalið. Eru láréttar ljósar rendur að birtast á því sem verið er að prenta? Vandamálið er leyst. Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Eru lóðréttar ljósar rendur að birtast á því sem verið er að prenta? Vandamálið er leyst. Athuga stöðuna á blekhylkinu. Frá heimaskjánum, snertu  Stillingar Skýrslur Tæki Tölfræði tækis . Athugaðu stöðuna á blekhylkinu í kafla upplýsingar um rekstrarvörur á prentuðu síðunum. Eru lóðréttar ljósar rendur að birtast á því sem verið er að prenta? Vandamálið er leyst. Skiptu um blekhylki. Prentaðu skjalið. Eru lóðréttar ljósar rendur að birtast á því sem verið er að prenta? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar lóðréttar ljósar rendur villuleit varðandi prentgæði lóðréttar ljósar rendur lóðréttar ljósar rendur"},{"UUID":"70b4e780-c860-42e0-8101-4918f957cd2b","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Lóðréttar hvítar línur Prenta gæðaprófunarsíður","descFull":"Lóðréttar hvítar línur Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef hylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Eru lóðréttar hvítar línur að birtast á því sem verið er að prenta? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Prentaðu skjalið. Eru lóðréttar hvítar línur að birtast á því sem verið er að prenta? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. lóðréttar hvítar línur villuleit, gæði prentunar lóðréttar hvítar línur villuleit varðandi prentgæði lóðréttar hvítar línur hvítar línur"},{"UUID":"e3780e99-5fa6-4976-9313-64bd5e4ea5c9","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Lóðréttar dökkar rákir Prenta gæðaprófunarsíður","descFull":"Lóðréttar dökkar rákir Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Birtast lóðréttar dökkar rákir á því sem verið er að prenta? Vandamálið er leyst. Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Prentaðu skjalið. Birtast lóðréttar dökkar rákir á því sem verið er að prenta? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Birtast lóðréttar dökkar rákir á því sem verið er að prenta? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. lóðrétt dökk strik villuleit, gæði prentunar lóðrétt dökk strik villuleit varðandi prentgæði lóðrétt dökk strik"},{"UUID":"2c4289b4-fe6e-4a24-9661-821c54ce0edc","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Lóðréttar dökkar línur eða rákir","descFull":"Lóðréttar dökkar línur eða rákir Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Birtast lóðrétt dökk strik eða rákir á því sem verið er að prenta? Vandamálið er leyst. Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Prentaðu skjalið. Birtast lóðrétt dökk strik eða rákir á því sem verið er að prenta? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi getur valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Birtast lóðrétt dökk strik eða rákir á því sem verið er að prenta? Vandamálið er leyst. Skiptu um myndeininguna. Prentaðu skjalið. Birtast lóðrétt dökk strik eða rákir á því sem verið er að prenta? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, gæði prentunar lóðréttar dökkar línur eða rákir villuleit varðandi prentgæði lóðréttar dökkar línur eða rákir lóðréttar dökkar línur á útprentun lóðréttar rákir á útprentun"},{"UUID":"56b2c38a-6ac8-4a63-9bdc-4ff9aa5c97b2","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Lóðréttar dökkar rákir með prentun","descFull":"Lóðréttar dökkar rákir með prentun sem vantar Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Fjarlægðu þurrku prentarahaussins og þrífðu síðan linsu prentarahaussins. Prentaðu skjalið. Birtast lóðréttar dökkar rákir með myndum sem vantar á útprentun? Vandamálið er leyst. Fjarlægðu myndeininguna og settu inn aftur. Ekki láta myndeininguna lenda í beinu ljósi. Löng viðvera í ljósi gæti valdið gæðavandamálum við prentun. Snertu ekki myndvalsinn. Sé það gert getur það haft áhrif á prentgæði prentverka í framtíðinni. Prentaðu skjalið. Birtast lóðréttar dökkar rákir með myndum sem vantar á útprentun? Vandamálið er leyst. Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Prentaðu skjalið. Birtast lóðréttar dökkar rákir með myndum sem vantar á útprentun? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. lóðréttar dökkar rákir prentun vantar villuleit, gæði prentunar lóðréttar dökkar rákir með prentun sem vantar villuleit varðandi prentgæði lóðréttar dökkar rákir með prentun sem vantar"},{"UUID":"9a92798c-5cb9-4523-92ab-1111639f843c","title":"Prentgæði eru léleg","link":"print-quality-is-poor-subgroup.html","desc":"Endurteknir gallar Prenta gæðaprófunarsíður áður","descFull":"Endurteknir gallar Prenta gæðaprófunarsíður áður en reynt er að leysa vandamálið. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Skref til að leysa vandamálið Aðgerð Já Nei Notaðu gæðaprófunarsíður til að athuga hvort fjarlægðin á milli endurtekinna galla samsvari einhverju af eftirfarandi: Myndeiningarsett 94,2 mm (3,7 to.) 37,7 mm (1,48 to.) 31,8 mm (1,25 to.) Önnur færslurúlla 50,3 mm (1,98 to.) Hitagjafi 95,1 mm (3,74 to.) 82,5 mm (3,25 to.) Samsvarar fjarlægðin á milli endurtekinna galla einverjum af mælingunum? Ef endurteknir gallar samsvara mælingum á flutningsrúllu eða hitagjafa, hafðu samband við  stuðning viðskiptavina . Ef endurteknir gallar samsvara mælingum á flutningsrúllu eða hitagjafa, hafðu samband við  tæknistuðning . Skráðu fjarlægðina og hafðu síðan samband við  stuðning viðskiptavina . Skráðu fjarlægðina og hafðu síðan samband við  tæknistuðning . Skiptu um viðkomandi birgðavöru. Prentaðu skjalið. Birtast endurteknu gallarnir? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit varðandi prentgæði endurteknir gallar villuleit, gæði prentunar endurteknir gallar endurteknir gallar sjást á útprentun"},{"UUID":"b7fa4f8b-04c0-4b34-a5d3-8570c795d8cb","title":"Vandamál við prentun","link":"print-quality-is-poor-subgroup.html","desc":"Prentverk prentast ekki Skref til","descFull":"Prentverk prentast ekki Skref til að leysa vandamálið Aðgerð Já Nei Opnaðu prentsamskipti í skjalinu sem þú ert að prenta og athugaðu síðan hvort þú hefur valið réttan prentara. Prentaðu skjalið. Er skjalið prentað? Vandamálið er leyst. Athugaðu hvort kveikt sé á prentaranum. Leystu úr villuboðum sem birtast á skjánum. Prentaðu skjalið. Er skjalið prentað? Vandamálið er leyst. Athugaðu hvort tengin eru að virka og hvort kaplar séu örugglega tengdir á milli tölvu og prentara. Skoðaðu skjölin sem fylgdu með prentaranum varðandi frekari upplýsingar. Prentaðu skjalið. Er skjalið prentað? Vandamálið er leyst. Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Prentaðu skjalið. Er skjalið prentað? Vandamálið er leyst. Fjarlægðu prentrekilinn og settu síðan upp aftur. Prentaðu skjalið. Er skjalið prentað? Vandamálið er leyst. Hafa samband  stuðning viðskiptavina . villuleit, prentun prentverk prentast ekki villuleit prentunar prentverk prentast ekki prentverk eru ekki prentuð"},{"UUID":"2b9194d8-39da-46ab-8054-ee071ff80b00","title":"Vandamál við prentun","link":"print-quality-is-poor-subgroup.html","desc":"Trúnaðarmál og önnur skjöl í","descFull":"Trúnaðarmál og önnur skjöl í bið prentast ekki Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu á stjórnborðinu hvort skjölin birtast í lista yfir  Verk í bið . Ef skjölin eru ekki á listanum, prentaðu þá skjölin með því að nota valkostina Prenta og bið. Prentaðu skjölin. Voru skjölin prentuð? Vandamálið er leyst. Prentverkið kann að innihalda sniðvillu eða ógild gögn. Eyddu prentverkinu og sendu það síðan aftur. Fyrir PDF-skrár, búðu til nýja skrá og prentaðu síðan skjölin. Voru skjölin prentuð? Vandamálið er leyst. Ef þú ert að prenta af Netinu, þá getur prentarinn verið að lesa marga verktitla sem afrit. Fyrir Windows-notendur Opnaðu samskipti kjörstillinga prentunar. Í flipa prenta og halda, smelltu á  Nota prenta og halda , og smelltu síðan á  Halda afriti skjala . Skráðu PIN-númer, og vistaðu síðan breytingarnar. Sendu verkið sem á að prenta. Fyrir Macintosh-notendur Vista og nefna hvert verk sérstaklega. Sendu verkin hvert fyrir sig. Voru skjölin prentuð? Vandamálið er leyst. Eyða nokkrum verkum í bið til að losa um minni prentarans. Prentaðu skjölin. Voru skjölin prentuð? Vandamálið er leyst. Bættu við prentaraminni. Prentaðu skjölin. Voru skjölin prentuð? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit, prentun trúnaðarmál og önnur skjöl í bið prentast ekki villuleit prentunar trúnaðarmál og önnur skjöl í bið prentast ekki skjöl trúnaðarmála prentast ekki skjöl í bið prentast ekki"},{"UUID":"f9e69613-289d-4200-8e94-f8ddad6deef1","title":"Vandamál við prentun","link":"print-quality-is-poor-subgroup.html","desc":"Verk prentast úr rangri skúffu","descFull":"Verk prentast úr rangri skúffu eða á rangan pappír Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort þú ert að prenta á rétta gerð af pappír. Prentaðu skjalið. Er skjalið prentað á rétta gerð pappírs? Settu í rétta stærð og gerð af pappír. Það fer eftir þínu stýrikerfi, skilgreindu pappírsstærð og gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Þú getur einnig breytt stillingunum á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Vertu viss um að stillingar samsvari pappírnum sem var hlaðið í skúffuna. Prentaðu skjalið. Er skjalið prentað á rétta gerð pappírs? Vandamálið er leyst. Athugaðu hvort skúffur séu tengdar. Varðandi frekari upplýsingar, sjá  . Prentaðu skjalið. Er skjalið prentað úr réttri skúffu? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit prentunar verk prentast úr rangri skúffu villuleit prentunar verk prentast á rangan pappír villuleit, prentun verk prentast úr rangri skúffu villuleit, prentun verk prentast á rangan pappír verk prentast úr rangri skúffu verk prentast á rangan pappír"},{"UUID":"44e7e3b8-b847-4cdc-b5dc-f2f3cec8a6a4","title":"Vandamál við prentun","link":"print-quality-is-poor-subgroup.html","desc":"Hæg prentun Skref til að","descFull":"Hæg prentun Skref til að leysa vandamálið Aðgerð Já Nei Vertu viss um að prentarakapallinn sé tengdur við prentara og tölvuna, prentþjón, valkost eða annan búnað netkerfis. Er prentarinn lengi að prenta? Vandamálið er leyst. Vertu viss um að prentarinn sé ekki í  Hljóðlátri stillingu . Á heimaskjánum, snertu  Stillingar Tæki Viðhald Valmynd uppsetningar Notkun tækis Hljóðlát stilling . Prentaðu skjalið. Er prentarinn lengi að prenta? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu upplausn prentunar í kjörstillingum prentunar eða í samskiptum prentunar. Stilltu upplausnina í 4800 CQ. Prentaðu skjalið. Er prentarinn lengi að prenta? Vandamálið er leyst. Það fer eftir þínu stýrikerfi, skilgreindu gerð pappírs í kjörstillingum prentunar eða í samskiptum prentunar. Vertu viss um að stillingin samsvari pappírnum sem var hlaðið. Þú getur einnig breytt stillingunni á stjórnborði prentarans. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Það tekur lengi tíma að prenta á mjög þykkan pappír. Pappír mjórri en bréf, A4 og lagalegt tekur lengri tíma í prentun. Prentaðu skjalið. Er prentarinn lengi að prenta? Vandamálið er leyst. Vertu viss um að stillingar prentarans fyrir áferð og þyngd samsvari pappírnum sem er hlaðið. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning á miðli Gerðir miðla . Gróf áferð pappírs og þykkur pappír tekur lengri tíma í prentun. Prentaðu skjalið. Er prentarinn lengi að prenta? Vandamálið er leyst. Fjarlægja verk í bið Er prentarinn lengi að prenta? Vandamálið er leyst. Vertu viss um að prentarinn sé ekki að ofhitna. Leyfðu prentaranum að kólna eftir löng prentverk. Fylgstu með meðmæltum umhverfishita fyrir prentarann. Varðandi frekari upplýsingar, sjá  . Prentaðu skjalið. Er prentarinn lengi að prenta? Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . Vandamálið er leyst. villuleit prentunar hæg prentun villuleit, prentun hæg prentun hæg prentun"},{"UUID":"b8fa4c89-a3c9-4410-8164-16132a7bae2d","title":"Leysa vandamál","link":"trb-printer-not-responding-topic.html","desc":"Prentarinn svarar ekki Skref til","descFull":"Prentarinn svarar ekki Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu að rafmagnssnúran sé tengd við rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Er prentarinn að svara? Vandamálið er leyst. Athugaðu að ekki sé slökkt á rafmagnsinnstungu með rofa eða öryggi. Er slökkt á rafmagnsinnstungu með rofa eða öryggi? Kveiktu á rofanum eða endurstilltu öryggið. Athugaðu hvort kveikt sé á prentaranum. Er kveikt á prentaranum? Kveiktu á prentaranum Athugaðu hvort prentarinn sé í svefnstillingu eða stillingu í dvala. Er prentarinn í svefnstillingu eða stillingu í dvala? Ýttu á straumhnappinn til að vekja prentarann, Athugað hvort snúrur í prentara og tölvu séu í réttum tengjum. Eru kaplar settir í rétt tengi? Settu kapla í rétt tengi. Slökktu á prentaranum, settu upp valkosti vélbúnaðar og kveiktu síðan á honum aftur. Skoðaðu skjölin sem fylgdu með aukabúnaðinum varðandi frekari upplýsingar. Er prentarinn að svara? Vandamálið er leyst. Settu upp réttan rekil fyrir prentara. Er prentarinn að svara? Vandamálið er leyst. Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Er prentarinn að svara? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . bilanaleit prentarinn svarar ekki prentarinn svarar ekki"},{"UUID":"7e07dc35-094d-4973-a3e0-4450f78a8a93","title":"Leysa vandamál","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Get ekki lesið minniskort Skref","descFull":"Get ekki lesið minniskort Skref til að leysa vandamálið Aðgerð Já Nei Athuga hvort prentarinn er ekki upptekinn við að vinna við aðra prentun, afritun, skönnun eða faxsendingu. Er prentarinn tilbúinn? Farðu í skref 3. Bíða þar til að prentarinn lýkur við vinnslu á öðru verki. Fjarlægðu minniskortið og settu inn aftur. Þekkir prentarinn minniskortið? Vandamálið er leyst. Athugaðu hvort minniskort sé sett í USB-tengið að framan. Minniskort mun ekki virka sé það sett í USB-tengið að aftan. Er minniskortið sett í rétt tengi? Farðu í skref 5. Settu minniskortið í rétt tengi. Þekkir prentarinn minniskortið? Vandamálið er leyst. Athugaðu hvort minniskortið er stutt. Varðandi frekari upplýsingar, sjá  . Er minniskortið stutt? Farðu í skref 7. Settu inn minniskort sem er stutt. Þekkir prentarinn minniskortið? Vandamálið er leyst. Fjarlægðu minniskortið og settu inn aftur. Þekkir prentarinn minniskortið? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . get ekki lesið minniskort villuleit, prentun villuleit prentunar get ekki lesið minniskort"},{"UUID":"a84f5881-bb1d-479c-b194-7eaf2960766b","title":"Leysa vandamál","link":"enabling-usb-port-topic.html","desc":"Virkja USB-tengið Frá heimaskjánum, snertu","descFull":"Virkja USB-tengið Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi USB Virkja USB-tengi . USB-tengi virkja virkja USB-tengið"},{"UUID":"d7c3f6df-3bd1-4428-930c-929f81c108ee","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Komast hjá stíflum Settu í","descFull":"Komast hjá stíflum Settu í pappír á réttan hátt Vertu viss um að pappírinn liggi flatur í skúffunni. Rétt og röng hleðsla á pappír Rétt hleðsla á pappír Röng hleðsla á pappír Ekki hlaða né fjarlægja skúffu þegar prentarinn er að prenta. Ekki hlaða of miklum pappír. Vertu viss um að hæð á stafla sé fyrir neðan vísun á hámarksfyllingu. Ekki renna pappírnum í skúffuna. Hlaðið pappírnum eins og sýnt er á skýringarmyndinni. Vertu viss um að stýringar fyrir pappír séu rétt staðsettar og eru ekki að ýta þétt á móti pappír eða umslögum. Ýttu skúffunni þétt inn í prentarann eftir hleðslu á pappír. Notið meðmæltan pappír Notið aðeins meðmæltan pappír eða sérstakan miðil. Ekki hlaða krumpuðum, brotnum, rökum, beygluðum eða krulluðum pappír. Sveigðu, blaðaðu og jafnaðu pappírsbrúnir áður en pappírnum er hlaðið. Ekki nota pappír sem hefur verið skorinn eða klipptur með hendi. Ekki blanda saman pappírsstærðum, þyngd og gerð saman í skúffu. Vertu viss um að stærð og gerð pappírs sé rétt stillt í tölvunni eða á stjórnborði prentarans. Geymið pappír samkvæmt ráðleggingum framleiðanda. pappírsstíflur komast hjá flækjur, pappír komast hjá komast hjá pappírsflækju"},{"UUID":"5052cce4-370b-4a57-bd66-2bbac3e13d1d","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Finna staðsetningar flækju Þegar ","descFull":"Finna staðsetningar flækju Þegar  Flækjuaðstoð  er stillt á  Kveikt , sendir prentarinn sjálfkrafa auðar síður eða síður með prentun að hluta eftir að flækt síða hefur verið hreinsuð. Athugaðu útprentun varðandi auðar síður. Þegar  Endurheimt flækju  er stillt á  Kveikt  eða  Sjálfvirkt , þá endurprentar prentarinn flæktar síður. Staðsetningar flækju Staðsetningar flækju 1 Fjölnotamatari 2 Hurð A 3 Sjálfvirkur matari skjala 4 Staðalbakki 5 Lárétt flutningseining 6 Frágangseining með heftara og gatara 7 Staðalskúffa 8 2000‑blaða skúffa 9 Heftarabúnaður 10 Aukaskúffur pappírsstíflur finna staðsetningar flækju auðkennir"},{"UUID":"0c7cd913-be61-4f02-a07b-4ecae2d9c327","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsstífla í staðalskúffu Opnaðu hurð","descFull":"Pappírsstífla í staðalskúffu Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Dragðu staðalskúffuna út. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Settu skúffuna inn og lokaðu síðan hurð A. hreinsa flækju í staðalskúffuna fjarlægja pappírsflækju í staðalskúffuna pappírsflækja í staðalskúffuna"},{"UUID":"7fc9e506-f126-429e-988f-562048f8a477","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsflækja í aukaskúffum Opnaðu hurð","descFull":"Pappírsflækja í aukaskúffum Opnaðu hurð B. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hurðinni. Dragðu úr 520-blaða aukaskúffuna eða 2000-blaða samstæðuskúffuna sem er aukabúnaður. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Dragðu út handfang C í samstæðuskúffu og opnaðu síðan innri hlífina. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hlífinni og settu síðan handfang C inn. Settu skúffuna inn. hreinsa flækju í hurð B hreinsa flækju í 520‑blaða skúffu hreinsa flækju í 2000-blaða samstæðuskúffu fjarlægja pappírsflækju í hurð B fjarlægja pappírsflækju í 520‑blaða skúffu fjarlægja pappírsflækju í 2000-blaða samstæðuskúffu pappírsflækja í hurð B pappírsflækja í 520‑blaða skúffu pappírsflækja í 2000-blaða samstæðuskúffu pappírsflækja í aukaskúffum hreinsa flækju í aukaskúffum fjarlægja pappírsflækju í aukaskúffum"},{"UUID":"35e66669-dc5f-437f-90c1-c6548ce35657","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsstífla í fjölnotamatara Fjarlægðu pappírinn","descFull":"Pappírsstífla í fjölnotamatara Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. hreinsa flækju í fjölnotamatara fjarlægja pappírsflækju í fjölnotamatara pappírsflækja í fjölnotamatara"},{"UUID":"d8fcbe5f-9b1b-4161-b093-02b4e50132f0","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsflækja í 2000‑blaða skúffunni Renndu","descFull":"Pappírsflækja í 2000‑blaða skúffunni Renndu skúffunni til vinstri. Opnaðu hurð J og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hurðinni og renndu síðan skúffunni aftur á sinn stað. Dragðu út skúffuinnleggið og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Ýttu skúffuinnlegginu aftur á sinn stað. hreinsa flækju í 2000‑blaða skúffu fjarlægja pappírsflækju í 2000‑blaða skúffu pappírsflækja í 2000‑blaða skúffu"},{"UUID":"b7b82b85-e58a-4f48-80e5-bb46d16d225a","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsflækja í hurð A Pappírsflækja","descFull":"Pappírsflækja í hurð A Pappírsflækja í hurð A Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Fjarlægðu pappírinn sem stíflaðist frá eftirfarandi svæðum: Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Svæði hitagjafa Tvívirk (duplex)-eining Hurð C Loka hurð A. hreinsa flækju í hurð A hreinsa flækju í tvívirkri (duplex) einingu hreinsa flækju í hurð C hreinsa flækju á svæði hitagjafa fjarlægja pappírsflækju á svæði hitagjafa fjarlægja pappírsflækju í hurð C fjarlægja pappírsflækju í tvívirkri (duplex) einingu fjarlægja pappírsflækju í hurð A pappírsflækja í hurð A pappírsstífla í tvívirkri einingu (duplex) pappírsstífla á svæði hitaeiningar pappírsflækja í hurð C"},{"UUID":"6d1b5e6e-ce61-4cca-a363-7b4655412183","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsstífla í staðalskúffu Opnaðu hurð","descFull":"Pappírsstífla í staðalskúffu Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Opnaðu hurð C og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hurð C og lokaðu síðan hurð A. Pappírsflækja er fjarlægð úr staðalbakka. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. hreinsa flækju í staðalbakka fjarlægja pappírsflækju staðalbakki pappírsflækja í staðalbakka"},{"UUID":"0b1070cd-942a-4625-86f5-d40d66a0b4c2","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsstífla í sjálfvirkum matara skjala","descFull":"Pappírsstífla í sjálfvirkum matara skjala Fjarlægðu öll upphafleg skjöl úr skúffu sjálfvirks matara skjala. Opnaðu hlíf á sjálfvirkum matara. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu loki á sjálfvirkum matara. hreinsa flækju í sjálfvirkum matara skjala pappírsflækja í sjálfvirkum matara skjala fjarlægja pappírsflækju í sjálfvirkum matara skjala"},{"UUID":"f983249c-b163-46ec-a9e3-0b2f52c63de2","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsflækja í frágangsbúnaði heftara Opnaðu","descFull":"Pappírsflækja í frágangsbúnaði heftara Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Opnaðu hurð A1 og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hurð A1 og lokaðu síðan hurð A. Opnaðu efra lokið á frágangseiningunni og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu lokinu. Opnaðu fremra lokið á frágangseiningunni, snúðu hnúðnum og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu lokinu. Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Opnaðu hurð C og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hurð C og lokaðu síðan hurð A. hreinsa flækju í frágangseiningu heftara fjarlægja pappírsflækju í frágangseiningu heftara pappírsflækja í frágangseiningu heftara"},{"UUID":"cb75287f-d47b-4a16-8741-4e3b46c50827","title":"Losa um flækjur","link":"avoiding-jams-topic.html","desc":"Pappírsflækja í heftara- og gatarabúnaði","descFull":"Pappírsflækja í heftara- og gatarabúnaði Opnaðu hurð A. Prentarinn kann að vera heitur að innanverðu. Til að draga úr hættu á meiðslum frá heitum hlut, leyfið yfirborðinu að kólna áður en það er snert. Opnaðu hurð A1 og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hurð A1 og lokaðu síðan hurð A. Lyftu loki F yfir pappírsflutningnum og fjarlægðu síðan flækta pappírinn. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hlíf yfir pappírsflutningi. Togaðu í stöngina á frágangseiningu með heftara og gatara og lyftu síðan lokinu. Fjarlægðu pappírinn sem stíflaðist. Vertu viss um að öll pappírssnifsi hafi verið fjarlægð. Lokaðu hlíf á frágangseiningu. hreinsa flækju í frágangseiningu með heftara og gatara fjarlægja pappírsflækju í frágangseiningu með heftara og gatara pappírsflækja í heftara- og gatarabúnaði"},{"UUID":"86ea6033-b146-4b85-910f-250e903d1b50","title":"Vandamál við nettengingu","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Get ekki opnað innfelldan vefþjón","descFull":"Get ekki opnað innfelldan vefþjón Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort kveikt sé á prentaranum. Fara í innbyggða vefþjóninn (EWS). Geturðu opnað EWS? Vandamálið er leyst. Vertu viss um að IP-tala prentarans sé rétt. Skoða IP-töluna á heimaskjánum. IP-tala birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Fara í EWS. Geturðu opnað EWS? Vandamálið er leyst. Gakktu úr skugga um að þú hafir sett upp studdan vafra: Internet Explorer útgáfa 11 eða nýrri Microsoft Edge Safari útgáfa 6 eða nýrri Google Chrome  útgáfa 32 eða nýrri Mozilla Firefox útgáfa 24 eða nýrri Fara í EWS. Geturðu opnað EWS? Vandamálið er leyst. Athugun hvort tenging við netkerfi sé virk. Ef tengingin virkar ekki skaltu hafa samband við kerfisstjórann þinn. Fara í EWS. Geturðu opnað EWS? Vandamálið er leyst. Vertu viss um að tengingar á köplum við prentarann og prentþjóninn séu rétt tengdar. Skoðaðu skjölin sem fylgdu með prentþjóninum varðandi frekari upplýsingar. Fara í EWS. Geturðu opnað EWS? Vandamálið er leyst. Athugaðu hvort staðgengilsþjónar (proxy) séu óvirkir. Ef þjónarnir eru óvirkir skaltu hafa samband við kerfisstjórann þinn. Fara í EWS. Geturðu opnað EWS? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . get ekki opnað innfelldan vefþjón bilanaleit get ekki opnað innfelldan vefþjón"},{"UUID":"7cf503b4-ee8f-4534-8094-1c76252c0a26","title":"Vandamál við nettengingu","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Get ekki tengt prentarann við","descFull":"Get ekki tengt prentarann við þráðlausa netið (Wi-Fi) Skref til að leysa vandamálið Aðgerð Já Nei Vertu viss um að  Virkur tengibúnaður  sé stilltur á  Sjálfvirkt . Á heimaskjánum, snertu  Stillingar Netkerfi/tengi Yfirlit netkerfis Virkur tengibúnaður Sjálfvirkt . Getur prentarinn tengst við þráðlaust netkerfi (Wi‑Fi)? Vandamálið er leyst. Athugaðu hvort rétt Wi‑Fi net sé valið. Sumir beinar geta deilt sjálfvöldu SSID. Ertu að reyna að tengjast réttu Wi‑Fi neti? Farðu í skref 4. Tengstu við rétt þráðlaust net (Wi-Fi). Varðandi frekari upplýsingar, sjá  . Getur prentarinn tengst við þráðlaust netkerfi (Wi‑Fi)? Vandamálið er leyst. Athugaði öryggisstillingu þráðlausrar tengingar Frá heimaskjánum, snertu  Stillingar Netkerfi/tengi Þráðlaust Öryggisstilling þráðlausrar tengingar . Er rétt öryggisstilling þráðlausrar tengingar valin? Farðu í skref 6. Veldu rétta öryggisstillingu fyrir þráðlausa tengingu. Getur prentarinn tengst við þráðlaust netkerfi (Wi‑Fi)? Vandamálið er leyst. Vertu viss um að þú hafir skráð rétt aðgangsorð fyrir netið. Skrifaðu hjá þér millibil, tölur og upphafsstafi í aðgangsorðinu. Getur prentarinn tengst við þráðlaust netkerfi (Wi‑Fi)? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . get ekki tengt prentara við þráðlaust net (Wi‑Fi) bilanaleit get ekki tengt prentara við þráðlaust net (Wi‑Fi)"},{"UUID":"c6b188dd-84be-4cfa-b680-44f36135ecb0","title":"Vandamál varðandi valkosti vélbúnaðar","link":"trb-cannot-detect-internal-option-topic.html","desc":"Getur ekki uppgötvað innri valkost","descFull":"Getur ekki uppgötvað innri valkost Skref til að leysa vandamálið Aðgerð Já Nei Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Er prentarinn að uppgötva innri valkosti? Vandamálið er leyst. Prentaðu síður valmyndar fyrir stillingar og athugaðu hvort innri valkostur birtist á lista yfir uppsetta eiginleika. Er innri valkostur á listanum? Farðu í skref 4. Athugaðu hvort innri valkostur er rétt uppsettur á stýrispjaldinu. Slökktu á prentaranum og taktu síðan rafmagnssnúruna úr sambandi við rafmagn. Vertu viss um að innri valkostur sé uppsettur í viðeigandi tengi á stýrispjaldinu. Tengdu straumsnúruna við rafmagnsinnstunguna og kveiktu síðan á prentaranum. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Er prentarinn að uppgötva innri valkosti? Vandamálið er leyst. Athugaðu hvort innri valkostur sé tiltækur í rekli prentarans. Ef þörf krefur, bættu innri valkosti handvirkt inn í prentararekilinn til að gera hann tiltækan fyrir prentverk. Varðandi frekari upplýsingar, sjá  . Prentaðu skjalið. Er prentarinn að uppgötva innri valkosti? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit, valkostir prentara getur ekki uppgötvað innri valkost villuleit valkosta prentara getur ekki uppgötvað innri valkost innri valkostur ekki uppgötvaður"},{"UUID":"4bc8051d-4b2e-413a-9df0-79e53b3c1510","title":"Vandamál varðandi valkosti vélbúnaðar","link":"trb-cannot-detect-internal-option-topic.html","desc":"Bilað minniskort uppgötvað Reyndu eitt","descFull":"Bilað minniskort uppgötvað Reyndu eitt eða fleira af eftirfarandi: Skiptu út skynvædda geymsludrifinu. Á heimaskjánum, snertu  Halda áfram  til að hunsa skilaboðin og halda áfram að prenta. Hætta við núverandi verk í prentun. skilaboð prentara Bilað minniskort uppgötvað bilað skynvætt geymsludrif"},{"UUID":"fd96586a-9e0e-45a6-967a-b6766567de64","title":"Vandamál varðandi valkosti vélbúnaðar","link":"trb-cannot-detect-internal-option-topic.html","desc":"Ekki nægilegt pláss á minniskorti","descFull":"Ekki nægilegt pláss á minniskorti fyrir tilföng Reyndu eitt eða fleira af eftirfarandi: Snertu  Halda áfram  til að hreinsa skilaboðin og halda áfram að prenta. Eyða leturgerðum, fjölvum og öðrum gögnum á minniskortinu. Settu harðan disk á sinn stað. Niðurhlöðnum leturtegundum og fjölvum sem eru ekki áður vistuð á minniskorti er eytt. skilaboð prentara Ekki nægilegt pláss á minniskorti fyrir tilföng Ekki nægilegt pláss á minniskorti fyrir tilföng"},{"UUID":"08504cfc-6f5e-48af-8a11-36d07a9b227c","title":"Vandamál varðandi rekstarvörur","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Blekhylki vantar eða svarar ekki","descFull":"Blekhylki vantar eða svarar ekki Skref til að leysa vandamálið Aðgerð Já Nei Opnaðu hurð að framan. Fjarlægðu blekhylkið og settu inn aftur. Vantar blekhylkið eða svarar það ekki? Vandamálið er leyst. Athugaðu hvort prentarinn er að nota ekta blekhylki frá Lexmark eða hylki sem er stutt. Athugaðu hvort prentarinn er að nota ekta blekhylki eða hylki sem er stutt. Ef blekhylkið er ekki stutt, settu í hylki sem er stutt. Vantar blekhylkið eða svarar það ekki? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. bilanaleit, aðföng blekhylki vantar eða svarar ekki blekhylki vantar eða svarar ekki bilanaleit fyrir aðföng blekhylki vantar eða svarar ekki"},{"UUID":"57407ce2-e544-412b-8d29-bb997621bfae","title":"Vandamál varðandi rekstarvörur","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Rekstrarvara sem er ekki frá","descFull":"Rekstrarvara sem er ekki frá Lexmark Rekstrarvara sem er ekki frá Dell Rekstrarvara sem er ekki frá framleiðanda prentara Prentarinn hefur uppgötvað rekstrarvöru eða hlut sem er ekki frá Lexmark sem er uppsettur í prentaranum. Prentarinn hefur uppgötvað rekstrarvöru eða hlut sem er ekki frá Dell sem er uppsettur í prentaranum. Prentarinn hefur uppgötvað óþekkta rekstrarvöru eða hlut sem er uppsettur í prentaranum. Lexmark prentarinn þinn er hannaður til að virka best með upprunalegum rekstrarvörum og hlutum frá Lexmark. Notkun á rekstrarvörum eða hlutum frá þriðja aðila getur haft áhrif á afköst, áreiðanleika eða endingu prentarans og myndeiningar hans. Dell-prentarinn þinn er hannaður til að virka best með upprunalegum rekstrarvörum og hlutum frá Dell. Notkun á rekstrarvörum eða hlutum frá þriðja aðila getur haft áhrif á afköst, áreiðanleika eða endingu prentarans og myndeiningar hans. Prentarinn þinn er hannaður til að virka best með upprunalegri rekstrarvöru og hlutum eru framleiddir af framleiðanda prentarans. Notkun á rekstrarvörum eða hlutum frá þriðja aðila getur haft áhrif á afköst, áreiðanleika eða endingu prentarans og myndeiningar hans. Allar vísanir á endingu eru hannaðar til að virka með rekstrarvörum eða hlutum frá Lexmark og geta því gefið ónákvæmar niðurstöður ef rekstrarvörur eða hlutir frá þriðja aðila eru notaðir. Notkun á hlutum myndeiningar umfram ætlaða endingu geta skaðað Lexmark-prentarann þinn eða tengda hluti. Allar vísanir á endingu eru hannaðar til að virka með rekstrarvörum eða hlutum frá Dell og geta því gefið ónákvæmar niðurstöður ef rekstrarvörur eða hlutir frá þriðja aðila eru notaðir. Notkun á hlutum myndeiningar umfram ætlaða endingu geta skaðað Dell-prentarann þinn eða tengda hluti. Allar vísanir á endingu eru hannaðar til að virka með rekstrarvörum eða hlutum frá framleiðanda prentarans og geta því gefið ónákvæmar niðurstöður ef rekstrarvörur eða hlutir frá þriðja aðila eru notaðir. Notkun á hlutum myndeiningar umfram ætlaða endingu geta skaðað prentarann þinn eða tengda hluti. Notkun á rekstrarvörum eða hlutum frá þriðja aðila getur haft áhrif á ábyrgð. Ábyrgðin nær ekki yfir skemmdir vegna notkunar á rekstrarvörum eða hlutum frá þriðja aðila. Til að samþykkja þessa áhættu og að halda áfram með notkun á rekstrarvörum eða hlutum frá öðrum aðila í prentaranum, ýttu á og haltu villuboðum á skjá prentarans með tveimur fingrum í 15 sekúndur. Þegar staðfestingargluggi birtist skaltu snerta  Halda áfram . Ef þú vilt ekki samþykkja þessa áhættu, fjarlægðu þá rekstrarvöru eða hlut frá þriðja aðila úr prentaranum þínum, og settu síðan ósvikna rekstrarvöru eða hlut frá Lexmark í staðinn. Varðandi frekari upplýsingar, sjá  . Ef þú vilt ekki samþykkja þessa áhættu, fjarlægðu þá rekstrarvöru eða hlut frá þriðja aðila úr prentaranum þínum, og settu síðan ósvikna rekstrarvöru eða hlut frá Dell í staðinn. Ef þú vilt ekki samþykkja þessa áhættu, fjarlægðu rekstrarvöru eða hlut þriðja aðila úr prentaranum og settu ekta rekstrarvöru eða hlut frá framleiðanda prentarans. Ef prentarinn prentar ekki eftir að villuboð hafa verið hreinsuð, endurstilltu þá teljara notkunar rekstrarvöru. Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Notkun rekstrarvöru og teljarar . Veldu hlut eða rekstrarvöru sem þú vilt endurstilla og snertu síðan  Start . Lestu viðvörunarskilaboðin og snertu síðan  Halda áfram . Notaðu tvo fingur og snertu skjáinn í 15 sekúndur til að hreinsa skilaboðin. Ef þú getur ekki endurstillt teljara notkunar á rekstrarvöru, skilaðu hlut rekstrarvöru til þess staðar sem hann var keyptur á. skilaboð prentara Rekstrarvörur ekki frá Lexmark Rekstrarvörur ekki frá Lexmark skilaboð prentara Rekstrarvörur ekki frá Dell Rekstrarvörur ekki frá Dell skilaboð prentara Rekstrarvörur ekki frá framleiðanda prentara Rekstrarvörur ekki frá framleiðanda prentara endurstilla teljarar notkunar rekstrarvöru teljarar notkunar rekstrarvöru endurstilla endurstilla teljara notkunar rekstrarvöru"},{"UUID":"f26a25e1-aea0-44b7-9af4-1b7a64225c9a","title":"Vandamál við mötun pappírs","link":"trb-envelope-seals-when-printing-topic.html","desc":"Umslag lokast við prentun Skref","descFull":"Umslag lokast við prentun Skref til að leysa vandamálið Aðgerð Já Nei Nota umslög sem hafa verið geymd í þurru umhverfi. Prentun á umslög með miklu rakainnihaldi getur lokað flipanum. Sendu verkið sem á að prenta. Lokast umslagið við prentun? Vandamálið er leyst. Vertu viss um að gerð pappírs sé stillt á Umslag. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Sendu verkið sem á að prenta. Lokast umslagið við prentun? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, prentun umslag lokast við prentun villuleit prentunar umslag lokast við prentun umslag lokast við prentun"},{"UUID":"c06f30af-1cca-41d4-b9a4-e3c976354c3d","title":"Vandamál við mötun pappírs","link":"trb-envelope-seals-when-printing-topic.html","desc":"Prentun með samröðun virkar ekki","descFull":"Prentun með samröðun virkar ekki Skref til að leysa vandamálið Aðgerð Já Nei Frá heimaskjánum, snertu  Stillingar Prenta Útlit Samröðun . Snertu  Kveikt [1,2,1,2,1,2] . Prentaðu skjalið. Er skjalinu raðað rétt? Vandamálið er leyst. Opnaðu gluggann Prentsamskipti úr því skjali sem þú ert að reyna að prenta og veldu síðan  Samraða . Prentaðu skjalið. Er skjalinu raðað rétt? Vandamálið er leyst. Fækkaðu fjölda á síðum sem á að prenta. Prentaðu skjalið. Er síðunum raðað rétt saman? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit prentunar prentun með samröðun virkar ekki villuleit, prentun prentun með samröðun virkar ekki prentun með samröðun virkar ekki"},{"UUID":"0317e0cc-3f6e-4534-ad56-54b2ae1a49d7","title":"Vandamál við mötun pappírs","link":"trb-envelope-seals-when-printing-topic.html","desc":"Tenging á skúffum virkar ekki","descFull":"Tenging á skúffum virkar ekki Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu hvort skúffur séu með sömu pappírsstærð og gerð pappírs. Athugaðu hvort stýringar séu rétt staðsettar. Prentaðu skjalið. Tengjast skúffurnar rétt? Vandamálið er leyst. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Stillið stærð pappírs og gerð til að samsvara pappírnum sem hlaðið er í tengdu skúffurnar. Prentaðu skjalið. Tengjast skúffurnar rétt? Vandamálið er leyst. Vertu viss um að  Tenging á skúffum  sé stillt á  Sjálfvirkt . Varðandi frekari upplýsingar, sjá  . Prentaðu skjalið. Tengjast skúffurnar rétt? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit, prentun tenging á skúffum virkar ekki villuleit prentunar tenging á skúffum virkar ekki"},{"UUID":"a603fd64-359e-4fdb-8084-054b1dc5ac6e","title":"Vandamál við mötun pappírs","link":"trb-envelope-seals-when-printing-topic.html","desc":"Pappír flækist oft Skref til","descFull":"Pappír flækist oft Skref til að leysa vandamálið Aðgerð Já Nei Fjarlægðu skúffuna. Athugaðu hvort pappír sé hlaðið rétt. Vertu viss um að pappírsstýringar séu rétt staðsettar. Vertu viss um að hæð á stafla sé fyrir neðan vísun á hámarksfyllingu. Vertu viss um að prenta á meðmælta stærð og gerð pappírs. Settu skúffuna inn. Prentaðu skjalið. Eiga pappírsflækjur sér stað oft? Vandamálið er leyst. Frá heimaskjánum, snertu  Stillingar Pappír Uppsetning skúffu Pappírsstærð/gerð . Stilltu rétta stærð og gerð af pappír. Prentaðu skjalið. Eiga pappírsflækjur sér stað oft? Vandamálið er leyst. Settu í pappír úr nýjum pakka. Pappírinn dregur til sín raka vegna þess að rakastig er hátt. Geymdu pappír í upphaflegum umbúðum þar til það á að nota hann. Prentaðu skjalið. Eiga pappírsflækjur sér stað oft? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, prentun pappír flækist oft villuleit prentunar pappír flækist oft pappír flækist oft"},{"UUID":"05983b25-472d-4a73-8087-01f163b28100","title":"Vandamál við mötun pappírs","link":"trb-envelope-seals-when-printing-topic.html","desc":"Síður sem flækjast eru ekki","descFull":"Síður sem flækjast eru ekki endurprentaðar Skref til að leysa vandamálið Aðgerð Já Nei Frá heimaskjánum, veldu  Stillingar Tæki Tilkynningar Endurheimta innihald við flækju . Í valmynd fyrir endurheimtu flækju, snertu  Kveikt  eða  Sjálfvirkt . Prentaðu skjalið. Eru flæktar síður endurprentaðar? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit, prentun síður sem flækjast eru ekki endurprentaðar síður sem flækjast eru ekki endurprentaðar"},{"UUID":"ccfc6fac-1771-401d-be53-dbb21b3d7a38","title":"Vandamál við sendingu tölvupósts","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Gera villuboð „SMTP-þjónn ekki uppsettur“","descFull":"Gera villuboð „SMTP-þjónn ekki uppsettur“ óvirk. Frá heimaskjánum, snertu  Stillingar Tölvupóstur Uppsetning tölvupósts  Gera villu „SMTP-þjónn ekki uppsettur“ óvirka Kveikt . Til að koma í veg fyrir að villan endurtaki sig skaltu gera eitt eða fleiri af eftirfarandi: Uppfæra fastbúnað prentarans. Varðandi frekari upplýsingar, sjá  . Stilla SMTP stillingar tölvupósts Varðandi frekari upplýsingar, sjá  . Villa SMTP-þjónn ekki uppsettur gera óvirkt bilanaleit Villa SMTP-þjónn ekki uppsettur gera villu SMTP-þjónn ekki uppsettur óvirka"},{"UUID":"e616bbe5-89cd-4380-86b6-1681e5a08047","title":"Vandamál við sendingu tölvupósts","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Get ekki sent tölvupósta Skref","descFull":"Get ekki sent tölvupósta Skref til að leysa vandamálið Aðgerð Já Nei Veru viss um að SMTP-stillingar tölvupósts séu rétt stilltar. Varðandi frekari upplýsingar, sjá  . Getur þú sent tölvupóst? Vandamálið er leyst. Gangtu úr skugga aum að þú sért að nota rétt aðgangsorð. Notaðu lykilorð reikningsins þíns, lykilorð forritsins eða auðkenningarlykilorð, en þetta fer eftir veitu tölvupósts. Varðandi frekari upplýsingar, sjá  . Getur þú sent tölvupóst? Vandamálið er leyst. Gangtu úr skugga um að prentarinn sé tengdur við netkerfi og að netið sé tengt internetinu. Getur þú sent tölvupóst? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit tölvupósts get ekki sent tölvupósta villuleit, tölvupóstur get ekki sent tölvupósta get ekki sent tölvupósta"},{"UUID":"9e579c7e-b478-4e59-8497-ce5ee4dd8ca9","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Auðkenni þess sem hringir sést","descFull":"Auðkenni þess sem hringir sést ekki Þessar leiðbeiningar eiga aðeins við prentara sem styðja hliðstætt fax. Frekari upplýsingar má sjá í kaflanum  Setja upp prentarann fyrir fax . Skref til að leysa vandamálið Aðgerð Já Nei Virkja símanúmerabirti. Frá heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Móttökustillingar á faxi Stillingar stjórnanda Virkja símanúmerabirti . Birtist auðkenni þess sem hringir? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit, fax auðkenni þess sem hringir sést ekki villuleit fax auðkenni þess sem hringir sést ekki auðkenni þess sem hringir sést ekki"},{"UUID":"571604ca-e5cc-46df-a556-6cacdfe23034","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Get ekki sent eða tekið","descFull":"Get ekki sent eða tekið á móti föxum með því að nota hliðrænt fax Skref til að leysa vandamálið Aðgerð Já Nei Leystu úr villuboðum sem birtast á skjánum. Getur þú sent eða tekið á móti faxi? Vandamálið er leyst. Vertu viss um að tengingar fyrir eftirfarandi búnað séu örugglega tengdar: Síma Símtól Símsvara Getur þú sent eða tekið á móti faxi? Vandamálið er leyst. Hlustaðu eftir hringisón. Hringdu í faxnúmerið til að vera viss um að það virki rétt. Ef þú ert að nota eiginleikann Lagt á, þá á að hækka hljóðstigið til að athuga hvort þú heyrir hringitón. Heyrir þú hringitón? Farðu í skref 5. Athugið veggtengil símans. Tengdu hliðrænan síma beint í veggtengilinn. Hlustið eftir hringisón. Ef hringisónn heyrist ekki, notaðu þá aðra símasnúru. Ef hringisónn heyrist ekki ennþá, tengdi hliðrænan síma í annan veggtengil. Ef þú heyrir hringisón, tengdu þá prentarann við þann veggtengil. Getur þú sent eða tekið á móti faxi? Vandamálið er leyst. Athugaðu hvort prentarinn er tengdur við hliðræna símaþjónustu eða rétta stafræna tengið. Ef þú notar símaþjónustu með samþætta þjónustu fyrir stafrænt net (ISDN) tengdu þá við hliðstætt símatengi á ISDN-tengi. Hafðu samband við þína ISDN-veitu varðandi frekari upplýsingar. Ef þú ert að nota DSL, tengdu þá DSL-síu eða beini sem styður hliðræna notkun. Hafðu samband við þína DSL-veitu varðandi frekari upplýsingar. Ef þú ert að nota PBX-símaþjónustu, vertu viss um að þú sért tengdur við hliðrænt tengi á PBX. Ef ekki til staðar, íhugaðu að koma upp hliðrænni símalínu fyrir faxtækið. Getur þú sent eða tekið á móti faxi? Vandamálið er leyst. Aftengdu tímabundið annan búnað og gerðu aðra símaþjónustu óvirka. Aftengdu annan búnað (eins og símsvara, tölvur, mótöld eða símalínur) milli prentarans og símalínu. Gerðu símtal í bið og talhólf óvirk. Hafðu samband við símafyrirtækið þitt varðandi frekari upplýsingar. Getur þú sent eða tekið á móti faxi? Vandamálið er leyst. Skannaðu upphaflega skjalið, eina síðu í einu. Hringdu í faxnúmerið. Skannaðu skjalið. Getur þú sent eða tekið á móti faxi? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit fax get ekki sent eða tekið á móti föxum með því að nota hliðrænt fax villuleit, fax get ekki sent eða tekið á móti föxum með því að nota hliðrænt fax get ekki sent eða tekið á móti föxum með því að nota hliðrænt fax"},{"UUID":"94655167-ef94-44cf-b6e1-3c107f09cb4b","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Get tekið á móti en","descFull":"Get tekið á móti en ekki sent föx með því að nota hliðrænt fax Skref til að leysa vandamálið Aðgerð Já Nei Settu upprunalegt skjal rétt í sjálfvirka matarann eða á gler skannans. Getur þú sent fax? Vandamálið er leyst. Setja upp númer á flýtivísi á réttan hátt. Athugaðu hvort búið er að setja upp númer fyrir flýtivísi á símanúmer sem þú vilt nota til hringingar. Hringdu handvirkt í símanúmerið. Getur þú sent fax? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Setja upp númer á flýtivísi á réttan hátt. Athugaðu hvort búið er að setja upp númer fyrir flýtivísi á símanúmer sem þú vilt nota til hringingar. Hringdu handvirkt í símanúmerið. Getur þú sent fax? Vandamálið er leyst. Hafa samband við  tæknistuðning . villuleit fax get ekki sent föx með því að nota hliðrænt fax villuleit, fax get ekki sent föx með því að nota hliðrænt fax"},{"UUID":"18dcafbc-b0cb-419f-98f7-d01c0d27c0c2","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Get sent en ekki tekið","descFull":"Get sent en ekki tekið á móti föxum með því að nota hliðrænt fax Skref til að leysa vandamálið Aðgerð Já Nei Vertu viss um að uppruni pappírs sé ekki tómur. Geturðu tekið á móti faxi? Vandamálið er leyst. Athuga biðstillingar á fjölda hringinga. Frá heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Móttökustillingar á faxi Hringingar fyrir svörun . Geturðu tekið á móti faxi? Vandamálið er leyst. Ef prentarinn er að prenta auðar síður, skoðaðu þá  . Geturðu tekið á móti faxi? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit fax get sent en ekki tekið á móti föxum með því að nota hliðrænt fax villuleit, fax get sent en ekki tekið á móti föxum með því að nota hliðrænt fax get ekki tekið á móti föxum með því að nota hliðrænt fax"},{"UUID":"9be9b854-615e-4f8b-af1d-8cdb38f95803","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Get ekki sett upp etherFAX","descFull":"Get ekki sett upp etherFAX Skref til að leysa vandamálið Aðgerð Já Nei Athuga tengingar prentarans. Prenta  uppsetningarsíðu netkerfis . Frá heimaskjánum, snertu  Stillingar Skýrslur Netkerfi Uppsetningarsíða netkerfis . Athuga stöðu netkerfis prentarans Er prentarinn tengdur við netkerfið? Farðu í skref 3. Gangtu úr skugga um að prentarinn sé tengdur við netkerfi og að netið sé tengt internetinu. Getur þú sett upp etherFAX? Vandamálið er leyst. Gangtu úr skugga um að etherFAX sé sett rétt upp. Varðandi frekari upplýsingar, sjá  . Getur þú sett upp etherFAX? Vandamálið er leyst. Farðu á  https://www.etherfax.net/lexmark . villuleit fax get ekki sett upp etherFAX villuleit, fax get ekki sett upp etherFAX"},{"UUID":"5ab775cf-d6a4-4fb8-ae44-dbdce677a816","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Get ekki sent eða tekið","descFull":"Get ekki sent eða tekið á móti föxum með því að nota etherFAX Skref til að leysa vandamálið Aðgerð Já Nei Gangtu úr skugga um að prentarinn sé tengdur við netkerfi og að netið sé tengt internetinu. Geturðu sent eða tekið á móti föxum með því að nota etherFAX? Vandamálið er leyst. Gangtu úr skugga um að etherFAX sé sett rétt upp. Af heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Almennar stillingar á faxi . Vertu viss um að þú sért með rétt faxnúmer. Vertu viss um að  Flutningur á faxi  sé stillt á  etherFAX . Þessi valmynd birtist aðeins þegar fleiri en einn faxflutningur er tiltækur. Ef aðeins etherFAX er uppsett á prentaranum er það sjálfkrafa stillt. Geturðu sent eða tekið á móti föxum með því að nota etherFAX? Vandamálið er leyst. Skiptu stórum skjölum í minni skráarstærðir. Geturðu sent eða tekið á móti föxum með því að nota etherFAX? Vandamálið er leyst. Farðu á  https://www.etherfax.net/lexmark . villuleit fax get ekki sent eða tekið á móti föxum með því að nota etherFAX villuleit, fax get ekki sent eða tekið á móti föxum með því að nota etherFAX get ekki sent eða tekið á móti föxum með því að nota etherFAX"},{"UUID":"9d934805-3604-449e-a109-2d015afff24c","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Léleg prentgæði símbréfs Skref til","descFull":"Léleg prentgæði símbréfs Skref til að leysa vandamálið Aðgerð Já Nei Ganga úr skugga um að það séu engir gallar í prentgæðum. Frá heimaskjánum, snertu  Stillingar Bilanaleit Prenta gæðaprófunarsíður . Leiðréttu alla galla í prentgæðum. Varðandi frekari upplýsingar, sjá  . Eru prentgæði á faxi ásættanleg? Vandamálið er leyst. Ef þú ert að nota hliðrænt fax skaltu minnka sendingarhraða á mótteknu faxi. Frá heimaskjánum, snertu  Stillingar Fax Uppsetning á faxi Móttökustillingar á faxi Stillingar stjórnanda . Veldu minni sendingarhraða í valmynd fyrir hámarkshraða. Eru prentgæði á faxi ásættanleg? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit fax léleg prentgæði léleg prentgæði á faxi villuleit, fax léleg prentgæði"},{"UUID":"b42587ae-0a95-45c2-a38b-5c5d1135a5ae","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Upplýsingar vantar á forsíðu á","descFull":"Upplýsingar vantar á forsíðu á faxi Skref til að leysa vandamálið Aðgerð Nei Já Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu á honum aftur. Senda eða taka á móti faxi. Vantar upplýsingar á forsíðu á faxi? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit fax upplýsingar vantar á forsíðu á faxi villuleit, fax upplýsingar vantar á forsíðu á faxi upplýsingar vantar á forsíðu á faxi"},{"UUID":"f99b79b9-472b-43cf-95a4-5b12e047db38","title":"Vandamál við faxsendingu","link":"trb-caller-id-not-shown-topic.html","desc":"Get ekki sent forsíðu á","descFull":"Get ekki sent forsíðu á faxi frá tölvunni Skref til að leysa vandamálið Aðgerð Já Nei Gangtu úr skugga um að prentrekill sé uppfærður. Varðandi frekari upplýsingar, sjá  . Sendu faxið. Getur þú sent forsíðu á faxi? Vandamálið er leyst. Opnaðu samskipti  Prienta  úr því skjali sem þú ert að reyna að faxa. Veldu prentarann og smelltu síðan á  Eiginleikar ,  Kjörstillingar ,  Valkostir , eða  Uppsetning . Smelltu á  Fax , og hreinsaðu stillinguuna  Alltaf að sýna stillingar áður en fax er sent . Sendu faxið. Getur þú sent forsíðu á faxi? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit fax get ekki sent forsíðu á faxi frá tölvunni villuleit, fax get ekki sent forsíðu á faxi frá tölvunni get ekki sent forsíðu á faxi frá tölvunni"},{"UUID":"c5a0edfd-8d31-4dff-8f4d-5a9ac16388c6","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Get ekki skannað til tölvu","descFull":"Get ekki skannað til tölvu Skref til að leysa vandamálið Aðgerð Já Nei Framkvæma verk í afritun. Heppnaðist verk í afritun? Farðu í skref 3. Slökktu á prentaranum, bíddu síðan í um það bil 10 sekúndur, og kveiktu síðan á honum aftur. Skannaðu skjalið. Getur þú skannað skjal til tölvu? Vandamálið er leyst. Athuga tengingar prentarans. Prenta  uppsetningarsíðu netkerfis . Frá heimaskjánum, snertu  Stillingar Skýrslur Netkerfi Uppsetningarsíða netkerfis . Athuga stöðu netkerfis prentarans Er prentarinn tengdur við netkerfið? Farðu í skref 5. Tengja prentarann við netkerfið. Skannaðu skjalið. Getur þú skannað skjal til tölvu? Vandamálið er leyst. Vertu viss um að prentarinn og tölvan séu tengd við sama netkerfið. Skannaðu skjalið. Getur þú skannað skjal til tölvu? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . villuleit við skönnun get ekki skannað til tölvu villuleit, skönnun get ekki skannað til tölvu get ekki skannað til tölvu"},{"UUID":"c75a6d19-5a92-47c7-992e-7324de062acd","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Get ekki skannað til möppu","descFull":"Get ekki skannað til möppu á netinu Skref til að leysa vandamálið Aðgerð Já Nei Búa til flýtivísi fyrir möppu netkerfis Skanna skjal með því að nota flýtivísi. Varðandi frekari upplýsingar, sjá  . Getur þú skannað skjal og vistað það í möppu í netkerfi? Vandamálið er leyst. Gangtu úr skugga um að vefslóð að möppu netkerfis og snið séu rétt. Til dæmis,  // netþjónn_hýsisheiti /heitimöppu/slóð , þar sem  netþjónn_hýsisheiti  er fullgilt lén (FQDN) eða IP-tala. Er vefslóð möppu netkerfis og snið rétt? Farðu í skref 4. Gakktu úr skugga um að þú hafir heimild til skrifaðgangs að netmöppunni. Getur þú skannað skjal og vistað það í möppu í netkerfi? Vandamálið er leyst. Uppfæra flýtivísi að möppu netkerfis. Opnaðu vafra og skráðu IP-tölu prentarans í svæði vistfangs. Skoða IP-tölu prentara á heimaskjánum. IP-talan birtist sem fjögur sett af tölum sem eru aðskildar af punktum, svo sem 123.123.123.123. Ef verið er að nota staðgengilsþjón (proxy), gerðu hann óvirkan tímabundið til að opna vefsíðuna rétt. Smelltu á  Flýtivísar , og veldu síðan flýtivísi. Ef þú ert með margar gerðir flýtivísa, veldu þá  Möppu netkerfis . Í svæði  Slóð deilingar  skráðu vefslóð að möppu netkerfis. E þín slóð deilingar er  \\\\netþjónn_hýsisheiti\\heitimöppu\\slóð , skráðu þá  //netþjónn_hýsisheiti/heitimöppu/slóð . Gakktu úr skugga um að þú notir skástrik hallandi fram þegar þú slærð inn slóð deilingar. Frá valmynd  Sannvottun  veldu aðferð sannvottunar. Ef  Sannvottun  er stillt á „ Nota úthlutað notendanafn og aðgangsorð “ skráðu þá skilríkin þín í svæðin  Notendanafn  og  Aðgangsorð . Smelltu á  Vista . Getur þú skannað skjal og vistað það í möppu í netkerfi? Vandamálið er leyst. Vertu viss um að prentarinn og mappa netkerfis séu tengd við sama netkerfið. Getur þú skannað skjal og vistað það í möppu í netkerfi? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . get ekki skannað í möppu á netinu villuleit, skönnun get ekki skannað í möppu á netinu villuleit við skönnun get ekki skannað í möppu á netinu"},{"UUID":"355fe111-2485-4f47-bf30-77321b7bcf60","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Afrit að hluta af skjali","descFull":"Afrit að hluta af skjali eða mynd Skref til að leysa vandamálið Aðgerð Já Nei Vertu viss um að skjalið eða myndin sé sett snúandi niður í efra vinstra horni á gleri skannans. Afrita skjalið eða ljósmynd. Afritaðist skjalið eða mynd rétt? Vandamálið er leyst. Stilltu samsvarandi stærð á pappír og á pappírnum sem var hlaðið í skúffuna. Afrita skjalið eða ljósmynd. Afritaðist skjalið eða mynd rétt? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Stilltu samsvarandi stærð á pappír og á pappírnum sem var hlaðið í skúffuna. Afrita skjalið eða ljósmynd. Afritaðist skjalið eða mynd rétt? Vandamálið er leyst. Hafðu samband við  tæknistuðning . villuleit, afrit afrit að hluta af skjölum eða myndum afrit villuleit afrit að hluta af skjölum eða myndum villuleit, skönnun afrit að hluta af skjölum eða myndum villuleit við skönnun afrit að hluta af skjölum eða myndum"},{"UUID":"49088f27-6b5c-4662-a17b-294e9bcc18d0","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Léleg gæði á afriti Skref","descFull":"Léleg gæði á afriti Skref til að leysa vandamálið Aðgerð Já Nei Hreinsaðu gler á skanna og gler á sjálfvirkum matara með rökum, lófríum klút. Ef prentarinn þinn er með annað gler á sjálfvirkum matara inni í mataranum, þá skal einnig hreinsa þetta gler. Varðandi frekari upplýsingar, sjá  . Vertu viss um að skjalið eða myndin sé sett snúandi niður í efra vinstra horni á gleri skannans. Afritaðu skjalið eða myndina. Eru gæði afritsins ásættanleg? Vandamálið er leyst. Athugaðu gæðin á upprunalega skjalinu eða myndinni. Stilltu gæðastillingar skönnunar. Afritaðu skjalið eða myndina. Eru gæði afritsins ásættanleg? Vandamálið er leyst. Hafa samband  stuðning viðskiptavina . Athugaðu gæðin á upprunalega skjalinu eða myndinni. Stilltu gæðastillingar skönnunar. Afritaðu skjalið eða myndina. Eru gæði afritsins ásættanleg? Vandamálið er leyst. Hafa samband  tæknistuðning . afrit villuleit léleg gæði á afriti villuleit, afrit léleg gæði á afriti villuleit við skönnun léleg gæði á afriti villuleit, skönnun léleg gæði á afriti"},{"UUID":"b3b0b2f9-6f43-4000-b4d0-18d2a00f7c51","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Lóðréttar dökkar rákir þegar skannað","descFull":"Lóðréttar dökkar rákir þegar skannað er frá sjálfvirkum matara Skref til að leysa vandamálið Aðgerð Já Nei Opnaðu lokið á skannanum. Notaðu rakan, mjúkan og lófrían klút og þurrkaðu glerið og púðann í sjálfvirka mataranum. Lokaðu loki á skannanum. Skannaðu skjalið. Sjást lóðréttar rákir á skönnuðum skjölum? Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . Vandamálið er leyst. villuleit, skönnun lóðréttar dökkar rákir þegar skannað er frá sjálfvirkum matara villuleit við skönnun lóðréttar dökkar rákir þegar skannað er frá sjálfvirkum matara lóðréttar dökkar rákir þegar skannað er frá sjálfvirkum matara gæðavandamál við skönnun"},{"UUID":"2935173f-64e2-4bc8-9454-9bb02bbc43e4","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skörðótt mynd eða texti við","descFull":"Skörðótt mynd eða texti við skönnun frá sjálfvirka mataranum Skref til að leysa vandamálið Aðgerð Já Nei Settu 50 blöð af hreinum, venjulegum pappír í sjálfvirka matarann. Venjulegur pappír hjálpar til við að hreinsa eða fjarlægja ryk og aðra húðun af færslurúllum sjálfvirks matara. Frá heimaskjá, snertu  . Settu upphaflegt skjal í sjálfvirka matarann. Skannaðu skjalið. Birtast skörðóttar myndir eða textar á úttakinu? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit, skönnun skörðótt mynd við skönnun frá sjálfvirka mataranum villuleit, skönnun skörðóttur texti við skönnun frá sjálfvirka mataranum villuleit við skönnun skörðótt mynd við skönnun frá sjálfvirka mataranum villuleit við skönnun skörðóttur texti við skönnun frá sjálfvirka mataranum skörðótt mynd skönnun frá sjálfvirka mataranum skörðóttur texti skönnun frá sjálfvirka mataranum skönnun frá sjálvirkum matara skörðótt mynd skönnun frá sjálvirkum matara skörðóttur texti"},{"UUID":"31a5f93b-e99a-4964-8f02-bf68407fc5aa","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Verk í skönnun heppnaðist ekki","descFull":"Verk í skönnun heppnaðist ekki Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu tengingar kapla. Vertu viss um að Ethernet- eða USB-kapall sé tryggilega tengdur við tölvuna og prentarann. Endursendu verkið sem verið er að skanna. Heppnaðist verkið í skönnun? Vandamálið er leyst. Athugaðu skrána sem þú vilt skanna. Vertu viss um að skráarheitið sé ekki þegar í notkun í möppu ákvörðunarstaðar. Vertu viss um að skjalið eða myndin sem þú vilt skanna sé ekki opin í öðru forriti. Endursendu verkið sem verið er að skanna. Heppnaðist verkið í skönnun? Vandamálið er leyst. Vertu viss um að gátreitir fyrir  Breyta tímastimpli  eða  Yfirskrifa núverandi skrá  séu valdir í stillingum fyrir móttökustað. Endursendu verkið sem verið er að skanna. Heppnaðist verkið í skönnun? Vandamálið er leyst. Hafðu samband við  stuðning viðskiptavina . Vertu viss um að gátreitir fyrir  Breyta tímastimpli  eða  Yfirskrifa núverandi skrá  séu valdir í stillingum fyrir móttökustað. Endursendu verkið sem verið er að skanna. Heppnaðist verkið í skönnun? Vandamálið er leyst. Hafðu samband við  tæknistuðning . villuleit við skönnun verk í skönnun heppnaðist ekki villuleit, skönnun verk í skönnun heppnaðist ekki"},{"UUID":"b0504454-e834-48b8-9a54-f1eb9119c3d4","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skanninn lokast ekki Skref til","descFull":"Skanninn lokast ekki Skref til að leysa vandamálið Aðgerð Já Nei Fjarlægðu hindrun sem heldur loki á skanna opnu. Lokaðist lokið á skannanum rétt? Vandamálið er leyst. Hafa samband við  stuðning viðskiptavina . Hafa samband við  tæknistuðning . villuleit, afrit skanninn lokast ekki villuleit, skönnun skanninn lokast ekki skanninn lokast ekki"},{"UUID":"4428a7f7-0325-4c4a-9da2-31bb9f572d26","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skönnun tekur of langan tíma","descFull":"Skönnun tekur of langan tíma eða tölvan frýs Skref til að leysa vandamálið Aðgerð Já Nei Loka öllum forritum sem trufla skönnunina. Tekur skönnun enn of langan tíma eða frýs tölvan? Hafðu samband við  stuðning viðskiptavina . Hafðu samband við  tæknistuðning . Vandamálið er leyst. villuleit við skönnun Skönnun tekur of langan tíma villuleit við skönnun tölvan frýs við skönnun"},{"UUID":"6299a184-74af-4171-8cea-918d77f354a3","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skanninn svarar ekki Skref til","descFull":"Skanninn svarar ekki Skref til að leysa vandamálið Aðgerð Já Nei Athugaðu að rafmagnssnúran sé rétt tengd við prentarann og rafmagnsinnstungu. Til að koma í veg fyrir hættu á eldsvoða eða raflosti tengið rafmagnssnúruna við innstungu með viðeigandi getu og rétta jarðtengingu sem er nálægt vörunni og auðveldlega aðgengileg. Afrita eða skanna skjalið. Er skanninn að svara? Vandamálið er leyst. Athugun á hvort kveikt sé á prentaranum. Leystu úr villuboðum sem birtast á skjánum. Afrita eða skanna skjalið. Er skanninn að svara? Vandamálið er leyst. Slökktu á prentaranum, bíddu í um það bil 10 sekúndur, og kveiktu síðan á prentaranum aftur. Afrita eða skanna skjalið. Er skanninn að svara? Vandamálið er leyst. Hafa samband  stuðning viðskiptavina . Slökktu á prentaranum, bíddu í um það bil 10 sekúndur, og kveiktu síðan á prentaranum aftur. Afrita eða skanna skjalið. Er skanninn að svara? Vandamálið er leyst. Hafa samband  tæknistuðning . villuleit, afrit skannerinn svarar ekki afrit villuleit skannerinn svarar ekki villuleit, skönnun skannerinn svarar ekki villuleit við skönnun skannerinn svarar ekki"},{"UUID":"16d65212-dacf-4cde-8af4-d95d604c8a47","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Aðlaga stillingu á skanna Frá","descFull":"Aðlaga stillingu á skanna Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Uppsetning skanna Handvirk stilling á skanna . Frá valmynd Prenta fljótvirka prófun, snertu  Gangsetja . Settu síðu fyrir fljótvirka prófun á gler skannans, og snertu síðan  Stilling á flatskanna . Frá valmynd fyrir fljótvirka prófun afritunar, snertu  Gangsetja . Berðu saman prófunarsíðu fyrir fljótvirka afritun við upphaflega skjalið. Ef spássíur á prófunarsíðu eru frábrugðnar upphaflega skjalinu, stilltu þá vinstri spássíu og spássíu að ofan. Endurtaktu   og   þar til spássíur á prófunarsíðu fyrir fljótvirka afritun passa nálægt því við upphaflega skjalið. stillir stilling á skanna"},{"UUID":"aaf3de86-c878-4644-92db-ccf3e6c561e5","title":"Vandamál við skönnun","link":"trb-cannot-scan-to-computer-topic.html","desc":"Stilla staðsetningu sjálfvirks matara Frá","descFull":"Stilla staðsetningu sjálfvirks matara Frá heimaskjánum, snertu  Stillingar Tæki Viðhald Uppsetningarvalmynd Uppsetning skanna Handvirk stilling á skanna . Frá valmynd Prenta fljótvirka prófun, snertu  Gangsetja . Settu síðu fyrir fljótvirka prófun í bakka sjálfvirks matara. Snertu  Stilling á sjálfvirkum matara að framan  eða  Stilling á sjálfvirkum matara að aftan . Til að stilla sjálfvirkan matara að framan, settu prófunarsíðuna snúandi upp, stutta brúnin á undan í sjálfvirka matarann. Til að stilla sjálfvirkan matara að aftan, settu prófunarsíðuna snúandi niður, stutta brúnin á undan í sjálfvirka matarann. Frá valmynd fyrir fljótvirka prófun afritunar, snertu  Gangsetja . Berðu saman prófunarsíðu fyrir fljótvirka afritun við upphaflega skjalið. Ef spássíur á prófunarsíðu eru frábrugðnar upphaflega skjalinu, stilltu þá lárétta stillingu og spássíu að ofan. Endurtaktu   og   þar til spássíur á prófunarsíðu fyrir fljótvirka afritun passa nálægt því við upphaflega skjalið. Stilling sjálfvirks matara stillir stilla staðsetningu sjálfvirks matara"},{"UUID":"1bbbdbbc-590a-4c43-9d35-edbcc498e859","title":"Leysa vandamál","link":"trb-contacting-customer-support-topic.html","desc":"Hafa samband við stuðning viðskiptavina","descFull":"Hafa samband við stuðning viðskiptavina Áður en samband er haft við þjónustuver, vertu viss um að hafa eftirfarandi upplýsingar: Vandamál prentara Villuboð Gerð á prentara og raðnúmer Farðu á  http://support.lexmark.com  til að fá stuðningi í tölvupósti eða spjalli, eða fletta í safni handbóka, rekla eða öðru niðurhali. Tæknilegur stuðningur í síma er einnig tiltækur. Í Bandaríkjunum eða Kanada, hringdu í 1-800-539-6275. Í öðrum löndum eða svæðum, farðu á  http://support.lexmark.com . farðu á staðinn þar sem þú keyptir prentarann. hafa samband við stuðning viðskiptavina stuðningur viðskiptavina hafa samband"},{"UUID":"9efdc5aa-936d-48c1-bde4-8e2e6e8e93b5","title":"Leysa vandamál","link":"troubleshoot-problem-chapter.html","desc":"Hafa samband við tæknistuðning Þegar","descFull":"Hafa samband við tæknistuðning Þegar þú hefur samband við tæknistuðning, lýstu vandamálinu, skilaboðunum á prentaraskjánum og skrefunum í úrræðaleit þú hefur þegar tekið til að finna lausn. Skoðaðu miða innan í lokinu að ofan á prentaranum eða aftan á honum og skráðu hjá þér eftirfarandi: Gerð prentara Númer þjónustumerkis eða kóða fyrir hraðþjónustu Varðandi frekari upplýsingar, farðu á  www.dell.com/support . bilanaleit hafa samband við tæknistuðning hafa samband við tæknistuðning"},{"UUID":"35e0f85b-6614-4bcf-a019-9794f569e1c8","title":"Endurvinnsla og förgun","link":"recycling-lexmark-products-topic.html","desc":"Endurnýting á vörum Lexmark Til","descFull":"Endurnýting á vörum Lexmark Til að skila vörum frá Lexmark til endurnýtingar: Farðu á  www.lexmark.com/recycle . Veldur vöruna sem þú vilt endurnýta. Vörur fyrir prentara og vélbúnaður sem ekki eru skráðar í söfnunar- og endurvinnslukerfi Lexmark má endurvinna með endurvinnslustöð í þínu nágrenni. endurnýting Lexmark-vörur"},{"UUID":"a76e4a10-c6de-4830-93e2-cf7b6a66206c","title":"Endurvinnsla og förgun","link":"recycling-lexmark-packaging-topic.html","desc":"Endurvinnsla Lexmark umbúða Lexmark leitast","descFull":"Endurvinnsla Lexmark umbúða Lexmark leitast stöðugt við að lágmarka umbúðir. Minni umbúðir hjálpa til við að tryggja að Lexmark prentarar eru fluttir á sem skilvirkastan og umhverfisvænan hátt og að það er minna af umbúðum sem þarf að farga. Þessi framkvæmd leiðir til minni losunar efna, orkusparnaðar og nýtingu náttúrulegra gæða. Lexmark býður einnig upp á endurvinnslu umbúðanna í sumum löndum eða svæðum. Fyrir frekari upplýsingar farðu á  www.lexmark.com/recycle , og veldu síðan þitt land eða svæði.. Upplýsingar um tiltæk endurvinnslukerfi fylgja með upplýsingum um endurvinnslu á vöru Kassar Lexmark eru 100% endurvinnanlegir þar sem endurvinnslustöðvar bylgjupappa eru til staðar. Þessar aðstæður kunna ekki að vera til staðar á þínu svæði. Frauð sem er notað í Lexmark umbúðunum er endurvinnanlegt þar sem slíkar endurvinnslustöðvar eru. Þessar aðstæður kunna ekki að vera til staðar á þínu svæði.  Þegar þú skila prenthylki til Lexmark, getur þú endurnýtt kassann sem prenthylkið kom í. Lexmark endurvinnur kassann. endurvinnsla Umbúðir Lexmark"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"MX931 MFP"}},[_vm._v("\n    MX931 MFP\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_is","title":"&Ouml;ryggisuppl&yacute;singar"}},[_vm._v("\n    Öryggisupplýsingar\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Tilkynningar"}},[_vm._v("\n     Tilkynningar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Yfirl&yacute;singar um v&ouml;runa"}},[_vm._v("\n     Yfirlýsingar um vöruna\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learn-about-printer-chapter.html#learn-about-printer-chapter_is","title":"Fr&aelig;&eth;ast um prentarann"}},[_vm._v("\n    Fræðast um prentarann\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e170"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_is","title":"Finna uppl&yacute;singar um prentarann"}},[_vm._v("\n     Finna upplýsingar um prentarann\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_is","title":"Finna ra&eth;n&uacute;meri&eth; &aacute; prentaranum"}},[_vm._v("\n     Finna raðnúmerið á prentaranum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_is","title":"Uppsetningar prentara"}},[_vm._v("\n     Uppsetningar prentara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_is","title":"Nota stj&oacute;rnbor&eth; prentara"}},[_vm._v("\n     Nota stjórnborð prentara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_is","title":"Skilja st&ouml;&eth;una &aacute; gaumlj&oacute;sinu"}},[_vm._v("\n     Skilja stöðuna á gaumljósinu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-paper-group.html#d0e562","title":"Val &aacute; papp&iacute;r"}},[_vm._v("\n     Val á pappír\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_is","title":"Setja upp, setja inn og stilla"}},[_vm._v("\n    Setja upp, setja inn og stilla\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e3851"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_is","title":"Velja sta&eth;setningu fyrir prentarann"}},[_vm._v("\n     Velja staðsetningu fyrir prentarann\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_is","title":"Tenging &aacute; k&ouml;plum"}},[_vm._v("\n     Tenging á köplum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e4039","title":"Setja upp og nota forrit &aacute; heimaskj&aacute;num"}},[_vm._v("\n     Setja upp og nota forrit á heimaskjánum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e4656","title":"Setja upp og nota eiginleika a&eth;gengis"}},[_vm._v("\n     Setja upp og nota eiginleika aðgengis\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e4959","title":"Setja upp prentarann til a&eth; senda fax"}},[_vm._v("\n     Setja upp prentarann til að senda fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_is","title":"Setja upp SMTP stillingar t&ouml;lvup&oacute;sts"}},[_vm._v("\n     Setja upp SMTP stillingar tölvupósts\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#d0e6754","title":"Setja &iacute; papp&iacute;r og s&eacute;rstaka mi&eth;la"}},[_vm._v("\n     Setja í pappír og sérstaka miðla\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e7149","title":"Setja upp og uppf&aelig;ra hugb&uacute;na&eth;, prentrekla og fastb&uacute;na&eth;"}},[_vm._v("\n     Setja upp og uppfæra hugbúnað, prentrekla og fastbúnað\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-envelope-tray-topic.html#d0e7431","title":"Setja upp valkosti v&eacute;lb&uacute;na&eth;ar"}},[_vm._v("\n     Setja upp valkosti vélbúnaðar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"networking-intro-topic.html#d0e8103","title":"Nettenging"}},[_vm._v("\n     Nettenging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-serial-printing-topic.html#setting-up-serial-printing_is","title":"Setja upp prentun &aacute; ra&eth;tengi (a&eth;eins Windows)"}},[_vm._v("\n     Setja upp prentun á raðtengi (aðeins Windows)\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_is","title":"Gera prentarann &ouml;ruggan"}},[_vm._v("\n    Gera prentarann öruggan\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8500"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_is","title":"Finna &ouml;ryggistengi"}},[_vm._v("\n     Finna öryggistengi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_is","title":"Ey&eth;a minni prentara"}},[_vm._v("\n     Eyða minni prentara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_is","title":"Ey&eth;a af geymsludrifi prentara"}},[_vm._v("\n     Eyða af geymsludrifi prentara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_is","title":"Endurheimta sj&aacute;lfgefnar verksmi&eth;justillingar"}},[_vm._v("\n     Endurheimta sjálfgefnar verksmiðjustillingar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_is","title":"Yfirl&yacute;sing var&eth;andi &oacute;st&ouml;&eth;ugleika"}},[_vm._v("\n     Yfirlýsing varðandi óstöðugleika\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"print-chapter.html#print-chapter_is","title":"Prenta"}},[_vm._v("\n    Prenta\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8693"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_is","title":"Prentun fr&aacute; t&ouml;lvu"}},[_vm._v("\n     Prentun frá tölvu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e8719","title":"Prentun fr&aacute; fart&aelig;ki"}},[_vm._v("\n     Prentun frá fartæki\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_is","title":"Prentun af minniskorti"}},[_vm._v("\n     Prentun af minniskorti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_is","title":"Studd minniskort og skr&aacute;arger&eth;ir"}},[_vm._v("\n     Studd minniskort og skráargerðir\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_is","title":"Setja upp tr&uacute;na&eth;arverk"}},[_vm._v("\n     Setja upp trúnaðarverk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_is","title":"Prentun &aacute; tr&uacute;na&eth;arm&aacute;lum og &ouml;&eth;rum verndu&eth;um verkum"}},[_vm._v("\n     Prentun á trúnaðarmálum og öðrum vernduðum verkum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_is","title":"Prenta lista yfir s&yacute;nishorn leturger&eth;a"}},[_vm._v("\n     Prenta lista yfir sýnishorn leturgerða\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_is","title":"Prenta lista skr&aacute;asafns"}},[_vm._v("\n     Prenta lista skráasafns\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_is","title":"Setja a&eth;skilna&eth;ars&iacute;&eth;ur &aacute; milli afrita"}},[_vm._v("\n     Setja aðskilnaðarsíður á milli afrita\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-printed-sheets-topic.html#stapling-printed-sheets_is","title":"Hefta prentu&eth; bl&ouml;&eth;"}},[_vm._v("\n     Hefta prentuð blöð\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_is","title":"Gata prentu&eth; bl&ouml;&eth;"}},[_vm._v("\n     Gata prentuð blöð\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_is","title":"Nota hli&eth;runarst&ouml;flun &iacute; prentu&eth;um bl&ouml;&eth;um"}},[_vm._v("\n     Nota hliðrunarstöflun í prentuðum blöðum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_is","title":"H&aelig;tta vi&eth; verk &iacute; prentun"}},[_vm._v("\n     Hætta við verk í prentun\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_is","title":"Stilla svertustig prentdufts"}},[_vm._v("\n     Stilla svertustig prentdufts\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying-chapter.html#copying-chapter_is","title":"Afritun"}},[_vm._v("\n    Afritun\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9484"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_is","title":"Nota sj&aacute;lfvirkan matara skjala (ADF) og"}},[_vm._v("\n     Nota sjálfvirkan matara skjala (ADF) og\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_is","title":"Taka afrit"}},[_vm._v("\n     Taka afrit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_is","title":"Afritun &aacute; myndum"}},[_vm._v("\n     Afritun á myndum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_is","title":"Afritun &aacute; br&eacute;fhaus"}},[_vm._v("\n     Afritun á bréfhaus\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_is","title":"Afritun &aacute; b&aacute;&eth;ar hli&eth;ar &aacute; papp&iacute;rnum"}},[_vm._v("\n     Afritun á báðar hliðar á pappírnum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_is","title":"Minnka e&eth;a st&aelig;kka afrit"}},[_vm._v("\n     Minnka eða stækka afrit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_is","title":"Samra&eth;a afritum"}},[_vm._v("\n     Samraða afritum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_is","title":"Setja a&eth;skilna&eth;ars&iacute;&eth;ur &aacute; milli afrita"}},[_vm._v("\n     Setja aðskilnaðarsíður á milli afrita\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_is","title":"Afrita margar s&iacute;&eth;ur &aacute; eina &ouml;rk"}},[_vm._v("\n     Afrita margar síður á eina örk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_is","title":"Afrita kort"}},[_vm._v("\n     Afrita kort\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-copies-topic.html#stapling-copies_is","title":"Hefta afrit"}},[_vm._v("\n     Hefta afrit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-copies-topic.html#punching-holes-copies_is","title":"Gata afrit"}},[_vm._v("\n     Gata afrit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-copies-topic.html#using-offset-stacking-copies_is","title":"Nota hli&eth;runarst&ouml;flun &iacute; afritum"}},[_vm._v("\n     Nota hliðrunarstöflun í afritum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_is","title":"B&uacute;a til fl&yacute;tiv&iacute;si afritunar"}},[_vm._v("\n     Búa til flýtivísi afritunar\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"e-mailing-chapter.html#e-mailing-chapter_is","title":"T&ouml;lvup&oacute;stur"}},[_vm._v("\n    Tölvupóstur\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9863"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_is","title":"Nota sj&aacute;lfvirkan matara skjala (ADF) og"}},[_vm._v("\n     Nota sjálfvirkan matara skjala (ADF) og\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_is","title":"Senda t&ouml;lvup&oacute;st"}},[_vm._v("\n     Senda tölvupóst\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_is","title":"B&uacute;a til fl&yacute;tiv&iacute;si fyrir t&ouml;lvup&oacute;st"}},[_vm._v("\n     Búa til flýtivísi fyrir tölvupóst\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faxing-chapter.html#faxing-chapter_is","title":"Fax"}},[_vm._v("\n    Fax\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9957"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_is","title":"Nota sj&aacute;lfvirkan matara skjala (ADF) og"}},[_vm._v("\n     Nota sjálfvirkan matara skjala (ADF) og\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_is","title":"Senda fax"}},[_vm._v("\n     Senda fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_is","title":"Skipuleggja fax"}},[_vm._v("\n     Skipuleggja fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_is","title":"B&uacute;a til fl&yacute;tiv&iacute;si fyrir &aacute;kv&ouml;r&eth;unarsta&eth; &aacute; faxi"}},[_vm._v("\n     Búa til flýtivísi fyrir ákvörðunarstað á faxi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_is","title":"Breyta upplausn &iacute; faxi"}},[_vm._v("\n     Breyta upplausn í faxi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_is","title":"Stilla svertustig &aacute; faxi"}},[_vm._v("\n     Stilla svertustig á faxi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_is","title":"Prenta atvikaskr&aacute; fyrir fax"}},[_vm._v("\n     Prenta atvikaskrá fyrir fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_is","title":"Loka &aacute; ruslf&ouml;x"}},[_vm._v("\n     Loka á ruslföx\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_is","title":"Geyma f&ouml;x"}},[_vm._v("\n     Geyma föx\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_is","title":"Framsenda fax"}},[_vm._v("\n     Framsenda fax\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"ftp-chapter.html#ftp-chapter_is","title":"Sk&ouml;nnun"}},[_vm._v("\n    Skönnun\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10321"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_is","title":"Nota sj&aacute;lfvirkan matara skjala (ADF) og"}},[_vm._v("\n     Nota sjálfvirkan matara skjala (ADF) og\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_is","title":"Skanna til t&ouml;lvu"}},[_vm._v("\n     Skanna til tölvu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_is","title":"Skanna til FTP-mi&eth;lara"}},[_vm._v("\n     Skanna til FTP-miðlara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_is","title":"B&uacute;a til FTP-fl&yacute;tiv&iacute;si"}},[_vm._v("\n     Búa til FTP-flýtivísi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_is","title":"Skanna &iacute; m&ouml;ppu &aacute; netinu"}},[_vm._v("\n     Skanna í möppu á netinu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_is","title":"B&uacute;a til fl&yacute;tiv&iacute;si fyrir m&ouml;ppu netkerfis"}},[_vm._v("\n     Búa til flýtivísi fyrir möppu netkerfis\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_is","title":"Skanna til minniskorts"}},[_vm._v("\n     Skanna til minniskorts\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"use-printer-menus-chapter.html#use-printer-menus-chapter_is","title":"Nota valmyndir prentarans"}},[_vm._v("\n    Nota valmyndir prentarans\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10623"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menus-map-mfp_is","title":"Yfirlit valmynda"}},[_vm._v("\n     Yfirlit valmynda\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e10986","title":"T&aelig;ki"}},[_vm._v("\n     Tæki\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e13274","title":"Prenta"}},[_vm._v("\n     Prenta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e14542","title":"Papp&iacute;r"}},[_vm._v("\n     Pappír\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e14911","title":"Afritun"}},[_vm._v("\n     Afritun\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e15500","title":"Fax"}},[_vm._v("\n     Fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e17906","title":"T&ouml;lvup&oacute;stur"}},[_vm._v("\n     Tölvupóstur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e18956","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e19634","title":"USB-drif"}},[_vm._v("\n     USB-drif\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e20479","title":"Netkerfi/tengi"}},[_vm._v("\n     Netkerfi/tengi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e22670","title":"Sk&yacute;ja&thorn;j&oacute;nustur"}},[_vm._v("\n     Skýjaþjónustur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e22727","title":"&Ouml;ryggi"}},[_vm._v("\n     Öryggi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e23916","title":"Sk&yacute;rslur"}},[_vm._v("\n     Skýrslur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_is","title":"Bilanaleit"}},[_vm._v("\n     Bilanaleit\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_is","title":"Prentar Stillingars&iacute;&eth;u valmyndar"}},[_vm._v("\n     Prentar Stillingarsíðu valmyndar\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_is","title":"Vi&eth;hald &aacute; prentaranum"}},[_vm._v("\n    Viðhald á prentaranum\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e24256"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_is","title":"Athugun &aacute; st&ouml;&eth;unni &aacute; hlutum og rekstrarv&ouml;rum"}},[_vm._v("\n     Athugun á stöðunni á hlutum og rekstrarvörum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_is","title":"Stilla tilkynningar var&eth;andi rekstrarv&ouml;ru"}},[_vm._v("\n     Stilla tilkynningar varðandi rekstrarvöru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_is","title":"Setja upp vi&eth;varanir t&ouml;lvup&oacute;sts"}},[_vm._v("\n     Setja upp viðvaranir tölvupósts\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_is","title":"Sko&eth;a sk&yacute;rslur"}},[_vm._v("\n     Skoða skýrslur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-supplies-group_is","title":"P&ouml;ntun &aacute; hlutum og rekstrarv&ouml;rum"}},[_vm._v("\n     Pöntun á hlutum og rekstrarvörum\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e24457","title":"Skipta um hluti og rekstrarv&ouml;rur"}},[_vm._v("\n     Skipta um hluti og rekstrarvörur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e25002","title":"Hreinsun &aacute; hlutum prentarans"}},[_vm._v("\n     Hreinsun á hlutum prentarans\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e25255","title":"Spara orku og papp&iacute;r"}},[_vm._v("\n     Spara orku og pappír\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_is","title":"Prentarinn f&aelig;r&eth;ur &aacute; a&eth;ra sta&eth;setningu"}},[_vm._v("\n     Prentarinn færður á aðra staðsetningu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_is","title":"Flutningur &aacute; prentaranum"}},[_vm._v("\n     Flutningur á prentaranum\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_is","title":"Leysa vandam&aacute;l"}},[_vm._v("\n    Leysa vandamál\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e25409"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-picker-topic.html#print-quality-problems-picker_is","title":"Vandam&aacute;l var&eth;andi prentg&aelig;&eth;i"}},[_vm._v("\n     Vandamál varðandi prentgæði\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_is","title":"Villuk&oacute;&eth;ar prentara"}},[_vm._v("\n     Villukóðar prentara\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-is-poor-subgroup.html#d0e26363","title":"Vandam&aacute;l vi&eth; prentun"}},[_vm._v("\n     Vandamál við prentun\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_is","title":"Prentarinn svarar ekki"}},[_vm._v("\n     Prentarinn svarar ekki\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_is","title":"Get ekki lesi&eth; minniskort"}},[_vm._v("\n     Get ekki lesið minniskort\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_is","title":"Virkja USB-tengi&eth;"}},[_vm._v("\n     Virkja USB-tengið\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"avoiding-jams-topic.html#d0e28928","title":"Losa um fl&aelig;kjur"}},[_vm._v("\n     Losa um flækjur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e29438","title":"Vandam&aacute;l vi&eth; nettengingu"}},[_vm._v("\n     Vandamál við nettengingu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e29666","title":"Vandam&aacute;l var&eth;andi valkosti v&eacute;lb&uacute;na&eth;ar"}},[_vm._v("\n     Vandamál varðandi valkosti vélbúnaðar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e29792","title":"Vandam&aacute;l var&eth;andi rekstarv&ouml;rur"}},[_vm._v("\n     Vandamál varðandi rekstarvörur\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e29897","title":"Vandam&aacute;l vi&eth; m&ouml;tun papp&iacute;rs"}},[_vm._v("\n     Vandamál við mötun pappírs\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e30263","title":"Vandam&aacute;l vi&eth; sendingu t&ouml;lvup&oacute;sts"}},[_vm._v("\n     Vandamál við sendingu tölvupósts\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e30357","title":"Vandam&aacute;l vi&eth; faxsendingu"}},[_vm._v("\n     Vandamál við faxsendingu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e31002","title":"Vandam&aacute;l vi&eth; sk&ouml;nnun"}},[_vm._v("\n     Vandamál við skönnun\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_is","title":"Hafa samband vi&eth; stu&eth;ning vi&eth;skiptavina"}},[_vm._v("\n     Hafa samband við stuðning viðskiptavina\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_is","title":"Endurvinnsla og f&ouml;rgun"}},[_vm._v("\n    Endurvinnsla og förgun\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e31798"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_is","title":"Endurn&yacute;ting &aacute; v&ouml;rum Lexmark"}},[_vm._v("\n     Endurnýting á vörum Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_is","title":"Endurvinnsla Lexmark umb&uacute;&eth;a"}},[_vm._v("\n     Endurvinnsla Lexmark umbúða\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_is","title":"Tilkynningar"}},[_vm._v("\n    Tilkynningar\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e31833"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31836","title":"V&ouml;ruuppl&yacute;singar"}},[_vm._v("\n     Vöruupplýsingar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31853","title":"Tilkynning var&eth;andi &uacute;tg&aacute;fu"}},[_vm._v("\n     Tilkynning varðandi útgáfu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_is","title":"V&ouml;rumerki"}},[_vm._v("\n     Vörumerki\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_is","title":"Tilkynningar var&eth;andi leyfism&aacute;l"}},[_vm._v("\n     Tilkynningar varðandi leyfismál\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_is","title":"Stig h&aacute;va&eth;amengunar"}},[_vm._v("\n     Stig hávaðamengunar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_is","title":"Tilskipun vegna &uacute;rgangs fr&aacute; raf- og rafeindab&uacute;na&eth;i (WEEE)"}},[_vm._v("\n     Tilskipun vegna úrgangs frá raf- og rafeindabúnaði (WEEE)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31958","title":"Lit&iacute;um-&iacute;on endurhla&eth;anleg rafhla&eth;a"}},[_vm._v("\n     Litíum-íon endurhlaðanleg rafhlaða\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_is","title":"Regluger&eth; (ESB) 2023/1542"}},[_vm._v("\n     Reglugerð (ESB) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e31996","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_is","title":"F&ouml;rgun &aacute; v&ouml;runni"}},[_vm._v("\n     Förgun á vörunni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_is","title":"Skil &aacute; Lexmark-hylkjum til endurnota e&eth;a endurn&yacute;tingar"}},[_vm._v("\n     Skil á Lexmark-hylkjum til endurnota eða endurnýtingar\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_is","title":"Tilkynning vegna st&ouml;&eth;urafmagns"}},[_vm._v("\n     Tilkynning vegna stöðurafmagns\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_is","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_is","title":"Uppl&yacute;singar um hitastig"}},[_vm._v("\n     Upplýsingar um hitastig\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_is","title":"Orkunotkun"}},[_vm._v("\n     Orkunotkun\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_is","title":"Regluger&eth;atilkynningar um endab&uacute;na&eth; fjarskipta"}},[_vm._v("\n     Reglugerðatilkynningar um endabúnað fjarskipta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_is","title":"Samr&aelig;mi vi&eth; tilskipanir Evr&oacute;pusambandsins (EB)"}},[_vm._v("\n     Samræmi við tilskipanir Evrópusambandsins (EB)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_is","title":"Tilkynning um &uacute;tvarpstruflanir"}},[_vm._v("\n     Tilkynning um útvarpstruflanir\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js